//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get_wellKnownOauthAuthorizationServer(): Promise<void> {
        let url_ = this.baseUrl + "/.well-known/oauth-authorization-server";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet_wellKnownOauthAuthorizationServer(_response);
        });
    }

    protected processGet_wellKnownOauthAuthorizationServer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    analytics_GetProductMarginSummary(timeWindow: string | undefined, groupingMode: ProductGroupingMode | undefined, marginLevel: MarginLevel | undefined, sortBy: string | null | undefined, sortDescending: boolean | undefined): Promise<GetProductMarginSummaryResponse> {
        let url_ = this.baseUrl + "/api/Analytics/product-margin-summary?";
        if (timeWindow === null)
            throw new Error("The parameter 'timeWindow' cannot be null.");
        else if (timeWindow !== undefined)
            url_ += "TimeWindow=" + encodeURIComponent("" + timeWindow) + "&";
        if (groupingMode === null)
            throw new Error("The parameter 'groupingMode' cannot be null.");
        else if (groupingMode !== undefined)
            url_ += "GroupingMode=" + encodeURIComponent("" + groupingMode) + "&";
        if (marginLevel === null)
            throw new Error("The parameter 'marginLevel' cannot be null.");
        else if (marginLevel !== undefined)
            url_ += "MarginLevel=" + encodeURIComponent("" + marginLevel) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnalytics_GetProductMarginSummary(_response);
        });
    }

    protected processAnalytics_GetProductMarginSummary(response: Response): Promise<GetProductMarginSummaryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProductMarginSummaryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetProductMarginSummaryResponse>(null as any);
    }

    analytics_GetMarginAnalysis(productId: string | undefined, startDate: Date | undefined, endDate: Date | undefined, includeBreakdown: boolean | undefined): Promise<GetProductMarginAnalysisResponse> {
        let url_ = this.baseUrl + "/api/Analytics/margin-analysis?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (includeBreakdown === null)
            throw new Error("The parameter 'includeBreakdown' cannot be null.");
        else if (includeBreakdown !== undefined)
            url_ += "IncludeBreakdown=" + encodeURIComponent("" + includeBreakdown) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnalytics_GetMarginAnalysis(_response);
        });
    }

    protected processAnalytics_GetMarginAnalysis(response: Response): Promise<GetProductMarginAnalysisResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProductMarginAnalysisResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetProductMarginAnalysisResponse>(null as any);
    }

    analytics_GetMarginReport(startDate: Date | undefined, endDate: Date | undefined, productFilter: string | null | undefined, categoryFilter: string | null | undefined, maxProducts: number | undefined): Promise<GetMarginReportResponse> {
        let url_ = this.baseUrl + "/api/Analytics/margin-report?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (productFilter !== undefined && productFilter !== null)
            url_ += "ProductFilter=" + encodeURIComponent("" + productFilter) + "&";
        if (categoryFilter !== undefined && categoryFilter !== null)
            url_ += "CategoryFilter=" + encodeURIComponent("" + categoryFilter) + "&";
        if (maxProducts === null)
            throw new Error("The parameter 'maxProducts' cannot be null.");
        else if (maxProducts !== undefined)
            url_ += "MaxProducts=" + encodeURIComponent("" + maxProducts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnalytics_GetMarginReport(_response);
        });
    }

    protected processAnalytics_GetMarginReport(response: Response): Promise<GetMarginReportResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMarginReportResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMarginReportResponse>(null as any);
    }

    analytics_GetInvoiceImportStatistics(dateType: ImportDateType | undefined, daysBack: number | null | undefined): Promise<GetInvoiceImportStatisticsResponse> {
        let url_ = this.baseUrl + "/api/Analytics/invoice-import-statistics?";
        if (dateType === null)
            throw new Error("The parameter 'dateType' cannot be null.");
        else if (dateType !== undefined)
            url_ += "DateType=" + encodeURIComponent("" + dateType) + "&";
        if (daysBack !== undefined && daysBack !== null)
            url_ += "DaysBack=" + encodeURIComponent("" + daysBack) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnalytics_GetInvoiceImportStatistics(_response);
        });
    }

    protected processAnalytics_GetInvoiceImportStatistics(response: Response): Promise<GetInvoiceImportStatisticsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInvoiceImportStatisticsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetInvoiceImportStatisticsResponse>(null as any);
    }

    analytics_GetBankStatementImportStatistics(startDate: Date | null | undefined, endDate: Date | null | undefined, dateType: BankStatementDateType | undefined): Promise<GetBankStatementImportStatisticsResponse> {
        let url_ = this.baseUrl + "/api/Analytics/bank-statement-import-statistics?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (dateType === null)
            throw new Error("The parameter 'dateType' cannot be null.");
        else if (dateType !== undefined)
            url_ += "DateType=" + encodeURIComponent("" + dateType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnalytics_GetBankStatementImportStatistics(_response);
        });
    }

    protected processAnalytics_GetBankStatementImportStatistics(response: Response): Promise<GetBankStatementImportStatisticsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBankStatementImportStatisticsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetBankStatementImportStatisticsResponse>(null as any);
    }

    articles_Generate(request: GenerateArticleRequest): Promise<GenerateArticleResponse> {
        let url_ = this.baseUrl + "/api/Articles/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArticles_Generate(_response);
        });
    }

    protected processArticles_Generate(response: Response): Promise<GenerateArticleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateArticleResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateArticleResponse>(null as any);
    }

    articles_GetById(id: string): Promise<GetArticleResponse> {
        let url_ = this.baseUrl + "/api/Articles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArticles_GetById(_response);
        });
    }

    protected processArticles_GetById(response: Response): Promise<GetArticleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArticleResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleResponse>(null as any);
    }

    articles_GetTrace(id: string): Promise<GetArticleTraceResponse> {
        let url_ = this.baseUrl + "/api/Articles/{id}/trace";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArticles_GetTrace(_response);
        });
    }

    protected processArticles_GetTrace(response: Response): Promise<GetArticleTraceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArticleTraceResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleTraceResponse>(null as any);
    }

    articles_List(status: ArticleStatus | null | undefined, page: number | undefined, pageSize: number | undefined): Promise<ListArticlesResponse> {
        let url_ = this.baseUrl + "/api/Articles?";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArticles_List(_response);
        });
    }

    protected processArticles_List(response: Response): Promise<ListArticlesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListArticlesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListArticlesResponse>(null as any);
    }

    articles_SubmitFeedback(id: string, request: SubmitArticleFeedbackRequest): Promise<SubmitArticleFeedbackResponse> {
        let url_ = this.baseUrl + "/api/Articles/{id}/feedback";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArticles_SubmitFeedback(_response);
        });
    }

    protected processArticles_SubmitFeedback(response: Response): Promise<SubmitArticleFeedbackResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitArticleFeedbackResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = SubmitArticleFeedbackResponse.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitArticleFeedbackResponse>(null as any);
    }

    articles_FeedbackList(hasFeedback: boolean | null | undefined, requestedBy: string | null | undefined, sortBy: string | undefined, sortDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined): Promise<GetArticleFeedbackListResponse> {
        let url_ = this.baseUrl + "/api/Articles/feedback/list?";
        if (hasFeedback !== undefined && hasFeedback !== null)
            url_ += "HasFeedback=" + encodeURIComponent("" + hasFeedback) + "&";
        if (requestedBy !== undefined && requestedBy !== null)
            url_ += "RequestedBy=" + encodeURIComponent("" + requestedBy) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArticles_FeedbackList(_response);
        });
    }

    protected processArticles_FeedbackList(response: Response): Promise<GetArticleFeedbackListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArticleFeedbackListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArticleFeedbackListResponse>(null as any);
    }

    articles_BackfillRequestedBy(request: BackfillArticleRequestedByCommand): Promise<BackfillArticleRequestedByResponse> {
        let url_ = this.baseUrl + "/api/Articles/admin/backfill-requested-by";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArticles_BackfillRequestedBy(_response);
        });
    }

    protected processArticles_BackfillRequestedBy(response: Response): Promise<BackfillArticleRequestedByResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackfillArticleRequestedByResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackfillArticleRequestedByResponse>(null as any);
    }

    attendance_RunBreakInsertion(request: RunBreakInsertionRequest): Promise<RunBreakInsertionResponse> {
        let url_ = this.baseUrl + "/api/attendance/break-insertion/run";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAttendance_RunBreakInsertion(_response);
        });
    }

    protected processAttendance_RunBreakInsertion(response: Response): Promise<RunBreakInsertionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RunBreakInsertionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RunBreakInsertionResponse>(null as any);
    }

    auth_Me(): Promise<GetMeResponse> {
        let url_ = this.baseUrl + "/api/auth/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuth_Me(_response);
        });
    }

    protected processAuth_Me(response: Response): Promise<GetMeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMeResponse>(null as any);
    }

    authorization_Catalogue(): Promise<GetPermissionCatalogueResponse> {
        let url_ = this.baseUrl + "/api/admin/authorization/catalogue";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorization_Catalogue(_response);
        });
    }

    protected processAuthorization_Catalogue(response: Response): Promise<GetPermissionCatalogueResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPermissionCatalogueResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPermissionCatalogueResponse>(null as any);
    }

    authorization_GetGroups(): Promise<GetGroupsResponse> {
        let url_ = this.baseUrl + "/api/admin/authorization/groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorization_GetGroups(_response);
        });
    }

    protected processAuthorization_GetGroups(response: Response): Promise<GetGroupsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGroupsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGroupsResponse>(null as any);
    }

    authorization_CreateGroup(request: CreateGroupRequest): Promise<CreateGroupResponse> {
        let url_ = this.baseUrl + "/api/admin/authorization/groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorization_CreateGroup(_response);
        });
    }

    protected processAuthorization_CreateGroup(response: Response): Promise<CreateGroupResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateGroupResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateGroupResponse>(null as any);
    }

    authorization_GetGroup(id: string): Promise<GetGroupDetailResponse> {
        let url_ = this.baseUrl + "/api/admin/authorization/groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorization_GetGroup(_response);
        });
    }

    protected processAuthorization_GetGroup(response: Response): Promise<GetGroupDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGroupDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGroupDetailResponse>(null as any);
    }

    authorization_UpdateGroup(id: string, request: UpdateGroupRequest): Promise<UpdateGroupResponse> {
        let url_ = this.baseUrl + "/api/admin/authorization/groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorization_UpdateGroup(_response);
        });
    }

    protected processAuthorization_UpdateGroup(response: Response): Promise<UpdateGroupResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGroupResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateGroupResponse>(null as any);
    }

    authorization_DeleteGroup(id: string): Promise<DeleteGroupResponse> {
        let url_ = this.baseUrl + "/api/admin/authorization/groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorization_DeleteGroup(_response);
        });
    }

    protected processAuthorization_DeleteGroup(response: Response): Promise<DeleteGroupResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteGroupResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteGroupResponse>(null as any);
    }

    authorization_AddGroupMember(id: string, request: AddGroupMemberRequest): Promise<AddGroupMemberResponse> {
        let url_ = this.baseUrl + "/api/admin/authorization/groups/{id}/members";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorization_AddGroupMember(_response);
        });
    }

    protected processAuthorization_AddGroupMember(response: Response): Promise<AddGroupMemberResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddGroupMemberResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddGroupMemberResponse>(null as any);
    }

    authorization_GetUsers(): Promise<GetUsersResponse> {
        let url_ = this.baseUrl + "/api/admin/authorization/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorization_GetUsers(_response);
        });
    }

    protected processAuthorization_GetUsers(response: Response): Promise<GetUsersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUsersResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetUsersResponse>(null as any);
    }

    authorization_GetEntraUsers(): Promise<GetEntraAccessUsersResponse> {
        let url_ = this.baseUrl + "/api/admin/authorization/entra-users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorization_GetEntraUsers(_response);
        });
    }

    protected processAuthorization_GetEntraUsers(response: Response): Promise<GetEntraAccessUsersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEntraAccessUsersResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetEntraAccessUsersResponse>(null as any);
    }

    authorization_GetUserPermissions(id: string): Promise<GetUserEffectivePermissionsResponse> {
        let url_ = this.baseUrl + "/api/admin/authorization/users/{id}/permissions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorization_GetUserPermissions(_response);
        });
    }

    protected processAuthorization_GetUserPermissions(response: Response): Promise<GetUserEffectivePermissionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserEffectivePermissionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetUserEffectivePermissionsResponse>(null as any);
    }

    authorization_AssignGroups(id: string, request: AssignUserGroupsRequest): Promise<AssignUserGroupsResponse> {
        let url_ = this.baseUrl + "/api/admin/authorization/users/{id}/groups";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorization_AssignGroups(_response);
        });
    }

    protected processAuthorization_AssignGroups(response: Response): Promise<AssignUserGroupsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignUserGroupsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignUserGroupsResponse>(null as any);
    }

    authorization_SetActive(id: string, request: SetUserActiveRequest): Promise<SetUserActiveResponse> {
        let url_ = this.baseUrl + "/api/admin/authorization/users/{id}/active";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorization_SetActive(_response);
        });
    }

    protected processAuthorization_SetActive(response: Response): Promise<SetUserActiveResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetUserActiveResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetUserActiveResponse>(null as any);
    }

    authorization_UpdateUser(id: string, request: UpdateUserRequest): Promise<UpdateUserResponse> {
        let url_ = this.baseUrl + "/api/admin/authorization/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorization_UpdateUser(_response);
        });
    }

    protected processAuthorization_UpdateUser(response: Response): Promise<UpdateUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateUserResponse>(null as any);
    }

    authorization_CreateLocalUser(request: CreateLocalUserRequest): Promise<CreateLocalUserResponse> {
        let url_ = this.baseUrl + "/api/admin/authorization/users/local";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorization_CreateLocalUser(_response);
        });
    }

    protected processAuthorization_CreateLocalUser(response: Response): Promise<CreateLocalUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateLocalUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateLocalUserResponse>(null as any);
    }

    authorization_SetCanPack(id: string, request: SetUserCanPackRequest): Promise<SetUserCanPackResponse> {
        let url_ = this.baseUrl + "/api/admin/authorization/users/{id}/can-pack";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorization_SetCanPack(_response);
        });
    }

    protected processAuthorization_SetCanPack(response: Response): Promise<SetUserCanPackResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetUserCanPackResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetUserCanPackResponse>(null as any);
    }

    backgroundRefresh_GetRegisteredTasks(): Promise<RefreshTaskDto[]> {
        let url_ = this.baseUrl + "/api/BackgroundRefresh/tasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBackgroundRefresh_GetRegisteredTasks(_response);
        });
    }

    protected processBackgroundRefresh_GetRegisteredTasks(response: Response): Promise<RefreshTaskDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RefreshTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RefreshTaskDto[]>(null as any);
    }

    backgroundRefresh_GetTaskHistory(taskId: string, maxRecords: number | undefined): Promise<RefreshTaskExecutionLogDto[]> {
        let url_ = this.baseUrl + "/api/BackgroundRefresh/tasks/{taskId}/history?";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (maxRecords === null)
            throw new Error("The parameter 'maxRecords' cannot be null.");
        else if (maxRecords !== undefined)
            url_ += "maxRecords=" + encodeURIComponent("" + maxRecords) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBackgroundRefresh_GetTaskHistory(_response);
        });
    }

    protected processBackgroundRefresh_GetTaskHistory(response: Response): Promise<RefreshTaskExecutionLogDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RefreshTaskExecutionLogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RefreshTaskExecutionLogDto[]>(null as any);
    }

    backgroundRefresh_GetAllHistory(maxRecords: number | undefined): Promise<RefreshTaskExecutionLogDto[]> {
        let url_ = this.baseUrl + "/api/BackgroundRefresh/history?";
        if (maxRecords === null)
            throw new Error("The parameter 'maxRecords' cannot be null.");
        else if (maxRecords !== undefined)
            url_ += "maxRecords=" + encodeURIComponent("" + maxRecords) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBackgroundRefresh_GetAllHistory(_response);
        });
    }

    protected processBackgroundRefresh_GetAllHistory(response: Response): Promise<RefreshTaskExecutionLogDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RefreshTaskExecutionLogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RefreshTaskExecutionLogDto[]>(null as any);
    }

    backgroundRefresh_ForceRefresh(taskId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BackgroundRefresh/tasks/{taskId}/force-refresh";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBackgroundRefresh_ForceRefresh(_response);
        });
    }

    protected processBackgroundRefresh_ForceRefresh(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    backgroundRefresh_RunHydrationTier(tier: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BackgroundRefresh/tiers/{tier}/run";
        if (tier === undefined || tier === null)
            throw new Error("The parameter 'tier' must be defined.");
        url_ = url_.replace("{tier}", encodeURIComponent("" + tier));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBackgroundRefresh_RunHydrationTier(_response);
        });
    }

    protected processBackgroundRefresh_RunHydrationTier(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    backgroundRefresh_GetTaskStatus(taskId: string): Promise<RefreshTaskStatusDto> {
        let url_ = this.baseUrl + "/api/BackgroundRefresh/tasks/{taskId}/status";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBackgroundRefresh_GetTaskStatus(_response);
        });
    }

    protected processBackgroundRefresh_GetTaskStatus(response: Response): Promise<RefreshTaskStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTaskStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RefreshTaskStatusDto>(null as any);
    }

    bankStatements_GetAccounts(): Promise<BankAccountDto[]> {
        let url_ = this.baseUrl + "/api/bank-statements/accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBankStatements_GetAccounts(_response);
        });
    }

    protected processBankStatements_GetAccounts(response: Response): Promise<BankAccountDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankAccountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankAccountDto[]>(null as any);
    }

    bankStatements_ImportStatements(request: BankImportRequestDto): Promise<BankStatementImportResultDto> {
        let url_ = this.baseUrl + "/api/bank-statements/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBankStatements_ImportStatements(_response);
        });
    }

    protected processBankStatements_ImportStatements(response: Response): Promise<BankStatementImportResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankStatementImportResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankStatementImportResultDto>(null as any);
    }

    bankStatements_GetBankStatements(id: number | null | undefined, transferId: string | null | undefined, account: string | null | undefined, statementDate: Date | null | undefined, importDate: Date | null | undefined, dateFrom: Date | null | undefined, dateTo: Date | null | undefined, errorsOnly: boolean | null | undefined, skip: number | undefined, take: number | undefined, orderBy: string | null | undefined, ascending: boolean | undefined): Promise<GetBankStatementListResponse> {
        let url_ = this.baseUrl + "/api/bank-statements?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (transferId !== undefined && transferId !== null)
            url_ += "transferId=" + encodeURIComponent("" + transferId) + "&";
        if (account !== undefined && account !== null)
            url_ += "account=" + encodeURIComponent("" + account) + "&";
        if (statementDate !== undefined && statementDate !== null)
            url_ += "statementDate=" + encodeURIComponent(statementDate ? "" + statementDate.toISOString() : "") + "&";
        if (importDate !== undefined && importDate !== null)
            url_ += "importDate=" + encodeURIComponent(importDate ? "" + importDate.toISOString() : "") + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (errorsOnly !== undefined && errorsOnly !== null)
            url_ += "errorsOnly=" + encodeURIComponent("" + errorsOnly) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (ascending === null)
            throw new Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "ascending=" + encodeURIComponent("" + ascending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBankStatements_GetBankStatements(_response);
        });
    }

    protected processBankStatements_GetBankStatements(response: Response): Promise<GetBankStatementListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBankStatementListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetBankStatementListResponse>(null as any);
    }

    bankStatements_GetBankStatement(id: number): Promise<BankStatementImportDto> {
        let url_ = this.baseUrl + "/api/bank-statements/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBankStatements_GetBankStatement(_response);
        });
    }

    protected processBankStatements_GetBankStatement(response: Response): Promise<BankStatementImportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankStatementImportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankStatementImportDto>(null as any);
    }

    carrierCooling_GetMatrix(): Promise<GetCarrierCoolingMatrixResponse> {
        let url_ = this.baseUrl + "/api/carrier-cooling";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCarrierCooling_GetMatrix(_response);
        });
    }

    protected processCarrierCooling_GetMatrix(response: Response): Promise<GetCarrierCoolingMatrixResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCarrierCoolingMatrixResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCarrierCoolingMatrixResponse>(null as any);
    }

    carrierCooling_SetCooling(request: SetCarrierCoolingRequest): Promise<SetCarrierCoolingResponse> {
        let url_ = this.baseUrl + "/api/carrier-cooling";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCarrierCooling_SetCooling(_response);
        });
    }

    protected processCarrierCooling_SetCooling(response: Response): Promise<SetCarrierCoolingResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetCarrierCoolingResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetCarrierCoolingResponse>(null as any);
    }

    catalog_GetCatalogList(productTypes: ProductType[] | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDescending: boolean | undefined, productName: string | null | undefined, productCode: string | null | undefined, searchTerm: string | null | undefined, expirationFrom: string | null | undefined, expirationTo: string | null | undefined): Promise<GetCatalogListResponse> {
        let url_ = this.baseUrl + "/api/Catalog?";
        if (productTypes !== undefined && productTypes !== null)
            productTypes && productTypes.forEach(item => { url_ += "ProductTypes=" + encodeURIComponent("" + item) + "&"; });
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        if (productName !== undefined && productName !== null)
            url_ += "ProductName=" + encodeURIComponent("" + productName) + "&";
        if (productCode !== undefined && productCode !== null)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (expirationFrom !== undefined && expirationFrom !== null)
            url_ += "ExpirationFrom=" + encodeURIComponent("" + expirationFrom) + "&";
        if (expirationTo !== undefined && expirationTo !== null)
            url_ += "ExpirationTo=" + encodeURIComponent("" + expirationTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalog_GetCatalogList(_response);
        });
    }

    protected processCatalog_GetCatalogList(response: Response): Promise<GetCatalogListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCatalogListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCatalogListResponse>(null as any);
    }

    catalog_GetCatalogDetail(productCode: string, monthsBack: number | undefined): Promise<GetCatalogDetailResponse> {
        let url_ = this.baseUrl + "/api/Catalog/{productCode}?";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        if (monthsBack === null)
            throw new Error("The parameter 'monthsBack' cannot be null.");
        else if (monthsBack !== undefined)
            url_ += "monthsBack=" + encodeURIComponent("" + monthsBack) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalog_GetCatalogDetail(_response);
        });
    }

    protected processCatalog_GetCatalogDetail(response: Response): Promise<GetCatalogDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCatalogDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCatalogDetailResponse>(null as any);
    }

    catalog_GetProductStatistics(productCodes: string[] | undefined, metric: ProductStatisticsMetric | undefined, dateFrom: string | undefined, dateTo: string | undefined): Promise<GetProductStatisticsResponse> {
        let url_ = this.baseUrl + "/api/Catalog/product-statistics?";
        if (productCodes === null)
            throw new Error("The parameter 'productCodes' cannot be null.");
        else if (productCodes !== undefined)
            productCodes && productCodes.forEach(item => { url_ += "ProductCodes=" + encodeURIComponent("" + item) + "&"; });
        if (metric === null)
            throw new Error("The parameter 'metric' cannot be null.");
        else if (metric !== undefined)
            url_ += "Metric=" + encodeURIComponent("" + metric) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalog_GetProductStatistics(_response);
        });
    }

    protected processCatalog_GetProductStatistics(response: Response): Promise<GetProductStatisticsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProductStatisticsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetProductStatisticsResponse>(null as any);
    }

    catalog_GetComposition(productCode: string): Promise<GetProductCompositionResponse> {
        let url_ = this.baseUrl + "/api/Catalog/{productCode}/composition";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalog_GetComposition(_response);
        });
    }

    protected processCatalog_GetComposition(response: Response): Promise<GetProductCompositionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProductCompositionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetProductCompositionResponse>(null as any);
    }

    catalog_UpdateCompositionOrder(productCode: string, request: UpdateProductCompositionOrderRequest): Promise<UpdateProductCompositionOrderResponse> {
        let url_ = this.baseUrl + "/api/Catalog/{productCode}/composition/order";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalog_UpdateCompositionOrder(_response);
        });
    }

    protected processCatalog_UpdateCompositionOrder(response: Response): Promise<UpdateProductCompositionOrderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateProductCompositionOrderResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateProductCompositionOrderResponse>(null as any);
    }

    catalog_GetMaterialsForPurchase(searchTerm: string | null | undefined, limit: number | undefined): Promise<GetMaterialsForPurchaseResponse> {
        let url_ = this.baseUrl + "/api/Catalog/materials-for-purchase?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalog_GetMaterialsForPurchase(_response);
        });
    }

    protected processCatalog_GetMaterialsForPurchase(response: Response): Promise<GetMaterialsForPurchaseResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMaterialsForPurchaseResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMaterialsForPurchaseResponse>(null as any);
    }

    catalog_GetProductsForAutocomplete(searchTerm: string | null | undefined, limit: number | undefined, productTypes: ProductType[] | null | undefined): Promise<GetCatalogListResponse> {
        let url_ = this.baseUrl + "/api/Catalog/autocomplete?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (productTypes !== undefined && productTypes !== null)
            productTypes && productTypes.forEach(item => { url_ += "productTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalog_GetProductsForAutocomplete(_response);
        });
    }

    protected processCatalog_GetProductsForAutocomplete(response: Response): Promise<GetCatalogListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCatalogListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCatalogListResponse>(null as any);
    }

    catalog_GetManufactureDifficultyHistory(productCode: string, asOfDate: Date | null | undefined): Promise<GetManufactureDifficultySettingsResponse> {
        let url_ = this.baseUrl + "/api/Catalog/{productCode}/manufacture-difficulty?";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        if (asOfDate !== undefined && asOfDate !== null)
            url_ += "asOfDate=" + encodeURIComponent(asOfDate ? "" + asOfDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalog_GetManufactureDifficultyHistory(_response);
        });
    }

    protected processCatalog_GetManufactureDifficultyHistory(response: Response): Promise<GetManufactureDifficultySettingsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetManufactureDifficultySettingsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetManufactureDifficultySettingsResponse>(null as any);
    }

    catalog_CreateManufactureDifficulty(request: CreateManufactureDifficultyRequest): Promise<CreateManufactureDifficultyResponse> {
        let url_ = this.baseUrl + "/api/Catalog/manufacture-difficulty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalog_CreateManufactureDifficulty(_response);
        });
    }

    protected processCatalog_CreateManufactureDifficulty(response: Response): Promise<CreateManufactureDifficultyResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateManufactureDifficultyResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateManufactureDifficultyResponse>(null as any);
    }

    catalog_UpdateManufactureDifficulty(id: number, request: UpdateManufactureDifficultyRequest): Promise<UpdateManufactureDifficultyResponse> {
        let url_ = this.baseUrl + "/api/Catalog/manufacture-difficulty/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalog_UpdateManufactureDifficulty(_response);
        });
    }

    protected processCatalog_UpdateManufactureDifficulty(response: Response): Promise<UpdateManufactureDifficultyResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateManufactureDifficultyResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateManufactureDifficultyResponse>(null as any);
    }

    catalog_DeleteManufactureDifficulty(id: number): Promise<DeleteManufactureDifficultyResponse> {
        let url_ = this.baseUrl + "/api/Catalog/manufacture-difficulty/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalog_DeleteManufactureDifficulty(_response);
        });
    }

    protected processCatalog_DeleteManufactureDifficulty(response: Response): Promise<DeleteManufactureDifficultyResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteManufactureDifficultyResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteManufactureDifficultyResponse>(null as any);
    }

    catalog_GetProductUsage(productCode: string): Promise<GetProductUsageResponse> {
        let url_ = this.baseUrl + "/api/Catalog/{productCode}/usage";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalog_GetProductUsage(_response);
        });
    }

    protected processCatalog_GetProductUsage(response: Response): Promise<GetProductUsageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProductUsageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetProductUsageResponse>(null as any);
    }

    catalog_GetWarehouseStatistics(): Promise<GetWarehouseStatisticsResponse> {
        let url_ = this.baseUrl + "/api/Catalog/warehouse-statistics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalog_GetWarehouseStatistics(_response);
        });
    }

    protected processCatalog_GetWarehouseStatistics(response: Response): Promise<GetWarehouseStatisticsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWarehouseStatisticsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetWarehouseStatisticsResponse>(null as any);
    }

    catalog_RecalculateProductWeight(request: RecalculateProductWeightRequest): Promise<RecalculateProductWeightResponse> {
        let url_ = this.baseUrl + "/api/Catalog/recalculate-product-weight";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalog_RecalculateProductWeight(_response);
        });
    }

    protected processCatalog_RecalculateProductWeight(response: Response): Promise<RecalculateProductWeightResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecalculateProductWeightResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecalculateProductWeightResponse>(null as any);
    }

    catalog_SetNd(productCode: string, request: SetNdRequest): Promise<SetNdResponse> {
        let url_ = this.baseUrl + "/api/Catalog/{productCode}/nd";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalog_SetNd(_response);
        });
    }

    protected processCatalog_SetNd(response: Response): Promise<SetNdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetNdResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetNdResponse>(null as any);
    }

    catalog_RecalculateProductWeight2(productCode: string): Promise<RecalculateProductWeightResponse> {
        let url_ = this.baseUrl + "/api/Catalog/recalculate-product-weight/{productCode}";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalog_RecalculateProductWeight2(_response);
        });
    }

    protected processCatalog_RecalculateProductWeight2(response: Response): Promise<RecalculateProductWeightResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecalculateProductWeightResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecalculateProductWeightResponse>(null as any);
    }

    catalogDocuments_ListMaterialDocuments(productCode: string): Promise<ListCatalogDocumentsResponse> {
        let url_ = this.baseUrl + "/api/catalog-documents/materials/{productCode}";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalogDocuments_ListMaterialDocuments(_response);
        });
    }

    protected processCatalogDocuments_ListMaterialDocuments(response: Response): Promise<ListCatalogDocumentsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListCatalogDocumentsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListCatalogDocumentsResponse>(null as any);
    }

    catalogDocuments_UploadMaterialDocument(productCode: string, file: FileParameter | null | undefined, documentTypeCode: string | null | undefined, lot: string | null | undefined, commonName: string | null | undefined, uploadAsIs: boolean | undefined): Promise<CatalogDocumentsUploadDocumentResponse> {
        let url_ = this.baseUrl + "/api/catalog-documents/materials/{productCode}";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (documentTypeCode !== null && documentTypeCode !== undefined)
            content_.append("documentTypeCode", documentTypeCode.toString());
        if (lot !== null && lot !== undefined)
            content_.append("lot", lot.toString());
        if (commonName !== null && commonName !== undefined)
            content_.append("commonName", commonName.toString());
        if (uploadAsIs === null || uploadAsIs === undefined)
            throw new Error("The parameter 'uploadAsIs' cannot be null.");
        else
            content_.append("uploadAsIs", uploadAsIs.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalogDocuments_UploadMaterialDocument(_response);
        });
    }

    protected processCatalogDocuments_UploadMaterialDocument(response: Response): Promise<CatalogDocumentsUploadDocumentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CatalogDocumentsUploadDocumentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogDocumentsUploadDocumentResponse>(null as any);
    }

    catalogDocuments_ListPifDocuments(productCode: string): Promise<ListCatalogDocumentsResponse> {
        let url_ = this.baseUrl + "/api/catalog-documents/pif/{productCode}";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalogDocuments_ListPifDocuments(_response);
        });
    }

    protected processCatalogDocuments_ListPifDocuments(response: Response): Promise<ListCatalogDocumentsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListCatalogDocumentsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListCatalogDocumentsResponse>(null as any);
    }

    catalogDocuments_UploadPifDocument(productCode: string, file: FileParameter | null | undefined): Promise<CatalogDocumentsUploadDocumentResponse> {
        let url_ = this.baseUrl + "/api/catalog-documents/pif/{productCode}";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalogDocuments_UploadPifDocument(_response);
        });
    }

    protected processCatalogDocuments_UploadPifDocument(response: Response): Promise<CatalogDocumentsUploadDocumentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CatalogDocumentsUploadDocumentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogDocumentsUploadDocumentResponse>(null as any);
    }

    catalogDocuments_GetMaterialDocumentTypes(): Promise<GetMaterialDocumentTypesResponse> {
        let url_ = this.baseUrl + "/api/catalog-documents/material-document-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCatalogDocuments_GetMaterialDocumentTypes(_response);
        });
    }

    protected processCatalogDocuments_GetMaterialDocumentTypes(response: Response): Promise<GetMaterialDocumentTypesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMaterialDocumentTypesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMaterialDocumentTypesResponse>(null as any);
    }

    configuration_GetConfiguration(): Promise<GetConfigurationResponse> {
        let url_ = this.baseUrl + "/api/Configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfiguration_GetConfiguration(_response);
        });
    }

    protected processConfiguration_GetConfiguration(response: Response): Promise<GetConfigurationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConfigurationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetConfigurationResponse>(null as any);
    }

    dashboard_GetAvailableTiles(): Promise<DashboardTileDto[]> {
        let url_ = this.baseUrl + "/api/Dashboard/tiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashboard_GetAvailableTiles(_response);
        });
    }

    protected processDashboard_GetAvailableTiles(response: Response): Promise<DashboardTileDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardTileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardTileDto[]>(null as any);
    }

    dashboard_GetUserSettings(): Promise<UserDashboardSettingsDto> {
        let url_ = this.baseUrl + "/api/Dashboard/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashboard_GetUserSettings(_response);
        });
    }

    protected processDashboard_GetUserSettings(response: Response): Promise<UserDashboardSettingsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDashboardSettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDashboardSettingsDto>(null as any);
    }

    dashboard_SaveUserSettings(request: SaveUserSettingsRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Dashboard/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashboard_SaveUserSettings(_response);
        });
    }

    protected processDashboard_SaveUserSettings(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    dashboard_GetTileData(tileParameters: { [key: string]: string; } | null | undefined): Promise<DashboardTileDto[]> {
        let url_ = this.baseUrl + "/api/Dashboard/data?";
        if (tileParameters !== undefined && tileParameters !== null)
            url_ += "tileParameters=" + encodeURIComponent("" + tileParameters) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashboard_GetTileData(_response);
        });
    }

    protected processDashboard_GetTileData(response: Response): Promise<DashboardTileDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardTileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardTileDto[]>(null as any);
    }

    dashboard_EnableTile(tileId: string): Promise<EnableTileResponse> {
        let url_ = this.baseUrl + "/api/Dashboard/tiles/{tileId}/enable";
        if (tileId === undefined || tileId === null)
            throw new Error("The parameter 'tileId' must be defined.");
        url_ = url_.replace("{tileId}", encodeURIComponent("" + tileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashboard_EnableTile(_response);
        });
    }

    protected processDashboard_EnableTile(response: Response): Promise<EnableTileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnableTileResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnableTileResponse>(null as any);
    }

    dashboard_DisableTile(tileId: string): Promise<DisableTileResponse> {
        let url_ = this.baseUrl + "/api/Dashboard/tiles/{tileId}/disable";
        if (tileId === undefined || tileId === null)
            throw new Error("The parameter 'tileId' must be defined.");
        url_ = url_.replace("{tileId}", encodeURIComponent("" + tileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashboard_DisableTile(_response);
        });
    }

    protected processDashboard_DisableTile(response: Response): Promise<DisableTileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisableTileResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisableTileResponse>(null as any);
    }

    dataQuality_GetRuns(testType: DqtTestType | null | undefined, status: DqtRunStatus | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<GetDqtRunsResponse> {
        let url_ = this.baseUrl + "/api/data-quality/runs?";
        if (testType !== undefined && testType !== null)
            url_ += "testType=" + encodeURIComponent("" + testType) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDataQuality_GetRuns(_response);
        });
    }

    protected processDataQuality_GetRuns(response: Response): Promise<GetDqtRunsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDqtRunsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDqtRunsResponse>(null as any);
    }

    dataQuality_RunDqt(request: RunDqtRequest): Promise<RunDqtResponse> {
        let url_ = this.baseUrl + "/api/data-quality/runs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDataQuality_RunDqt(_response);
        });
    }

    protected processDataQuality_RunDqt(response: Response): Promise<RunDqtResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RunDqtResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RunDqtResponse>(null as any);
    }

    dataQuality_GetRunDetail(id: string, resultPage: number | undefined, resultPageSize: number | undefined): Promise<GetDqtRunDetailResponse> {
        let url_ = this.baseUrl + "/api/data-quality/runs/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (resultPage === null)
            throw new Error("The parameter 'resultPage' cannot be null.");
        else if (resultPage !== undefined)
            url_ += "resultPage=" + encodeURIComponent("" + resultPage) + "&";
        if (resultPageSize === null)
            throw new Error("The parameter 'resultPageSize' cannot be null.");
        else if (resultPageSize !== undefined)
            url_ += "resultPageSize=" + encodeURIComponent("" + resultPageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDataQuality_GetRunDetail(_response);
        });
    }

    protected processDataQuality_GetRunDetail(response: Response): Promise<GetDqtRunDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDqtRunDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDqtRunDetailResponse>(null as any);
    }

    departments_GetDepartments(): Promise<GetDepartmentsResponse> {
        let url_ = this.baseUrl + "/api/Departments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDepartments_GetDepartments(_response);
        });
    }

    protected processDepartments_GetDepartments(response: Response): Promise<GetDepartmentsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDepartmentsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDepartmentsResponse>(null as any);
    }

    diagnostics_TestLogging(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Diagnostics/test-logging";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDiagnostics_TestLogging(_response);
        });
    }

    protected processDiagnostics_TestLogging(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    diagnostics_TestException(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Diagnostics/test-exception";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDiagnostics_TestException(_response);
        });
    }

    protected processDiagnostics_TestException(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    diagnostics_Health(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Diagnostics/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDiagnostics_Health(_response);
        });
    }

    protected processDiagnostics_Health(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    diagnostics_GetApplicationInsightsConfig(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Diagnostics/appinsights-config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDiagnostics_GetApplicationInsightsConfig(_response);
        });
    }

    protected processDiagnostics_GetApplicationInsightsConfig(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    e2ETest_GetEnvironmentInfo(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/E2ETest/env-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processE2ETest_GetEnvironmentInfo(_response);
        });
    }

    protected processE2ETest_GetEnvironmentInfo(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    e2ETest_CreateE2ESession(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/E2ETest/auth";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processE2ETest_CreateE2ESession(_response);
        });
    }

    protected processE2ETest_CreateE2ESession(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    e2ETest_GetAuthStatus(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/E2ETest/auth-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processE2ETest_GetAuthStatus(_response);
        });
    }

    protected processE2ETest_GetAuthStatus(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    e2ETest_GetE2EApp(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/E2ETest/app";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processE2ETest_GetE2EApp(_response);
        });
    }

    protected processE2ETest_GetE2EApp(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    expeditionListArchive_GetDates(page: number | undefined, pageSize: number | undefined): Promise<GetExpeditionDatesResponse> {
        let url_ = this.baseUrl + "/api/expedition-list-archive/dates?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExpeditionListArchive_GetDates(_response);
        });
    }

    protected processExpeditionListArchive_GetDates(response: Response): Promise<GetExpeditionDatesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExpeditionDatesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetExpeditionDatesResponse>(null as any);
    }

    expeditionListArchive_GetByDate(date: string): Promise<GetExpeditionListsByDateResponse> {
        let url_ = this.baseUrl + "/api/expedition-list-archive/{date}";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExpeditionListArchive_GetByDate(_response);
        });
    }

    protected processExpeditionListArchive_GetByDate(response: Response): Promise<GetExpeditionListsByDateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExpeditionListsByDateResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetExpeditionListsByDateResponse>(null as any);
    }

    expeditionListArchive_Download(blobPath: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/expedition-list-archive/download/{blobPath}";
        if (blobPath === undefined || blobPath === null)
            throw new Error("The parameter 'blobPath' must be defined.");
        url_ = url_.replace("{blobPath}", encodeURIComponent("" + blobPath));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExpeditionListArchive_Download(_response);
        });
    }

    protected processExpeditionListArchive_Download(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    expeditionListArchive_Reprint(request: ReprintExpeditionListRequest): Promise<ReprintExpeditionListResponse> {
        let url_ = this.baseUrl + "/api/expedition-list-archive/reprint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExpeditionListArchive_Reprint(_response);
        });
    }

    protected processExpeditionListArchive_Reprint(response: Response): Promise<ReprintExpeditionListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReprintExpeditionListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReprintExpeditionListResponse>(null as any);
    }

    expeditionList_RunFix(): Promise<RunExpeditionListPrintFixResponse> {
        let url_ = this.baseUrl + "/api/expedition-list/run-fix";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExpeditionList_RunFix(_response);
        });
    }

    protected processExpeditionList_RunFix(response: Response): Promise<RunExpeditionListPrintFixResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RunExpeditionListPrintFixResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RunExpeditionListPrintFixResponse>(null as any);
    }

    expeditionList_PrintOrder(request: PrintExpeditionOrderRequest): Promise<PrintExpeditionOrderResponse> {
        let url_ = this.baseUrl + "/api/expedition-list/print-order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExpeditionList_PrintOrder(_response);
        });
    }

    protected processExpeditionList_PrintOrder(response: Response): Promise<PrintExpeditionOrderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintExpeditionOrderResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintExpeditionOrderResponse>(null as any);
    }

    featureFlags_Get(): Promise<EvaluateFlagsForClientResponse> {
        let url_ = this.baseUrl + "/api/feature-flags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFeatureFlags_Get(_response);
        });
    }

    protected processFeatureFlags_Get(response: Response): Promise<EvaluateFlagsForClientResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EvaluateFlagsForClientResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvaluateFlagsForClientResponse>(null as any);
    }

    featureFlags_GetAdmin(): Promise<ListFlagsResponse> {
        let url_ = this.baseUrl + "/api/feature-flags/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFeatureFlags_GetAdmin(_response);
        });
    }

    protected processFeatureFlags_GetAdmin(response: Response): Promise<ListFlagsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListFlagsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListFlagsResponse>(null as any);
    }

    featureFlags_Put(key: string, body: UpsertFlagOverrideBodyDto): Promise<UpsertFlagOverrideResponse> {
        let url_ = this.baseUrl + "/api/feature-flags/admin/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFeatureFlags_Put(_response);
        });
    }

    protected processFeatureFlags_Put(response: Response): Promise<UpsertFlagOverrideResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertFlagOverrideResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = UpsertFlagOverrideResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpsertFlagOverrideResponse>(null as any);
    }

    featureFlags_Delete(key: string): Promise<ClearFlagOverrideResponse> {
        let url_ = this.baseUrl + "/api/feature-flags/admin/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFeatureFlags_Delete(_response);
        });
    }

    protected processFeatureFlags_Delete(response: Response): Promise<ClearFlagOverrideResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClearFlagOverrideResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ClearFlagOverrideResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClearFlagOverrideResponse>(null as any);
    }

    fileStorage_DownloadFromUrl(request: DownloadFromUrlRequest): Promise<DownloadFromUrlResponse> {
        let url_ = this.baseUrl + "/api/FileStorage/download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFileStorage_DownloadFromUrl(_response);
        });
    }

    protected processFileStorage_DownloadFromUrl(response: Response): Promise<DownloadFromUrlResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadFromUrlResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadFromUrlResponse>(null as any);
    }

    financialOverview_GetFinancialOverview(months: number | null | undefined, includeStockData: boolean | undefined, excludedDepartments: string[] | null | undefined, includeCurrentMonth: boolean | undefined): Promise<GetFinancialOverviewResponse> {
        let url_ = this.baseUrl + "/api/FinancialOverview?";
        if (months !== undefined && months !== null)
            url_ += "months=" + encodeURIComponent("" + months) + "&";
        if (includeStockData === null)
            throw new Error("The parameter 'includeStockData' cannot be null.");
        else if (includeStockData !== undefined)
            url_ += "includeStockData=" + encodeURIComponent("" + includeStockData) + "&";
        if (excludedDepartments !== undefined && excludedDepartments !== null)
            excludedDepartments && excludedDepartments.forEach(item => { url_ += "excludedDepartments=" + encodeURIComponent("" + item) + "&"; });
        if (includeCurrentMonth === null)
            throw new Error("The parameter 'includeCurrentMonth' cannot be null.");
        else if (includeCurrentMonth !== undefined)
            url_ += "includeCurrentMonth=" + encodeURIComponent("" + includeCurrentMonth) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFinancialOverview_GetFinancialOverview(_response);
        });
    }

    protected processFinancialOverview_GetFinancialOverview(response: Response): Promise<GetFinancialOverviewResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFinancialOverviewResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetFinancialOverviewResponse>(null as any);
    }

    financialOverview_GetFinancialComparison(years: number | undefined, includeStockData: boolean | undefined, excludedDepartments: string[] | null | undefined, includePartialMonth: boolean | undefined): Promise<GetFinancialComparisonResponse> {
        let url_ = this.baseUrl + "/api/FinancialOverview/comparison?";
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            url_ += "years=" + encodeURIComponent("" + years) + "&";
        if (includeStockData === null)
            throw new Error("The parameter 'includeStockData' cannot be null.");
        else if (includeStockData !== undefined)
            url_ += "includeStockData=" + encodeURIComponent("" + includeStockData) + "&";
        if (excludedDepartments !== undefined && excludedDepartments !== null)
            excludedDepartments && excludedDepartments.forEach(item => { url_ += "excludedDepartments=" + encodeURIComponent("" + item) + "&"; });
        if (includePartialMonth === null)
            throw new Error("The parameter 'includePartialMonth' cannot be null.");
        else if (includePartialMonth !== undefined)
            url_ += "includePartialMonth=" + encodeURIComponent("" + includePartialMonth) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFinancialOverview_GetFinancialComparison(_response);
        });
    }

    protected processFinancialOverview_GetFinancialComparison(response: Response): Promise<GetFinancialComparisonResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFinancialComparisonResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetFinancialComparisonResponse>(null as any);
    }

    giftSettings_GetGiftSetting(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/gift-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGiftSettings_GetGiftSetting(_response);
        });
    }

    protected processGiftSettings_GetGiftSetting(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    giftSettings_SetGiftSetting(command: SetGiftSettingCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/gift-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGiftSettings_SetGiftSetting(_response);
        });
    }

    protected processGiftSettings_SetGiftSetting(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    gridLayouts_Get(gridKey: string): Promise<GridLayoutDto> {
        let url_ = this.baseUrl + "/api/GridLayouts/{gridKey}";
        if (gridKey === undefined || gridKey === null)
            throw new Error("The parameter 'gridKey' must be defined.");
        url_ = url_.replace("{gridKey}", encodeURIComponent("" + gridKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGridLayouts_Get(_response);
        });
    }

    protected processGridLayouts_Get(response: Response): Promise<GridLayoutDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridLayoutDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GridLayoutDto>(null as any);
    }

    gridLayouts_Save(gridKey: string, body: SaveGridLayoutRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/GridLayouts/{gridKey}";
        if (gridKey === undefined || gridKey === null)
            throw new Error("The parameter 'gridKey' must be defined.");
        url_ = url_.replace("{gridKey}", encodeURIComponent("" + gridKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGridLayouts_Save(_response);
        });
    }

    protected processGridLayouts_Save(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    gridLayouts_Reset(gridKey: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/GridLayouts/{gridKey}";
        if (gridKey === undefined || gridKey === null)
            throw new Error("The parameter 'gridKey' must be defined.");
        url_ = url_.replace("{gridKey}", encodeURIComponent("" + gridKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGridLayouts_Reset(_response);
        });
    }

    protected processGridLayouts_Reset(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    invoiceClassification_GetRules(includeInactive: boolean | undefined): Promise<GetClassificationRulesResponse> {
        let url_ = this.baseUrl + "/api/InvoiceClassification/rules?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvoiceClassification_GetRules(_response);
        });
    }

    protected processInvoiceClassification_GetRules(response: Response): Promise<GetClassificationRulesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClassificationRulesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetClassificationRulesResponse>(null as any);
    }

    invoiceClassification_CreateRule(request: CreateClassificationRuleRequest): Promise<CreateClassificationRuleResponse> {
        let url_ = this.baseUrl + "/api/InvoiceClassification/rules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvoiceClassification_CreateRule(_response);
        });
    }

    protected processInvoiceClassification_CreateRule(response: Response): Promise<CreateClassificationRuleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateClassificationRuleResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateClassificationRuleResponse>(null as any);
    }

    invoiceClassification_ReorderRules(request: ReorderClassificationRulesRequest): Promise<ReorderClassificationRulesResponse> {
        let url_ = this.baseUrl + "/api/InvoiceClassification/rules/reorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvoiceClassification_ReorderRules(_response);
        });
    }

    protected processInvoiceClassification_ReorderRules(response: Response): Promise<ReorderClassificationRulesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReorderClassificationRulesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReorderClassificationRulesResponse>(null as any);
    }

    invoiceClassification_UpdateRule(id: string, request: UpdateClassificationRuleRequest): Promise<UpdateClassificationRuleResponse> {
        let url_ = this.baseUrl + "/api/InvoiceClassification/rules/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvoiceClassification_UpdateRule(_response);
        });
    }

    protected processInvoiceClassification_UpdateRule(response: Response): Promise<UpdateClassificationRuleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClassificationRuleResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateClassificationRuleResponse>(null as any);
    }

    invoiceClassification_DeleteRule(id: string): Promise<DeleteClassificationRuleResponse> {
        let url_ = this.baseUrl + "/api/InvoiceClassification/rules/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvoiceClassification_DeleteRule(_response);
        });
    }

    protected processInvoiceClassification_DeleteRule(response: Response): Promise<DeleteClassificationRuleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteClassificationRuleResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteClassificationRuleResponse>(null as any);
    }

    invoiceClassification_ClassifyInvoices(request: ClassifyInvoicesRequest): Promise<ClassifyInvoicesResponse> {
        let url_ = this.baseUrl + "/api/InvoiceClassification/classify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvoiceClassification_ClassifyInvoices(_response);
        });
    }

    protected processInvoiceClassification_ClassifyInvoices(response: Response): Promise<ClassifyInvoicesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClassifyInvoicesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClassifyInvoicesResponse>(null as any);
    }

    invoiceClassification_GetAvailableRuleTypes(): Promise<ClassificationRuleTypeDto[]> {
        let url_ = this.baseUrl + "/api/InvoiceClassification/rule-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvoiceClassification_GetAvailableRuleTypes(_response);
        });
    }

    protected processInvoiceClassification_GetAvailableRuleTypes(response: Response): Promise<ClassificationRuleTypeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClassificationRuleTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClassificationRuleTypeDto[]>(null as any);
    }

    invoiceClassification_GetAccountingTemplates(): Promise<GetAccountingTemplatesResponse> {
        let url_ = this.baseUrl + "/api/InvoiceClassification/accounting-templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvoiceClassification_GetAccountingTemplates(_response);
        });
    }

    protected processInvoiceClassification_GetAccountingTemplates(response: Response): Promise<GetAccountingTemplatesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAccountingTemplatesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAccountingTemplatesResponse>(null as any);
    }

    invoiceClassification_GetClassificationHistory(page: number | undefined, pageSize: number | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, invoiceNumber: string | null | undefined, companyName: string | null | undefined): Promise<GetClassificationHistoryResponse> {
        let url_ = this.baseUrl + "/api/InvoiceClassification/history?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (invoiceNumber !== undefined && invoiceNumber !== null)
            url_ += "invoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (companyName !== undefined && companyName !== null)
            url_ += "companyName=" + encodeURIComponent("" + companyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvoiceClassification_GetClassificationHistory(_response);
        });
    }

    protected processInvoiceClassification_GetClassificationHistory(response: Response): Promise<GetClassificationHistoryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClassificationHistoryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetClassificationHistoryResponse>(null as any);
    }

    invoiceClassification_ClassifySingleInvoice(invoiceId: string): Promise<ClassifyInvoicesResponse> {
        let url_ = this.baseUrl + "/api/InvoiceClassification/classify/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvoiceClassification_ClassifySingleInvoice(_response);
        });
    }

    protected processInvoiceClassification_ClassifySingleInvoice(response: Response): Promise<ClassifyInvoicesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClassifyInvoicesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClassifyInvoicesResponse>(null as any);
    }

    invoiceClassification_GetInvoiceDetails(invoiceId: string): Promise<GetInvoiceDetailsResponse> {
        let url_ = this.baseUrl + "/api/InvoiceClassification/invoice/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvoiceClassification_GetInvoiceDetails(_response);
        });
    }

    protected processInvoiceClassification_GetInvoiceDetails(response: Response): Promise<GetInvoiceDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInvoiceDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetInvoiceDetailsResponse>(null as any);
    }

    invoices_GetInvoicesList(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDescending: boolean | undefined, invoiceId: string | null | undefined, customerName: string | null | undefined, invoiceDateFrom: Date | null | undefined, invoiceDateTo: Date | null | undefined, isSynced: boolean | null | undefined, showOnlyUnsynced: boolean | undefined, showOnlyWithErrors: boolean | undefined): Promise<GetIssuedInvoicesListResponse> {
        let url_ = this.baseUrl + "/api/invoices?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        if (invoiceId !== undefined && invoiceId !== null)
            url_ += "InvoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        if (customerName !== undefined && customerName !== null)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (invoiceDateFrom !== undefined && invoiceDateFrom !== null)
            url_ += "InvoiceDateFrom=" + encodeURIComponent(invoiceDateFrom ? "" + invoiceDateFrom.toISOString() : "") + "&";
        if (invoiceDateTo !== undefined && invoiceDateTo !== null)
            url_ += "InvoiceDateTo=" + encodeURIComponent(invoiceDateTo ? "" + invoiceDateTo.toISOString() : "") + "&";
        if (isSynced !== undefined && isSynced !== null)
            url_ += "IsSynced=" + encodeURIComponent("" + isSynced) + "&";
        if (showOnlyUnsynced === null)
            throw new Error("The parameter 'showOnlyUnsynced' cannot be null.");
        else if (showOnlyUnsynced !== undefined)
            url_ += "ShowOnlyUnsynced=" + encodeURIComponent("" + showOnlyUnsynced) + "&";
        if (showOnlyWithErrors === null)
            throw new Error("The parameter 'showOnlyWithErrors' cannot be null.");
        else if (showOnlyWithErrors !== undefined)
            url_ += "ShowOnlyWithErrors=" + encodeURIComponent("" + showOnlyWithErrors) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvoices_GetInvoicesList(_response);
        });
    }

    protected processInvoices_GetInvoicesList(response: Response): Promise<GetIssuedInvoicesListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIssuedInvoicesListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetIssuedInvoicesListResponse>(null as any);
    }

    invoices_GetInvoiceDetail(id: string, withDetails: boolean | undefined): Promise<GetIssuedInvoiceDetailResponse> {
        let url_ = this.baseUrl + "/api/invoices/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (withDetails === null)
            throw new Error("The parameter 'withDetails' cannot be null.");
        else if (withDetails !== undefined)
            url_ += "withDetails=" + encodeURIComponent("" + withDetails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvoices_GetInvoiceDetail(_response);
        });
    }

    protected processInvoices_GetInvoiceDetail(response: Response): Promise<GetIssuedInvoiceDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIssuedInvoiceDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetIssuedInvoiceDetailResponse>(null as any);
    }

    invoices_GetSyncStats(fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<GetIssuedInvoiceSyncStatsResponse> {
        let url_ = this.baseUrl + "/api/invoices/stats?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvoices_GetSyncStats(_response);
        });
    }

    protected processInvoices_GetSyncStats(response: Response): Promise<GetIssuedInvoiceSyncStatsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIssuedInvoiceSyncStatsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetIssuedInvoiceSyncStatsResponse>(null as any);
    }

    invoices_EnqueueImportInvoices(request: EnqueueImportInvoicesRequest): Promise<EnqueueImportInvoicesResponse> {
        let url_ = this.baseUrl + "/api/invoices/import/enqueue-async";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvoices_EnqueueImportInvoices(_response);
        });
    }

    protected processInvoices_EnqueueImportInvoices(response: Response): Promise<EnqueueImportInvoicesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnqueueImportInvoicesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnqueueImportInvoicesResponse>(null as any);
    }

    invoices_GetInvoiceImportJobStatus(jobId: string): Promise<BackgroundJobInfo> {
        let url_ = this.baseUrl + "/api/invoices/import/job-status/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvoices_GetInvoiceImportJobStatus(_response);
        });
    }

    protected processInvoices_GetInvoiceImportJobStatus(response: Response): Promise<BackgroundJobInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackgroundJobInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackgroundJobInfo>(null as any);
    }

    invoices_GetRunningInvoiceImportJobs(): Promise<BackgroundJobInfo[]> {
        let url_ = this.baseUrl + "/api/invoices/import/running-jobs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvoices_GetRunningInvoiceImportJobs(_response);
        });
    }

    protected processInvoices_GetRunningInvoiceImportJobs(response: Response): Promise<BackgroundJobInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BackgroundJobInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackgroundJobInfo[]>(null as any);
    }

    journal_GetJournalEntries(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | undefined, sortDirection: string | undefined): Promise<GetJournalEntriesResponse> {
        let url_ = this.baseUrl + "/api/Journal?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJournal_GetJournalEntries(_response);
        });
    }

    protected processJournal_GetJournalEntries(response: Response): Promise<GetJournalEntriesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJournalEntriesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJournalEntriesResponse>(null as any);
    }

    journal_CreateJournalEntry(request: CreateJournalEntryRequest): Promise<CreateJournalEntryResponse> {
        let url_ = this.baseUrl + "/api/Journal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJournal_CreateJournalEntry(_response);
        });
    }

    protected processJournal_CreateJournalEntry(response: Response): Promise<CreateJournalEntryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateJournalEntryResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateJournalEntryResponse>(null as any);
    }

    journal_SearchJournalEntries(searchText: string | null | undefined, dateFrom: Date | null | undefined, dateTo: Date | null | undefined, productCodePrefix: string | null | undefined, tagIds: number[] | null | undefined, createdByUserId: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | undefined, sortDirection: string | undefined, withoutProducts: boolean | undefined): Promise<SearchJournalEntriesResponse> {
        let url_ = this.baseUrl + "/api/Journal/search?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (productCodePrefix !== undefined && productCodePrefix !== null)
            url_ += "ProductCodePrefix=" + encodeURIComponent("" + productCodePrefix) + "&";
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
        if (createdByUserId !== undefined && createdByUserId !== null)
            url_ += "CreatedByUserId=" + encodeURIComponent("" + createdByUserId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (withoutProducts === null)
            throw new Error("The parameter 'withoutProducts' cannot be null.");
        else if (withoutProducts !== undefined)
            url_ += "WithoutProducts=" + encodeURIComponent("" + withoutProducts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJournal_SearchJournalEntries(_response);
        });
    }

    protected processJournal_SearchJournalEntries(response: Response): Promise<SearchJournalEntriesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchJournalEntriesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchJournalEntriesResponse>(null as any);
    }

    journal_GetJournalEntry(id: number): Promise<GetJournalEntryResponse> {
        let url_ = this.baseUrl + "/api/Journal/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJournal_GetJournalEntry(_response);
        });
    }

    protected processJournal_GetJournalEntry(response: Response): Promise<GetJournalEntryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJournalEntryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJournalEntryResponse>(null as any);
    }

    journal_UpdateJournalEntry(id: number, request: UpdateJournalEntryRequest): Promise<UpdateJournalEntryResponse> {
        let url_ = this.baseUrl + "/api/Journal/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJournal_UpdateJournalEntry(_response);
        });
    }

    protected processJournal_UpdateJournalEntry(response: Response): Promise<UpdateJournalEntryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateJournalEntryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateJournalEntryResponse>(null as any);
    }

    journal_DeleteJournalEntry(id: number): Promise<DeleteJournalEntryResponse> {
        let url_ = this.baseUrl + "/api/Journal/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJournal_DeleteJournalEntry(_response);
        });
    }

    protected processJournal_DeleteJournalEntry(response: Response): Promise<DeleteJournalEntryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteJournalEntryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteJournalEntryResponse>(null as any);
    }

    journal_GetJournalTags(): Promise<GetJournalTagsResponse> {
        let url_ = this.baseUrl + "/api/Journal/tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJournal_GetJournalTags(_response);
        });
    }

    protected processJournal_GetJournalTags(response: Response): Promise<GetJournalTagsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJournalTagsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJournalTagsResponse>(null as any);
    }

    journal_CreateJournalTag(request: CreateJournalTagRequest): Promise<CreateJournalTagResponse> {
        let url_ = this.baseUrl + "/api/Journal/tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJournal_CreateJournalTag(_response);
        });
    }

    protected processJournal_CreateJournalTag(response: Response): Promise<CreateJournalTagResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateJournalTagResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateJournalTagResponse>(null as any);
    }

    knowledgeBase_GetDocuments(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | undefined, sortDescending: boolean | undefined, filenameFilter: string | null | undefined, statusFilter: string | null | undefined, contentTypeFilter: string | null | undefined): Promise<GetDocumentsResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeBase/documents?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "sortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        if (filenameFilter !== undefined && filenameFilter !== null)
            url_ += "filenameFilter=" + encodeURIComponent("" + filenameFilter) + "&";
        if (statusFilter !== undefined && statusFilter !== null)
            url_ += "statusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (contentTypeFilter !== undefined && contentTypeFilter !== null)
            url_ += "contentTypeFilter=" + encodeURIComponent("" + contentTypeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKnowledgeBase_GetDocuments(_response);
        });
    }

    protected processKnowledgeBase_GetDocuments(response: Response): Promise<GetDocumentsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDocumentsResponse>(null as any);
    }

    knowledgeBase_GetDocumentContentTypes(): Promise<GetDocumentContentTypesResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeBase/documents/content-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKnowledgeBase_GetDocumentContentTypes(_response);
        });
    }

    protected processKnowledgeBase_GetDocumentContentTypes(response: Response): Promise<GetDocumentContentTypesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentContentTypesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDocumentContentTypesResponse>(null as any);
    }

    knowledgeBase_Search(request: SearchDocumentsRequest): Promise<SearchDocumentsResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeBase/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKnowledgeBase_Search(_response);
        });
    }

    protected processKnowledgeBase_Search(response: Response): Promise<SearchDocumentsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchDocumentsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchDocumentsResponse>(null as any);
    }

    knowledgeBase_GetChunkDetail(id: string): Promise<GetChunkDetailResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeBase/chunks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKnowledgeBase_GetChunkDetail(_response);
        });
    }

    protected processKnowledgeBase_GetChunkDetail(response: Response): Promise<GetChunkDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetChunkDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetChunkDetailResponse>(null as any);
    }

    knowledgeBase_Ask(request: AskQuestionRequest): Promise<AskQuestionResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeBase/ask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKnowledgeBase_Ask(_response);
        });
    }

    protected processKnowledgeBase_Ask(response: Response): Promise<AskQuestionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AskQuestionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AskQuestionResponse>(null as any);
    }

    knowledgeBase_DeleteDocument(id: string): Promise<DeleteDocumentResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeBase/documents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKnowledgeBase_DeleteDocument(_response);
        });
    }

    protected processKnowledgeBase_DeleteDocument(response: Response): Promise<DeleteDocumentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteDocumentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteDocumentResponse>(null as any);
    }

    knowledgeBase_GetFeedbackList(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | undefined, sortDescending: boolean | undefined, hasFeedback: boolean | null | undefined, userId: string | null | undefined, dateFrom: Date | null | undefined, dateTo: Date | null | undefined, problemTag: string | null | undefined, productTag: string | null | undefined): Promise<GetFeedbackListResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeBase/feedback/list?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "sortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        if (hasFeedback !== undefined && hasFeedback !== null)
            url_ += "hasFeedback=" + encodeURIComponent("" + hasFeedback) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (problemTag !== undefined && problemTag !== null)
            url_ += "problemTag=" + encodeURIComponent("" + problemTag) + "&";
        if (productTag !== undefined && productTag !== null)
            url_ += "productTag=" + encodeURIComponent("" + productTag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKnowledgeBase_GetFeedbackList(_response);
        });
    }

    protected processKnowledgeBase_GetFeedbackList(response: Response): Promise<GetFeedbackListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFeedbackListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetFeedbackListResponse>(null as any);
    }

    knowledgeBase_GetQuestionTagStats(dateFrom: Date | null | undefined, dateTo: Date | null | undefined): Promise<GetQuestionTagStatsResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeBase/feedback/tag-stats?";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKnowledgeBase_GetQuestionTagStats(_response);
        });
    }

    protected processKnowledgeBase_GetQuestionTagStats(response: Response): Promise<GetQuestionTagStatsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetQuestionTagStatsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetQuestionTagStatsResponse>(null as any);
    }

    knowledgeBase_SubmitFeedback(request: SubmitFeedbackRequest): Promise<SubmitFeedbackResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeBase/feedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKnowledgeBase_SubmitFeedback(_response);
        });
    }

    protected processKnowledgeBase_SubmitFeedback(response: Response): Promise<SubmitFeedbackResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitFeedbackResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitFeedbackResponse>(null as any);
    }

    knowledgeBase_UploadDocument(file: FileParameter | null | undefined, documentType: string | null | undefined): Promise<KnowledgeBaseUploadDocumentResponse> {
        let url_ = this.baseUrl + "/api/KnowledgeBase/documents/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (documentType !== null && documentType !== undefined)
            content_.append("documentType", documentType.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKnowledgeBase_UploadDocument(_response);
        });
    }

    protected processKnowledgeBase_UploadDocument(response: Response): Promise<KnowledgeBaseUploadDocumentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KnowledgeBaseUploadDocumentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KnowledgeBaseUploadDocumentResponse>(null as any);
    }

    labelIdentification_Identify(photo: FileParameter | null | undefined): Promise<IdentifyLabelResponse> {
        let url_ = this.baseUrl + "/api/label-identification/identify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (photo !== null && photo !== undefined)
            content_.append("photo", photo.data, photo.fileName ? photo.fileName : "photo");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLabelIdentification_Identify(_response);
        });
    }

    protected processLabelIdentification_Identify(response: Response): Promise<IdentifyLabelResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentifyLabelResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdentifyLabelResponse>(null as any);
    }

    leaflet_Generate(request: GenerateLeafletRequest): Promise<GenerateLeafletResponse> {
        let url_ = this.baseUrl + "/api/leaflet/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeaflet_Generate(_response);
        });
    }

    protected processLeaflet_Generate(response: Response): Promise<GenerateLeafletResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateLeafletResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = GenerateLeafletResponse.fromJS(resultData422);
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateLeafletResponse>(null as any);
    }

    leaflet_GetDocuments(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | undefined, sortDescending: boolean | undefined, filenameFilter: string | null | undefined, statusFilter: string | null | undefined, contentTypeFilter: string | null | undefined): Promise<GetLeafletDocumentsResponse> {
        let url_ = this.baseUrl + "/api/leaflet/documents?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "sortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        if (filenameFilter !== undefined && filenameFilter !== null)
            url_ += "filenameFilter=" + encodeURIComponent("" + filenameFilter) + "&";
        if (statusFilter !== undefined && statusFilter !== null)
            url_ += "statusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (contentTypeFilter !== undefined && contentTypeFilter !== null)
            url_ += "contentTypeFilter=" + encodeURIComponent("" + contentTypeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeaflet_GetDocuments(_response);
        });
    }

    protected processLeaflet_GetDocuments(response: Response): Promise<GetLeafletDocumentsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLeafletDocumentsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLeafletDocumentsResponse>(null as any);
    }

    leaflet_GetDocumentContentTypes(): Promise<GetLeafletDocumentContentTypesResponse> {
        let url_ = this.baseUrl + "/api/leaflet/documents/content-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeaflet_GetDocumentContentTypes(_response);
        });
    }

    protected processLeaflet_GetDocumentContentTypes(response: Response): Promise<GetLeafletDocumentContentTypesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLeafletDocumentContentTypesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLeafletDocumentContentTypesResponse>(null as any);
    }

    leaflet_GetChunkDetail(id: string): Promise<GetLeafletChunkDetailResponse> {
        let url_ = this.baseUrl + "/api/leaflet/chunks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeaflet_GetChunkDetail(_response);
        });
    }

    protected processLeaflet_GetChunkDetail(response: Response): Promise<GetLeafletChunkDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLeafletChunkDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLeafletChunkDetailResponse>(null as any);
    }

    leaflet_DeleteDocument(id: string): Promise<DeleteLeafletDocumentResponse> {
        let url_ = this.baseUrl + "/api/leaflet/documents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeaflet_DeleteDocument(_response);
        });
    }

    protected processLeaflet_DeleteDocument(response: Response): Promise<DeleteLeafletDocumentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteLeafletDocumentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteLeafletDocumentResponse>(null as any);
    }

    leaflet_UploadDocument(file: FileParameter | null | undefined): Promise<UploadLeafletResponse> {
        let url_ = this.baseUrl + "/api/leaflet/documents/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeaflet_UploadDocument(_response);
        });
    }

    protected processLeaflet_UploadDocument(response: Response): Promise<UploadLeafletResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadLeafletResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadLeafletResponse>(null as any);
    }

    leaflet_SubmitFeedback(request: SubmitLeafletFeedbackRequest): Promise<SubmitLeafletFeedbackResponse> {
        let url_ = this.baseUrl + "/api/leaflet/feedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeaflet_SubmitFeedback(_response);
        });
    }

    protected processLeaflet_SubmitFeedback(response: Response): Promise<SubmitLeafletFeedbackResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitLeafletFeedbackResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitLeafletFeedbackResponse>(null as any);
    }

    leaflet_GetFeedbackList(hasFeedback: boolean | null | undefined, userId: string | null | undefined, sortBy: string | undefined, sortDescending: boolean | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<GetLeafletFeedbackListResponse> {
        let url_ = this.baseUrl + "/api/leaflet/feedback/list?";
        if (hasFeedback !== undefined && hasFeedback !== null)
            url_ += "hasFeedback=" + encodeURIComponent("" + hasFeedback) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "sortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeaflet_GetFeedbackList(_response);
        });
    }

    protected processLeaflet_GetFeedbackList(response: Response): Promise<GetLeafletFeedbackListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLeafletFeedbackListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLeafletFeedbackListResponse>(null as any);
    }

    leaflet_GetGeneration(id: string): Promise<GetLeafletGenerationResponse> {
        let url_ = this.baseUrl + "/api/leaflet/generations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeaflet_GetGeneration(_response);
        });
    }

    protected processLeaflet_GetGeneration(response: Response): Promise<GetLeafletGenerationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLeafletGenerationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLeafletGenerationResponse>(null as any);
    }

    logistics_GetAvailableGiftPackages(salesCoefficient: number | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<GetAvailableGiftPackagesResponse> {
        let url_ = this.baseUrl + "/api/logistics/gift-packages/available?";
        if (salesCoefficient === null)
            throw new Error("The parameter 'salesCoefficient' cannot be null.");
        else if (salesCoefficient !== undefined)
            url_ += "salesCoefficient=" + encodeURIComponent("" + salesCoefficient) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogistics_GetAvailableGiftPackages(_response);
        });
    }

    protected processLogistics_GetAvailableGiftPackages(response: Response): Promise<GetAvailableGiftPackagesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAvailableGiftPackagesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAvailableGiftPackagesResponse>(null as any);
    }

    logistics_GetGiftPackageDetail(giftPackageCode: string, salesCoefficient: number | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<GetGiftPackageDetailResponse> {
        let url_ = this.baseUrl + "/api/logistics/gift-packages/{giftPackageCode}/detail?";
        if (giftPackageCode === undefined || giftPackageCode === null)
            throw new Error("The parameter 'giftPackageCode' must be defined.");
        url_ = url_.replace("{giftPackageCode}", encodeURIComponent("" + giftPackageCode));
        if (salesCoefficient === null)
            throw new Error("The parameter 'salesCoefficient' cannot be null.");
        else if (salesCoefficient !== undefined)
            url_ += "salesCoefficient=" + encodeURIComponent("" + salesCoefficient) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogistics_GetGiftPackageDetail(_response);
        });
    }

    protected processLogistics_GetGiftPackageDetail(response: Response): Promise<GetGiftPackageDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGiftPackageDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGiftPackageDetailResponse>(null as any);
    }

    logistics_CreateGiftPackageManufacture(request: CreateGiftPackageManufactureRequest): Promise<CreateGiftPackageManufactureResponse> {
        let url_ = this.baseUrl + "/api/logistics/gift-packages/manufacture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogistics_CreateGiftPackageManufacture(_response);
        });
    }

    protected processLogistics_CreateGiftPackageManufacture(response: Response): Promise<CreateGiftPackageManufactureResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateGiftPackageManufactureResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateGiftPackageManufactureResponse>(null as any);
    }

    logistics_DisassembleGiftPackage(request: DisassembleGiftPackageRequest): Promise<DisassembleGiftPackageResponse> {
        let url_ = this.baseUrl + "/api/logistics/gift-packages/disassemble";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogistics_DisassembleGiftPackage(_response);
        });
    }

    protected processLogistics_DisassembleGiftPackage(response: Response): Promise<DisassembleGiftPackageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisassembleGiftPackageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisassembleGiftPackageResponse>(null as any);
    }

    logistics_GetManufactureLog(count: number | undefined): Promise<GetManufactureLogResponse> {
        let url_ = this.baseUrl + "/api/logistics/gift-packages/manufacture-log?";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogistics_GetManufactureLog(_response);
        });
    }

    protected processLogistics_GetManufactureLog(response: Response): Promise<GetManufactureLogResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetManufactureLogResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetManufactureLogResponse>(null as any);
    }

    lots_GetLots(materialCode: string | null | undefined, expirationFrom: Date | null | undefined, expirationTo: Date | null | undefined, page: number | undefined, pageSize: number | undefined): Promise<ListLotsResponse> {
        let url_ = this.baseUrl + "/api/lots?";
        if (materialCode !== undefined && materialCode !== null)
            url_ += "materialCode=" + encodeURIComponent("" + materialCode) + "&";
        if (expirationFrom !== undefined && expirationFrom !== null)
            url_ += "expirationFrom=" + encodeURIComponent(expirationFrom ? "" + expirationFrom.toISOString() : "") + "&";
        if (expirationTo !== undefined && expirationTo !== null)
            url_ += "expirationTo=" + encodeURIComponent(expirationTo ? "" + expirationTo.toISOString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLots_GetLots(_response);
        });
    }

    protected processLots_GetLots(response: Response): Promise<ListLotsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListLotsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListLotsResponse>(null as any);
    }

    lots_CreateLot(request: CreateLotRequest): Promise<CreateLotResponse> {
        let url_ = this.baseUrl + "/api/lots";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLots_CreateLot(_response);
        });
    }

    protected processLots_CreateLot(response: Response): Promise<CreateLotResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateLotResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateLotResponse>(null as any);
    }

    lots_GetLotById(id: number): Promise<GetLotResponse> {
        let url_ = this.baseUrl + "/api/lots/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLots_GetLotById(_response);
        });
    }

    protected processLots_GetLotById(response: Response): Promise<GetLotResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLotResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLotResponse>(null as any);
    }

    lots_UpdateLot(id: number, request: UpdateLotRequest): Promise<UpdateLotResponse> {
        let url_ = this.baseUrl + "/api/lots/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLots_UpdateLot(_response);
        });
    }

    protected processLots_UpdateLot(response: Response): Promise<UpdateLotResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateLotResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateLotResponse>(null as any);
    }

    lots_DeleteLot(id: number): Promise<DeleteLotResponse> {
        let url_ = this.baseUrl + "/api/lots/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLots_DeleteLot(_response);
        });
    }

    protected processLots_DeleteLot(response: Response): Promise<DeleteLotResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteLotResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteLotResponse>(null as any);
    }

    lots_PrintLabels(request: PrintLotLabelsRequest): Promise<PrintLotLabelsResponse> {
        let url_ = this.baseUrl + "/api/lots/print-labels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLots_PrintLabels(_response);
        });
    }

    protected processLots_PrintLabels(response: Response): Promise<PrintLotLabelsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintLotLabelsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintLotLabelsResponse>(null as any);
    }

    lots_PrintCalibrationLabel(request: PrintLotCalibrationLabelRequest): Promise<PrintLotCalibrationLabelResponse> {
        let url_ = this.baseUrl + "/api/lots/print-calibration-label";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLots_PrintCalibrationLabel(_response);
        });
    }

    protected processLots_PrintCalibrationLabel(response: Response): Promise<PrintLotCalibrationLabelResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintLotCalibrationLabelResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintLotCalibrationLabelResponse>(null as any);
    }

    lots_FeedMedia(request: FeedLotMediaRequest): Promise<FeedLotMediaResponse> {
        let url_ = this.baseUrl + "/api/lots/feed-media";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLots_FeedMedia(_response);
        });
    }

    protected processLots_FeedMedia(response: Response): Promise<FeedLotMediaResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedLotMediaResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeedLotMediaResponse>(null as any);
    }

    lots_GetLabelCalibration(): Promise<GetLotLabelCalibrationResponse> {
        let url_ = this.baseUrl + "/api/lots/label-calibration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLots_GetLabelCalibration(_response);
        });
    }

    protected processLots_GetLabelCalibration(response: Response): Promise<GetLotLabelCalibrationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLotLabelCalibrationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLotLabelCalibrationResponse>(null as any);
    }

    lots_SetLabelCalibration(request: SetLotLabelCalibrationRequest): Promise<SetLotLabelCalibrationResponse> {
        let url_ = this.baseUrl + "/api/lots/label-calibration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLots_SetLabelCalibration(_response);
        });
    }

    protected processLots_SetLabelCalibration(response: Response): Promise<SetLotLabelCalibrationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetLotLabelCalibrationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetLotLabelCalibrationResponse>(null as any);
    }

    lots_NudgeLabelCalibration(request: NudgeLotLabelCalibrationRequest): Promise<NudgeLotLabelCalibrationResponse> {
        let url_ = this.baseUrl + "/api/lots/label-calibration/nudge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLots_NudgeLabelCalibration(_response);
        });
    }

    protected processLots_NudgeLabelCalibration(response: Response): Promise<NudgeLotLabelCalibrationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NudgeLotLabelCalibrationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NudgeLotLabelCalibrationResponse>(null as any);
    }

    manufactureBatch_GetBatchTemplate(productCode: string): Promise<CalculatedBatchSizeResponse> {
        let url_ = this.baseUrl + "/api/manufacture-batch/template/{productCode}";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureBatch_GetBatchTemplate(_response);
        });
    }

    protected processManufactureBatch_GetBatchTemplate(response: Response): Promise<CalculatedBatchSizeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculatedBatchSizeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculatedBatchSizeResponse>(null as any);
    }

    manufactureBatch_CalculateBatchBySize(request: CalculatedBatchSizeRequest): Promise<CalculatedBatchSizeResponse> {
        let url_ = this.baseUrl + "/api/manufacture-batch/calculate-by-size";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureBatch_CalculateBatchBySize(_response);
        });
    }

    protected processManufactureBatch_CalculateBatchBySize(response: Response): Promise<CalculatedBatchSizeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculatedBatchSizeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculatedBatchSizeResponse>(null as any);
    }

    manufactureBatch_CalculateBatchByIngredient(request: CalculateBatchByIngredientRequest): Promise<CalculateBatchByIngredientResponse> {
        let url_ = this.baseUrl + "/api/manufacture-batch/calculate-by-ingredient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureBatch_CalculateBatchByIngredient(_response);
        });
    }

    protected processManufactureBatch_CalculateBatchByIngredient(response: Response): Promise<CalculateBatchByIngredientResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateBatchByIngredientResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculateBatchByIngredientResponse>(null as any);
    }

    manufactureBatch_CalculateBatchPlan(request: CalculateBatchPlanRequest): Promise<CalculateBatchPlanResponse> {
        let url_ = this.baseUrl + "/api/manufacture-batch/calculate-batch-plan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureBatch_CalculateBatchPlan(_response);
        });
    }

    protected processManufactureBatch_CalculateBatchPlan(response: Response): Promise<CalculateBatchPlanResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateBatchPlanResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculateBatchPlanResponse>(null as any);
    }

    manufactureBatch_GetRecipePdf(productCode: string, batchSize: number | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/manufacture-batch/recipe-pdf/{productCode}?";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        if (batchSize !== undefined && batchSize !== null)
            url_ += "batchSize=" + encodeURIComponent("" + batchSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureBatch_GetRecipePdf(_response);
        });
    }

    protected processManufactureBatch_GetRecipePdf(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    manufacturedProductInventory_GetInventory(search: string | null | undefined, onlyWithStock: boolean | undefined, manufactureOrderId: number | null | undefined, page: number | undefined, pageSize: number | undefined): Promise<GetManufacturedInventoryResponse> {
        let url_ = this.baseUrl + "/api/manufactured-inventory?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (onlyWithStock === null)
            throw new Error("The parameter 'onlyWithStock' cannot be null.");
        else if (onlyWithStock !== undefined)
            url_ += "OnlyWithStock=" + encodeURIComponent("" + onlyWithStock) + "&";
        if (manufactureOrderId !== undefined && manufactureOrderId !== null)
            url_ += "ManufactureOrderId=" + encodeURIComponent("" + manufactureOrderId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufacturedProductInventory_GetInventory(_response);
        });
    }

    protected processManufacturedProductInventory_GetInventory(response: Response): Promise<GetManufacturedInventoryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetManufacturedInventoryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetManufacturedInventoryResponse>(null as any);
    }

    manufacturedProductInventory_CreateItem(request: CreateManufacturedInventoryItemRequest): Promise<CreateManufacturedInventoryItemResponse> {
        let url_ = this.baseUrl + "/api/manufactured-inventory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufacturedProductInventory_CreateItem(_response);
        });
    }

    protected processManufacturedProductInventory_CreateItem(response: Response): Promise<CreateManufacturedInventoryItemResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateManufacturedInventoryItemResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateManufacturedInventoryItemResponse>(null as any);
    }

    manufacturedProductInventory_UpdateItem(id: number, body: UpdateManufacturedInventoryItemBody): Promise<UpdateManufacturedInventoryItemResponse> {
        let url_ = this.baseUrl + "/api/manufactured-inventory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufacturedProductInventory_UpdateItem(_response);
        });
    }

    protected processManufacturedProductInventory_UpdateItem(response: Response): Promise<UpdateManufacturedInventoryItemResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateManufacturedInventoryItemResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateManufacturedInventoryItemResponse>(null as any);
    }

    manufacturedProductInventory_DeleteItem(id: number, note: string | null | undefined): Promise<DeleteManufacturedInventoryItemResponse> {
        let url_ = this.baseUrl + "/api/manufactured-inventory/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (note !== undefined && note !== null)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufacturedProductInventory_DeleteItem(_response);
        });
    }

    protected processManufacturedProductInventory_DeleteItem(response: Response): Promise<DeleteManufacturedInventoryItemResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteManufacturedInventoryItemResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteManufacturedInventoryItemResponse>(null as any);
    }

    manufactureOrder_GetOrders(state: ManufactureOrderState | null | undefined, dateFrom: Date | null | undefined, dateTo: Date | null | undefined, responsiblePerson: string | null | undefined, orderNumber: string | null | undefined, productCode: string | null | undefined, erpDocumentNumber: string | null | undefined, manualActionRequired: boolean | null | undefined, lotNumber: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<GetManufactureOrdersResponse> {
        let url_ = this.baseUrl + "/api/ManufactureOrder?";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (responsiblePerson !== undefined && responsiblePerson !== null)
            url_ += "ResponsiblePerson=" + encodeURIComponent("" + responsiblePerson) + "&";
        if (orderNumber !== undefined && orderNumber !== null)
            url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&";
        if (productCode !== undefined && productCode !== null)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        if (erpDocumentNumber !== undefined && erpDocumentNumber !== null)
            url_ += "ErpDocumentNumber=" + encodeURIComponent("" + erpDocumentNumber) + "&";
        if (manualActionRequired !== undefined && manualActionRequired !== null)
            url_ += "ManualActionRequired=" + encodeURIComponent("" + manualActionRequired) + "&";
        if (lotNumber !== undefined && lotNumber !== null)
            url_ += "LotNumber=" + encodeURIComponent("" + lotNumber) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureOrder_GetOrders(_response);
        });
    }

    protected processManufactureOrder_GetOrders(response: Response): Promise<GetManufactureOrdersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetManufactureOrdersResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetManufactureOrdersResponse>(null as any);
    }

    manufactureOrder_CreateOrder(request: CreateManufactureOrderRequest): Promise<CreateManufactureOrderResponse> {
        let url_ = this.baseUrl + "/api/ManufactureOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureOrder_CreateOrder(_response);
        });
    }

    protected processManufactureOrder_CreateOrder(response: Response): Promise<CreateManufactureOrderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateManufactureOrderResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateManufactureOrderResponse>(null as any);
    }

    manufactureOrder_GetOrder(id: number): Promise<GetManufactureOrderResponse> {
        let url_ = this.baseUrl + "/api/ManufactureOrder/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureOrder_GetOrder(_response);
        });
    }

    protected processManufactureOrder_GetOrder(response: Response): Promise<GetManufactureOrderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetManufactureOrderResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetManufactureOrderResponse>(null as any);
    }

    manufactureOrder_UpdateOrder(id: number, request: UpdateManufactureOrderRequest): Promise<UpdateManufactureOrderResponse> {
        let url_ = this.baseUrl + "/api/ManufactureOrder/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureOrder_UpdateOrder(_response);
        });
    }

    protected processManufactureOrder_UpdateOrder(response: Response): Promise<UpdateManufactureOrderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateManufactureOrderResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateManufactureOrderResponse>(null as any);
    }

    manufactureOrder_UpdateOrderStatus(id: number, request: UpdateManufactureOrderStatusRequest): Promise<UpdateManufactureOrderStatusResponse> {
        let url_ = this.baseUrl + "/api/ManufactureOrder/{id}/status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureOrder_UpdateOrderStatus(_response);
        });
    }

    protected processManufactureOrder_UpdateOrderStatus(response: Response): Promise<UpdateManufactureOrderStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateManufactureOrderStatusResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateManufactureOrderStatusResponse>(null as any);
    }

    manufactureOrder_ConfirmSemiProductManufacture(id: number, request: ConfirmSemiProductManufactureRequest): Promise<ConfirmSemiProductManufactureResponse> {
        let url_ = this.baseUrl + "/api/ManufactureOrder/{id}/confirm-semi-product";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureOrder_ConfirmSemiProductManufacture(_response);
        });
    }

    protected processManufactureOrder_ConfirmSemiProductManufacture(response: Response): Promise<ConfirmSemiProductManufactureResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmSemiProductManufactureResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmSemiProductManufactureResponse>(null as any);
    }

    manufactureOrder_ConfirmProductCompletion(id: number, request: ConfirmProductCompletionRequest): Promise<ConfirmProductCompletionResponse> {
        let url_ = this.baseUrl + "/api/ManufactureOrder/{id}/confirm-products";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureOrder_ConfirmProductCompletion(_response);
        });
    }

    protected processManufactureOrder_ConfirmProductCompletion(response: Response): Promise<ConfirmProductCompletionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmProductCompletionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmProductCompletionResponse>(null as any);
    }

    manufactureOrder_GetCalendarView(startDate: Date | undefined, endDate: Date | undefined): Promise<GetCalendarViewResponse> {
        let url_ = this.baseUrl + "/api/ManufactureOrder/calendar?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureOrder_GetCalendarView(_response);
        });
    }

    protected processManufactureOrder_GetCalendarView(response: Response): Promise<GetCalendarViewResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCalendarViewResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCalendarViewResponse>(null as any);
    }

    manufactureOrder_DuplicateOrder(id: number): Promise<DuplicateManufactureOrderResponse> {
        let url_ = this.baseUrl + "/api/ManufactureOrder/{id}/duplicate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureOrder_DuplicateOrder(_response);
        });
    }

    protected processManufactureOrder_DuplicateOrder(response: Response): Promise<DuplicateManufactureOrderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DuplicateManufactureOrderResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DuplicateManufactureOrderResponse>(null as any);
    }

    manufactureOrder_ResolveManualAction(id: number, request: ResolveManualActionRequest): Promise<ResolveManualActionResponse> {
        let url_ = this.baseUrl + "/api/ManufactureOrder/{id}/resolve-manual-action";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureOrder_ResolveManualAction(_response);
        });
    }

    protected processManufactureOrder_ResolveManualAction(response: Response): Promise<ResolveManualActionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResolveManualActionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResolveManualActionResponse>(null as any);
    }

    manufactureOrder_GetProtocolPdf(id: number): Promise<GetManufactureProtocolResponse> {
        let url_ = this.baseUrl + "/api/ManufactureOrder/{id}/protocol.pdf";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureOrder_GetProtocolPdf(_response);
        });
    }

    protected processManufactureOrder_GetProtocolPdf(response: Response): Promise<GetManufactureProtocolResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetManufactureProtocolResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetManufactureProtocolResponse>(null as any);
    }

    manufactureOrder_UpdateOrderSchedule(id: number, request: UpdateManufactureOrderScheduleRequest): Promise<UpdateManufactureOrderScheduleResponse> {
        let url_ = this.baseUrl + "/api/ManufactureOrder/{id}/schedule";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureOrder_UpdateOrderSchedule(_response);
        });
    }

    protected processManufactureOrder_UpdateOrderSchedule(response: Response): Promise<UpdateManufactureOrderScheduleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateManufactureOrderScheduleResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateManufactureOrderScheduleResponse>(null as any);
    }

    manufactureOutput_GetManufactureOutput(monthsBack: number | undefined): Promise<GetManufactureOutputResponse> {
        let url_ = this.baseUrl + "/api/manufacture-output?";
        if (monthsBack === null)
            throw new Error("The parameter 'monthsBack' cannot be null.");
        else if (monthsBack !== undefined)
            url_ += "monthsBack=" + encodeURIComponent("" + monthsBack) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureOutput_GetManufactureOutput(_response);
        });
    }

    protected processManufactureOutput_GetManufactureOutput(response: Response): Promise<GetManufactureOutputResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetManufactureOutputResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetManufactureOutputResponse>(null as any);
    }

    manufactureSettings_GetSettings(): Promise<GetManufactureSettingsResponse> {
        let url_ = this.baseUrl + "/api/manufacture/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureSettings_GetSettings(_response);
        });
    }

    protected processManufactureSettings_GetSettings(response: Response): Promise<GetManufactureSettingsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetManufactureSettingsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetManufactureSettingsResponse>(null as any);
    }

    manufactureStockTaking_SubmitManufactureStockTaking(request: SubmitManufactureStockTakingRequest): Promise<SubmitManufactureStockTakingResponse> {
        let url_ = this.baseUrl + "/api/ManufactureStockTaking/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureStockTaking_SubmitManufactureStockTaking(_response);
        });
    }

    protected processManufactureStockTaking_SubmitManufactureStockTaking(response: Response): Promise<SubmitManufactureStockTakingResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitManufactureStockTakingResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitManufactureStockTakingResponse>(null as any);
    }

    manufactureStockTaking_GetManufactureStockTakingHistory(productCode: string | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDescending: boolean | undefined): Promise<GetManufactureStockTakingHistoryResponse> {
        let url_ = this.baseUrl + "/api/ManufactureStockTaking/history?";
        if (productCode === null)
            throw new Error("The parameter 'productCode' cannot be null.");
        else if (productCode !== undefined)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufactureStockTaking_GetManufactureStockTakingHistory(_response);
        });
    }

    protected processManufactureStockTaking_GetManufactureStockTakingHistory(response: Response): Promise<GetManufactureStockTakingHistoryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetManufactureStockTakingHistoryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetManufactureStockTakingHistoryResponse>(null as any);
    }

    manufacturingStockAnalysis_GetStockAnalysis(timePeriod: TimePeriod | undefined, customFromDate: Date | null | undefined, customToDate: Date | null | undefined, productFamily: string | null | undefined, criticalItemsOnly: boolean | undefined, majorItemsOnly: boolean | undefined, adequateItemsOnly: boolean | undefined, unconfiguredOnly: boolean | undefined, searchTerm: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: ManufacturingStockSortBy | undefined, sortDescending: boolean | undefined, salesMultiplier: number | undefined, isExport: boolean | undefined): Promise<GetManufacturingStockAnalysisResponse> {
        let url_ = this.baseUrl + "/api/manufacturing-stock-analysis?";
        if (timePeriod === null)
            throw new Error("The parameter 'timePeriod' cannot be null.");
        else if (timePeriod !== undefined)
            url_ += "TimePeriod=" + encodeURIComponent("" + timePeriod) + "&";
        if (customFromDate !== undefined && customFromDate !== null)
            url_ += "CustomFromDate=" + encodeURIComponent(customFromDate ? "" + customFromDate.toISOString() : "") + "&";
        if (customToDate !== undefined && customToDate !== null)
            url_ += "CustomToDate=" + encodeURIComponent(customToDate ? "" + customToDate.toISOString() : "") + "&";
        if (productFamily !== undefined && productFamily !== null)
            url_ += "ProductFamily=" + encodeURIComponent("" + productFamily) + "&";
        if (criticalItemsOnly === null)
            throw new Error("The parameter 'criticalItemsOnly' cannot be null.");
        else if (criticalItemsOnly !== undefined)
            url_ += "CriticalItemsOnly=" + encodeURIComponent("" + criticalItemsOnly) + "&";
        if (majorItemsOnly === null)
            throw new Error("The parameter 'majorItemsOnly' cannot be null.");
        else if (majorItemsOnly !== undefined)
            url_ += "MajorItemsOnly=" + encodeURIComponent("" + majorItemsOnly) + "&";
        if (adequateItemsOnly === null)
            throw new Error("The parameter 'adequateItemsOnly' cannot be null.");
        else if (adequateItemsOnly !== undefined)
            url_ += "AdequateItemsOnly=" + encodeURIComponent("" + adequateItemsOnly) + "&";
        if (unconfiguredOnly === null)
            throw new Error("The parameter 'unconfiguredOnly' cannot be null.");
        else if (unconfiguredOnly !== undefined)
            url_ += "UnconfiguredOnly=" + encodeURIComponent("" + unconfiguredOnly) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        if (salesMultiplier === null)
            throw new Error("The parameter 'salesMultiplier' cannot be null.");
        else if (salesMultiplier !== undefined)
            url_ += "SalesMultiplier=" + encodeURIComponent("" + salesMultiplier) + "&";
        if (isExport === null)
            throw new Error("The parameter 'isExport' cannot be null.");
        else if (isExport !== undefined)
            url_ += "IsExport=" + encodeURIComponent("" + isExport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processManufacturingStockAnalysis_GetStockAnalysis(_response);
        });
    }

    protected processManufacturingStockAnalysis_GetStockAnalysis(response: Response): Promise<GetManufacturingStockAnalysisResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetManufacturingStockAnalysisResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetManufacturingStockAnalysisResponse>(null as any);
    }

    marketingAdsActivity_ListAuditEvents(proposalId: number | null | undefined, eventType: AdAuditEventType | null | undefined, page: number | undefined, pageSize: number | undefined): Promise<ListAdAuditEventsResponse> {
        let url_ = this.baseUrl + "/api/marketing-ads/activity/audit?";
        if (proposalId !== undefined && proposalId !== null)
            url_ += "ProposalId=" + encodeURIComponent("" + proposalId) + "&";
        if (eventType !== undefined && eventType !== null)
            url_ += "EventType=" + encodeURIComponent("" + eventType) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingAdsActivity_ListAuditEvents(_response);
        });
    }

    protected processMarketingAdsActivity_ListAuditEvents(response: Response): Promise<ListAdAuditEventsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListAdAuditEventsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListAdAuditEventsResponse>(null as any);
    }

    marketingAdsActivity_ListAgentRuns(page: number | undefined, pageSize: number | undefined): Promise<ListAgentRunsResponse> {
        let url_ = this.baseUrl + "/api/marketing-ads/activity/agent-runs?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingAdsActivity_ListAgentRuns(_response);
        });
    }

    protected processMarketingAdsActivity_ListAgentRuns(response: Response): Promise<ListAgentRunsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListAgentRunsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListAgentRunsResponse>(null as any);
    }

    marketingAdsActivity_ListChangeEvents(platform: AdPlatform | null | undefined, accountExternalId: string | null | undefined, origin: AdChangeOrigin | null | undefined, actorKind: AdChangeActorKind | null | undefined, from: Date | null | undefined, to: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<GetAdChangeHistoryResponse> {
        let url_ = this.baseUrl + "/api/marketing-ads/activity/change-events?";
        if (platform !== undefined && platform !== null)
            url_ += "Platform=" + encodeURIComponent("" + platform) + "&";
        if (accountExternalId !== undefined && accountExternalId !== null)
            url_ += "AccountExternalId=" + encodeURIComponent("" + accountExternalId) + "&";
        if (origin !== undefined && origin !== null)
            url_ += "Origin=" + encodeURIComponent("" + origin) + "&";
        if (actorKind !== undefined && actorKind !== null)
            url_ += "ActorKind=" + encodeURIComponent("" + actorKind) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingAdsActivity_ListChangeEvents(_response);
        });
    }

    protected processMarketingAdsActivity_ListChangeEvents(response: Response): Promise<GetAdChangeHistoryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdChangeHistoryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = GetAdChangeHistoryResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = GetAdChangeHistoryResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAdChangeHistoryResponse>(null as any);
    }

    marketingAdsProposals_ListProposals(status: AdProposalStatus | null | undefined, platform: AdPlatform | null | undefined, mine: boolean | undefined, page: number | undefined, pageSize: number | undefined, oldestFirst: boolean | undefined): Promise<ListAdProposalsResponse> {
        let url_ = this.baseUrl + "/api/marketing-ads/proposals?";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (platform !== undefined && platform !== null)
            url_ += "Platform=" + encodeURIComponent("" + platform) + "&";
        if (mine === null)
            throw new Error("The parameter 'mine' cannot be null.");
        else if (mine !== undefined)
            url_ += "Mine=" + encodeURIComponent("" + mine) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (oldestFirst === null)
            throw new Error("The parameter 'oldestFirst' cannot be null.");
        else if (oldestFirst !== undefined)
            url_ += "OldestFirst=" + encodeURIComponent("" + oldestFirst) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingAdsProposals_ListProposals(_response);
        });
    }

    protected processMarketingAdsProposals_ListProposals(response: Response): Promise<ListAdProposalsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListAdProposalsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListAdProposalsResponse>(null as any);
    }

    marketingAdsProposals_SubmitProposal(request: SubmitAdProposalRequest): Promise<SubmitAdProposalResponse> {
        let url_ = this.baseUrl + "/api/marketing-ads/proposals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingAdsProposals_SubmitProposal(_response);
        });
    }

    protected processMarketingAdsProposals_SubmitProposal(response: Response): Promise<SubmitAdProposalResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitAdProposalResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = SubmitAdProposalResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = SubmitAdProposalResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = SubmitAdProposalResponse.fromJS(resultData422);
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitAdProposalResponse>(null as any);
    }

    marketingAdsProposals_GetProposal(id: number): Promise<GetAdProposalResponse> {
        let url_ = this.baseUrl + "/api/marketing-ads/proposals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingAdsProposals_GetProposal(_response);
        });
    }

    protected processMarketingAdsProposals_GetProposal(response: Response): Promise<GetAdProposalResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdProposalResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = GetAdProposalResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAdProposalResponse>(null as any);
    }

    marketingAdsProposals_ReviseProposal(id: number, request: ReviseAdProposalRequest): Promise<ReviseAdProposalResponse> {
        let url_ = this.baseUrl + "/api/marketing-ads/proposals/{id}/revisions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingAdsProposals_ReviseProposal(_response);
        });
    }

    protected processMarketingAdsProposals_ReviseProposal(response: Response): Promise<ReviseAdProposalResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReviseAdProposalResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ReviseAdProposalResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ReviseAdProposalResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ReviseAdProposalResponse.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ReviseAdProposalResponse.fromJS(resultData422);
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ReviseAdProposalResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReviseAdProposalResponse>(null as any);
    }

    marketingAdsProposals_ApproveProposal(id: number, request: ApproveAdProposalRequest): Promise<ApproveAdProposalResponse> {
        let url_ = this.baseUrl + "/api/marketing-ads/proposals/{id}/approve";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingAdsProposals_ApproveProposal(_response);
        });
    }

    protected processMarketingAdsProposals_ApproveProposal(response: Response): Promise<ApproveAdProposalResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApproveAdProposalResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApproveAdProposalResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ApproveAdProposalResponse.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ApproveAdProposalResponse.fromJS(resultData422);
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ApproveAdProposalResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApproveAdProposalResponse>(null as any);
    }

    marketingAdsProposals_RejectProposal(id: number, request: RejectAdProposalRequest): Promise<RejectAdProposalResponse> {
        let url_ = this.baseUrl + "/api/marketing-ads/proposals/{id}/reject";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingAdsProposals_RejectProposal(_response);
        });
    }

    protected processMarketingAdsProposals_RejectProposal(response: Response): Promise<RejectAdProposalResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RejectAdProposalResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RejectAdProposalResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RejectAdProposalResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = RejectAdProposalResponse.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RejectAdProposalResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RejectAdProposalResponse>(null as any);
    }

    marketingAdsProposals_RevertProposal(id: number): Promise<RevertAdProposalResponse> {
        let url_ = this.baseUrl + "/api/marketing-ads/proposals/{id}/revert";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingAdsProposals_RevertProposal(_response);
        });
    }

    protected processMarketingAdsProposals_RevertProposal(response: Response): Promise<RevertAdProposalResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevertAdProposalResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RevertAdProposalResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = RevertAdProposalResponse.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 502) {
            return response.text().then((_responseText) => {
            let result502: any = null;
            let resultData502 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result502 = RevertAdProposalResponse.fromJS(resultData502);
            return throwException("A server side error occurred.", status, _responseText, _headers, result502);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RevertAdProposalResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RevertAdProposalResponse>(null as any);
    }

    marketingAdsSettings_GetSettings(): Promise<GetAdSettingsResponse> {
        let url_ = this.baseUrl + "/api/marketing-ads/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingAdsSettings_GetSettings(_response);
        });
    }

    protected processMarketingAdsSettings_GetSettings(response: Response): Promise<GetAdSettingsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdSettingsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAdSettingsResponse>(null as any);
    }

    marketingAdsSettings_UpdateAutonomy(request: UpdateAdAutonomySettingRequest): Promise<UpdateAdAutonomySettingResponse> {
        let url_ = this.baseUrl + "/api/marketing-ads/settings/autonomy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingAdsSettings_UpdateAutonomy(_response);
        });
    }

    protected processMarketingAdsSettings_UpdateAutonomy(response: Response): Promise<UpdateAdAutonomySettingResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAdAutonomySettingResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdateAdAutonomySettingResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = UpdateAdAutonomySettingResponse.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = UpdateAdAutonomySettingResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateAdAutonomySettingResponse>(null as any);
    }

    marketingAdsSettings_UpdateLimit(request: UpdateAdLimitSettingRequest): Promise<UpdateAdLimitSettingResponse> {
        let url_ = this.baseUrl + "/api/marketing-ads/settings/limits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingAdsSettings_UpdateLimit(_response);
        });
    }

    protected processMarketingAdsSettings_UpdateLimit(response: Response): Promise<UpdateAdLimitSettingResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAdLimitSettingResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdateAdLimitSettingResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = UpdateAdLimitSettingResponse.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = UpdateAdLimitSettingResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateAdLimitSettingResponse>(null as any);
    }

    marketingAdsSettings_SetKillSwitch(request: SetAdKillSwitchRequest): Promise<SetAdKillSwitchResponse> {
        let url_ = this.baseUrl + "/api/marketing-ads/settings/kill-switch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingAdsSettings_SetKillSwitch(_response);
        });
    }

    protected processMarketingAdsSettings_SetKillSwitch(response: Response): Promise<SetAdKillSwitchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetAdKillSwitchResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = SetAdKillSwitchResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = SetAdKillSwitchResponse.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = SetAdKillSwitchResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetAdKillSwitchResponse>(null as any);
    }

    marketingCalendar_GetMarketingActions(pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined, actionType: MarketingActionType | null | undefined, productCodePrefix: string | null | undefined, startDateFrom: Date | null | undefined, startDateTo: Date | null | undefined, endDateFrom: Date | null | undefined, endDateTo: Date | null | undefined, includeDeleted: boolean | undefined): Promise<GetMarketingActionsResponse> {
        let url_ = this.baseUrl + "/api/MarketingCalendar?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (actionType !== undefined && actionType !== null)
            url_ += "ActionType=" + encodeURIComponent("" + actionType) + "&";
        if (productCodePrefix !== undefined && productCodePrefix !== null)
            url_ += "ProductCodePrefix=" + encodeURIComponent("" + productCodePrefix) + "&";
        if (startDateFrom !== undefined && startDateFrom !== null)
            url_ += "StartDateFrom=" + encodeURIComponent(startDateFrom ? "" + startDateFrom.toISOString() : "") + "&";
        if (startDateTo !== undefined && startDateTo !== null)
            url_ += "StartDateTo=" + encodeURIComponent(startDateTo ? "" + startDateTo.toISOString() : "") + "&";
        if (endDateFrom !== undefined && endDateFrom !== null)
            url_ += "EndDateFrom=" + encodeURIComponent(endDateFrom ? "" + endDateFrom.toISOString() : "") + "&";
        if (endDateTo !== undefined && endDateTo !== null)
            url_ += "EndDateTo=" + encodeURIComponent(endDateTo ? "" + endDateTo.toISOString() : "") + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingCalendar_GetMarketingActions(_response);
        });
    }

    protected processMarketingCalendar_GetMarketingActions(response: Response): Promise<GetMarketingActionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMarketingActionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMarketingActionsResponse>(null as any);
    }

    marketingCalendar_CreateMarketingAction(request: CreateMarketingActionRequest): Promise<CreateMarketingActionResponse> {
        let url_ = this.baseUrl + "/api/MarketingCalendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingCalendar_CreateMarketingAction(_response);
        });
    }

    protected processMarketingCalendar_CreateMarketingAction(response: Response): Promise<CreateMarketingActionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateMarketingActionResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateMarketingActionResponse>(null as any);
    }

    marketingCalendar_GetMarketingAction(id: number): Promise<GetMarketingActionResponse> {
        let url_ = this.baseUrl + "/api/MarketingCalendar/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingCalendar_GetMarketingAction(_response);
        });
    }

    protected processMarketingCalendar_GetMarketingAction(response: Response): Promise<GetMarketingActionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMarketingActionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMarketingActionResponse>(null as any);
    }

    marketingCalendar_UpdateMarketingAction(id: number, request: UpdateMarketingActionRequest): Promise<UpdateMarketingActionResponse> {
        let url_ = this.baseUrl + "/api/MarketingCalendar/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingCalendar_UpdateMarketingAction(_response);
        });
    }

    protected processMarketingCalendar_UpdateMarketingAction(response: Response): Promise<UpdateMarketingActionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateMarketingActionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateMarketingActionResponse>(null as any);
    }

    marketingCalendar_DeleteMarketingAction(id: number): Promise<DeleteMarketingActionResponse> {
        let url_ = this.baseUrl + "/api/MarketingCalendar/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingCalendar_DeleteMarketingAction(_response);
        });
    }

    protected processMarketingCalendar_DeleteMarketingAction(response: Response): Promise<DeleteMarketingActionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteMarketingActionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteMarketingActionResponse>(null as any);
    }

    marketingCalendar_GetCalendar(startDate: Date | undefined, endDate: Date | undefined): Promise<GetMarketingCalendarResponse> {
        let url_ = this.baseUrl + "/api/MarketingCalendar/calendar?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingCalendar_GetCalendar(_response);
        });
    }

    protected processMarketingCalendar_GetCalendar(response: Response): Promise<GetMarketingCalendarResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMarketingCalendarResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMarketingCalendarResponse>(null as any);
    }

    marketingCalendar_MoveMarketingAction(id: number, request: MoveMarketingActionRequest): Promise<MoveMarketingActionResponse> {
        let url_ = this.baseUrl + "/api/MarketingCalendar/{id}/move";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingCalendar_MoveMarketingAction(_response);
        });
    }

    protected processMarketingCalendar_MoveMarketingAction(response: Response): Promise<MoveMarketingActionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveMarketingActionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MoveMarketingActionResponse>(null as any);
    }

    marketingCalendar_ImportFromOutlook(request: ImportFromOutlookRequest): Promise<ImportFromOutlookResponse> {
        let url_ = this.baseUrl + "/api/MarketingCalendar/import-from-outlook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingCalendar_ImportFromOutlook(_response);
        });
    }

    protected processMarketingCalendar_ImportFromOutlook(response: Response): Promise<ImportFromOutlookResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportFromOutlookResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportFromOutlookResponse>(null as any);
    }

    marketingPerformance_GetMonths(from: string | null | undefined, to: string | null | undefined, includeWholesale: boolean | undefined): Promise<GetMarketingPerformanceMonthsResponse> {
        let url_ = this.baseUrl + "/api/MarketingPerformance/months?";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (includeWholesale === null)
            throw new Error("The parameter 'includeWholesale' cannot be null.");
        else if (includeWholesale !== undefined)
            url_ += "includeWholesale=" + encodeURIComponent("" + includeWholesale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingPerformance_GetMonths(_response);
        });
    }

    protected processMarketingPerformance_GetMonths(response: Response): Promise<GetMarketingPerformanceMonthsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMarketingPerformanceMonthsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = GetMarketingPerformanceMonthsResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMarketingPerformanceMonthsResponse>(null as any);
    }

    marketingPerformance_GetComparison(years: number | undefined, includeWholesale: boolean | undefined): Promise<GetMarketingPerformanceComparisonResponse> {
        let url_ = this.baseUrl + "/api/MarketingPerformance/comparison?";
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            url_ += "years=" + encodeURIComponent("" + years) + "&";
        if (includeWholesale === null)
            throw new Error("The parameter 'includeWholesale' cannot be null.");
        else if (includeWholesale !== undefined)
            url_ += "includeWholesale=" + encodeURIComponent("" + includeWholesale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingPerformance_GetComparison(_response);
        });
    }

    protected processMarketingPerformance_GetComparison(response: Response): Promise<GetMarketingPerformanceComparisonResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMarketingPerformanceComparisonResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMarketingPerformanceComparisonResponse>(null as any);
    }

    marketingPerformance_Recompute(request: RecomputeMarketingPerformanceRequest): Promise<RecomputeMarketingPerformanceResponse> {
        let url_ = this.baseUrl + "/api/MarketingPerformance/recompute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketingPerformance_Recompute(_response);
        });
    }

    protected processMarketingPerformance_Recompute(response: Response): Promise<RecomputeMarketingPerformanceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = RecomputeMarketingPerformanceResponse.fromJS(resultData202);
            return result202;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RecomputeMarketingPerformanceResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = RecomputeMarketingPerformanceResponse.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RecomputeMarketingPerformanceResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecomputeMarketingPerformanceResponse>(null as any);
    }

    materialContainers_GetMaterialContainers(materialCode: string | null | undefined, lotCode: string | null | undefined, code: string | null | undefined, page: number | undefined, pageSize: number | undefined): Promise<ListMaterialContainersResponse> {
        let url_ = this.baseUrl + "/api/material-containers?";
        if (materialCode !== undefined && materialCode !== null)
            url_ += "materialCode=" + encodeURIComponent("" + materialCode) + "&";
        if (lotCode !== undefined && lotCode !== null)
            url_ += "lotCode=" + encodeURIComponent("" + lotCode) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaterialContainers_GetMaterialContainers(_response);
        });
    }

    protected processMaterialContainers_GetMaterialContainers(response: Response): Promise<ListMaterialContainersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListMaterialContainersResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListMaterialContainersResponse>(null as any);
    }

    materialContainers_Create(request: CreateMaterialContainersRequest): Promise<CreateMaterialContainersResponse> {
        let url_ = this.baseUrl + "/api/material-containers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaterialContainers_Create(_response);
        });
    }

    protected processMaterialContainers_Create(response: Response): Promise<CreateMaterialContainersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateMaterialContainersResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateMaterialContainersResponse>(null as any);
    }

    materialContainers_GetLastUsedLot(materialCode: string | undefined): Promise<GetLastUsedLotForMaterialResponse> {
        let url_ = this.baseUrl + "/api/material-containers/last-used-lot?";
        if (materialCode === null)
            throw new Error("The parameter 'materialCode' cannot be null.");
        else if (materialCode !== undefined)
            url_ += "materialCode=" + encodeURIComponent("" + materialCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaterialContainers_GetLastUsedLot(_response);
        });
    }

    protected processMaterialContainers_GetLastUsedLot(response: Response): Promise<GetLastUsedLotForMaterialResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLastUsedLotForMaterialResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLastUsedLotForMaterialResponse>(null as any);
    }

    materialContainers_GetByCode(code: string): Promise<GetMaterialContainerByCodeResponse> {
        let url_ = this.baseUrl + "/api/material-containers/by-code/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaterialContainers_GetByCode(_response);
        });
    }

    protected processMaterialContainers_GetByCode(response: Response): Promise<GetMaterialContainerByCodeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMaterialContainerByCodeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMaterialContainerByCodeResponse>(null as any);
    }

    materialContainers_Discard(id: number): Promise<DiscardMaterialContainerResponse> {
        let url_ = this.baseUrl + "/api/material-containers/{id}/discard";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaterialContainers_Discard(_response);
        });
    }

    protected processMaterialContainers_Discard(response: Response): Promise<DiscardMaterialContainerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscardMaterialContainerResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscardMaterialContainerResponse>(null as any);
    }

    materialContainers_PrintLabels(request: PrintMaterialContainerLabelsRequest): Promise<PrintMaterialContainerLabelsResponse> {
        let url_ = this.baseUrl + "/api/material-containers/print-labels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaterialContainers_PrintLabels(_response);
        });
    }

    protected processMaterialContainers_PrintLabels(response: Response): Promise<PrintMaterialContainerLabelsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintMaterialContainerLabelsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintMaterialContainerLabelsResponse>(null as any);
    }

    meetingTasks_List(statusFilter: string | null | undefined, searchText: string | null | undefined, searchInTranscript: boolean | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<GetTranscriptListResponse> {
        let url_ = this.baseUrl + "/api/meeting-tasks?";
        if (statusFilter !== undefined && statusFilter !== null)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (searchInTranscript === null)
            throw new Error("The parameter 'searchInTranscript' cannot be null.");
        else if (searchInTranscript !== undefined)
            url_ += "SearchInTranscript=" + encodeURIComponent("" + searchInTranscript) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMeetingTasks_List(_response);
        });
    }

    protected processMeetingTasks_List(response: Response): Promise<GetTranscriptListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTranscriptListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTranscriptListResponse>(null as any);
    }

    meetingTasks_Users(): Promise<GetMeetingUsersResponse> {
        let url_ = this.baseUrl + "/api/meeting-tasks/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMeetingTasks_Users(_response);
        });
    }

    protected processMeetingTasks_Users(response: Response): Promise<GetMeetingUsersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeetingUsersResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMeetingUsersResponse>(null as any);
    }

    meetingTasks_Detail(id: string): Promise<GetTranscriptDetailResponse> {
        let url_ = this.baseUrl + "/api/meeting-tasks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMeetingTasks_Detail(_response);
        });
    }

    protected processMeetingTasks_Detail(response: Response): Promise<GetTranscriptDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTranscriptDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTranscriptDetailResponse>(null as any);
    }

    meetingTasks_UpdateTask(transcriptId: string, taskId: string, request: UpdateProposedTaskRequest): Promise<UpdateProposedTaskResponse> {
        let url_ = this.baseUrl + "/api/meeting-tasks/{transcriptId}/tasks/{taskId}";
        if (transcriptId === undefined || transcriptId === null)
            throw new Error("The parameter 'transcriptId' must be defined.");
        url_ = url_.replace("{transcriptId}", encodeURIComponent("" + transcriptId));
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMeetingTasks_UpdateTask(_response);
        });
    }

    protected processMeetingTasks_UpdateTask(response: Response): Promise<UpdateProposedTaskResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateProposedTaskResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateProposedTaskResponse>(null as any);
    }

    meetingTasks_UpdateTaskStatus(transcriptId: string, taskId: string, request: UpdateProposedTaskStatusRequest): Promise<UpdateProposedTaskStatusResponse> {
        let url_ = this.baseUrl + "/api/meeting-tasks/{transcriptId}/tasks/{taskId}/status";
        if (transcriptId === undefined || transcriptId === null)
            throw new Error("The parameter 'transcriptId' must be defined.");
        url_ = url_.replace("{transcriptId}", encodeURIComponent("" + transcriptId));
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMeetingTasks_UpdateTaskStatus(_response);
        });
    }

    protected processMeetingTasks_UpdateTaskStatus(response: Response): Promise<UpdateProposedTaskStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateProposedTaskStatusResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateProposedTaskStatusResponse>(null as any);
    }

    meetingTasks_UpdateStatus(transcriptId: string, request: UpdateTranscriptStatusRequest): Promise<UpdateTranscriptStatusResponse> {
        let url_ = this.baseUrl + "/api/meeting-tasks/{transcriptId}/status";
        if (transcriptId === undefined || transcriptId === null)
            throw new Error("The parameter 'transcriptId' must be defined.");
        url_ = url_.replace("{transcriptId}", encodeURIComponent("" + transcriptId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMeetingTasks_UpdateStatus(_response);
        });
    }

    protected processMeetingTasks_UpdateStatus(response: Response): Promise<UpdateTranscriptStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateTranscriptStatusResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateTranscriptStatusResponse>(null as any);
    }

    meetingTasks_AddTask(transcriptId: string, request: AddProposedTaskRequest): Promise<AddProposedTaskResponse> {
        let url_ = this.baseUrl + "/api/meeting-tasks/{transcriptId}/tasks";
        if (transcriptId === undefined || transcriptId === null)
            throw new Error("The parameter 'transcriptId' must be defined.");
        url_ = url_.replace("{transcriptId}", encodeURIComponent("" + transcriptId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMeetingTasks_AddTask(_response);
        });
    }

    protected processMeetingTasks_AddTask(response: Response): Promise<AddProposedTaskResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddProposedTaskResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddProposedTaskResponse>(null as any);
    }

    meetingTasks_Submit(transcriptId: string): Promise<SubmitToTodoResponse> {
        let url_ = this.baseUrl + "/api/meeting-tasks/{transcriptId}/submit";
        if (transcriptId === undefined || transcriptId === null)
            throw new Error("The parameter 'transcriptId' must be defined.");
        url_ = url_.replace("{transcriptId}", encodeURIComponent("" + transcriptId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMeetingTasks_Submit(_response);
        });
    }

    protected processMeetingTasks_Submit(response: Response): Promise<SubmitToTodoResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitToTodoResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitToTodoResponse>(null as any);
    }

    meetingTasks_ExplainSummary(transcriptId: string, request: ExplainSummaryRequest): Promise<ExplainSummaryResponse> {
        let url_ = this.baseUrl + "/api/meeting-tasks/{transcriptId}/explain";
        if (transcriptId === undefined || transcriptId === null)
            throw new Error("The parameter 'transcriptId' must be defined.");
        url_ = url_.replace("{transcriptId}", encodeURIComponent("" + transcriptId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMeetingTasks_ExplainSummary(_response);
        });
    }

    protected processMeetingTasks_ExplainSummary(response: Response): Promise<ExplainSummaryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExplainSummaryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExplainSummaryResponse>(null as any);
    }

    meetingTasks_UpdateAccess(transcriptId: string, request: UpdateMeetingAccessRequest): Promise<UpdateMeetingAccessResponse> {
        let url_ = this.baseUrl + "/api/meeting-tasks/{transcriptId}/access";
        if (transcriptId === undefined || transcriptId === null)
            throw new Error("The parameter 'transcriptId' must be defined.");
        url_ = url_.replace("{transcriptId}", encodeURIComponent("" + transcriptId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMeetingTasks_UpdateAccess(_response);
        });
    }

    protected processMeetingTasks_UpdateAccess(response: Response): Promise<UpdateMeetingAccessResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateMeetingAccessResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateMeetingAccessResponse>(null as any);
    }

    meetingTasks_Reimport(transcriptId: string): Promise<ReimportMeetingTranscriptResponse> {
        let url_ = this.baseUrl + "/api/meeting-tasks/{transcriptId}/reimport";
        if (transcriptId === undefined || transcriptId === null)
            throw new Error("The parameter 'transcriptId' must be defined.");
        url_ = url_.replace("{transcriptId}", encodeURIComponent("" + transcriptId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMeetingTasks_Reimport(_response);
        });
    }

    protected processMeetingTasks_Reimport(response: Response): Promise<ReimportMeetingTranscriptResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReimportMeetingTranscriptResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReimportMeetingTranscriptResponse>(null as any);
    }

    meetingTasks_Delete(transcriptId: string): Promise<DeleteMeetingTranscriptResponse> {
        let url_ = this.baseUrl + "/api/meeting-tasks/{transcriptId}";
        if (transcriptId === undefined || transcriptId === null)
            throw new Error("The parameter 'transcriptId' must be defined.");
        url_ = url_.replace("{transcriptId}", encodeURIComponent("" + transcriptId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMeetingTasks_Delete(_response);
        });
    }

    protected processMeetingTasks_Delete(response: Response): Promise<DeleteMeetingTranscriptResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteMeetingTranscriptResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteMeetingTranscriptResponse>(null as any);
    }

    mindMaps_List(): Promise<GetMindMapListResponse> {
        let url_ = this.baseUrl + "/api/mind-maps";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMindMaps_List(_response);
        });
    }

    protected processMindMaps_List(response: Response): Promise<GetMindMapListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMindMapListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMindMapListResponse>(null as any);
    }

    mindMaps_Create(request: CreateMindMapRequest): Promise<CreateMindMapResponse> {
        let url_ = this.baseUrl + "/api/mind-maps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMindMaps_Create(_response);
        });
    }

    protected processMindMaps_Create(response: Response): Promise<CreateMindMapResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateMindMapResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateMindMapResponse>(null as any);
    }

    mindMaps_Detail(id: string): Promise<GetMindMapDetailResponse> {
        let url_ = this.baseUrl + "/api/mind-maps/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMindMaps_Detail(_response);
        });
    }

    protected processMindMaps_Detail(response: Response): Promise<GetMindMapDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMindMapDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMindMapDetailResponse>(null as any);
    }

    mindMaps_Delete(id: string): Promise<DeleteMindMapResponse> {
        let url_ = this.baseUrl + "/api/mind-maps/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMindMaps_Delete(_response);
        });
    }

    protected processMindMaps_Delete(response: Response): Promise<DeleteMindMapResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteMindMapResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteMindMapResponse>(null as any);
    }

    mindMaps_AttachMeeting(id: string, request: AttachMeetingRequest): Promise<AttachMeetingResponse> {
        let url_ = this.baseUrl + "/api/mind-maps/{id}/meetings";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMindMaps_AttachMeeting(_response);
        });
    }

    protected processMindMaps_AttachMeeting(response: Response): Promise<AttachMeetingResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttachMeetingResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachMeetingResponse>(null as any);
    }

    mindMaps_DetachMeeting(id: string, meetingId: string): Promise<DetachMeetingResponse> {
        let url_ = this.baseUrl + "/api/mind-maps/{id}/meetings/{meetingId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMindMaps_DetachMeeting(_response);
        });
    }

    protected processMindMaps_DetachMeeting(response: Response): Promise<DetachMeetingResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DetachMeetingResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DetachMeetingResponse>(null as any);
    }

    mindMaps_Regenerate(id: string): Promise<RegenerateMindMapResponse> {
        let url_ = this.baseUrl + "/api/mind-maps/{id}/regenerate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMindMaps_Regenerate(_response);
        });
    }

    protected processMindMaps_Regenerate(response: Response): Promise<RegenerateMindMapResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegenerateMindMapResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegenerateMindMapResponse>(null as any);
    }

    mindMaps_SaveDocument(id: string, request: SaveMindMapDocumentRequest): Promise<SaveMindMapDocumentResponse> {
        let url_ = this.baseUrl + "/api/mind-maps/{id}/document";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMindMaps_SaveDocument(_response);
        });
    }

    protected processMindMaps_SaveDocument(response: Response): Promise<SaveMindMapDocumentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveMindMapDocumentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveMindMapDocumentResponse>(null as any);
    }

    mindMaps_RestoreVersion(id: string, versionNumber: number): Promise<RestoreMindMapVersionResponse> {
        let url_ = this.baseUrl + "/api/mind-maps/{id}/versions/{versionNumber}/restore";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (versionNumber === undefined || versionNumber === null)
            throw new Error("The parameter 'versionNumber' must be defined.");
        url_ = url_.replace("{versionNumber}", encodeURIComponent("" + versionNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMindMaps_RestoreVersion(_response);
        });
    }

    protected processMindMaps_RestoreVersion(response: Response): Promise<RestoreMindMapVersionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RestoreMindMapVersionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RestoreMindMapVersionResponse>(null as any);
    }

    orgChart_GetOrganizationStructure(): Promise<OrgChartResponse> {
        let url_ = this.baseUrl + "/api/OrgChart";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrgChart_GetOrganizationStructure(_response);
        });
    }

    protected processOrgChart_GetOrganizationStructure(response: Response): Promise<OrgChartResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrgChartResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrgChartResponse>(null as any);
    }

    overtime_GetEmployees(): Promise<GetOvertimeEmployeesResponse> {
        let url_ = this.baseUrl + "/api/overtime/employees";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOvertime_GetEmployees(_response);
        });
    }

    protected processOvertime_GetEmployees(response: Response): Promise<GetOvertimeEmployeesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOvertimeEmployeesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOvertimeEmployeesResponse>(null as any);
    }

    overtime_UpsertEmployee(request: UpsertOvertimeEmployeeRequest): Promise<UpsertOvertimeEmployeeResponse> {
        let url_ = this.baseUrl + "/api/overtime/employees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOvertime_UpsertEmployee(_response);
        });
    }

    protected processOvertime_UpsertEmployee(response: Response): Promise<UpsertOvertimeEmployeeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertOvertimeEmployeeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpsertOvertimeEmployeeResponse>(null as any);
    }

    overtime_GetMonthlyStatements(year: number, month: number): Promise<GetMonthlyStatementsResponse> {
        let url_ = this.baseUrl + "/api/overtime/statements/{year}/{month}";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined.");
        url_ = url_.replace("{month}", encodeURIComponent("" + month));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOvertime_GetMonthlyStatements(_response);
        });
    }

    protected processOvertime_GetMonthlyStatements(response: Response): Promise<GetMonthlyStatementsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMonthlyStatementsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMonthlyStatementsResponse>(null as any);
    }

    overtime_SetReviewed(year: number, month: number, request: SetStatementReviewedRequest): Promise<SetStatementReviewedResponse> {
        let url_ = this.baseUrl + "/api/overtime/statements/{year}/{month}/reviewed";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined.");
        url_ = url_.replace("{month}", encodeURIComponent("" + month));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOvertime_SetReviewed(_response);
        });
    }

    protected processOvertime_SetReviewed(response: Response): Promise<SetStatementReviewedResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetStatementReviewedResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetStatementReviewedResponse>(null as any);
    }

    overtime_CreateAdjustment(request: CreateAdjustmentRequest): Promise<CreateAdjustmentResponse> {
        let url_ = this.baseUrl + "/api/overtime/adjustments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOvertime_CreateAdjustment(_response);
        });
    }

    protected processOvertime_CreateAdjustment(response: Response): Promise<CreateAdjustmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAdjustmentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAdjustmentResponse>(null as any);
    }

    overtime_DeleteAdjustment(id: number): Promise<DeleteAdjustmentResponse> {
        let url_ = this.baseUrl + "/api/overtime/adjustments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOvertime_DeleteAdjustment(_response);
        });
    }

    protected processOvertime_DeleteAdjustment(response: Response): Promise<DeleteAdjustmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteAdjustmentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteAdjustmentResponse>(null as any);
    }

    overtime_CloseMonth(year: number, month: number, force: boolean | undefined): Promise<CloseMonthResponse> {
        let url_ = this.baseUrl + "/api/overtime/close/{year}/{month}?";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined.");
        url_ = url_.replace("{month}", encodeURIComponent("" + month));
        if (force === null)
            throw new Error("The parameter 'force' cannot be null.");
        else if (force !== undefined)
            url_ += "force=" + encodeURIComponent("" + force) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOvertime_CloseMonth(_response);
        });
    }

    protected processOvertime_CloseMonth(response: Response): Promise<CloseMonthResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CloseMonthResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CloseMonthResponse>(null as any);
    }

    overtime_DownloadReport(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/overtime/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOvertime_DownloadReport(_response);
        });
    }

    protected processOvertime_DownloadReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    overtime_PublishReport(): Promise<ExportOvertimeReportResponse> {
        let url_ = this.baseUrl + "/api/overtime/export/publish";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOvertime_PublishReport(_response);
        });
    }

    protected processOvertime_PublishReport(response: Response): Promise<ExportOvertimeReportResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportOvertimeReportResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportOvertimeReportResponse>(null as any);
    }

    packaging_ScanOrder(orderCode: string, numberOfPackages: number | undefined, body: ScanOrderBody | undefined): Promise<ScanPackingOrderResponse> {
        let url_ = this.baseUrl + "/api/packaging/orders/{orderCode}/scan?";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        if (numberOfPackages === null)
            throw new Error("The parameter 'numberOfPackages' cannot be null.");
        else if (numberOfPackages !== undefined)
            url_ += "numberOfPackages=" + encodeURIComponent("" + numberOfPackages) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackaging_ScanOrder(_response);
        });
    }

    protected processPackaging_ScanOrder(response: Response): Promise<ScanPackingOrderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScanPackingOrderResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScanPackingOrderResponse>(null as any);
    }

    packaging_ResetShipment(orderCode: string, numberOfPackages: number | undefined): Promise<ResetOrderShipmentResponse> {
        let url_ = this.baseUrl + "/api/packaging/orders/{orderCode}/shipment/reset?";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        if (numberOfPackages === null)
            throw new Error("The parameter 'numberOfPackages' cannot be null.");
        else if (numberOfPackages !== undefined)
            url_ += "numberOfPackages=" + encodeURIComponent("" + numberOfPackages) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackaging_ResetShipment(_response);
        });
    }

    protected processPackaging_ResetShipment(response: Response): Promise<ResetOrderShipmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetOrderShipmentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResetOrderShipmentResponse>(null as any);
    }

    packaging_GetPackageLabelPdf(orderCode: string, packageNumber: number, offsets: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/packaging/orders/{orderCode}/packages/{packageNumber}/label.pdf?";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        if (packageNumber === undefined || packageNumber === null)
            throw new Error("The parameter 'packageNumber' must be defined.");
        url_ = url_.replace("{packageNumber}", encodeURIComponent("" + packageNumber));
        if (offsets !== undefined && offsets !== null)
            url_ += "offsets=" + encodeURIComponent("" + offsets) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackaging_GetPackageLabelPdf(_response);
        });
    }

    protected processPackaging_GetPackageLabelPdf(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    packaging_GetOrderTrackingNumber(orderCode: string): Promise<GetOrderTrackingNumberResponse> {
        let url_ = this.baseUrl + "/api/packaging/orders/{orderCode}/tracking-number";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackaging_GetOrderTrackingNumber(_response);
        });
    }

    protected processPackaging_GetOrderTrackingNumber(response: Response): Promise<GetOrderTrackingNumberResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrderTrackingNumberResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOrderTrackingNumberResponse>(null as any);
    }

    packaging_GetOrderTrackingNumbers(orderCode: string): Promise<GetOrderTrackingNumbersResponse> {
        let url_ = this.baseUrl + "/api/packaging/orders/{orderCode}/tracking-numbers";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackaging_GetOrderTrackingNumbers(_response);
        });
    }

    protected processPackaging_GetOrderTrackingNumbers(response: Response): Promise<GetOrderTrackingNumbersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrderTrackingNumbersResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOrderTrackingNumbersResponse>(null as any);
    }

    packaging_GetDashboard(): Promise<GetPackingDashboardResponse> {
        let url_ = this.baseUrl + "/api/packaging/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackaging_GetDashboard(_response);
        });
    }

    protected processPackaging_GetDashboard(response: Response): Promise<GetPackingDashboardResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPackingDashboardResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPackingDashboardResponse>(null as any);
    }

    packaging_GetStatistics(fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<GetPackingStatisticsResponse> {
        let url_ = this.baseUrl + "/api/packaging/statistics?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackaging_GetStatistics(_response);
        });
    }

    protected processPackaging_GetStatistics(response: Response): Promise<GetPackingStatisticsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPackingStatisticsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPackingStatisticsResponse>(null as any);
    }

    packaging_GetPackages(orderCode: string | null | undefined, customerName: string | null | undefined, packageNumber: string | null | undefined, carrier: Carriers | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | undefined, sortDescending: boolean | undefined): Promise<GetPackagesResponse> {
        let url_ = this.baseUrl + "/api/packaging/packages?";
        if (orderCode !== undefined && orderCode !== null)
            url_ += "OrderCode=" + encodeURIComponent("" + orderCode) + "&";
        if (customerName !== undefined && customerName !== null)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (packageNumber !== undefined && packageNumber !== null)
            url_ += "PackageNumber=" + encodeURIComponent("" + packageNumber) + "&";
        if (carrier !== undefined && carrier !== null)
            url_ += "Carrier=" + encodeURIComponent("" + carrier) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackaging_GetPackages(_response);
        });
    }

    protected processPackaging_GetPackages(response: Response): Promise<GetPackagesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPackagesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPackagesResponse>(null as any);
    }

    packaging_GetPackingUsers(): Promise<GetPackingUsersResponse> {
        let url_ = this.baseUrl + "/api/packaging/packing-users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackaging_GetPackingUsers(_response);
        });
    }

    protected processPackaging_GetPackingUsers(response: Response): Promise<GetPackingUsersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPackingUsersResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPackingUsersResponse>(null as any);
    }

    packaging_DeletePackage(id: number): Promise<DeletePackageResponse> {
        let url_ = this.baseUrl + "/api/packaging/packages/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackaging_DeletePackage(_response);
        });
    }

    protected processPackaging_DeletePackage(response: Response): Promise<DeletePackageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeletePackageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeletePackageResponse>(null as any);
    }

    packaging_CompletePacking(orderCode: string): Promise<CompletePackingOrderResponse> {
        let url_ = this.baseUrl + "/api/packaging/orders/{orderCode}/packing/complete";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackaging_CompletePacking(_response);
        });
    }

    protected processPackaging_CompletePacking(response: Response): Promise<CompletePackingOrderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompletePackingOrderResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompletePackingOrderResponse>(null as any);
    }

    packingMaterials_GetPackingMaterials(): Promise<GetPackingMaterialsListResponse> {
        let url_ = this.baseUrl + "/api/packing-materials";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackingMaterials_GetPackingMaterials(_response);
        });
    }

    protected processPackingMaterials_GetPackingMaterials(response: Response): Promise<GetPackingMaterialsListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPackingMaterialsListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPackingMaterialsListResponse>(null as any);
    }

    packingMaterials_CreatePackingMaterial(request: CreatePackingMaterialRequest): Promise<CreatePackingMaterialResponse> {
        let url_ = this.baseUrl + "/api/packing-materials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackingMaterials_CreatePackingMaterial(_response);
        });
    }

    protected processPackingMaterials_CreatePackingMaterial(response: Response): Promise<CreatePackingMaterialResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePackingMaterialResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatePackingMaterialResponse>(null as any);
    }

    packingMaterials_UpdatePackingMaterial(id: number, request: UpdatePackingMaterialRequest): Promise<UpdatePackingMaterialResponse> {
        let url_ = this.baseUrl + "/api/packing-materials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackingMaterials_UpdatePackingMaterial(_response);
        });
    }

    protected processPackingMaterials_UpdatePackingMaterial(response: Response): Promise<UpdatePackingMaterialResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePackingMaterialResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdatePackingMaterialResponse>(null as any);
    }

    packingMaterials_DeletePackingMaterial(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/packing-materials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackingMaterials_DeletePackingMaterial(_response);
        });
    }

    protected processPackingMaterials_DeletePackingMaterial(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    packingMaterials_UpdatePackingMaterialQuantity(id: number, request: UpdateQuantityRequest): Promise<UpdatePackingMaterialQuantityResponse> {
        let url_ = this.baseUrl + "/api/packing-materials/{id}/quantity";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackingMaterials_UpdatePackingMaterialQuantity(_response);
        });
    }

    protected processPackingMaterials_UpdatePackingMaterialQuantity(response: Response): Promise<UpdatePackingMaterialQuantityResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePackingMaterialQuantityResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdatePackingMaterialQuantityResponse>(null as any);
    }

    packingMaterials_ProcessDailyConsumption(request: ProcessDailyConsumptionRequest): Promise<ProcessDailyConsumptionResponse> {
        let url_ = this.baseUrl + "/api/packing-materials/process-daily-consumption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackingMaterials_ProcessDailyConsumption(_response);
        });
    }

    protected processPackingMaterials_ProcessDailyConsumption(response: Response): Promise<ProcessDailyConsumptionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessDailyConsumptionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessDailyConsumptionResponse>(null as any);
    }

    packingMaterials_GetDailyConsumptionBreakdown(date: string | null | undefined, groupBy: ConsumptionGroupBy | undefined): Promise<GetDailyConsumptionBreakdownResponse> {
        let url_ = this.baseUrl + "/api/packing-materials/consumption?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (groupBy === null)
            throw new Error("The parameter 'groupBy' cannot be null.");
        else if (groupBy !== undefined)
            url_ += "groupBy=" + encodeURIComponent("" + groupBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackingMaterials_GetDailyConsumptionBreakdown(_response);
        });
    }

    protected processPackingMaterials_GetDailyConsumptionBreakdown(response: Response): Promise<GetDailyConsumptionBreakdownResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDailyConsumptionBreakdownResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDailyConsumptionBreakdownResponse>(null as any);
    }

    packingMaterials_GetConsumptionHistory(dateFrom: string | null | undefined, dateTo: string | null | undefined, packingMaterialId: number | null | undefined, consumptionType: ConsumptionType | null | undefined, productCode: string | null | undefined, invoiceId: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortDescending: boolean | undefined): Promise<GetConsumptionHistoryResponse> {
        let url_ = this.baseUrl + "/api/packing-materials/consumption-history?";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (packingMaterialId !== undefined && packingMaterialId !== null)
            url_ += "PackingMaterialId=" + encodeURIComponent("" + packingMaterialId) + "&";
        if (consumptionType !== undefined && consumptionType !== null)
            url_ += "ConsumptionType=" + encodeURIComponent("" + consumptionType) + "&";
        if (productCode !== undefined && productCode !== null)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        if (invoiceId !== undefined && invoiceId !== null)
            url_ += "InvoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackingMaterials_GetConsumptionHistory(_response);
        });
    }

    protected processPackingMaterials_GetConsumptionHistory(response: Response): Promise<GetConsumptionHistoryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConsumptionHistoryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetConsumptionHistoryResponse>(null as any);
    }

    packingMaterials_GetPackingMaterialLogs(id: number, days: number | undefined): Promise<GetPackingMaterialLogsResponse> {
        let url_ = this.baseUrl + "/api/packing-materials/{id}/logs?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (days === null)
            throw new Error("The parameter 'days' cannot be null.");
        else if (days !== undefined)
            url_ += "days=" + encodeURIComponent("" + days) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackingMaterials_GetPackingMaterialLogs(_response);
        });
    }

    protected processPackingMaterials_GetPackingMaterialLogs(response: Response): Promise<GetPackingMaterialLogsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPackingMaterialLogsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPackingMaterialLogsResponse>(null as any);
    }

    packingMaterials_GetAllocations(id: number): Promise<GetAllocationsResponse> {
        let url_ = this.baseUrl + "/api/packing-materials/{id}/allocations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackingMaterials_GetAllocations(_response);
        });
    }

    protected processPackingMaterials_GetAllocations(response: Response): Promise<GetAllocationsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllocationsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAllocationsResponse>(null as any);
    }

    packingMaterials_CreateAllocation(id: number, body: CreateAllocationRequestBody): Promise<CreateAllocationResponse> {
        let url_ = this.baseUrl + "/api/packing-materials/{id}/allocations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackingMaterials_CreateAllocation(_response);
        });
    }

    protected processPackingMaterials_CreateAllocation(response: Response): Promise<CreateAllocationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateAllocationResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAllocationResponse>(null as any);
    }

    packingMaterials_UpdateAllocation(id: number, allocationId: number, body: UpdateAllocationRequestBody): Promise<UpdateAllocationResponse> {
        let url_ = this.baseUrl + "/api/packing-materials/{id}/allocations/{allocationId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (allocationId === undefined || allocationId === null)
            throw new Error("The parameter 'allocationId' must be defined.");
        url_ = url_.replace("{allocationId}", encodeURIComponent("" + allocationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackingMaterials_UpdateAllocation(_response);
        });
    }

    protected processPackingMaterials_UpdateAllocation(response: Response): Promise<UpdateAllocationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAllocationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateAllocationResponse>(null as any);
    }

    packingMaterials_DeleteAllocation(id: number, allocationId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/packing-materials/{id}/allocations/{allocationId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (allocationId === undefined || allocationId === null)
            throw new Error("The parameter 'allocationId' must be defined.");
        url_ = url_.replace("{allocationId}", encodeURIComponent("" + allocationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPackingMaterials_DeleteAllocation(_response);
        });
    }

    protected processPackingMaterials_DeleteAllocation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    photobank_GetPhotos(tags: string[] | null | undefined, search: string | null | undefined, useRegex: boolean | undefined, withoutTags: boolean | undefined, page: number | undefined, pageSize: number | undefined): Promise<GetPhotosResponse> {
        let url_ = this.baseUrl + "/api/photobank/photos?";
        if (tags !== undefined && tags !== null)
            tags && tags.forEach(item => { url_ += "tags=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (useRegex === null)
            throw new Error("The parameter 'useRegex' cannot be null.");
        else if (useRegex !== undefined)
            url_ += "useRegex=" + encodeURIComponent("" + useRegex) + "&";
        if (withoutTags === null)
            throw new Error("The parameter 'withoutTags' cannot be null.");
        else if (withoutTags !== undefined)
            url_ += "withoutTags=" + encodeURIComponent("" + withoutTags) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_GetPhotos(_response);
        });
    }

    protected processPhotobank_GetPhotos(response: Response): Promise<GetPhotosResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPhotosResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPhotosResponse>(null as any);
    }

    photobank_GetTags(): Promise<GetTagsResponse> {
        let url_ = this.baseUrl + "/api/photobank/tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_GetTags(_response);
        });
    }

    protected processPhotobank_GetTags(response: Response): Promise<GetTagsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTagsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTagsResponse>(null as any);
    }

    photobank_CreateTag(body: CreateTagBody): Promise<CreateTagResponse> {
        let url_ = this.baseUrl + "/api/photobank/tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_CreateTag(_response);
        });
    }

    protected processPhotobank_CreateTag(response: Response): Promise<CreateTagResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateTagResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateTagResponse>(null as any);
    }

    photobank_DeleteTag(id: number): Promise<DeleteTagResponse> {
        let url_ = this.baseUrl + "/api/photobank/tags/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_DeleteTag(_response);
        });
    }

    protected processPhotobank_DeleteTag(response: Response): Promise<DeleteTagResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteTagResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteTagResponse>(null as any);
    }

    photobank_AddPhotoTag(id: number, body: AddPhotoTagBody): Promise<AddPhotoTagResponse> {
        let url_ = this.baseUrl + "/api/photobank/photos/{id}/tags";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_AddPhotoTag(_response);
        });
    }

    protected processPhotobank_AddPhotoTag(response: Response): Promise<AddPhotoTagResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddPhotoTagResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddPhotoTagResponse>(null as any);
    }

    photobank_RemovePhotoTag(id: number, tagId: number): Promise<RemovePhotoTagResponse> {
        let url_ = this.baseUrl + "/api/photobank/photos/{id}/tags/{tagId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tagId === undefined || tagId === null)
            throw new Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_RemovePhotoTag(_response);
        });
    }

    protected processPhotobank_RemovePhotoTag(response: Response): Promise<RemovePhotoTagResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemovePhotoTagResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RemovePhotoTagResponse>(null as any);
    }

    photobank_BulkAddPhotoTag(body: BulkAddPhotoTagBody): Promise<BulkAddPhotoTagResponse> {
        let url_ = this.baseUrl + "/api/photobank/photos/bulk-tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_BulkAddPhotoTag(_response);
        });
    }

    protected processPhotobank_BulkAddPhotoTag(response: Response): Promise<BulkAddPhotoTagResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BulkAddPhotoTagResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkAddPhotoTagResponse>(null as any);
    }

    photobank_BulkAddPhotoTagByIds(body: BulkAddPhotoTagByIdsBody): Promise<BulkAddPhotoTagByIdsResponse> {
        let url_ = this.baseUrl + "/api/photobank/photos/tag-by-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_BulkAddPhotoTagByIds(_response);
        });
    }

    protected processPhotobank_BulkAddPhotoTagByIds(response: Response): Promise<BulkAddPhotoTagByIdsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BulkAddPhotoTagByIdsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkAddPhotoTagByIdsResponse>(null as any);
    }

    photobank_RetagPhotos(body: RetagPhotosBody): Promise<RetagPhotosResponse> {
        let url_ = this.baseUrl + "/api/photobank/photos/auto-tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_RetagPhotos(_response);
        });
    }

    protected processPhotobank_RetagPhotos(response: Response): Promise<RetagPhotosResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = RetagPhotosResponse.fromJS(resultData202);
            return result202;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetagPhotosResponse>(null as any);
    }

    photobank_GetRoots(): Promise<GetRootsResponse> {
        let url_ = this.baseUrl + "/api/photobank/settings/roots";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_GetRoots(_response);
        });
    }

    protected processPhotobank_GetRoots(response: Response): Promise<GetRootsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRootsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRootsResponse>(null as any);
    }

    photobank_AddRoot(body: AddRootBody): Promise<AddRootResponse> {
        let url_ = this.baseUrl + "/api/photobank/settings/roots";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_AddRoot(_response);
        });
    }

    protected processPhotobank_AddRoot(response: Response): Promise<AddRootResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AddRootResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddRootResponse>(null as any);
    }

    photobank_DeleteRoot(id: number): Promise<DeleteRootResponse> {
        let url_ = this.baseUrl + "/api/photobank/settings/roots/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_DeleteRoot(_response);
        });
    }

    protected processPhotobank_DeleteRoot(response: Response): Promise<DeleteRootResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteRootResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteRootResponse>(null as any);
    }

    photobank_GetRules(): Promise<GetRulesResponse> {
        let url_ = this.baseUrl + "/api/photobank/settings/rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_GetRules(_response);
        });
    }

    protected processPhotobank_GetRules(response: Response): Promise<GetRulesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRulesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRulesResponse>(null as any);
    }

    photobank_AddRule(body: AddRuleBody): Promise<AddRuleResponse> {
        let url_ = this.baseUrl + "/api/photobank/settings/rules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_AddRule(_response);
        });
    }

    protected processPhotobank_AddRule(response: Response): Promise<AddRuleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AddRuleResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddRuleResponse>(null as any);
    }

    photobank_UpdateRule(id: number, body: UpdateRuleBody): Promise<UpdateRuleResponse> {
        let url_ = this.baseUrl + "/api/photobank/settings/rules/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_UpdateRule(_response);
        });
    }

    protected processPhotobank_UpdateRule(response: Response): Promise<UpdateRuleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateRuleResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateRuleResponse>(null as any);
    }

    photobank_DeleteRule(id: number): Promise<DeleteRuleResponse> {
        let url_ = this.baseUrl + "/api/photobank/settings/rules/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_DeleteRule(_response);
        });
    }

    protected processPhotobank_DeleteRule(response: Response): Promise<DeleteRuleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteRuleResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteRuleResponse>(null as any);
    }

    photobank_ReapplyRules(): Promise<ReapplyRulesResponse> {
        let url_ = this.baseUrl + "/api/photobank/settings/rules/reapply";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_ReapplyRules(_response);
        });
    }

    protected processPhotobank_ReapplyRules(response: Response): Promise<ReapplyRulesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReapplyRulesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReapplyRulesResponse>(null as any);
    }

    photobank_ReapplyRule(id: number): Promise<ReapplyRulesResponse> {
        let url_ = this.baseUrl + "/api/photobank/settings/rules/{id}/reapply";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_ReapplyRule(_response);
        });
    }

    protected processPhotobank_ReapplyRule(response: Response): Promise<ReapplyRulesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReapplyRulesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReapplyRulesResponse>(null as any);
    }

    photobank_GetThumbnail(id: number, size: ThumbnailSize): Promise<void> {
        let url_ = this.baseUrl + "/api/photobank/photos/{id}/thumbnail/{size}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (size === undefined || size === null)
            throw new Error("The parameter 'size' must be defined.");
        url_ = url_.replace("{size}", encodeURIComponent("" + size));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPhotobank_GetThumbnail(_response);
        });
    }

    protected processPhotobank_GetThumbnail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 502) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    pricingScenarios_GetScenarios(): Promise<GetPricingScenariosResponse> {
        let url_ = this.baseUrl + "/api/pricing-scenarios";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPricingScenarios_GetScenarios(_response);
        });
    }

    protected processPricingScenarios_GetScenarios(response: Response): Promise<GetPricingScenariosResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPricingScenariosResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPricingScenariosResponse>(null as any);
    }

    pricingScenarios_CreateScenario(request: SavePricingScenarioRequest): Promise<SavePricingScenarioResponse> {
        let url_ = this.baseUrl + "/api/pricing-scenarios";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPricingScenarios_CreateScenario(_response);
        });
    }

    protected processPricingScenarios_CreateScenario(response: Response): Promise<SavePricingScenarioResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavePricingScenarioResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SavePricingScenarioResponse>(null as any);
    }

    pricingScenarios_GetScenario(id: string): Promise<GetPricingScenarioResponse> {
        let url_ = this.baseUrl + "/api/pricing-scenarios/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPricingScenarios_GetScenario(_response);
        });
    }

    protected processPricingScenarios_GetScenario(response: Response): Promise<GetPricingScenarioResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPricingScenarioResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPricingScenarioResponse>(null as any);
    }

    pricingScenarios_UpdateScenario(id: string, request: SavePricingScenarioRequest): Promise<SavePricingScenarioResponse> {
        let url_ = this.baseUrl + "/api/pricing-scenarios/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPricingScenarios_UpdateScenario(_response);
        });
    }

    protected processPricingScenarios_UpdateScenario(response: Response): Promise<SavePricingScenarioResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavePricingScenarioResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SavePricingScenarioResponse>(null as any);
    }

    pricingScenarios_DeleteScenario(id: string): Promise<DeletePricingScenarioResponse> {
        let url_ = this.baseUrl + "/api/pricing-scenarios/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPricingScenarios_DeleteScenario(_response);
        });
    }

    protected processPricingScenarios_DeleteScenario(response: Response): Promise<DeletePricingScenarioResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeletePricingScenarioResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeletePricingScenarioResponse>(null as any);
    }

    pricingSimulator_GetBaseline(productCode: string | null | undefined, productName: string | null | undefined, productType: ProductType | null | undefined): Promise<GetPricingBaselineResponse> {
        let url_ = this.baseUrl + "/api/pricing-simulator/baseline?";
        if (productCode !== undefined && productCode !== null)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        if (productName !== undefined && productName !== null)
            url_ += "ProductName=" + encodeURIComponent("" + productName) + "&";
        if (productType !== undefined && productType !== null)
            url_ += "ProductType=" + encodeURIComponent("" + productType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPricingSimulator_GetBaseline(_response);
        });
    }

    protected processPricingSimulator_GetBaseline(response: Response): Promise<GetPricingBaselineResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPricingBaselineResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPricingBaselineResponse>(null as any);
    }

    pricingSimulator_Recalculate(request: RecalculatePricingRequest): Promise<RecalculatePricingResponse> {
        let url_ = this.baseUrl + "/api/pricing-simulator/recalculate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPricingSimulator_Recalculate(_response);
        });
    }

    protected processPricingSimulator_Recalculate(response: Response): Promise<RecalculatePricingResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecalculatePricingResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecalculatePricingResponse>(null as any);
    }

    productMargins_GetProductMargins(productCode: string | null | undefined, productName: string | null | undefined, productType: ProductType | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDescending: boolean | undefined, onlyWithSales: boolean | undefined): Promise<GetProductMarginsResponse> {
        let url_ = this.baseUrl + "/api/ProductMargins?";
        if (productCode !== undefined && productCode !== null)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        if (productName !== undefined && productName !== null)
            url_ += "ProductName=" + encodeURIComponent("" + productName) + "&";
        if (productType !== undefined && productType !== null)
            url_ += "ProductType=" + encodeURIComponent("" + productType) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        if (onlyWithSales === null)
            throw new Error("The parameter 'onlyWithSales' cannot be null.");
        else if (onlyWithSales !== undefined)
            url_ += "OnlyWithSales=" + encodeURIComponent("" + onlyWithSales) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductMargins_GetProductMargins(_response);
        });
    }

    protected processProductMargins_GetProductMargins(response: Response): Promise<GetProductMarginsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProductMarginsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetProductMarginsResponse>(null as any);
    }

    productPricing_GetDivergenceReport(): Promise<GetPriceDivergenceReportResponse> {
        let url_ = this.baseUrl + "/api/product-pricing/divergence";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductPricing_GetDivergenceReport(_response);
        });
    }

    protected processProductPricing_GetDivergenceReport(response: Response): Promise<GetPriceDivergenceReportResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPriceDivergenceReportResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPriceDivergenceReportResponse>(null as any);
    }

    productPricing_Sync(request: SyncProductPricesRequest): Promise<SyncProductPricesResponse> {
        let url_ = this.baseUrl + "/api/product-pricing/sync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductPricing_Sync(_response);
        });
    }

    protected processProductPricing_Sync(response: Response): Promise<SyncProductPricesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncProductPricesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncProductPricesResponse>(null as any);
    }

    productPricing_SetPrice(productCode: string, request: SetProductPriceRequest): Promise<SetProductPriceResponse> {
        let url_ = this.baseUrl + "/api/product-pricing/prices/{productCode}";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductPricing_SetPrice(_response);
        });
    }

    protected processProductPricing_SetPrice(response: Response): Promise<SetProductPriceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetProductPriceResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetProductPriceResponse>(null as any);
    }

    purchaseOrders_GetPurchaseOrders(searchTerm: string | null | undefined, status: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, activeOrdersOnly: boolean | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | undefined, sortDescending: boolean | undefined): Promise<GetPurchaseOrdersResponse> {
        let url_ = this.baseUrl + "/api/purchase-orders?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (activeOrdersOnly !== undefined && activeOrdersOnly !== null)
            url_ += "ActiveOrdersOnly=" + encodeURIComponent("" + activeOrdersOnly) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPurchaseOrders_GetPurchaseOrders(_response);
        });
    }

    protected processPurchaseOrders_GetPurchaseOrders(response: Response): Promise<GetPurchaseOrdersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPurchaseOrdersResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPurchaseOrdersResponse>(null as any);
    }

    purchaseOrders_CreatePurchaseOrder(request: CreatePurchaseOrderRequest): Promise<CreatePurchaseOrderResponse> {
        let url_ = this.baseUrl + "/api/purchase-orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPurchaseOrders_CreatePurchaseOrder(_response);
        });
    }

    protected processPurchaseOrders_CreatePurchaseOrder(response: Response): Promise<CreatePurchaseOrderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePurchaseOrderResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatePurchaseOrderResponse>(null as any);
    }

    purchaseOrders_GetPurchaseOrderById(id: number): Promise<GetPurchaseOrderByIdResponse> {
        let url_ = this.baseUrl + "/api/purchase-orders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPurchaseOrders_GetPurchaseOrderById(_response);
        });
    }

    protected processPurchaseOrders_GetPurchaseOrderById(response: Response): Promise<GetPurchaseOrderByIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPurchaseOrderByIdResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPurchaseOrderByIdResponse>(null as any);
    }

    purchaseOrders_UpdatePurchaseOrder(id: number, request: UpdatePurchaseOrderRequest): Promise<UpdatePurchaseOrderResponse> {
        let url_ = this.baseUrl + "/api/purchase-orders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPurchaseOrders_UpdatePurchaseOrder(_response);
        });
    }

    protected processPurchaseOrders_UpdatePurchaseOrder(response: Response): Promise<UpdatePurchaseOrderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePurchaseOrderResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdatePurchaseOrderResponse>(null as any);
    }

    purchaseOrders_UpdatePurchaseOrderStatus(id: number, request: UpdatePurchaseOrderStatusRequest): Promise<UpdatePurchaseOrderStatusResponse> {
        let url_ = this.baseUrl + "/api/purchase-orders/{id}/status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPurchaseOrders_UpdatePurchaseOrderStatus(_response);
        });
    }

    protected processPurchaseOrders_UpdatePurchaseOrderStatus(response: Response): Promise<UpdatePurchaseOrderStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePurchaseOrderStatusResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdatePurchaseOrderStatusResponse>(null as any);
    }

    purchaseOrders_UpdateInvoiceAcquired(id: number, request: UpdatePurchaseOrderInvoiceAcquiredRequest): Promise<UpdatePurchaseOrderInvoiceAcquiredResponse> {
        let url_ = this.baseUrl + "/api/purchase-orders/{id}/invoice-acquired";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPurchaseOrders_UpdateInvoiceAcquired(_response);
        });
    }

    protected processPurchaseOrders_UpdateInvoiceAcquired(response: Response): Promise<UpdatePurchaseOrderInvoiceAcquiredResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePurchaseOrderInvoiceAcquiredResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdatePurchaseOrderInvoiceAcquiredResponse>(null as any);
    }

    purchaseOrders_GetPurchaseOrderHistory(id: number): Promise<ListResponseOfPurchaseOrderHistoryDto> {
        let url_ = this.baseUrl + "/api/purchase-orders/{id}/history";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPurchaseOrders_GetPurchaseOrderHistory(_response);
        });
    }

    protected processPurchaseOrders_GetPurchaseOrderHistory(response: Response): Promise<ListResponseOfPurchaseOrderHistoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResponseOfPurchaseOrderHistoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListResponseOfPurchaseOrderHistoryDto>(null as any);
    }

    purchaseOrders_RecalculatePurchasePrice(request: RecalculatePurchasePriceRequest): Promise<RecalculatePurchasePriceResponse> {
        let url_ = this.baseUrl + "/api/purchase-orders/recalculate-purchase-price";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPurchaseOrders_RecalculatePurchasePrice(_response);
        });
    }

    protected processPurchaseOrders_RecalculatePurchasePrice(response: Response): Promise<RecalculatePurchasePriceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecalculatePurchasePriceResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecalculatePurchasePriceResponse>(null as any);
    }

    purchaseStockAnalysis_GetStockAnalysis(fromDate: Date | null | undefined, toDate: Date | null | undefined, stockStatus: StockStatusFilter | undefined, materialCategory: MaterialCategoryFilter | undefined, onlyConfigured: boolean | undefined, searchTerm: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: StockAnalysisSortBy | undefined, sortDescending: boolean | undefined, isExport: boolean | undefined): Promise<GetPurchaseStockAnalysisResponse> {
        let url_ = this.baseUrl + "/api/purchase-stock-analysis?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (stockStatus === null)
            throw new Error("The parameter 'stockStatus' cannot be null.");
        else if (stockStatus !== undefined)
            url_ += "StockStatus=" + encodeURIComponent("" + stockStatus) + "&";
        if (materialCategory === null)
            throw new Error("The parameter 'materialCategory' cannot be null.");
        else if (materialCategory !== undefined)
            url_ += "MaterialCategory=" + encodeURIComponent("" + materialCategory) + "&";
        if (onlyConfigured === null)
            throw new Error("The parameter 'onlyConfigured' cannot be null.");
        else if (onlyConfigured !== undefined)
            url_ += "OnlyConfigured=" + encodeURIComponent("" + onlyConfigured) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        if (isExport === null)
            throw new Error("The parameter 'isExport' cannot be null.");
        else if (isExport !== undefined)
            url_ += "IsExport=" + encodeURIComponent("" + isExport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPurchaseStockAnalysis_GetStockAnalysis(_response);
        });
    }

    protected processPurchaseStockAnalysis_GetStockAnalysis(response: Response): Promise<GetPurchaseStockAnalysisResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPurchaseStockAnalysisResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPurchaseStockAnalysisResponse>(null as any);
    }

    recurringJobs_GetRecurringJobs(): Promise<GetRecurringJobsListResponse> {
        let url_ = this.baseUrl + "/api/RecurringJobs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRecurringJobs_GetRecurringJobs(_response);
        });
    }

    protected processRecurringJobs_GetRecurringJobs(response: Response): Promise<GetRecurringJobsListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecurringJobsListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRecurringJobsListResponse>(null as any);
    }

    recurringJobs_GetRecurringJob(jobName: string): Promise<GetRecurringJobResponse> {
        let url_ = this.baseUrl + "/api/RecurringJobs/{jobName}";
        if (jobName === undefined || jobName === null)
            throw new Error("The parameter 'jobName' must be defined.");
        url_ = url_.replace("{jobName}", encodeURIComponent("" + jobName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRecurringJobs_GetRecurringJob(_response);
        });
    }

    protected processRecurringJobs_GetRecurringJob(response: Response): Promise<GetRecurringJobResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecurringJobResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRecurringJobResponse>(null as any);
    }

    recurringJobs_UpdateJobStatus(jobName: string, request: UpdateJobStatusRequestBody): Promise<UpdateRecurringJobStatusResponse> {
        let url_ = this.baseUrl + "/api/RecurringJobs/{jobName}/status";
        if (jobName === undefined || jobName === null)
            throw new Error("The parameter 'jobName' must be defined.");
        url_ = url_.replace("{jobName}", encodeURIComponent("" + jobName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRecurringJobs_UpdateJobStatus(_response);
        });
    }

    protected processRecurringJobs_UpdateJobStatus(response: Response): Promise<UpdateRecurringJobStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateRecurringJobStatusResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateRecurringJobStatusResponse>(null as any);
    }

    recurringJobs_UpdateJobCron(jobName: string, request: UpdateJobCronRequestBody): Promise<UpdateRecurringJobCronResponse> {
        let url_ = this.baseUrl + "/api/RecurringJobs/{jobName}/cron";
        if (jobName === undefined || jobName === null)
            throw new Error("The parameter 'jobName' must be defined.");
        url_ = url_.replace("{jobName}", encodeURIComponent("" + jobName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRecurringJobs_UpdateJobCron(_response);
        });
    }

    protected processRecurringJobs_UpdateJobCron(response: Response): Promise<UpdateRecurringJobCronResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateRecurringJobCronResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateRecurringJobCronResponse>(null as any);
    }

    recurringJobs_TriggerJob(jobName: string): Promise<TriggerRecurringJobResponse> {
        let url_ = this.baseUrl + "/api/RecurringJobs/{jobName}/trigger";
        if (jobName === undefined || jobName === null)
            throw new Error("The parameter 'jobName' must be defined.");
        url_ = url_.replace("{jobName}", encodeURIComponent("" + jobName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRecurringJobs_TriggerJob(_response);
        });
    }

    protected processRecurringJobs_TriggerJob(response: Response): Promise<TriggerRecurringJobResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = TriggerRecurringJobResponse.fromJS(resultData202);
            return result202;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TriggerRecurringJobResponse>(null as any);
    }

    shipmentLabels_GetLabels(body: GetShipmentLabelsRequest): Promise<GetOrderShipmentLabelsResponse> {
        let url_ = this.baseUrl + "/api/shipment-labels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processShipmentLabels_GetLabels(_response);
        });
    }

    protected processShipmentLabels_GetLabels(response: Response): Promise<GetOrderShipmentLabelsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrderShipmentLabelsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOrderShipmentLabelsResponse>(null as any);
    }

    shipmentLabels_CreateShipment(body: CreateShipmentRequest): Promise<CreateOrderShipmentResponse> {
        let url_ = this.baseUrl + "/api/shipment-labels/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processShipmentLabels_CreateShipment(_response);
        });
    }

    protected processShipmentLabels_CreateShipment(response: Response): Promise<CreateOrderShipmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrderShipmentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateOrderShipmentResponse>(null as any);
    }

    shoptetOrders_BlockOrder(code: string, body: BlockOrderRequest): Promise<BlockOrderProcessingResponse> {
        let url_ = this.baseUrl + "/api/shoptet-orders/{code}/block";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processShoptetOrders_BlockOrder(_response);
        });
    }

    protected processShoptetOrders_BlockOrder(response: Response): Promise<BlockOrderProcessingResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BlockOrderProcessingResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BlockOrderProcessingResponse>(null as any);
    }

    shoptetOrders_GetPackingOrder(code: string): Promise<GetPackingOrderResponse> {
        let url_ = this.baseUrl + "/api/shoptet-orders/{code}/packing";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processShoptetOrders_GetPackingOrder(_response);
        });
    }

    protected processShoptetOrders_GetPackingOrder(response: Response): Promise<GetPackingOrderResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPackingOrderResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPackingOrderResponse>(null as any);
    }

    smartsupp_GetConversations(status: string | undefined, page: number | undefined, pageSize: number | undefined): Promise<ListConversationsResponse> {
        let url_ = this.baseUrl + "/api/smartsupp/conversations?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSmartsupp_GetConversations(_response);
        });
    }

    protected processSmartsupp_GetConversations(response: Response): Promise<ListConversationsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListConversationsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListConversationsResponse>(null as any);
    }

    smartsupp_GetConversation(id: string): Promise<GetConversationResponse> {
        let url_ = this.baseUrl + "/api/smartsupp/conversations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSmartsupp_GetConversation(_response);
        });
    }

    protected processSmartsupp_GetConversation(response: Response): Promise<GetConversationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConversationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetConversationResponse>(null as any);
    }

    smartsupp_GenerateDraftReply(id: string, body: GenerateDraftReplyBody | undefined): Promise<GenerateDraftReplyResponse> {
        let url_ = this.baseUrl + "/api/smartsupp/conversations/{id}/draft-reply";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSmartsupp_GenerateDraftReply(_response);
        });
    }

    protected processSmartsupp_GenerateDraftReply(response: Response): Promise<GenerateDraftReplyResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateDraftReplyResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateDraftReplyResponse>(null as any);
    }

    smartsupp_GetShoptetInfo(id: string): Promise<GetSmartsuppContactShoptetInfoResponse> {
        let url_ = this.baseUrl + "/api/smartsupp/conversations/{id}/shoptet-info";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSmartsupp_GetShoptetInfo(_response);
        });
    }

    protected processSmartsupp_GetShoptetInfo(response: Response): Promise<GetSmartsuppContactShoptetInfoResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSmartsuppContactShoptetInfoResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetSmartsuppContactShoptetInfoResponse>(null as any);
    }

    smartsupp_GetVisitorInfo(id: string): Promise<GetVisitorInfoResponse> {
        let url_ = this.baseUrl + "/api/smartsupp/conversations/{id}/visitor-info";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSmartsupp_GetVisitorInfo(_response);
        });
    }

    protected processSmartsupp_GetVisitorInfo(response: Response): Promise<GetVisitorInfoResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetVisitorInfoResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetVisitorInfoResponse>(null as any);
    }

    smartsupp_SendMessage(conversationId: string, body: SendMessageBody): Promise<SendMessageResponse> {
        let url_ = this.baseUrl + "/api/smartsupp/conversations/{conversationId}/messages";
        if (conversationId === undefined || conversationId === null)
            throw new Error("The parameter 'conversationId' must be defined.");
        url_ = url_.replace("{conversationId}", encodeURIComponent("" + conversationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSmartsupp_SendMessage(_response);
        });
    }

    protected processSmartsupp_SendMessage(response: Response): Promise<SendMessageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendMessageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SendMessageResponse>(null as any);
    }

    smartsupp_SendMessageWithAttachments(conversationId: string, content: string | null | undefined, draftLogId: string | null | undefined, files: FileParameter[] | null | undefined): Promise<SendMessageResponse> {
        let url_ = this.baseUrl + "/api/smartsupp/conversations/{conversationId}/messages/with-attachments";
        if (conversationId === undefined || conversationId === null)
            throw new Error("The parameter 'conversationId' must be defined.");
        url_ = url_.replace("{conversationId}", encodeURIComponent("" + conversationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (content !== null && content !== undefined)
            content_.append("content", content.toString());
        if (draftLogId !== null && draftLogId !== undefined)
            content_.append("draftLogId", draftLogId.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSmartsupp_SendMessageWithAttachments(_response);
        });
    }

    protected processSmartsupp_SendMessageWithAttachments(response: Response): Promise<SendMessageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendMessageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SendMessageResponse>(null as any);
    }

    smartsupp_SubmitDraftReplyFeedback(request: SubmitDraftReplyFeedbackRequest): Promise<SubmitDraftReplyFeedbackResponse> {
        let url_ = this.baseUrl + "/api/smartsupp/draft-reply/feedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSmartsupp_SubmitDraftReplyFeedback(_response);
        });
    }

    protected processSmartsupp_SubmitDraftReplyFeedback(response: Response): Promise<SubmitDraftReplyFeedbackResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitDraftReplyFeedbackResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitDraftReplyFeedbackResponse>(null as any);
    }

    smartsupp_GetDraftReplyFeedbackList(pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | undefined, sortDescending: boolean | undefined, hasFeedback: boolean | null | undefined, userId: string | null | undefined): Promise<GetDraftReplyFeedbackListResponse> {
        let url_ = this.baseUrl + "/api/smartsupp/draft-reply/feedback/list?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "sortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        if (hasFeedback !== undefined && hasFeedback !== null)
            url_ += "hasFeedback=" + encodeURIComponent("" + hasFeedback) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSmartsupp_GetDraftReplyFeedbackList(_response);
        });
    }

    protected processSmartsupp_GetDraftReplyFeedbackList(response: Response): Promise<GetDraftReplyFeedbackListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDraftReplyFeedbackListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDraftReplyFeedbackListResponse>(null as any);
    }

    smartsupp_CloseConversation(id: string): Promise<CloseConversationResponse> {
        let url_ = this.baseUrl + "/api/smartsupp/conversations/{id}/close";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSmartsupp_CloseConversation(_response);
        });
    }

    protected processSmartsupp_CloseConversation(response: Response): Promise<CloseConversationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CloseConversationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CloseConversationResponse>(null as any);
    }

    smartsupp_RecordPresence(id: string): Promise<RecordPresenceResponse> {
        let url_ = this.baseUrl + "/api/smartsupp/conversations/{id}/presence";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSmartsupp_RecordPresence(_response);
        });
    }

    protected processSmartsupp_RecordPresence(response: Response): Promise<RecordPresenceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecordPresenceResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecordPresenceResponse>(null as any);
    }

    smartsupp_RemovePresence(id: string): Promise<RemovePresenceResponse> {
        let url_ = this.baseUrl + "/api/smartsupp/conversations/{id}/presence";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSmartsupp_RemovePresence(_response);
        });
    }

    protected processSmartsupp_RemovePresence(response: Response): Promise<RemovePresenceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemovePresenceResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RemovePresenceResponse>(null as any);
    }

    smartsupp_RefreshOrphanContacts(): Promise<RefreshOrphanContactsResponse> {
        let url_ = this.baseUrl + "/api/smartsupp/admin/refresh-orphan-contacts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSmartsupp_RefreshOrphanContacts(_response);
        });
    }

    protected processSmartsupp_RefreshOrphanContacts(response: Response): Promise<RefreshOrphanContactsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshOrphanContactsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RefreshOrphanContactsResponse>(null as any);
    }

    smartsuppWebhookAudit_List(from: Date | null | undefined, to: Date | null | undefined, eventName: string | null | undefined, signatureStatus: SmartsuppWebhookSignatureStatus | null | undefined, processingStatus: SmartsuppWebhookProcessingStatus | null | undefined, skip: number | undefined, take: number | undefined): Promise<ListWebhookAuditResponse> {
        let url_ = this.baseUrl + "/api/admin/smartsupp/webhooks?";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (eventName !== undefined && eventName !== null)
            url_ += "eventName=" + encodeURIComponent("" + eventName) + "&";
        if (signatureStatus !== undefined && signatureStatus !== null)
            url_ += "signatureStatus=" + encodeURIComponent("" + signatureStatus) + "&";
        if (processingStatus !== undefined && processingStatus !== null)
            url_ += "processingStatus=" + encodeURIComponent("" + processingStatus) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSmartsuppWebhookAudit_List(_response);
        });
    }

    protected processSmartsuppWebhookAudit_List(response: Response): Promise<ListWebhookAuditResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListWebhookAuditResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListWebhookAuditResponse>(null as any);
    }

    smartsuppWebhookAudit_Get(id: string): Promise<GetWebhookAuditEntryResponse> {
        let url_ = this.baseUrl + "/api/admin/smartsupp/webhooks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSmartsuppWebhookAudit_Get(_response);
        });
    }

    protected processSmartsuppWebhookAudit_Get(response: Response): Promise<GetWebhookAuditEntryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWebhookAuditEntryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetWebhookAuditEntryResponse>(null as any);
    }

    smartsuppWebhookAudit_Replay(id: string): Promise<ReplayWebhookEventResponse> {
        let url_ = this.baseUrl + "/api/admin/smartsupp/webhooks/{id}/replay";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSmartsuppWebhookAudit_Replay(_response);
        });
    }

    protected processSmartsuppWebhookAudit_Replay(response: Response): Promise<ReplayWebhookEventResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReplayWebhookEventResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReplayWebhookEventResponse>(null as any);
    }

    smartsuppWebhook_Receive(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/webhooks/smartsupp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSmartsuppWebhook_Receive(_response);
        });
    }

    protected processSmartsuppWebhook_Receive(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    stockTaking_SubmitStockTaking(request: SubmitStockTakingRequest): Promise<SubmitStockTakingResponse> {
        let url_ = this.baseUrl + "/api/StockTaking/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStockTaking_SubmitStockTaking(_response);
        });
    }

    protected processStockTaking_SubmitStockTaking(response: Response): Promise<SubmitStockTakingResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitStockTakingResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitStockTakingResponse>(null as any);
    }

    stockTaking_GetStockTakingHistory(productCode: string | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDescending: boolean | undefined): Promise<GetStockTakingHistoryResponse> {
        let url_ = this.baseUrl + "/api/StockTaking/history?";
        if (productCode === null)
            throw new Error("The parameter 'productCode' cannot be null.");
        else if (productCode !== undefined)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStockTaking_GetStockTakingHistory(_response);
        });
    }

    protected processStockTaking_GetStockTakingHistory(response: Response): Promise<GetStockTakingHistoryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStockTakingHistoryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetStockTakingHistoryResponse>(null as any);
    }

    stockUpOperations_GetOperations(state: string | null | undefined, pageSize: number | null | undefined, page: number | null | undefined, sourceType: StockUpSourceType | null | undefined, sourceId: number | null | undefined, productCode: string | null | undefined, documentNumber: string | null | undefined, createdFrom: Date | null | undefined, createdTo: Date | null | undefined, sortBy: string | null | undefined, sortDescending: boolean | undefined): Promise<GetStockUpOperationsResponse> {
        let url_ = this.baseUrl + "/api/StockUpOperations?";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (sourceType !== undefined && sourceType !== null)
            url_ += "sourceType=" + encodeURIComponent("" + sourceType) + "&";
        if (sourceId !== undefined && sourceId !== null)
            url_ += "sourceId=" + encodeURIComponent("" + sourceId) + "&";
        if (productCode !== undefined && productCode !== null)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        if (documentNumber !== undefined && documentNumber !== null)
            url_ += "documentNumber=" + encodeURIComponent("" + documentNumber) + "&";
        if (createdFrom !== undefined && createdFrom !== null)
            url_ += "createdFrom=" + encodeURIComponent(createdFrom ? "" + createdFrom.toISOString() : "") + "&";
        if (createdTo !== undefined && createdTo !== null)
            url_ += "createdTo=" + encodeURIComponent(createdTo ? "" + createdTo.toISOString() : "") + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "sortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStockUpOperations_GetOperations(_response);
        });
    }

    protected processStockUpOperations_GetOperations(response: Response): Promise<GetStockUpOperationsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStockUpOperationsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetStockUpOperationsResponse>(null as any);
    }

    stockUpOperations_RetryOperation(id: number): Promise<RetryStockUpOperationResponse> {
        let url_ = this.baseUrl + "/api/StockUpOperations/{id}/retry";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStockUpOperations_RetryOperation(_response);
        });
    }

    protected processStockUpOperations_RetryOperation(response: Response): Promise<RetryStockUpOperationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RetryStockUpOperationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetryStockUpOperationResponse>(null as any);
    }

    stockUpOperations_AcceptOperation(id: number): Promise<AcceptStockUpOperationResponse> {
        let url_ = this.baseUrl + "/api/StockUpOperations/{id}/accept";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStockUpOperations_AcceptOperation(_response);
        });
    }

    protected processStockUpOperations_AcceptOperation(response: Response): Promise<AcceptStockUpOperationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcceptStockUpOperationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AcceptStockUpOperationResponse>(null as any);
    }

    stockUpOperations_GetSummary(sourceType: StockUpSourceType | null | undefined): Promise<GetStockUpOperationsSummaryResponse> {
        let url_ = this.baseUrl + "/api/StockUpOperations/summary?";
        if (sourceType !== undefined && sourceType !== null)
            url_ += "sourceType=" + encodeURIComponent("" + sourceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStockUpOperations_GetSummary(_response);
        });
    }

    protected processStockUpOperations_GetSummary(response: Response): Promise<GetStockUpOperationsSummaryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStockUpOperationsSummaryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetStockUpOperationsSummaryResponse>(null as any);
    }

    suppliers_SearchSuppliers(searchTerm: string | undefined, limit: number | undefined): Promise<SearchSuppliersResponse> {
        let url_ = this.baseUrl + "/api/suppliers/search?";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuppliers_SearchSuppliers(_response);
        });
    }

    protected processSuppliers_SearchSuppliers(response: Response): Promise<SearchSuppliersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchSuppliersResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchSuppliersResponse>(null as any);
    }

    transportBox_GetTransportBoxes(skip: number | undefined, take: number | undefined, code: string | null | undefined, state: string | null | undefined, productCode: string | null | undefined, sortBy: string | null | undefined, sortDescending: boolean | undefined): Promise<GetTransportBoxesResponse> {
        let url_ = this.baseUrl + "/api/transport-boxes?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (productCode !== undefined && productCode !== null)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransportBox_GetTransportBoxes(_response);
        });
    }

    protected processTransportBox_GetTransportBoxes(response: Response): Promise<GetTransportBoxesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransportBoxesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTransportBoxesResponse>(null as any);
    }

    transportBox_CreateNewTransportBox(request: CreateNewTransportBoxRequest): Promise<CreateNewTransportBoxResponse> {
        let url_ = this.baseUrl + "/api/transport-boxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransportBox_CreateNewTransportBox(_response);
        });
    }

    protected processTransportBox_CreateNewTransportBox(response: Response): Promise<CreateNewTransportBoxResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateNewTransportBoxResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateNewTransportBoxResponse>(null as any);
    }

    transportBox_GetTransportBoxSummary(code: string | null | undefined, productCode: string | null | undefined): Promise<GetTransportBoxSummaryResponse> {
        let url_ = this.baseUrl + "/api/transport-boxes/summary?";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (productCode !== undefined && productCode !== null)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransportBox_GetTransportBoxSummary(_response);
        });
    }

    protected processTransportBox_GetTransportBoxSummary(response: Response): Promise<GetTransportBoxSummaryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransportBoxSummaryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTransportBoxSummaryResponse>(null as any);
    }

    transportBox_GetTransportBoxById(id: number): Promise<GetTransportBoxByIdResponse> {
        let url_ = this.baseUrl + "/api/transport-boxes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransportBox_GetTransportBoxById(_response);
        });
    }

    protected processTransportBox_GetTransportBoxById(response: Response): Promise<GetTransportBoxByIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransportBoxByIdResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTransportBoxByIdResponse>(null as any);
    }

    transportBox_ChangeTransportBoxState(id: number, request: ChangeTransportBoxStateRequest): Promise<ChangeTransportBoxStateResponse> {
        let url_ = this.baseUrl + "/api/transport-boxes/{id}/state";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransportBox_ChangeTransportBoxState(_response);
        });
    }

    protected processTransportBox_ChangeTransportBoxState(response: Response): Promise<ChangeTransportBoxStateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeTransportBoxStateResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeTransportBoxStateResponse>(null as any);
    }

    transportBox_AddItemToBox(id: number, request: AddItemToBoxRequest): Promise<AddItemToBoxResponse> {
        let url_ = this.baseUrl + "/api/transport-boxes/{id}/items";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransportBox_AddItemToBox(_response);
        });
    }

    protected processTransportBox_AddItemToBox(response: Response): Promise<AddItemToBoxResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddItemToBoxResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddItemToBoxResponse>(null as any);
    }

    transportBox_RemoveItemFromBox(id: number, itemId: number, amount: number | null | undefined): Promise<RemoveItemFromBoxResponse> {
        let url_ = this.baseUrl + "/api/transport-boxes/{id}/items/{itemId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (amount !== undefined && amount !== null)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransportBox_RemoveItemFromBox(_response);
        });
    }

    protected processTransportBox_RemoveItemFromBox(response: Response): Promise<RemoveItemFromBoxResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemoveItemFromBoxResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RemoveItemFromBoxResponse>(null as any);
    }

    transportBox_UpdateTransportBoxDescription(id: number, request: UpdateTransportBoxDescriptionRequest): Promise<UpdateTransportBoxDescriptionResponse> {
        let url_ = this.baseUrl + "/api/transport-boxes/{id}/description";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransportBox_UpdateTransportBoxDescription(_response);
        });
    }

    protected processTransportBox_UpdateTransportBoxDescription(response: Response): Promise<UpdateTransportBoxDescriptionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateTransportBoxDescriptionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateTransportBoxDescriptionResponse>(null as any);
    }

    transportBox_GetTransportBoxByCode(boxCode: string): Promise<GetTransportBoxByCodeResponse> {
        let url_ = this.baseUrl + "/api/transport-boxes/by-code/{boxCode}";
        if (boxCode === undefined || boxCode === null)
            throw new Error("The parameter 'boxCode' must be defined.");
        url_ = url_.replace("{boxCode}", encodeURIComponent("" + boxCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransportBox_GetTransportBoxByCode(_response);
        });
    }

    protected processTransportBox_GetTransportBoxByCode(response: Response): Promise<GetTransportBoxByCodeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransportBoxByCodeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTransportBoxByCodeResponse>(null as any);
    }

    transportBox_OpenOrResumeBoxByCode(request: OpenOrResumeBoxByCodeRequest): Promise<OpenOrResumeBoxByCodeResponse> {
        let url_ = this.baseUrl + "/api/transport-boxes/open-by-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransportBox_OpenOrResumeBoxByCode(_response);
        });
    }

    protected processTransportBox_OpenOrResumeBoxByCode(response: Response): Promise<OpenOrResumeBoxByCodeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OpenOrResumeBoxByCodeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OpenOrResumeBoxByCodeResponse>(null as any);
    }

    userManagement_GetGroupMembers(groupId: string | undefined): Promise<GetGroupMembersResponse> {
        let url_ = this.baseUrl + "/api/UserManagement/group-members?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserManagement_GetGroupMembers(_response);
        });
    }

    protected processUserManagement_GetGroupMembers(response: Response): Promise<GetGroupMembersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGroupMembersResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetGroupMembersResponse>(null as any);
    }

    weatherForecast_Get(): Promise<GetWeatherForecastResponse> {
        let url_ = this.baseUrl + "/api/weather-forecast";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWeatherForecast_Get(_response);
        });
    }

    protected processWeatherForecast_Get(response: Response): Promise<GetWeatherForecastResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWeatherForecastResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetWeatherForecastResponse>(null as any);
    }
}

export abstract class BaseResponse implements IBaseResponse {
    success?: boolean;
    errorCode?: ErrorCodes | undefined;
    params?: { [key: string]: string; } | undefined;

    constructor(data?: IBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            if (_data["params"]) {
                this.params = {} as any;
                for (let key in _data["params"]) {
                    if (_data["params"].hasOwnProperty(key))
                        (<any>this.params)![key] = _data["params"][key];
                }
            }
        }
    }

    static fromJS(data: any): BaseResponse {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        if (this.params) {
            data["params"] = {};
            for (let key in this.params) {
                if (this.params.hasOwnProperty(key))
                    (<any>data["params"])[key] = (<any>this.params)[key];
            }
        }
        return data;
    }
}

export interface IBaseResponse {
    success?: boolean;
    errorCode?: ErrorCodes | undefined;
    params?: { [key: string]: string; } | undefined;
}

export class GetProductMarginSummaryResponse extends BaseResponse implements IGetProductMarginSummaryResponse {
    monthlyData?: MonthlyProductMarginDto[];
    topProducts?: TopProductDto[];
    totalMargin?: number;
    timeWindow?: string;
    groupingMode?: ProductGroupingMode;
    marginLevel?: MarginLevel;
    fromDate?: Date;
    toDate?: Date;

    constructor(data?: IGetProductMarginSummaryResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["monthlyData"])) {
                this.monthlyData = [] as any;
                for (let item of _data["monthlyData"])
                    this.monthlyData!.push(MonthlyProductMarginDto.fromJS(item));
            }
            if (Array.isArray(_data["topProducts"])) {
                this.topProducts = [] as any;
                for (let item of _data["topProducts"])
                    this.topProducts!.push(TopProductDto.fromJS(item));
            }
            this.totalMargin = _data["totalMargin"];
            this.timeWindow = _data["timeWindow"];
            this.groupingMode = _data["groupingMode"];
            this.marginLevel = _data["marginLevel"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetProductMarginSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductMarginSummaryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.monthlyData)) {
            data["monthlyData"] = [];
            for (let item of this.monthlyData)
                data["monthlyData"].push(item.toJSON());
        }
        if (Array.isArray(this.topProducts)) {
            data["topProducts"] = [];
            for (let item of this.topProducts)
                data["topProducts"].push(item.toJSON());
        }
        data["totalMargin"] = this.totalMargin;
        data["timeWindow"] = this.timeWindow;
        data["groupingMode"] = this.groupingMode;
        data["marginLevel"] = this.marginLevel;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetProductMarginSummaryResponse extends IBaseResponse {
    monthlyData?: MonthlyProductMarginDto[];
    topProducts?: TopProductDto[];
    totalMargin?: number;
    timeWindow?: string;
    groupingMode?: ProductGroupingMode;
    marginLevel?: MarginLevel;
    fromDate?: Date;
    toDate?: Date;
}

export class MonthlyProductMarginDto implements IMonthlyProductMarginDto {
    year?: number;
    month?: number;
    monthDisplay?: string;
    productSegments?: ProductMarginSegmentDto[];
    totalMonthMargin?: number;

    constructor(data?: IMonthlyProductMarginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.monthDisplay = _data["monthDisplay"];
            if (Array.isArray(_data["productSegments"])) {
                this.productSegments = [] as any;
                for (let item of _data["productSegments"])
                    this.productSegments!.push(ProductMarginSegmentDto.fromJS(item));
            }
            this.totalMonthMargin = _data["totalMonthMargin"];
        }
    }

    static fromJS(data: any): MonthlyProductMarginDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyProductMarginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["monthDisplay"] = this.monthDisplay;
        if (Array.isArray(this.productSegments)) {
            data["productSegments"] = [];
            for (let item of this.productSegments)
                data["productSegments"].push(item.toJSON());
        }
        data["totalMonthMargin"] = this.totalMonthMargin;
        return data;
    }
}

export interface IMonthlyProductMarginDto {
    year?: number;
    month?: number;
    monthDisplay?: string;
    productSegments?: ProductMarginSegmentDto[];
    totalMonthMargin?: number;
}

export class ProductMarginSegmentDto implements IProductMarginSegmentDto {
    groupKey?: string;
    displayName?: string;
    marginContribution?: number;
    percentage?: number;
    colorCode?: string;
    isOther?: boolean;
    averageMarginPerPiece?: number;
    unitsSold?: number;
    averageSellingPriceWithoutVat?: number;
    averageMaterialCosts?: number;
    averageLaborCosts?: number;
    productCount?: number;

    constructor(data?: IProductMarginSegmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupKey = _data["groupKey"];
            this.displayName = _data["displayName"];
            this.marginContribution = _data["marginContribution"];
            this.percentage = _data["percentage"];
            this.colorCode = _data["colorCode"];
            this.isOther = _data["isOther"];
            this.averageMarginPerPiece = _data["averageMarginPerPiece"];
            this.unitsSold = _data["unitsSold"];
            this.averageSellingPriceWithoutVat = _data["averageSellingPriceWithoutVat"];
            this.averageMaterialCosts = _data["averageMaterialCosts"];
            this.averageLaborCosts = _data["averageLaborCosts"];
            this.productCount = _data["productCount"];
        }
    }

    static fromJS(data: any): ProductMarginSegmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMarginSegmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupKey"] = this.groupKey;
        data["displayName"] = this.displayName;
        data["marginContribution"] = this.marginContribution;
        data["percentage"] = this.percentage;
        data["colorCode"] = this.colorCode;
        data["isOther"] = this.isOther;
        data["averageMarginPerPiece"] = this.averageMarginPerPiece;
        data["unitsSold"] = this.unitsSold;
        data["averageSellingPriceWithoutVat"] = this.averageSellingPriceWithoutVat;
        data["averageMaterialCosts"] = this.averageMaterialCosts;
        data["averageLaborCosts"] = this.averageLaborCosts;
        data["productCount"] = this.productCount;
        return data;
    }
}

export interface IProductMarginSegmentDto {
    groupKey?: string;
    displayName?: string;
    marginContribution?: number;
    percentage?: number;
    colorCode?: string;
    isOther?: boolean;
    averageMarginPerPiece?: number;
    unitsSold?: number;
    averageSellingPriceWithoutVat?: number;
    averageMaterialCosts?: number;
    averageLaborCosts?: number;
    productCount?: number;
}

export class TopProductDto implements ITopProductDto {
    groupKey?: string;
    displayName?: string;
    totalMargin?: number;
    colorCode?: string;
    rank?: number;
    m0Amount?: number;
    m1Amount?: number;
    m2Amount?: number;
    m0Percentage?: number;
    m1Percentage?: number;
    m2Percentage?: number;
    sellingPrice?: number;
    purchasePrice?: number;

    constructor(data?: ITopProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupKey = _data["groupKey"];
            this.displayName = _data["displayName"];
            this.totalMargin = _data["totalMargin"];
            this.colorCode = _data["colorCode"];
            this.rank = _data["rank"];
            this.m0Amount = _data["m0Amount"];
            this.m1Amount = _data["m1Amount"];
            this.m2Amount = _data["m2Amount"];
            this.m0Percentage = _data["m0Percentage"];
            this.m1Percentage = _data["m1Percentage"];
            this.m2Percentage = _data["m2Percentage"];
            this.sellingPrice = _data["sellingPrice"];
            this.purchasePrice = _data["purchasePrice"];
        }
    }

    static fromJS(data: any): TopProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupKey"] = this.groupKey;
        data["displayName"] = this.displayName;
        data["totalMargin"] = this.totalMargin;
        data["colorCode"] = this.colorCode;
        data["rank"] = this.rank;
        data["m0Amount"] = this.m0Amount;
        data["m1Amount"] = this.m1Amount;
        data["m2Amount"] = this.m2Amount;
        data["m0Percentage"] = this.m0Percentage;
        data["m1Percentage"] = this.m1Percentage;
        data["m2Percentage"] = this.m2Percentage;
        data["sellingPrice"] = this.sellingPrice;
        data["purchasePrice"] = this.purchasePrice;
        return data;
    }
}

export interface ITopProductDto {
    groupKey?: string;
    displayName?: string;
    totalMargin?: number;
    colorCode?: string;
    rank?: number;
    m0Amount?: number;
    m1Amount?: number;
    m2Amount?: number;
    m0Percentage?: number;
    m1Percentage?: number;
    m2Percentage?: number;
    sellingPrice?: number;
    purchasePrice?: number;
}

export enum ProductGroupingMode {
    Products = "Products",
    ProductFamily = "ProductFamily",
    ProductCategory = "ProductCategory",
}

export enum MarginLevel {
    M0 = "M0",
    M1 = "M1",
    M2 = "M2",
}

export enum ErrorCodes {
    ValidationError = "ValidationError",
    RequiredFieldMissing = "RequiredFieldMissing",
    InvalidFormat = "InvalidFormat",
    InvalidValue = "InvalidValue",
    InvalidDateRange = "InvalidDateRange",
    ResourceNotFound = "ResourceNotFound",
    BusinessRuleViolation = "BusinessRuleViolation",
    InvalidOperation = "InvalidOperation",
    DuplicateEntry = "DuplicateEntry",
    InternalServerError = "InternalServerError",
    DatabaseError = "DatabaseError",
    ConfigurationError = "ConfigurationError",
    Unauthorized = "Unauthorized",
    Forbidden = "Forbidden",
    TokenExpired = "TokenExpired",
    InsufficientPermissions = "InsufficientPermissions",
    Exception = "Exception",
    PurchaseOrderNotFound = "PurchaseOrderNotFound",
    SupplierNotFound = "SupplierNotFound",
    StatusTransitionNotAllowed = "StatusTransitionNotAllowed",
    InsufficientStock = "InsufficientStock",
    InvalidPurchaseOrderStatus = "InvalidPurchaseOrderStatus",
    InvalidSupplier = "InvalidSupplier",
    PurchaseOrderUpdateFailed = "PurchaseOrderUpdateFailed",
    PurchaseOrderLineNotFound = "PurchaseOrderLineNotFound",
    PurchaseOrderNumberGenerationFailed = "PurchaseOrderNumberGenerationFailed",
    ManufacturingDataNotAvailable = "ManufacturingDataNotAvailable",
    ManufactureAnalysisCalculationFailed = "ManufactureAnalysisCalculationFailed",
    InvalidAnalysisParameters = "InvalidAnalysisParameters",
    InsufficientManufacturingData = "InsufficientManufacturingData",
    ManufactureTemplateNotFound = "ManufactureTemplateNotFound",
    InvalidBatchSize = "InvalidBatchSize",
    IngredientNotFoundInTemplate = "IngredientNotFoundInTemplate",
    InvalidIngredientAmount = "InvalidIngredientAmount",
    FixedProductsExceedAvailableVolume = "FixedProductsExceedAvailableVolume",
    OrderNotFound = "OrderNotFound",
    CannotUpdateCompletedOrder = "CannotUpdateCompletedOrder",
    CannotUpdateCancelledOrder = "CannotUpdateCancelledOrder",
    CannotScheduleInPast = "CannotScheduleInPast",
    InvalidScheduleDateOrder = "InvalidScheduleDateOrder",
    ManufacturedInventoryItemNotFound = "ManufacturedInventoryItemNotFound",
    ManufacturedInventoryInsufficientStock = "ManufacturedInventoryInsufficientStock",
    ManufactureOrderNotCompleted = "ManufactureOrderNotCompleted",
    ManufactureInsufficientMaterialStock = "ManufactureInsufficientMaterialStock",
    CatalogItemNotFound = "CatalogItemNotFound",
    ManufactureDifficultyNotFound = "ManufactureDifficultyNotFound",
    ManufactureDifficultyConflict = "ManufactureDifficultyConflict",
    MarginCalculationError = "MarginCalculationError",
    DataAccessUnavailable = "DataAccessUnavailable",
    ProductNotFound = "ProductNotFound",
    MaterialNotFound = "MaterialNotFound",
    InvalidSearchCriteria = "InvalidSearchCriteria",
    ExternalSyncFailed = "ExternalSyncFailed",
    AttributeError = "AttributeError",
    SupplierLookupFailed = "SupplierLookupFailed",
    CategoryError = "CategoryError",
    UnitValidationFailed = "UnitValidationFailed",
    AbraIntegrationFailed = "AbraIntegrationFailed",
    ShoptetSyncFailed = "ShoptetSyncFailed",
    StockTakingFailed = "StockTakingFailed",
    NdWriteFailed = "NdWriteFailed",
    TransportBoxNotFound = "TransportBoxNotFound",
    TransportBoxStateChangeError = "TransportBoxStateChangeError",
    TransportBoxCreationError = "TransportBoxCreationError",
    TransportBoxItemError = "TransportBoxItemError",
    TransportBoxDuplicateActiveBoxFound = "TransportBoxDuplicateActiveBoxFound",
    TransportBoxCodeRequired = "TransportBoxCodeRequired",
    TransportBoxCodeInvalidFormat = "TransportBoxCodeInvalidFormat",
    TransportBoxEmpty = "TransportBoxEmpty",
    TransportBoxInvalidStateTransition = "TransportBoxInvalidStateTransition",
    ConfigurationNotFound = "ConfigurationNotFound",
    JournalEntryNotFound = "JournalEntryNotFound",
    InvalidJournalTitle = "InvalidJournalTitle",
    InvalidJournalContent = "InvalidJournalContent",
    JournalTagNotFound = "JournalTagNotFound",
    JournalTagCreationFailed = "JournalTagCreationFailed",
    InvalidJournalDateFilter = "InvalidJournalDateFilter",
    JournalDeleteNotAllowed = "JournalDeleteNotAllowed",
    UnauthorizedJournalAccess = "UnauthorizedJournalAccess",
    DuplicateJournalTag = "DuplicateJournalTag",
    InvalidJournalEntryData = "InvalidJournalEntryData",
    AnalysisDataNotAvailable = "AnalysisDataNotAvailable",
    MarginCalculationFailed = "MarginCalculationFailed",
    InsufficientData = "InsufficientData",
    ProductNotFoundForAnalysis = "ProductNotFoundForAnalysis",
    InvalidReportPeriod = "InvalidReportPeriod",
    InvalidTimeWindow = "InvalidTimeWindow",
    InvalidUrlFormat = "InvalidUrlFormat",
    InvalidContainerName = "InvalidContainerName",
    FileDownloadFailed = "FileDownloadFailed",
    BlobUploadFailed = "BlobUploadFailed",
    BlobNotFound = "BlobNotFound",
    FileTooLarge = "FileTooLarge",
    UnsupportedFileType = "UnsupportedFileType",
    InvalidBlobPath = "InvalidBlobPath",
    RecurringJobNotFound = "RecurringJobNotFound",
    RecurringJobUpdateFailed = "RecurringJobUpdateFailed",
    InvalidCronExpression = "InvalidCronExpression",
    RecurringJobDisabled = "RecurringJobDisabled",
    RecurringJobEnqueueFailed = "RecurringJobEnqueueFailed",
    RecurringJobAlreadyRunning = "RecurringJobAlreadyRunning",
    KnowledgeBaseFeedbackLogNotFound = "KnowledgeBaseFeedbackLogNotFound",
    KnowledgeBaseFeedbackAlreadySubmitted = "KnowledgeBaseFeedbackAlreadySubmitted",
    KnowledgeBaseChunkNotFound = "KnowledgeBaseChunkNotFound",
    KnowledgeBaseAiUnavailable = "KnowledgeBaseAiUnavailable",
    ShoptetOrderInvalidSourceState = "ShoptetOrderInvalidSourceState",
    ShoptetOrderNotFound = "ShoptetOrderNotFound",
    ExpeditionOrderInvalidState = "ExpeditionOrderInvalidState",
    ExpeditionOrderNotPrinted = "ExpeditionOrderNotPrinted",
    DqtRunNotFound = "DqtRunNotFound",
    DqtInvalidDateRange = "DqtInvalidDateRange",
    DqtExternalServiceError = "DqtExternalServiceError",
    DqtUnsupportedTestType = "DqtUnsupportedTestType",
    MarketingActionNotFound = "MarketingActionNotFound",
    UnauthorizedMarketingAccess = "UnauthorizedMarketingAccess",
    MarketingCalendarAccessDenied = "MarketingCalendarAccessDenied",
    MarketingCalendarSyncFailed = "MarketingCalendarSyncFailed",
    ArticleNotFound = "ArticleNotFound",
    ArticleGenerationFailed = "ArticleGenerationFailed",
    WebSearchUnavailable = "WebSearchUnavailable",
    StyleGuideFetchFailed = "StyleGuideFetchFailed",
    ArticleAlreadyGenerated = "ArticleAlreadyGenerated",
    ArticleNotGenerated = "ArticleNotGenerated",
    ArticleFeedbackAlreadySubmitted = "ArticleFeedbackAlreadySubmitted",
    LeafletChunkNotFound = "LeafletChunkNotFound",
    LeafletFeedbackNotFound = "LeafletFeedbackNotFound",
    LeafletFeedbackAlreadySubmitted = "LeafletFeedbackAlreadySubmitted",
    LeafletEmptyRetrieval = "LeafletEmptyRetrieval",
    PhotoNotFound = "PhotoNotFound",
    PhotobankRootNotFound = "PhotobankRootNotFound",
    PhotobankRuleNotFound = "PhotobankRuleNotFound",
    PhotoTagCreationFailed = "PhotoTagCreationFailed",
    BulkTagFiltersRequired = "BulkTagFiltersRequired",
    BulkTagLimitExceeded = "BulkTagLimitExceeded",
    BulkTagInvalidRequest = "BulkTagInvalidRequest",
    PhotobankTagNotFound = "PhotobankTagNotFound",
    PhotobankInvalidRegexPattern = "PhotobankInvalidRegexPattern",
    PhotobankThumbnailNotFound = "PhotobankThumbnailNotFound",
    PhotobankThumbnailThrottled = "PhotobankThumbnailThrottled",
    PhotobankThumbnailAuthUnavailable = "PhotobankThumbnailAuthUnavailable",
    PhotobankThumbnailUpstream = "PhotobankThumbnailUpstream",
    SmartsuppConversationNotFound = "SmartsuppConversationNotFound",
    SmartsuppDraftReplyAiUnavailable = "SmartsuppDraftReplyAiUnavailable",
    SmartsuppConversationEmpty = "SmartsuppConversationEmpty",
    SmartsuppShoptetCustomerNotFound = "SmartsuppShoptetCustomerNotFound",
    SmartsuppVisitorNotFound = "SmartsuppVisitorNotFound",
    SmartsuppSendMessageUnavailable = "SmartsuppSendMessageUnavailable",
    SmartsuppAgentMappingNotFound = "SmartsuppAgentMappingNotFound",
    SmartsuppCloseConversationUnavailable = "SmartsuppCloseConversationUnavailable",
    SmartsuppDraftReplyFeedbackLogNotFound = "SmartsuppDraftReplyFeedbackLogNotFound",
    SmartsuppDraftReplyFeedbackAlreadySubmitted = "SmartsuppDraftReplyFeedbackAlreadySubmitted",
    SmartsuppAttachmentInvalid = "SmartsuppAttachmentInvalid",
    SmartsuppAttachmentTooLarge = "SmartsuppAttachmentTooLarge",
    SmartsuppAttachmentUploadFailed = "SmartsuppAttachmentUploadFailed",
    LotNotFound = "LotNotFound",
    MaterialContainerNotFound = "MaterialContainerNotFound",
    LotAlreadyExists = "LotAlreadyExists",
    InventoryMaterialNotFound = "InventoryMaterialNotFound",
    InventoryMaterialInvalidType = "InventoryMaterialInvalidType",
    LotHasEans = "LotHasEans",
    MaterialContainerCodeExists = "MaterialContainerCodeExists",
    MaterialContainerCodeInvalidFormat = "MaterialContainerCodeInvalidFormat",
    UnknownMaterialContainerCode = "UnknownMaterialContainerCode",
    WeatherForecastUnavailable = "WeatherForecastUnavailable",
    ShipmentLabelsNoShipmentFound = "ShipmentLabelsNoShipmentFound",
    ShipmentLabelsNotGenerated = "ShipmentLabelsNotGenerated",
    ShipmentAlreadyExists = "ShipmentAlreadyExists",
    ShipmentCarrierNotResolved = "ShipmentCarrierNotResolved",
    ShipmentCreationFailed = "ShipmentCreationFailed",
    ShipmentLabelNotReady = "ShipmentLabelNotReady",
    ShipmentOrderWeightUnavailable = "ShipmentOrderWeightUnavailable",
    ShipmentValidationFailed = "ShipmentValidationFailed",
    OrderNotInPackingState = "OrderNotInPackingState",
    ShipmentCancelFailed = "ShipmentCancelFailed",
    NoShipmentToReset = "NoShipmentToReset",
    PackageLabelNotFound = "PackageLabelNotFound",
    PackageLabelDownloadFailed = "PackageLabelDownloadFailed",
    PackageNotFound = "PackageNotFound",
    InvalidPackageCount = "InvalidPackageCount",
    PackingCompletionFailed = "PackingCompletionFailed",
    PackingUserNotEligible = "PackingUserNotEligible",
    CatalogDocumentInvalidTypeCode = "CatalogDocumentInvalidTypeCode",
    CatalogDocumentLotRequired = "CatalogDocumentLotRequired",
    CatalogDocumentFolderNotFound = "CatalogDocumentFolderNotFound",
    CatalogDocumentFolderMultipleMatches = "CatalogDocumentFolderMultipleMatches",
    CatalogDocumentFileMissing = "CatalogDocumentFileMissing",
    CatalogDocumentGraphError = "CatalogDocumentGraphError",
    AuthorizationGroupNotFound = "AuthorizationGroupNotFound",
    AuthorizationUserNotFound = "AuthorizationUserNotFound",
    AuthorizationInvalidPermission = "AuthorizationInvalidPermission",
    AuthorizationGroupCycleDetected = "AuthorizationGroupCycleDetected",
    AuthorizationDuplicateGroupName = "AuthorizationDuplicateGroupName",
    LabelPhotoMissingOrInvalid = "LabelPhotoMissingOrInvalid",
    LabelPhotoUndecodable = "LabelPhotoUndecodable",
    LabelTextUnreadable = "LabelTextUnreadable",
    LabelOcrServiceUnavailable = "LabelOcrServiceUnavailable",
    OvertimeEmployeeNotFound = "OvertimeEmployeeNotFound",
    OvertimeMonthAlreadyClosed = "OvertimeMonthAlreadyClosed",
    OvertimeAdjustmentNotFound = "OvertimeAdjustmentNotFound",
    OvertimeAdjustmentMonthClosed = "OvertimeAdjustmentMonthClosed",
    OvertimeMonthNotReviewed = "OvertimeMonthNotReviewed",
    OvertimeContractHoursMissing = "OvertimeContractHoursMissing",
    OvertimePreviousMonthOpen = "OvertimePreviousMonthOpen",
    OvertimeExportPublishFailed = "OvertimeExportPublishFailed",
    MindMapUpdateInProgress = "MindMapUpdateInProgress",
    MindMapMeetingAlreadyAttached = "MindMapMeetingAlreadyAttached",
    MindMapInvalidDocument = "MindMapInvalidDocument",
    ProductPriceNotFoundInShoptet = "ProductPriceNotFoundInShoptet",
    ProductPriceFlexiItemIdUnknown = "ProductPriceFlexiItemIdUnknown",
    ProductPriceShoptetWriteFailed = "ProductPriceShoptetWriteFailed",
    ProductPriceFlexiWriteFailed = "ProductPriceFlexiWriteFailed",
    ProductPriceErpReadFailed = "ProductPriceErpReadFailed",
    MarketingPerformanceInvalidMonthRange = "MarketingPerformanceInvalidMonthRange",
    MarketingPerformanceRangeTooLarge = "MarketingPerformanceRangeTooLarge",
    MarketingPerformanceRecomputeAlreadyRunning = "MarketingPerformanceRecomputeAlreadyRunning",
    MarketingPerformanceEnqueueFailed = "MarketingPerformanceEnqueueFailed",
    PricingInvalidPrice = "PricingInvalidPrice",
    PricingNegativeMaterialCost = "PricingNegativeMaterialCost",
    PricingNegativeManufacturingCost = "PricingNegativeManufacturingCost",
    PricingNegativeQuantity = "PricingNegativeQuantity",
    PricingScenarioNotFound = "PricingScenarioNotFound",
    PricingScenarioNameConflict = "PricingScenarioNameConflict",
    PricingProductNotInBaseline = "PricingProductNotInBaseline",
    ReportingDatasetNotFound = "ReportingDatasetNotFound",
    ReportingInvalidQuery = "ReportingInvalidQuery",
    ReportingQueryTimeout = "ReportingQueryTimeout",
    MarketingAdsProposalNotFound = "MarketingAdsProposalNotFound",
    MarketingAdsProposalVersionMismatch = "MarketingAdsProposalVersionMismatch",
    MarketingAdsProposalNotPending = "MarketingAdsProposalNotPending",
    MarketingAdsProposalExpired = "MarketingAdsProposalExpired",
    MarketingAdsApprovalChannelDenied = "MarketingAdsApprovalChannelDenied",
    MarketingAdsLimitsDenied = "MarketingAdsLimitsDenied",
    MarketingAdsNeedsWebApproval = "MarketingAdsNeedsWebApproval",
    MarketingAdsAlreadyApprovedByPrincipal = "MarketingAdsAlreadyApprovedByPrincipal",
    MarketingAdsInvalidProposal = "MarketingAdsInvalidProposal",
    MarketingAdsNotRevertible = "MarketingAdsNotRevertible",
    MarketingAdsRevertFailed = "MarketingAdsRevertFailed",
    MarketingAdsAgentRunNotFound = "MarketingAdsAgentRunNotFound",
    MarketingAdsInvalidSetting = "MarketingAdsInvalidSetting",
    MarketingAdsConcurrentChange = "MarketingAdsConcurrentChange",
    MarketingAdsNoExecutor = "MarketingAdsNoExecutor",
    MarketingAdsNotProposalOwner = "MarketingAdsNotProposalOwner",
    MarketingAdsInvalidAgentRun = "MarketingAdsInvalidAgentRun",
    ExternalServiceError = "ExternalServiceError",
    FlexiApiError = "FlexiApiError",
    ShoptetApiError = "ShoptetApiError",
    PaymentGatewayError = "PaymentGatewayError",
    ErpGatewayError = "ErpGatewayError",
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class GetProductMarginAnalysisResponse extends BaseResponse implements IGetProductMarginAnalysisResponse {
    productId?: string;
    productName?: string;
    totalMargin?: number;
    marginPercentage?: number;
    totalRevenue?: number;
    totalCost?: number;
    totalUnitsSold?: number;
    analysisPeriodStart?: Date;
    analysisPeriodEnd?: Date;
    monthlyBreakdown?: MonthlyMarginBreakdownDto[];

    constructor(data?: IGetProductMarginAnalysisResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.totalMargin = _data["totalMargin"];
            this.marginPercentage = _data["marginPercentage"];
            this.totalRevenue = _data["totalRevenue"];
            this.totalCost = _data["totalCost"];
            this.totalUnitsSold = _data["totalUnitsSold"];
            this.analysisPeriodStart = _data["analysisPeriodStart"] ? new Date(_data["analysisPeriodStart"].toString()) : <any>undefined;
            this.analysisPeriodEnd = _data["analysisPeriodEnd"] ? new Date(_data["analysisPeriodEnd"].toString()) : <any>undefined;
            if (Array.isArray(_data["monthlyBreakdown"])) {
                this.monthlyBreakdown = [] as any;
                for (let item of _data["monthlyBreakdown"])
                    this.monthlyBreakdown!.push(MonthlyMarginBreakdownDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetProductMarginAnalysisResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductMarginAnalysisResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["totalMargin"] = this.totalMargin;
        data["marginPercentage"] = this.marginPercentage;
        data["totalRevenue"] = this.totalRevenue;
        data["totalCost"] = this.totalCost;
        data["totalUnitsSold"] = this.totalUnitsSold;
        data["analysisPeriodStart"] = this.analysisPeriodStart ? this.analysisPeriodStart.toISOString() : <any>undefined;
        data["analysisPeriodEnd"] = this.analysisPeriodEnd ? this.analysisPeriodEnd.toISOString() : <any>undefined;
        if (Array.isArray(this.monthlyBreakdown)) {
            data["monthlyBreakdown"] = [];
            for (let item of this.monthlyBreakdown)
                data["monthlyBreakdown"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetProductMarginAnalysisResponse extends IBaseResponse {
    productId?: string;
    productName?: string;
    totalMargin?: number;
    marginPercentage?: number;
    totalRevenue?: number;
    totalCost?: number;
    totalUnitsSold?: number;
    analysisPeriodStart?: Date;
    analysisPeriodEnd?: Date;
    monthlyBreakdown?: MonthlyMarginBreakdownDto[];
}

export class MonthlyMarginBreakdownDto implements IMonthlyMarginBreakdownDto {
    month?: Date;
    marginAmount?: number;
    revenue?: number;
    cost?: number;
    unitsSold?: number;

    constructor(data?: IMonthlyMarginBreakdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"] ? new Date(_data["month"].toString()) : <any>undefined;
            this.marginAmount = _data["marginAmount"];
            this.revenue = _data["revenue"];
            this.cost = _data["cost"];
            this.unitsSold = _data["unitsSold"];
        }
    }

    static fromJS(data: any): MonthlyMarginBreakdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyMarginBreakdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month ? this.month.toISOString() : <any>undefined;
        data["marginAmount"] = this.marginAmount;
        data["revenue"] = this.revenue;
        data["cost"] = this.cost;
        data["unitsSold"] = this.unitsSold;
        return data;
    }
}

export interface IMonthlyMarginBreakdownDto {
    month?: Date;
    marginAmount?: number;
    revenue?: number;
    cost?: number;
    unitsSold?: number;
}

export class GetMarginReportResponse extends BaseResponse implements IGetMarginReportResponse {
    reportPeriodStart?: Date;
    reportPeriodEnd?: Date;
    totalMargin?: number;
    totalRevenue?: number;
    totalCost?: number;
    averageMarginPercentage?: number;
    totalProductsAnalyzed?: number;
    totalUnitsSold?: number;
    productSummaries?: ProductMarginSummaryDto[];
    categorySummaries?: CategoryMarginSummaryDto[];

    constructor(data?: IGetMarginReportResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reportPeriodStart = _data["reportPeriodStart"] ? new Date(_data["reportPeriodStart"].toString()) : <any>undefined;
            this.reportPeriodEnd = _data["reportPeriodEnd"] ? new Date(_data["reportPeriodEnd"].toString()) : <any>undefined;
            this.totalMargin = _data["totalMargin"];
            this.totalRevenue = _data["totalRevenue"];
            this.totalCost = _data["totalCost"];
            this.averageMarginPercentage = _data["averageMarginPercentage"];
            this.totalProductsAnalyzed = _data["totalProductsAnalyzed"];
            this.totalUnitsSold = _data["totalUnitsSold"];
            if (Array.isArray(_data["productSummaries"])) {
                this.productSummaries = [] as any;
                for (let item of _data["productSummaries"])
                    this.productSummaries!.push(ProductMarginSummaryDto.fromJS(item));
            }
            if (Array.isArray(_data["categorySummaries"])) {
                this.categorySummaries = [] as any;
                for (let item of _data["categorySummaries"])
                    this.categorySummaries!.push(CategoryMarginSummaryDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetMarginReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarginReportResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportPeriodStart"] = this.reportPeriodStart ? this.reportPeriodStart.toISOString() : <any>undefined;
        data["reportPeriodEnd"] = this.reportPeriodEnd ? this.reportPeriodEnd.toISOString() : <any>undefined;
        data["totalMargin"] = this.totalMargin;
        data["totalRevenue"] = this.totalRevenue;
        data["totalCost"] = this.totalCost;
        data["averageMarginPercentage"] = this.averageMarginPercentage;
        data["totalProductsAnalyzed"] = this.totalProductsAnalyzed;
        data["totalUnitsSold"] = this.totalUnitsSold;
        if (Array.isArray(this.productSummaries)) {
            data["productSummaries"] = [];
            for (let item of this.productSummaries)
                data["productSummaries"].push(item.toJSON());
        }
        if (Array.isArray(this.categorySummaries)) {
            data["categorySummaries"] = [];
            for (let item of this.categorySummaries)
                data["categorySummaries"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetMarginReportResponse extends IBaseResponse {
    reportPeriodStart?: Date;
    reportPeriodEnd?: Date;
    totalMargin?: number;
    totalRevenue?: number;
    totalCost?: number;
    averageMarginPercentage?: number;
    totalProductsAnalyzed?: number;
    totalUnitsSold?: number;
    productSummaries?: ProductMarginSummaryDto[];
    categorySummaries?: CategoryMarginSummaryDto[];
}

export class ProductMarginSummaryDto implements IProductMarginSummaryDto {
    productId?: string;
    productName?: string;
    category?: string;
    marginAmount?: number;
    m0Amount?: number;
    m1Amount?: number;
    m2Amount?: number;
    m0Percentage?: number;
    m1Percentage?: number;
    m2Percentage?: number;
    sellingPrice?: number;
    purchasePrice?: number;
    marginPercentage?: number;
    revenue?: number;
    cost?: number;
    unitsSold?: number;

    constructor(data?: IProductMarginSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.category = _data["category"];
            this.marginAmount = _data["marginAmount"];
            this.m0Amount = _data["m0Amount"];
            this.m1Amount = _data["m1Amount"];
            this.m2Amount = _data["m2Amount"];
            this.m0Percentage = _data["m0Percentage"];
            this.m1Percentage = _data["m1Percentage"];
            this.m2Percentage = _data["m2Percentage"];
            this.sellingPrice = _data["sellingPrice"];
            this.purchasePrice = _data["purchasePrice"];
            this.marginPercentage = _data["marginPercentage"];
            this.revenue = _data["revenue"];
            this.cost = _data["cost"];
            this.unitsSold = _data["unitsSold"];
        }
    }

    static fromJS(data: any): ProductMarginSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMarginSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["category"] = this.category;
        data["marginAmount"] = this.marginAmount;
        data["m0Amount"] = this.m0Amount;
        data["m1Amount"] = this.m1Amount;
        data["m2Amount"] = this.m2Amount;
        data["m0Percentage"] = this.m0Percentage;
        data["m1Percentage"] = this.m1Percentage;
        data["m2Percentage"] = this.m2Percentage;
        data["sellingPrice"] = this.sellingPrice;
        data["purchasePrice"] = this.purchasePrice;
        data["marginPercentage"] = this.marginPercentage;
        data["revenue"] = this.revenue;
        data["cost"] = this.cost;
        data["unitsSold"] = this.unitsSold;
        return data;
    }
}

export interface IProductMarginSummaryDto {
    productId?: string;
    productName?: string;
    category?: string;
    marginAmount?: number;
    m0Amount?: number;
    m1Amount?: number;
    m2Amount?: number;
    m0Percentage?: number;
    m1Percentage?: number;
    m2Percentage?: number;
    sellingPrice?: number;
    purchasePrice?: number;
    marginPercentage?: number;
    revenue?: number;
    cost?: number;
    unitsSold?: number;
}

export class CategoryMarginSummaryDto implements ICategoryMarginSummaryDto {
    category?: string;
    totalMargin?: number;
    totalRevenue?: number;
    averageMarginPercentage?: number;
    productCount?: number;
    totalUnitsSold?: number;

    constructor(data?: ICategoryMarginSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.totalMargin = _data["totalMargin"];
            this.totalRevenue = _data["totalRevenue"];
            this.averageMarginPercentage = _data["averageMarginPercentage"];
            this.productCount = _data["productCount"];
            this.totalUnitsSold = _data["totalUnitsSold"];
        }
    }

    static fromJS(data: any): CategoryMarginSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryMarginSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["totalMargin"] = this.totalMargin;
        data["totalRevenue"] = this.totalRevenue;
        data["averageMarginPercentage"] = this.averageMarginPercentage;
        data["productCount"] = this.productCount;
        data["totalUnitsSold"] = this.totalUnitsSold;
        return data;
    }
}

export interface ICategoryMarginSummaryDto {
    category?: string;
    totalMargin?: number;
    totalRevenue?: number;
    averageMarginPercentage?: number;
    productCount?: number;
    totalUnitsSold?: number;
}

export class GetInvoiceImportStatisticsResponse extends BaseResponse implements IGetInvoiceImportStatisticsResponse {
    data?: DailyInvoiceCountDto[];
    minimumThreshold?: number;

    constructor(data?: IGetInvoiceImportStatisticsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DailyInvoiceCountDto.fromJS(item));
            }
            this.minimumThreshold = _data["minimumThreshold"];
        }
    }

    static override fromJS(data: any): GetInvoiceImportStatisticsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvoiceImportStatisticsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["minimumThreshold"] = this.minimumThreshold;
        super.toJSON(data);
        return data;
    }
}

export interface IGetInvoiceImportStatisticsResponse extends IBaseResponse {
    data?: DailyInvoiceCountDto[];
    minimumThreshold?: number;
}

export class DailyInvoiceCountDto implements IDailyInvoiceCountDto {
    date?: Date;
    count?: number;
    isBelowThreshold?: boolean;

    constructor(data?: IDailyInvoiceCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.count = _data["count"];
            this.isBelowThreshold = _data["isBelowThreshold"];
        }
    }

    static fromJS(data: any): DailyInvoiceCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new DailyInvoiceCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["count"] = this.count;
        data["isBelowThreshold"] = this.isBelowThreshold;
        return data;
    }
}

export interface IDailyInvoiceCountDto {
    date?: Date;
    count?: number;
    isBelowThreshold?: boolean;
}

export enum ImportDateType {
    InvoiceDate = "InvoiceDate",
    LastSyncTime = "LastSyncTime",
}

export class GetBankStatementImportStatisticsResponse extends BaseResponse implements IGetBankStatementImportStatisticsResponse {
    statistics?: DailyBankStatementStatistics[];

    constructor(data?: IGetBankStatementImportStatisticsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["statistics"])) {
                this.statistics = [] as any;
                for (let item of _data["statistics"])
                    this.statistics!.push(DailyBankStatementStatistics.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetBankStatementImportStatisticsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankStatementImportStatisticsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statistics)) {
            data["statistics"] = [];
            for (let item of this.statistics)
                data["statistics"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetBankStatementImportStatisticsResponse extends IBaseResponse {
    statistics?: DailyBankStatementStatistics[];
}

export class DailyBankStatementStatistics implements IDailyBankStatementStatistics {
    date?: Date;
    importCount?: number;
    totalItemCount?: number;

    constructor(data?: IDailyBankStatementStatistics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.importCount = _data["importCount"];
            this.totalItemCount = _data["totalItemCount"];
        }
    }

    static fromJS(data: any): DailyBankStatementStatistics {
        data = typeof data === 'object' ? data : {};
        let result = new DailyBankStatementStatistics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["importCount"] = this.importCount;
        data["totalItemCount"] = this.totalItemCount;
        return data;
    }
}

export interface IDailyBankStatementStatistics {
    date?: Date;
    importCount?: number;
    totalItemCount?: number;
}

export enum BankStatementDateType {
    StatementDate = "StatementDate",
    ImportDate = "ImportDate",
}

export class GenerateArticleResponse extends BaseResponse implements IGenerateArticleResponse {
    articleId?: string | undefined;
    hangfireJobId?: string | undefined;
    status?: ArticleStatus;

    constructor(data?: IGenerateArticleResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articleId = _data["articleId"];
            this.hangfireJobId = _data["hangfireJobId"];
            this.status = _data["status"];
        }
    }

    static override fromJS(data: any): GenerateArticleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateArticleResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["hangfireJobId"] = this.hangfireJobId;
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IGenerateArticleResponse extends IBaseResponse {
    articleId?: string | undefined;
    hangfireJobId?: string | undefined;
    status?: ArticleStatus;
}

export enum ArticleStatus {
    Queued = "Queued",
    Researching = "Researching",
    Writing = "Writing",
    Generated = "Generated",
    Failed = "Failed",
}

export class GenerateArticleRequest implements IGenerateArticleRequest {
    topic!: string;
    scope!: string;
    audience?: string | undefined;
    angle?: string | undefined;
    length!: string;
    languageNote?: string | undefined;
    useKnowledgeBase?: boolean;
    useWebSearch?: boolean;
    styleGuideDriveId?: string | undefined;
    styleGuideItemPath?: string | undefined;

    constructor(data?: IGenerateArticleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topic = _data["topic"];
            this.scope = _data["scope"];
            this.audience = _data["audience"];
            this.angle = _data["angle"];
            this.length = _data["length"];
            this.languageNote = _data["languageNote"];
            this.useKnowledgeBase = _data["useKnowledgeBase"];
            this.useWebSearch = _data["useWebSearch"];
            this.styleGuideDriveId = _data["styleGuideDriveId"];
            this.styleGuideItemPath = _data["styleGuideItemPath"];
        }
    }

    static fromJS(data: any): GenerateArticleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateArticleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topic"] = this.topic;
        data["scope"] = this.scope;
        data["audience"] = this.audience;
        data["angle"] = this.angle;
        data["length"] = this.length;
        data["languageNote"] = this.languageNote;
        data["useKnowledgeBase"] = this.useKnowledgeBase;
        data["useWebSearch"] = this.useWebSearch;
        data["styleGuideDriveId"] = this.styleGuideDriveId;
        data["styleGuideItemPath"] = this.styleGuideItemPath;
        return data;
    }
}

export interface IGenerateArticleRequest {
    topic: string;
    scope: string;
    audience?: string | undefined;
    angle?: string | undefined;
    length: string;
    languageNote?: string | undefined;
    useKnowledgeBase?: boolean;
    useWebSearch?: boolean;
    styleGuideDriveId?: string | undefined;
    styleGuideItemPath?: string | undefined;
}

export class GetArticleResponse extends BaseResponse implements IGetArticleResponse {
    id?: string;
    topic?: string;
    scope?: string;
    audience?: string | undefined;
    angle?: string | undefined;
    length?: string;
    title?: string | undefined;
    htmlContent?: string | undefined;
    status?: ArticleStatus;
    errorMessage?: string | undefined;
    createdAt?: Date;
    generatedAt?: Date | undefined;
    useKnowledgeBase?: boolean;
    useWebSearch?: boolean;
    sources?: ArticleSourceDto[];
    precisionScore?: number | undefined;
    styleScore?: number | undefined;
    feedbackComment?: string | undefined;

    constructor(data?: IGetArticleResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.topic = _data["topic"];
            this.scope = _data["scope"];
            this.audience = _data["audience"];
            this.angle = _data["angle"];
            this.length = _data["length"];
            this.title = _data["title"];
            this.htmlContent = _data["htmlContent"];
            this.status = _data["status"];
            this.errorMessage = _data["errorMessage"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.generatedAt = _data["generatedAt"] ? new Date(_data["generatedAt"].toString()) : <any>undefined;
            this.useKnowledgeBase = _data["useKnowledgeBase"];
            this.useWebSearch = _data["useWebSearch"];
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(ArticleSourceDto.fromJS(item));
            }
            this.precisionScore = _data["precisionScore"];
            this.styleScore = _data["styleScore"];
            this.feedbackComment = _data["feedbackComment"];
        }
    }

    static override fromJS(data: any): GetArticleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticleResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["topic"] = this.topic;
        data["scope"] = this.scope;
        data["audience"] = this.audience;
        data["angle"] = this.angle;
        data["length"] = this.length;
        data["title"] = this.title;
        data["htmlContent"] = this.htmlContent;
        data["status"] = this.status;
        data["errorMessage"] = this.errorMessage;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["generatedAt"] = this.generatedAt ? this.generatedAt.toISOString() : <any>undefined;
        data["useKnowledgeBase"] = this.useKnowledgeBase;
        data["useWebSearch"] = this.useWebSearch;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item.toJSON());
        }
        data["precisionScore"] = this.precisionScore;
        data["styleScore"] = this.styleScore;
        data["feedbackComment"] = this.feedbackComment;
        super.toJSON(data);
        return data;
    }
}

export interface IGetArticleResponse extends IBaseResponse {
    id?: string;
    topic?: string;
    scope?: string;
    audience?: string | undefined;
    angle?: string | undefined;
    length?: string;
    title?: string | undefined;
    htmlContent?: string | undefined;
    status?: ArticleStatus;
    errorMessage?: string | undefined;
    createdAt?: Date;
    generatedAt?: Date | undefined;
    useKnowledgeBase?: boolean;
    useWebSearch?: boolean;
    sources?: ArticleSourceDto[];
    precisionScore?: number | undefined;
    styleScore?: number | undefined;
    feedbackComment?: string | undefined;
}

export class ArticleSourceDto implements IArticleSourceDto {
    title?: string;
    url?: string | undefined;
    type?: string;
    knowledgeBaseChunkId?: string | undefined;
    confidence?: number | undefined;
    excerpt?: string | undefined;
    validationNote?: string | undefined;

    constructor(data?: IArticleSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.url = _data["url"];
            this.type = _data["type"];
            this.knowledgeBaseChunkId = _data["knowledgeBaseChunkId"];
            this.confidence = _data["confidence"];
            this.excerpt = _data["excerpt"];
            this.validationNote = _data["validationNote"];
        }
    }

    static fromJS(data: any): ArticleSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["url"] = this.url;
        data["type"] = this.type;
        data["knowledgeBaseChunkId"] = this.knowledgeBaseChunkId;
        data["confidence"] = this.confidence;
        data["excerpt"] = this.excerpt;
        data["validationNote"] = this.validationNote;
        return data;
    }
}

export interface IArticleSourceDto {
    title?: string;
    url?: string | undefined;
    type?: string;
    knowledgeBaseChunkId?: string | undefined;
    confidence?: number | undefined;
    excerpt?: string | undefined;
    validationNote?: string | undefined;
}

export class GetArticleTraceResponse extends BaseResponse implements IGetArticleTraceResponse {
    articleId?: string;
    steps?: ArticleGenerationStepDto[];

    constructor(data?: IGetArticleTraceResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articleId = _data["articleId"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(ArticleGenerationStepDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetArticleTraceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticleTraceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetArticleTraceResponse extends IBaseResponse {
    articleId?: string;
    steps?: ArticleGenerationStepDto[];
}

export class ArticleGenerationStepDto implements IArticleGenerationStepDto {
    id?: string;
    stepName?: string;
    sequence?: number;
    status?: ArticleGenerationStepStatus;
    startedAt?: Date;
    finishedAt?: Date | undefined;
    durationMs?: number | undefined;
    model?: string | undefined;
    inputJson?: string | undefined;
    outputJson?: string | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IArticleGenerationStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stepName = _data["stepName"];
            this.sequence = _data["sequence"];
            this.status = _data["status"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.finishedAt = _data["finishedAt"] ? new Date(_data["finishedAt"].toString()) : <any>undefined;
            this.durationMs = _data["durationMs"];
            this.model = _data["model"];
            this.inputJson = _data["inputJson"];
            this.outputJson = _data["outputJson"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ArticleGenerationStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleGenerationStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepName"] = this.stepName;
        data["sequence"] = this.sequence;
        data["status"] = this.status;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["finishedAt"] = this.finishedAt ? this.finishedAt.toISOString() : <any>undefined;
        data["durationMs"] = this.durationMs;
        data["model"] = this.model;
        data["inputJson"] = this.inputJson;
        data["outputJson"] = this.outputJson;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IArticleGenerationStepDto {
    id?: string;
    stepName?: string;
    sequence?: number;
    status?: ArticleGenerationStepStatus;
    startedAt?: Date;
    finishedAt?: Date | undefined;
    durationMs?: number | undefined;
    model?: string | undefined;
    inputJson?: string | undefined;
    outputJson?: string | undefined;
    errorMessage?: string | undefined;
}

export enum ArticleGenerationStepStatus {
    Running = "Running",
    Succeeded = "Succeeded",
    Failed = "Failed",
}

export class ListArticlesResponse extends BaseResponse implements IListArticlesResponse {
    items?: ArticleListItemDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;

    constructor(data?: IListArticlesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ArticleListItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static override fromJS(data: any): ListArticlesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListArticlesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}

export interface IListArticlesResponse extends IBaseResponse {
    items?: ArticleListItemDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export class ArticleListItemDto implements IArticleListItemDto {
    id?: string;
    topic?: string;
    title?: string | undefined;
    status?: ArticleStatus;
    createdAt?: Date;
    generatedAt?: Date | undefined;

    constructor(data?: IArticleListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.topic = _data["topic"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.generatedAt = _data["generatedAt"] ? new Date(_data["generatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ArticleListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["topic"] = this.topic;
        data["title"] = this.title;
        data["status"] = this.status;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["generatedAt"] = this.generatedAt ? this.generatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IArticleListItemDto {
    id?: string;
    topic?: string;
    title?: string | undefined;
    status?: ArticleStatus;
    createdAt?: Date;
    generatedAt?: Date | undefined;
}

export class SubmitArticleFeedbackResponse extends BaseResponse implements ISubmitArticleFeedbackResponse {
    precisionScore?: number | undefined;
    styleScore?: number | undefined;
    feedbackComment?: string | undefined;

    constructor(data?: ISubmitArticleFeedbackResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.precisionScore = _data["precisionScore"];
            this.styleScore = _data["styleScore"];
            this.feedbackComment = _data["feedbackComment"];
        }
    }

    static override fromJS(data: any): SubmitArticleFeedbackResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitArticleFeedbackResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["precisionScore"] = this.precisionScore;
        data["styleScore"] = this.styleScore;
        data["feedbackComment"] = this.feedbackComment;
        super.toJSON(data);
        return data;
    }
}

export interface ISubmitArticleFeedbackResponse extends IBaseResponse {
    precisionScore?: number | undefined;
    styleScore?: number | undefined;
    feedbackComment?: string | undefined;
}

export class SubmitArticleFeedbackRequest implements ISubmitArticleFeedbackRequest {
    precisionScore?: number;
    styleScore?: number;
    comment?: string | undefined;

    constructor(data?: ISubmitArticleFeedbackRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.precisionScore = _data["precisionScore"];
            this.styleScore = _data["styleScore"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): SubmitArticleFeedbackRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitArticleFeedbackRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["precisionScore"] = this.precisionScore;
        data["styleScore"] = this.styleScore;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ISubmitArticleFeedbackRequest {
    precisionScore?: number;
    styleScore?: number;
    comment?: string | undefined;
}

export class GetArticleFeedbackListResponse extends BaseResponse implements IGetArticleFeedbackListResponse {
    items?: ArticleFeedbackSummary[];
    stats?: ArticleFeedbackStatsDto;
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;

    constructor(data?: IGetArticleFeedbackListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ArticleFeedbackSummary.fromJS(item));
            }
            this.stats = _data["stats"] ? ArticleFeedbackStatsDto.fromJS(_data["stats"]) : <any>undefined;
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static override fromJS(data: any): GetArticleFeedbackListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticleFeedbackListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["stats"] = this.stats ? this.stats.toJSON() : <any>undefined;
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        super.toJSON(data);
        return data;
    }
}

export interface IGetArticleFeedbackListResponse extends IBaseResponse {
    items?: ArticleFeedbackSummary[];
    stats?: ArticleFeedbackStatsDto;
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
}

export class ArticleFeedbackSummary implements IArticleFeedbackSummary {
    id?: string;
    title?: string | undefined;
    topic?: string;
    requestedBy?: string | undefined;
    userName?: string | undefined;
    createdAt?: Date;
    precisionScore?: number | undefined;
    styleScore?: number | undefined;
    hasComment?: boolean;

    constructor(data?: IArticleFeedbackSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.topic = _data["topic"];
            this.requestedBy = _data["requestedBy"];
            this.userName = _data["userName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.precisionScore = _data["precisionScore"];
            this.styleScore = _data["styleScore"];
            this.hasComment = _data["hasComment"];
        }
    }

    static fromJS(data: any): ArticleFeedbackSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleFeedbackSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["topic"] = this.topic;
        data["requestedBy"] = this.requestedBy;
        data["userName"] = this.userName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["precisionScore"] = this.precisionScore;
        data["styleScore"] = this.styleScore;
        data["hasComment"] = this.hasComment;
        return data;
    }
}

export interface IArticleFeedbackSummary {
    id?: string;
    title?: string | undefined;
    topic?: string;
    requestedBy?: string | undefined;
    userName?: string | undefined;
    createdAt?: Date;
    precisionScore?: number | undefined;
    styleScore?: number | undefined;
    hasComment?: boolean;
}

export class ArticleFeedbackStatsDto implements IArticleFeedbackStatsDto {
    totalArticles?: number;
    totalWithFeedback?: number;
    avgPrecisionScore?: number | undefined;
    avgStyleScore?: number | undefined;

    constructor(data?: IArticleFeedbackStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalArticles = _data["totalArticles"];
            this.totalWithFeedback = _data["totalWithFeedback"];
            this.avgPrecisionScore = _data["avgPrecisionScore"];
            this.avgStyleScore = _data["avgStyleScore"];
        }
    }

    static fromJS(data: any): ArticleFeedbackStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleFeedbackStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalArticles"] = this.totalArticles;
        data["totalWithFeedback"] = this.totalWithFeedback;
        data["avgPrecisionScore"] = this.avgPrecisionScore;
        data["avgStyleScore"] = this.avgStyleScore;
        return data;
    }
}

export interface IArticleFeedbackStatsDto {
    totalArticles?: number;
    totalWithFeedback?: number;
    avgPrecisionScore?: number | undefined;
    avgStyleScore?: number | undefined;
}

export class BackfillArticleRequestedByResponse extends BaseResponse implements IBackfillArticleRequestedByResponse {
    total?: number;
    alreadyMigrated?: number;
    resolved?: number;
    ambiguous?: number;
    unresolved?: number;
    wasDryRun?: boolean;
    unresolvedRows?: UnresolvedArticleRow[];

    constructor(data?: IBackfillArticleRequestedByResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.total = _data["total"];
            this.alreadyMigrated = _data["alreadyMigrated"];
            this.resolved = _data["resolved"];
            this.ambiguous = _data["ambiguous"];
            this.unresolved = _data["unresolved"];
            this.wasDryRun = _data["wasDryRun"];
            if (Array.isArray(_data["unresolvedRows"])) {
                this.unresolvedRows = [] as any;
                for (let item of _data["unresolvedRows"])
                    this.unresolvedRows!.push(UnresolvedArticleRow.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): BackfillArticleRequestedByResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BackfillArticleRequestedByResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["alreadyMigrated"] = this.alreadyMigrated;
        data["resolved"] = this.resolved;
        data["ambiguous"] = this.ambiguous;
        data["unresolved"] = this.unresolved;
        data["wasDryRun"] = this.wasDryRun;
        if (Array.isArray(this.unresolvedRows)) {
            data["unresolvedRows"] = [];
            for (let item of this.unresolvedRows)
                data["unresolvedRows"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBackfillArticleRequestedByResponse extends IBaseResponse {
    total?: number;
    alreadyMigrated?: number;
    resolved?: number;
    ambiguous?: number;
    unresolved?: number;
    wasDryRun?: boolean;
    unresolvedRows?: UnresolvedArticleRow[];
}

export class UnresolvedArticleRow implements IUnresolvedArticleRow {
    articleId?: string;
    originalValue?: string;
    reason?: string;

    constructor(data?: IUnresolvedArticleRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.originalValue = _data["originalValue"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): UnresolvedArticleRow {
        data = typeof data === 'object' ? data : {};
        let result = new UnresolvedArticleRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["originalValue"] = this.originalValue;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IUnresolvedArticleRow {
    articleId?: string;
    originalValue?: string;
    reason?: string;
}

export class BackfillArticleRequestedByCommand implements IBackfillArticleRequestedByCommand {
    groupId?: string;
    dryRun?: boolean;

    constructor(data?: IBackfillArticleRequestedByCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.dryRun = _data["dryRun"];
        }
    }

    static fromJS(data: any): BackfillArticleRequestedByCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BackfillArticleRequestedByCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["dryRun"] = this.dryRun;
        return data;
    }
}

export interface IBackfillArticleRequestedByCommand {
    groupId?: string;
    dryRun?: boolean;
}

export class RunBreakInsertionResponse extends BaseResponse implements IRunBreakInsertionResponse {
    daysScanned?: number;
    breaksInserted?: number;
    daysHealed?: number;
    recordsRecreated?: number;
    recreateFailed?: number;
    skippedExistingBreak?: number;
    skippedInProgress?: number;
    skippedBelowThreshold?: number;
    skippedHoursOnly?: number;
    skippedNoSlot?: number;
    failed?: number;

    constructor(data?: IRunBreakInsertionResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.daysScanned = _data["daysScanned"];
            this.breaksInserted = _data["breaksInserted"];
            this.daysHealed = _data["daysHealed"];
            this.recordsRecreated = _data["recordsRecreated"];
            this.recreateFailed = _data["recreateFailed"];
            this.skippedExistingBreak = _data["skippedExistingBreak"];
            this.skippedInProgress = _data["skippedInProgress"];
            this.skippedBelowThreshold = _data["skippedBelowThreshold"];
            this.skippedHoursOnly = _data["skippedHoursOnly"];
            this.skippedNoSlot = _data["skippedNoSlot"];
            this.failed = _data["failed"];
        }
    }

    static override fromJS(data: any): RunBreakInsertionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RunBreakInsertionResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["daysScanned"] = this.daysScanned;
        data["breaksInserted"] = this.breaksInserted;
        data["daysHealed"] = this.daysHealed;
        data["recordsRecreated"] = this.recordsRecreated;
        data["recreateFailed"] = this.recreateFailed;
        data["skippedExistingBreak"] = this.skippedExistingBreak;
        data["skippedInProgress"] = this.skippedInProgress;
        data["skippedBelowThreshold"] = this.skippedBelowThreshold;
        data["skippedHoursOnly"] = this.skippedHoursOnly;
        data["skippedNoSlot"] = this.skippedNoSlot;
        data["failed"] = this.failed;
        super.toJSON(data);
        return data;
    }
}

export interface IRunBreakInsertionResponse extends IBaseResponse {
    daysScanned?: number;
    breaksInserted?: number;
    daysHealed?: number;
    recordsRecreated?: number;
    recreateFailed?: number;
    skippedExistingBreak?: number;
    skippedInProgress?: number;
    skippedBelowThreshold?: number;
    skippedHoursOnly?: number;
    skippedNoSlot?: number;
    failed?: number;
}

export class RunBreakInsertionRequest implements IRunBreakInsertionRequest {
    fromDaysAgo?: number | undefined;
    toDaysAgo?: number | undefined;

    constructor(data?: IRunBreakInsertionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDaysAgo = _data["fromDaysAgo"];
            this.toDaysAgo = _data["toDaysAgo"];
        }
    }

    static fromJS(data: any): RunBreakInsertionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RunBreakInsertionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDaysAgo"] = this.fromDaysAgo;
        data["toDaysAgo"] = this.toDaysAgo;
        return data;
    }
}

export interface IRunBreakInsertionRequest {
    fromDaysAgo?: number | undefined;
    toDaysAgo?: number | undefined;
}

export class GetMeResponse extends BaseResponse implements IGetMeResponse {
    email?: string | undefined;
    displayName?: string | undefined;
    isSuperUser?: boolean;
    permissions?: string[];
    groups?: string[];

    constructor(data?: IGetMeResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"];
            this.displayName = _data["displayName"];
            this.isSuperUser = _data["isSuperUser"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
        }
    }

    static override fromJS(data: any): GetMeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["displayName"] = this.displayName;
        data["isSuperUser"] = this.isSuperUser;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetMeResponse extends IBaseResponse {
    email?: string | undefined;
    displayName?: string | undefined;
    isSuperUser?: boolean;
    permissions?: string[];
    groups?: string[];
}

export class GetPermissionCatalogueResponse extends BaseResponse implements IGetPermissionCatalogueResponse {
    permissions?: string[];
    features?: CatalogueFeatureDto[];

    constructor(data?: IGetPermissionCatalogueResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(CatalogueFeatureDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetPermissionCatalogueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPermissionCatalogueResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPermissionCatalogueResponse extends IBaseResponse {
    permissions?: string[];
    features?: CatalogueFeatureDto[];
}

export class CatalogueFeatureDto implements ICatalogueFeatureDto {
    key?: string;
    label?: string;
    section?: string;
    hasWrite?: boolean;
    hasAdmin?: boolean;

    constructor(data?: ICatalogueFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.section = _data["section"];
            this.hasWrite = _data["hasWrite"];
            this.hasAdmin = _data["hasAdmin"];
        }
    }

    static fromJS(data: any): CatalogueFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogueFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["section"] = this.section;
        data["hasWrite"] = this.hasWrite;
        data["hasAdmin"] = this.hasAdmin;
        return data;
    }
}

export interface ICatalogueFeatureDto {
    key?: string;
    label?: string;
    section?: string;
    hasWrite?: boolean;
    hasAdmin?: boolean;
}

export class GetGroupsResponse extends BaseResponse implements IGetGroupsResponse {
    groups?: GroupSummaryDto[];

    constructor(data?: IGetGroupsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GroupSummaryDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetGroupsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetGroupsResponse extends IBaseResponse {
    groups?: GroupSummaryDto[];
}

export class GroupSummaryDto implements IGroupSummaryDto {
    id?: string;
    name?: string;
    description?: string | undefined;
    permissionCount?: number;
    parentCount?: number;
    memberCount?: number;
    permissions?: string[];
    parentGroupIds?: string[];

    constructor(data?: IGroupSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.permissionCount = _data["permissionCount"];
            this.parentCount = _data["parentCount"];
            this.memberCount = _data["memberCount"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            if (Array.isArray(_data["parentGroupIds"])) {
                this.parentGroupIds = [] as any;
                for (let item of _data["parentGroupIds"])
                    this.parentGroupIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GroupSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["permissionCount"] = this.permissionCount;
        data["parentCount"] = this.parentCount;
        data["memberCount"] = this.memberCount;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        if (Array.isArray(this.parentGroupIds)) {
            data["parentGroupIds"] = [];
            for (let item of this.parentGroupIds)
                data["parentGroupIds"].push(item);
        }
        return data;
    }
}

export interface IGroupSummaryDto {
    id?: string;
    name?: string;
    description?: string | undefined;
    permissionCount?: number;
    parentCount?: number;
    memberCount?: number;
    permissions?: string[];
    parentGroupIds?: string[];
}

export class GetGroupDetailResponse extends BaseResponse implements IGetGroupDetailResponse {
    group?: GroupDetailDto | undefined;

    constructor(data?: IGetGroupDetailResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.group = _data["group"] ? GroupDetailDto.fromJS(_data["group"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetGroupDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupDetailResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetGroupDetailResponse extends IBaseResponse {
    group?: GroupDetailDto | undefined;
}

export class GroupDetailDto implements IGroupDetailDto {
    id?: string;
    name?: string;
    description?: string | undefined;
    permissions?: string[];
    parentGroupIds?: string[];

    constructor(data?: IGroupDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            if (Array.isArray(_data["parentGroupIds"])) {
                this.parentGroupIds = [] as any;
                for (let item of _data["parentGroupIds"])
                    this.parentGroupIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GroupDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        if (Array.isArray(this.parentGroupIds)) {
            data["parentGroupIds"] = [];
            for (let item of this.parentGroupIds)
                data["parentGroupIds"].push(item);
        }
        return data;
    }
}

export interface IGroupDetailDto {
    id?: string;
    name?: string;
    description?: string | undefined;
    permissions?: string[];
    parentGroupIds?: string[];
}

export class CreateGroupResponse extends BaseResponse implements ICreateGroupResponse {
    id?: string;

    constructor(data?: ICreateGroupResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): CreateGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroupResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateGroupResponse extends IBaseResponse {
    id?: string;
}

export class CreateGroupRequest implements ICreateGroupRequest {
    name?: string;
    description?: string | undefined;
    permissions?: string[];
    parentGroupIds?: string[];

    constructor(data?: ICreateGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            if (Array.isArray(_data["parentGroupIds"])) {
                this.parentGroupIds = [] as any;
                for (let item of _data["parentGroupIds"])
                    this.parentGroupIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        if (Array.isArray(this.parentGroupIds)) {
            data["parentGroupIds"] = [];
            for (let item of this.parentGroupIds)
                data["parentGroupIds"].push(item);
        }
        return data;
    }
}

export interface ICreateGroupRequest {
    name?: string;
    description?: string | undefined;
    permissions?: string[];
    parentGroupIds?: string[];
}

export class UpdateGroupResponse extends BaseResponse implements IUpdateGroupResponse {

    constructor(data?: IUpdateGroupResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGroupResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateGroupResponse extends IBaseResponse {
}

export class UpdateGroupRequest implements IUpdateGroupRequest {
    id?: string;
    name?: string;
    description?: string | undefined;
    permissions?: string[];
    parentGroupIds?: string[];

    constructor(data?: IUpdateGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            if (Array.isArray(_data["parentGroupIds"])) {
                this.parentGroupIds = [] as any;
                for (let item of _data["parentGroupIds"])
                    this.parentGroupIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        if (Array.isArray(this.parentGroupIds)) {
            data["parentGroupIds"] = [];
            for (let item of this.parentGroupIds)
                data["parentGroupIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateGroupRequest {
    id?: string;
    name?: string;
    description?: string | undefined;
    permissions?: string[];
    parentGroupIds?: string[];
}

export class DeleteGroupResponse extends BaseResponse implements IDeleteGroupResponse {

    constructor(data?: IDeleteGroupResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DeleteGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteGroupResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteGroupResponse extends IBaseResponse {
}

export class AddGroupMemberResponse extends BaseResponse implements IAddGroupMemberResponse {
    user?: AppUserDto | undefined;

    constructor(data?: IAddGroupMemberResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["user"] ? AppUserDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AddGroupMemberResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddGroupMemberResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAddGroupMemberResponse extends IBaseResponse {
    user?: AppUserDto | undefined;
}

export class AppUserDto implements IAppUserDto {
    id?: string;
    entraObjectId?: string | undefined;
    email?: string;
    displayName?: string;
    isActive?: boolean;
    source?: string;
    canPack?: boolean;
    lastLoginAt?: Date | undefined;
    groupIds?: string[];

    constructor(data?: IAppUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entraObjectId = _data["entraObjectId"];
            this.email = _data["email"];
            this.displayName = _data["displayName"];
            this.isActive = _data["isActive"];
            this.source = _data["source"];
            this.canPack = _data["canPack"];
            this.lastLoginAt = _data["lastLoginAt"] ? new Date(_data["lastLoginAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["groupIds"])) {
                this.groupIds = [] as any;
                for (let item of _data["groupIds"])
                    this.groupIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AppUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entraObjectId"] = this.entraObjectId;
        data["email"] = this.email;
        data["displayName"] = this.displayName;
        data["isActive"] = this.isActive;
        data["source"] = this.source;
        data["canPack"] = this.canPack;
        data["lastLoginAt"] = this.lastLoginAt ? this.lastLoginAt.toISOString() : <any>undefined;
        if (Array.isArray(this.groupIds)) {
            data["groupIds"] = [];
            for (let item of this.groupIds)
                data["groupIds"].push(item);
        }
        return data;
    }
}

export interface IAppUserDto {
    id?: string;
    entraObjectId?: string | undefined;
    email?: string;
    displayName?: string;
    isActive?: boolean;
    source?: string;
    canPack?: boolean;
    lastLoginAt?: Date | undefined;
    groupIds?: string[];
}

export class AddGroupMemberRequest implements IAddGroupMemberRequest {
    groupId?: string;
    entraObjectId?: string;
    email?: string;
    displayName?: string;

    constructor(data?: IAddGroupMemberRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.entraObjectId = _data["entraObjectId"];
            this.email = _data["email"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): AddGroupMemberRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddGroupMemberRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["entraObjectId"] = this.entraObjectId;
        data["email"] = this.email;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IAddGroupMemberRequest {
    groupId?: string;
    entraObjectId?: string;
    email?: string;
    displayName?: string;
}

export class GetUsersResponse extends BaseResponse implements IGetUsersResponse {
    users?: AppUserDto[];

    constructor(data?: IGetUsersResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(AppUserDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetUsersResponse extends IBaseResponse {
    users?: AppUserDto[];
}

export class GetEntraAccessUsersResponse extends BaseResponse implements IGetEntraAccessUsersResponse {
    users?: EntraUserDto[];

    constructor(data?: IGetEntraAccessUsersResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(EntraUserDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetEntraAccessUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntraAccessUsersResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetEntraAccessUsersResponse extends IBaseResponse {
    users?: EntraUserDto[];
}

export class EntraUserDto implements IEntraUserDto {
    entraObjectId?: string;
    email?: string;
    displayName?: string;

    constructor(data?: IEntraUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entraObjectId = _data["entraObjectId"];
            this.email = _data["email"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): EntraUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntraUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entraObjectId"] = this.entraObjectId;
        data["email"] = this.email;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IEntraUserDto {
    entraObjectId?: string;
    email?: string;
    displayName?: string;
}

export class GetUserEffectivePermissionsResponse extends BaseResponse implements IGetUserEffectivePermissionsResponse {
    permissions?: string[];

    constructor(data?: IGetUserEffectivePermissionsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static override fromJS(data: any): GetUserEffectivePermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserEffectivePermissionsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetUserEffectivePermissionsResponse extends IBaseResponse {
    permissions?: string[];
}

export class AssignUserGroupsResponse extends BaseResponse implements IAssignUserGroupsResponse {

    constructor(data?: IAssignUserGroupsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AssignUserGroupsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssignUserGroupsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAssignUserGroupsResponse extends IBaseResponse {
}

export class AssignUserGroupsRequest implements IAssignUserGroupsRequest {
    userId?: string;
    groupIds?: string[];

    constructor(data?: IAssignUserGroupsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["groupIds"])) {
                this.groupIds = [] as any;
                for (let item of _data["groupIds"])
                    this.groupIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AssignUserGroupsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignUserGroupsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.groupIds)) {
            data["groupIds"] = [];
            for (let item of this.groupIds)
                data["groupIds"].push(item);
        }
        return data;
    }
}

export interface IAssignUserGroupsRequest {
    userId?: string;
    groupIds?: string[];
}

export class SetUserActiveResponse extends BaseResponse implements ISetUserActiveResponse {

    constructor(data?: ISetUserActiveResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SetUserActiveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserActiveResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISetUserActiveResponse extends IBaseResponse {
}

export class SetUserActiveRequest implements ISetUserActiveRequest {
    userId?: string;
    isActive?: boolean;

    constructor(data?: ISetUserActiveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SetUserActiveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserActiveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISetUserActiveRequest {
    userId?: string;
    isActive?: boolean;
}

export class UpdateUserResponse extends BaseResponse implements IUpdateUserResponse {

    constructor(data?: IUpdateUserResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateUserResponse extends IBaseResponse {
}

export class UpdateUserRequest implements IUpdateUserRequest {
    userId?: string;
    displayName?: string;
    email?: string | undefined;
    canPack?: boolean;

    constructor(data?: IUpdateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.canPack = _data["canPack"];
        }
    }

    static fromJS(data: any): UpdateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["canPack"] = this.canPack;
        return data;
    }
}

export interface IUpdateUserRequest {
    userId?: string;
    displayName?: string;
    email?: string | undefined;
    canPack?: boolean;
}

export class CreateLocalUserResponse extends BaseResponse implements ICreateLocalUserResponse {
    user?: AppUserDto | undefined;

    constructor(data?: ICreateLocalUserResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["user"] ? AppUserDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CreateLocalUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLocalUserResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateLocalUserResponse extends IBaseResponse {
    user?: AppUserDto | undefined;
}

export class CreateLocalUserRequest implements ICreateLocalUserRequest {
    displayName?: string;

    constructor(data?: ICreateLocalUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CreateLocalUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLocalUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICreateLocalUserRequest {
    displayName?: string;
}

export class SetUserCanPackResponse extends BaseResponse implements ISetUserCanPackResponse {

    constructor(data?: ISetUserCanPackResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SetUserCanPackResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserCanPackResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISetUserCanPackResponse extends IBaseResponse {
}

export class SetUserCanPackRequest implements ISetUserCanPackRequest {
    userId?: string;
    canPack?: boolean;

    constructor(data?: ISetUserCanPackRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.canPack = _data["canPack"];
        }
    }

    static fromJS(data: any): SetUserCanPackRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserCanPackRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["canPack"] = this.canPack;
        return data;
    }
}

export interface ISetUserCanPackRequest {
    userId?: string;
    canPack?: boolean;
}

export class RefreshTaskDto implements IRefreshTaskDto {
    taskId?: string;
    initialDelay?: string;
    refreshInterval?: string;
    enabled?: boolean;
    hydrationTier?: number;
    nextScheduledRun?: Date | undefined;
    lastExecution?: RefreshTaskExecutionLogDto | undefined;

    constructor(data?: IRefreshTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.initialDelay = _data["initialDelay"];
            this.refreshInterval = _data["refreshInterval"];
            this.enabled = _data["enabled"];
            this.hydrationTier = _data["hydrationTier"];
            this.nextScheduledRun = _data["nextScheduledRun"] ? new Date(_data["nextScheduledRun"].toString()) : <any>undefined;
            this.lastExecution = _data["lastExecution"] ? RefreshTaskExecutionLogDto.fromJS(_data["lastExecution"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RefreshTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["initialDelay"] = this.initialDelay;
        data["refreshInterval"] = this.refreshInterval;
        data["enabled"] = this.enabled;
        data["hydrationTier"] = this.hydrationTier;
        data["nextScheduledRun"] = this.nextScheduledRun ? this.nextScheduledRun.toISOString() : <any>undefined;
        data["lastExecution"] = this.lastExecution ? this.lastExecution.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRefreshTaskDto {
    taskId?: string;
    initialDelay?: string;
    refreshInterval?: string;
    enabled?: boolean;
    hydrationTier?: number;
    nextScheduledRun?: Date | undefined;
    lastExecution?: RefreshTaskExecutionLogDto | undefined;
}

export class RefreshTaskExecutionLogDto implements IRefreshTaskExecutionLogDto {
    taskId?: string;
    startedAt?: Date;
    completedAt?: Date | undefined;
    status?: string;
    errorMessage?: string | undefined;
    duration?: string | undefined;
    metadata?: { [key: string]: any; } | undefined;

    constructor(data?: IRefreshTaskExecutionLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.errorMessage = _data["errorMessage"];
            this.duration = _data["duration"];
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
        }
    }

    static fromJS(data: any): RefreshTaskExecutionLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTaskExecutionLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["errorMessage"] = this.errorMessage;
        data["duration"] = this.duration;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        return data;
    }
}

export interface IRefreshTaskExecutionLogDto {
    taskId?: string;
    startedAt?: Date;
    completedAt?: Date | undefined;
    status?: string;
    errorMessage?: string | undefined;
    duration?: string | undefined;
    metadata?: { [key: string]: any; } | undefined;
}

export class RefreshTaskStatusDto implements IRefreshTaskStatusDto {
    taskId?: string;
    enabled?: boolean;
    refreshInterval?: string;
    lastExecution?: RefreshTaskExecutionLogDto | undefined;

    constructor(data?: IRefreshTaskStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.enabled = _data["enabled"];
            this.refreshInterval = _data["refreshInterval"];
            this.lastExecution = _data["lastExecution"] ? RefreshTaskExecutionLogDto.fromJS(_data["lastExecution"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RefreshTaskStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTaskStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["enabled"] = this.enabled;
        data["refreshInterval"] = this.refreshInterval;
        data["lastExecution"] = this.lastExecution ? this.lastExecution.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRefreshTaskStatusDto {
    taskId?: string;
    enabled?: boolean;
    refreshInterval?: string;
    lastExecution?: RefreshTaskExecutionLogDto | undefined;
}

export class BankAccountDto implements IBankAccountDto {
    name?: string;
    accountNumber?: string;
    provider?: string;
    currency?: string;

    constructor(data?: IBankAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.accountNumber = _data["accountNumber"];
            this.provider = _data["provider"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): BankAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["accountNumber"] = this.accountNumber;
        data["provider"] = this.provider;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IBankAccountDto {
    name?: string;
    accountNumber?: string;
    provider?: string;
    currency?: string;
}

export class BankStatementImportResultDto implements IBankStatementImportResultDto {
    statements?: BankStatementImportDto[];
    successCount?: number;
    errorCount?: number;
    skippedCount?: number;
    totalCount?: number;
    hasErrors?: boolean;

    constructor(data?: IBankStatementImportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["statements"])) {
                this.statements = [] as any;
                for (let item of _data["statements"])
                    this.statements!.push(BankStatementImportDto.fromJS(item));
            }
            this.successCount = _data["successCount"];
            this.errorCount = _data["errorCount"];
            this.skippedCount = _data["skippedCount"];
            this.totalCount = _data["totalCount"];
            this.hasErrors = _data["hasErrors"];
        }
    }

    static fromJS(data: any): BankStatementImportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankStatementImportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statements)) {
            data["statements"] = [];
            for (let item of this.statements)
                data["statements"].push(item.toJSON());
        }
        data["successCount"] = this.successCount;
        data["errorCount"] = this.errorCount;
        data["skippedCount"] = this.skippedCount;
        data["totalCount"] = this.totalCount;
        data["hasErrors"] = this.hasErrors;
        return data;
    }
}

export interface IBankStatementImportResultDto {
    statements?: BankStatementImportDto[];
    successCount?: number;
    errorCount?: number;
    skippedCount?: number;
    totalCount?: number;
    hasErrors?: boolean;
}

export class BankStatementImportDto implements IBankStatementImportDto {
    id?: number;
    transferId?: string;
    statementDate?: Date;
    importDate?: Date;
    account?: string;
    currency?: string;
    itemCount?: number;
    importResult?: string;
    errorType?: string | undefined;

    constructor(data?: IBankStatementImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.transferId = _data["transferId"];
            this.statementDate = _data["statementDate"] ? new Date(_data["statementDate"].toString()) : <any>undefined;
            this.importDate = _data["importDate"] ? new Date(_data["importDate"].toString()) : <any>undefined;
            this.account = _data["account"];
            this.currency = _data["currency"];
            this.itemCount = _data["itemCount"];
            this.importResult = _data["importResult"];
            this.errorType = _data["errorType"];
        }
    }

    static fromJS(data: any): BankStatementImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankStatementImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transferId"] = this.transferId;
        data["statementDate"] = this.statementDate ? this.statementDate.toISOString() : <any>undefined;
        data["importDate"] = this.importDate ? this.importDate.toISOString() : <any>undefined;
        data["account"] = this.account;
        data["currency"] = this.currency;
        data["itemCount"] = this.itemCount;
        data["importResult"] = this.importResult;
        data["errorType"] = this.errorType;
        return data;
    }
}

export interface IBankStatementImportDto {
    id?: number;
    transferId?: string;
    statementDate?: Date;
    importDate?: Date;
    account?: string;
    currency?: string;
    itemCount?: number;
    importResult?: string;
    errorType?: string | undefined;
}

export class BankImportRequestDto implements IBankImportRequestDto {
    accountName!: string;
    dateFrom!: Date;
    dateTo!: Date;

    constructor(data?: IBankImportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BankImportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankImportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBankImportRequestDto {
    accountName: string;
    dateFrom: Date;
    dateTo: Date;
}

export class GetBankStatementListResponse extends BaseResponse implements IGetBankStatementListResponse {
    items?: BankStatementImportDto[];
    totalCount?: number;

    constructor(data?: IGetBankStatementListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BankStatementImportDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static override fromJS(data: any): GetBankStatementListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankStatementListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        super.toJSON(data);
        return data;
    }
}

export interface IGetBankStatementListResponse extends IBaseResponse {
    items?: BankStatementImportDto[];
    totalCount?: number;
}

export class GetCarrierCoolingMatrixResponse extends BaseResponse implements IGetCarrierCoolingMatrixResponse {
    groups?: CarrierGroupDto[];

    constructor(data?: IGetCarrierCoolingMatrixResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(CarrierGroupDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetCarrierCoolingMatrixResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCarrierCoolingMatrixResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetCarrierCoolingMatrixResponse extends IBaseResponse {
    groups?: CarrierGroupDto[];
}

export class CarrierGroupDto implements ICarrierGroupDto {
    carrier?: Carriers;
    rows?: CarrierCoolingRowDto[];

    constructor(data?: ICarrierGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrier = _data["carrier"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CarrierCoolingRowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CarrierGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carrier"] = this.carrier;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICarrierGroupDto {
    carrier?: Carriers;
    rows?: CarrierCoolingRowDto[];
}

export enum Carriers {
    Zasilkovna = "Zasilkovna",
    PPL = "PPL",
    GLS = "GLS",
    Osobak = "Osobak",
}

export class CarrierCoolingRowDto implements ICarrierCoolingRowDto {
    deliveryHandling?: DeliveryHandling;
    cooling?: Cooling;
    coolingText?: string | undefined;

    constructor(data?: ICarrierCoolingRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryHandling = _data["deliveryHandling"];
            this.cooling = _data["cooling"];
            this.coolingText = _data["coolingText"];
        }
    }

    static fromJS(data: any): CarrierCoolingRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierCoolingRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryHandling"] = this.deliveryHandling;
        data["cooling"] = this.cooling;
        data["coolingText"] = this.coolingText;
        return data;
    }
}

export interface ICarrierCoolingRowDto {
    deliveryHandling?: DeliveryHandling;
    cooling?: Cooling;
    coolingText?: string | undefined;
}

export enum DeliveryHandling {
    NaRuky = "NaRuky",
    Box = "Box",
}

export enum Cooling {
    None = "None",
    L1 = "L1",
    L2 = "L2",
}

export class SetCarrierCoolingResponse extends BaseResponse implements ISetCarrierCoolingResponse {

    constructor(data?: ISetCarrierCoolingResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SetCarrierCoolingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetCarrierCoolingResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISetCarrierCoolingResponse extends IBaseResponse {
}

export class SetCarrierCoolingRequest implements ISetCarrierCoolingRequest {
    carrier?: Carriers;
    deliveryHandling?: DeliveryHandling;
    cooling?: Cooling;
    coolingText?: string | undefined;

    constructor(data?: ISetCarrierCoolingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrier = _data["carrier"];
            this.deliveryHandling = _data["deliveryHandling"];
            this.cooling = _data["cooling"];
            this.coolingText = _data["coolingText"];
        }
    }

    static fromJS(data: any): SetCarrierCoolingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetCarrierCoolingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carrier"] = this.carrier;
        data["deliveryHandling"] = this.deliveryHandling;
        data["cooling"] = this.cooling;
        data["coolingText"] = this.coolingText;
        return data;
    }
}

export interface ISetCarrierCoolingRequest {
    carrier?: Carriers;
    deliveryHandling?: DeliveryHandling;
    cooling?: Cooling;
    coolingText?: string | undefined;
}

export class GetCatalogListResponse extends BaseResponse implements IGetCatalogListResponse {
    items?: CatalogItemDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;

    constructor(data?: IGetCatalogListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CatalogItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static override fromJS(data: any): GetCatalogListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCatalogListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        super.toJSON(data);
        return data;
    }
}

export interface IGetCatalogListResponse extends IBaseResponse {
    items?: CatalogItemDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class CatalogItemDto implements ICatalogItemDto {
    productCode?: string;
    productName?: string;
    productNameSuffix?: string | undefined;
    type?: ProductType;
    stock?: StockDto;
    price?: PriceDto;
    properties?: PropertiesDto;
    location?: string;
    minimalOrderQuantity?: string;
    minimalManufactureQuantity?: number;
    manufactureDifficulty?: number;
    marginPercentage?: number;
    marginAmount?: number;
    supplierName?: string | undefined;
    note?: string | undefined;
    image?: string | undefined;
    lastStockTaking?: Date | undefined;
    minimalExpiration?: Date | undefined;
    hasLots?: boolean;
    lots?: LotDto[];
    eshopFlags?: EshopFlagDto[];

    constructor(data?: ICatalogItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.productNameSuffix = _data["productNameSuffix"];
            this.type = _data["type"];
            this.stock = _data["stock"] ? StockDto.fromJS(_data["stock"]) : <any>undefined;
            this.price = _data["price"] ? PriceDto.fromJS(_data["price"]) : <any>undefined;
            this.properties = _data["properties"] ? PropertiesDto.fromJS(_data["properties"]) : <any>undefined;
            this.location = _data["location"];
            this.minimalOrderQuantity = _data["minimalOrderQuantity"];
            this.minimalManufactureQuantity = _data["minimalManufactureQuantity"];
            this.manufactureDifficulty = _data["manufactureDifficulty"];
            this.marginPercentage = _data["marginPercentage"];
            this.marginAmount = _data["marginAmount"];
            this.supplierName = _data["supplierName"];
            this.note = _data["note"];
            this.image = _data["image"];
            this.lastStockTaking = _data["lastStockTaking"] ? new Date(_data["lastStockTaking"].toString()) : <any>undefined;
            this.minimalExpiration = _data["minimalExpiration"] ? new Date(_data["minimalExpiration"].toString()) : <any>undefined;
            this.hasLots = _data["hasLots"];
            if (Array.isArray(_data["lots"])) {
                this.lots = [] as any;
                for (let item of _data["lots"])
                    this.lots!.push(LotDto.fromJS(item));
            }
            if (Array.isArray(_data["eshopFlags"])) {
                this.eshopFlags = [] as any;
                for (let item of _data["eshopFlags"])
                    this.eshopFlags!.push(EshopFlagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CatalogItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productNameSuffix"] = this.productNameSuffix;
        data["type"] = this.type;
        data["stock"] = this.stock ? this.stock.toJSON() : <any>undefined;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["properties"] = this.properties ? this.properties.toJSON() : <any>undefined;
        data["location"] = this.location;
        data["minimalOrderQuantity"] = this.minimalOrderQuantity;
        data["minimalManufactureQuantity"] = this.minimalManufactureQuantity;
        data["manufactureDifficulty"] = this.manufactureDifficulty;
        data["marginPercentage"] = this.marginPercentage;
        data["marginAmount"] = this.marginAmount;
        data["supplierName"] = this.supplierName;
        data["note"] = this.note;
        data["image"] = this.image;
        data["lastStockTaking"] = this.lastStockTaking ? this.lastStockTaking.toISOString() : <any>undefined;
        data["minimalExpiration"] = this.minimalExpiration ? formatDate(this.minimalExpiration) : <any>undefined;
        data["hasLots"] = this.hasLots;
        if (Array.isArray(this.lots)) {
            data["lots"] = [];
            for (let item of this.lots)
                data["lots"].push(item.toJSON());
        }
        if (Array.isArray(this.eshopFlags)) {
            data["eshopFlags"] = [];
            for (let item of this.eshopFlags)
                data["eshopFlags"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICatalogItemDto {
    productCode?: string;
    productName?: string;
    productNameSuffix?: string | undefined;
    type?: ProductType;
    stock?: StockDto;
    price?: PriceDto;
    properties?: PropertiesDto;
    location?: string;
    minimalOrderQuantity?: string;
    minimalManufactureQuantity?: number;
    manufactureDifficulty?: number;
    marginPercentage?: number;
    marginAmount?: number;
    supplierName?: string | undefined;
    note?: string | undefined;
    image?: string | undefined;
    lastStockTaking?: Date | undefined;
    minimalExpiration?: Date | undefined;
    hasLots?: boolean;
    lots?: LotDto[];
    eshopFlags?: EshopFlagDto[];
}

export enum ProductType {
    UNDEFINED = "UNDEFINED",
    Goods = "Goods",
    Material = "Material",
    SemiProduct = "SemiProduct",
    Product = "Product",
    Set = "Set",
}

export class StockDto implements IStockDto {
    eshop?: number;
    erp?: number;
    transport?: number;
    reserve?: number;
    quarantine?: number;
    ordered?: number;
    available?: number;

    constructor(data?: IStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eshop = _data["eshop"];
            this.erp = _data["erp"];
            this.transport = _data["transport"];
            this.reserve = _data["reserve"];
            this.quarantine = _data["quarantine"];
            this.ordered = _data["ordered"];
            this.available = _data["available"];
        }
    }

    static fromJS(data: any): StockDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eshop"] = this.eshop;
        data["erp"] = this.erp;
        data["transport"] = this.transport;
        data["reserve"] = this.reserve;
        data["quarantine"] = this.quarantine;
        data["ordered"] = this.ordered;
        data["available"] = this.available;
        return data;
    }
}

export interface IStockDto {
    eshop?: number;
    erp?: number;
    transport?: number;
    reserve?: number;
    quarantine?: number;
    ordered?: number;
    available?: number;
}

export class PriceDto implements IPriceDto {
    currentSellingPrice?: number | undefined;
    currentPurchasePrice?: number | undefined;
    sellingPriceWithVat?: number | undefined;
    purchasePriceWithVat?: number | undefined;
    stockPrice?: number | undefined;
    eshopPrice?: EshopPriceDto | undefined;
    erpPrice?: ErpPriceDto | undefined;

    constructor(data?: IPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentSellingPrice = _data["currentSellingPrice"];
            this.currentPurchasePrice = _data["currentPurchasePrice"];
            this.sellingPriceWithVat = _data["sellingPriceWithVat"];
            this.purchasePriceWithVat = _data["purchasePriceWithVat"];
            this.stockPrice = _data["stockPrice"];
            this.eshopPrice = _data["eshopPrice"] ? EshopPriceDto.fromJS(_data["eshopPrice"]) : <any>undefined;
            this.erpPrice = _data["erpPrice"] ? ErpPriceDto.fromJS(_data["erpPrice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentSellingPrice"] = this.currentSellingPrice;
        data["currentPurchasePrice"] = this.currentPurchasePrice;
        data["sellingPriceWithVat"] = this.sellingPriceWithVat;
        data["purchasePriceWithVat"] = this.purchasePriceWithVat;
        data["stockPrice"] = this.stockPrice;
        data["eshopPrice"] = this.eshopPrice ? this.eshopPrice.toJSON() : <any>undefined;
        data["erpPrice"] = this.erpPrice ? this.erpPrice.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPriceDto {
    currentSellingPrice?: number | undefined;
    currentPurchasePrice?: number | undefined;
    sellingPriceWithVat?: number | undefined;
    purchasePriceWithVat?: number | undefined;
    stockPrice?: number | undefined;
    eshopPrice?: EshopPriceDto | undefined;
    erpPrice?: ErpPriceDto | undefined;
}

export class EshopPriceDto implements IEshopPriceDto {
    priceWithVat?: number;
    purchasePrice?: number;
    priceWithoutVat?: number;
    regularPriceWithVat?: number | undefined;
    actionPriceWithVat?: number | undefined;
    actionFrom?: Date | undefined;
    actionUntil?: Date | undefined;
    isInAction?: boolean;

    constructor(data?: IEshopPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priceWithVat = _data["priceWithVat"];
            this.purchasePrice = _data["purchasePrice"];
            this.priceWithoutVat = _data["priceWithoutVat"];
            this.regularPriceWithVat = _data["regularPriceWithVat"];
            this.actionPriceWithVat = _data["actionPriceWithVat"];
            this.actionFrom = _data["actionFrom"] ? new Date(_data["actionFrom"].toString()) : <any>undefined;
            this.actionUntil = _data["actionUntil"] ? new Date(_data["actionUntil"].toString()) : <any>undefined;
            this.isInAction = _data["isInAction"];
        }
    }

    static fromJS(data: any): EshopPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new EshopPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceWithVat"] = this.priceWithVat;
        data["purchasePrice"] = this.purchasePrice;
        data["priceWithoutVat"] = this.priceWithoutVat;
        data["regularPriceWithVat"] = this.regularPriceWithVat;
        data["actionPriceWithVat"] = this.actionPriceWithVat;
        data["actionFrom"] = this.actionFrom ? formatDate(this.actionFrom) : <any>undefined;
        data["actionUntil"] = this.actionUntil ? formatDate(this.actionUntil) : <any>undefined;
        data["isInAction"] = this.isInAction;
        return data;
    }
}

export interface IEshopPriceDto {
    priceWithVat?: number;
    purchasePrice?: number;
    priceWithoutVat?: number;
    regularPriceWithVat?: number | undefined;
    actionPriceWithVat?: number | undefined;
    actionFrom?: Date | undefined;
    actionUntil?: Date | undefined;
    isInAction?: boolean;
}

export class ErpPriceDto implements IErpPriceDto {
    priceWithoutVat?: number;
    priceWithVat?: number;
    purchasePrice?: number;
    purchasePriceWithVat?: number;

    constructor(data?: IErpPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priceWithoutVat = _data["priceWithoutVat"];
            this.priceWithVat = _data["priceWithVat"];
            this.purchasePrice = _data["purchasePrice"];
            this.purchasePriceWithVat = _data["purchasePriceWithVat"];
        }
    }

    static fromJS(data: any): ErpPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErpPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceWithoutVat"] = this.priceWithoutVat;
        data["priceWithVat"] = this.priceWithVat;
        data["purchasePrice"] = this.purchasePrice;
        data["purchasePriceWithVat"] = this.purchasePriceWithVat;
        return data;
    }
}

export interface IErpPriceDto {
    priceWithoutVat?: number;
    priceWithVat?: number;
    purchasePrice?: number;
    purchasePriceWithVat?: number;
}

export class PropertiesDto implements IPropertiesDto {
    optimalStockDaysSetup?: number;
    stockMinSetup?: number;
    batchSize?: number;
    seasonMonths?: number[];
    cooling?: Cooling;
    isNd?: boolean;

    constructor(data?: IPropertiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optimalStockDaysSetup = _data["optimalStockDaysSetup"];
            this.stockMinSetup = _data["stockMinSetup"];
            this.batchSize = _data["batchSize"];
            if (Array.isArray(_data["seasonMonths"])) {
                this.seasonMonths = [] as any;
                for (let item of _data["seasonMonths"])
                    this.seasonMonths!.push(item);
            }
            this.cooling = _data["cooling"];
            this.isNd = _data["isNd"];
        }
    }

    static fromJS(data: any): PropertiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PropertiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optimalStockDaysSetup"] = this.optimalStockDaysSetup;
        data["stockMinSetup"] = this.stockMinSetup;
        data["batchSize"] = this.batchSize;
        if (Array.isArray(this.seasonMonths)) {
            data["seasonMonths"] = [];
            for (let item of this.seasonMonths)
                data["seasonMonths"].push(item);
        }
        data["cooling"] = this.cooling;
        data["isNd"] = this.isNd;
        return data;
    }
}

export interface IPropertiesDto {
    optimalStockDaysSetup?: number;
    stockMinSetup?: number;
    batchSize?: number;
    seasonMonths?: number[];
    cooling?: Cooling;
    isNd?: boolean;
}

export class LotDto implements ILotDto {
    lotCode?: string | undefined;
    amount?: number;
    expiration?: Date | undefined;

    constructor(data?: ILotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lotCode = _data["lotCode"];
            this.amount = _data["amount"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LotDto {
        data = typeof data === 'object' ? data : {};
        let result = new LotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lotCode"] = this.lotCode;
        data["amount"] = this.amount;
        data["expiration"] = this.expiration ? formatDate(this.expiration) : <any>undefined;
        return data;
    }
}

export interface ILotDto {
    lotCode?: string | undefined;
    amount?: number;
    expiration?: Date | undefined;
}

export class EshopFlagDto implements IEshopFlagDto {
    code?: string;
    title?: string;

    constructor(data?: IEshopFlagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): EshopFlagDto {
        data = typeof data === 'object' ? data : {};
        let result = new EshopFlagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["title"] = this.title;
        return data;
    }
}

export interface IEshopFlagDto {
    code?: string;
    title?: string;
}

export class GetCatalogDetailResponse extends BaseResponse implements IGetCatalogDetailResponse {
    item?: CatalogItemDto;
    historicalData?: CatalogHistoricalDataDto;

    constructor(data?: IGetCatalogDetailResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.item = _data["item"] ? CatalogItemDto.fromJS(_data["item"]) : <any>undefined;
            this.historicalData = _data["historicalData"] ? CatalogHistoricalDataDto.fromJS(_data["historicalData"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetCatalogDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCatalogDetailResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["historicalData"] = this.historicalData ? this.historicalData.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetCatalogDetailResponse extends IBaseResponse {
    item?: CatalogItemDto;
    historicalData?: CatalogHistoricalDataDto;
}

export class CatalogHistoricalDataDto implements ICatalogHistoricalDataDto {
    salesHistory?: CatalogSalesRecordDto[];
    purchaseHistory?: CatalogPurchaseRecordDto[];
    consumedHistory?: CatalogConsumedRecordDto[];
    manufactureHistory?: CatalogManufactureRecordDto[];
    manufactureCostHistory?: ManufactureCostDto[];
    marginHistory?: MarginHistoryDto[];

    constructor(data?: ICatalogHistoricalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["salesHistory"])) {
                this.salesHistory = [] as any;
                for (let item of _data["salesHistory"])
                    this.salesHistory!.push(CatalogSalesRecordDto.fromJS(item));
            }
            if (Array.isArray(_data["purchaseHistory"])) {
                this.purchaseHistory = [] as any;
                for (let item of _data["purchaseHistory"])
                    this.purchaseHistory!.push(CatalogPurchaseRecordDto.fromJS(item));
            }
            if (Array.isArray(_data["consumedHistory"])) {
                this.consumedHistory = [] as any;
                for (let item of _data["consumedHistory"])
                    this.consumedHistory!.push(CatalogConsumedRecordDto.fromJS(item));
            }
            if (Array.isArray(_data["manufactureHistory"])) {
                this.manufactureHistory = [] as any;
                for (let item of _data["manufactureHistory"])
                    this.manufactureHistory!.push(CatalogManufactureRecordDto.fromJS(item));
            }
            if (Array.isArray(_data["manufactureCostHistory"])) {
                this.manufactureCostHistory = [] as any;
                for (let item of _data["manufactureCostHistory"])
                    this.manufactureCostHistory!.push(ManufactureCostDto.fromJS(item));
            }
            if (Array.isArray(_data["marginHistory"])) {
                this.marginHistory = [] as any;
                for (let item of _data["marginHistory"])
                    this.marginHistory!.push(MarginHistoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CatalogHistoricalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogHistoricalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.salesHistory)) {
            data["salesHistory"] = [];
            for (let item of this.salesHistory)
                data["salesHistory"].push(item.toJSON());
        }
        if (Array.isArray(this.purchaseHistory)) {
            data["purchaseHistory"] = [];
            for (let item of this.purchaseHistory)
                data["purchaseHistory"].push(item.toJSON());
        }
        if (Array.isArray(this.consumedHistory)) {
            data["consumedHistory"] = [];
            for (let item of this.consumedHistory)
                data["consumedHistory"].push(item.toJSON());
        }
        if (Array.isArray(this.manufactureHistory)) {
            data["manufactureHistory"] = [];
            for (let item of this.manufactureHistory)
                data["manufactureHistory"].push(item.toJSON());
        }
        if (Array.isArray(this.manufactureCostHistory)) {
            data["manufactureCostHistory"] = [];
            for (let item of this.manufactureCostHistory)
                data["manufactureCostHistory"].push(item.toJSON());
        }
        if (Array.isArray(this.marginHistory)) {
            data["marginHistory"] = [];
            for (let item of this.marginHistory)
                data["marginHistory"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICatalogHistoricalDataDto {
    salesHistory?: CatalogSalesRecordDto[];
    purchaseHistory?: CatalogPurchaseRecordDto[];
    consumedHistory?: CatalogConsumedRecordDto[];
    manufactureHistory?: CatalogManufactureRecordDto[];
    manufactureCostHistory?: ManufactureCostDto[];
    marginHistory?: MarginHistoryDto[];
}

export class CatalogSalesRecordDto implements ICatalogSalesRecordDto {
    year?: number;
    month?: number;
    amountTotal?: number;
    amountB2B?: number;
    amountB2C?: number;
    sumTotal?: number;
    sumB2B?: number;
    sumB2C?: number;

    constructor(data?: ICatalogSalesRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.amountTotal = _data["amountTotal"];
            this.amountB2B = _data["amountB2B"];
            this.amountB2C = _data["amountB2C"];
            this.sumTotal = _data["sumTotal"];
            this.sumB2B = _data["sumB2B"];
            this.sumB2C = _data["sumB2C"];
        }
    }

    static fromJS(data: any): CatalogSalesRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogSalesRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["amountTotal"] = this.amountTotal;
        data["amountB2B"] = this.amountB2B;
        data["amountB2C"] = this.amountB2C;
        data["sumTotal"] = this.sumTotal;
        data["sumB2B"] = this.sumB2B;
        data["sumB2C"] = this.sumB2C;
        return data;
    }
}

export interface ICatalogSalesRecordDto {
    year?: number;
    month?: number;
    amountTotal?: number;
    amountB2B?: number;
    amountB2C?: number;
    sumTotal?: number;
    sumB2B?: number;
    sumB2C?: number;
}

export class CatalogPurchaseRecordDto implements ICatalogPurchaseRecordDto {
    date?: Date;
    supplierName?: string;
    amount?: number;
    pricePerPiece?: number;
    priceTotal?: number;
    documentNumber?: string;
    year?: number;
    month?: number;

    constructor(data?: ICatalogPurchaseRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.supplierName = _data["supplierName"];
            this.amount = _data["amount"];
            this.pricePerPiece = _data["pricePerPiece"];
            this.priceTotal = _data["priceTotal"];
            this.documentNumber = _data["documentNumber"];
            this.year = _data["year"];
            this.month = _data["month"];
        }
    }

    static fromJS(data: any): CatalogPurchaseRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogPurchaseRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["supplierName"] = this.supplierName;
        data["amount"] = this.amount;
        data["pricePerPiece"] = this.pricePerPiece;
        data["priceTotal"] = this.priceTotal;
        data["documentNumber"] = this.documentNumber;
        data["year"] = this.year;
        data["month"] = this.month;
        return data;
    }
}

export interface ICatalogPurchaseRecordDto {
    date?: Date;
    supplierName?: string;
    amount?: number;
    pricePerPiece?: number;
    priceTotal?: number;
    documentNumber?: string;
    year?: number;
    month?: number;
}

export class CatalogConsumedRecordDto implements ICatalogConsumedRecordDto {
    year?: number;
    month?: number;
    amount?: number;
    productName?: string;

    constructor(data?: ICatalogConsumedRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.amount = _data["amount"];
            this.productName = _data["productName"];
        }
    }

    static fromJS(data: any): CatalogConsumedRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogConsumedRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["amount"] = this.amount;
        data["productName"] = this.productName;
        return data;
    }
}

export interface ICatalogConsumedRecordDto {
    year?: number;
    month?: number;
    amount?: number;
    productName?: string;
}

export class CatalogManufactureRecordDto implements ICatalogManufactureRecordDto {
    date?: Date;
    amount?: number;
    pricePerPiece?: number;
    priceTotal?: number;
    productCode?: string;
    documentNumber?: string;
    year?: number | undefined;
    month?: number | undefined;

    constructor(data?: ICatalogManufactureRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.pricePerPiece = _data["pricePerPiece"];
            this.priceTotal = _data["priceTotal"];
            this.productCode = _data["productCode"];
            this.documentNumber = _data["documentNumber"];
            this.year = _data["year"];
            this.month = _data["month"];
        }
    }

    static fromJS(data: any): CatalogManufactureRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogManufactureRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["pricePerPiece"] = this.pricePerPiece;
        data["priceTotal"] = this.priceTotal;
        data["productCode"] = this.productCode;
        data["documentNumber"] = this.documentNumber;
        data["year"] = this.year;
        data["month"] = this.month;
        return data;
    }
}

export interface ICatalogManufactureRecordDto {
    date?: Date;
    amount?: number;
    pricePerPiece?: number;
    priceTotal?: number;
    productCode?: string;
    documentNumber?: string;
    year?: number | undefined;
    month?: number | undefined;
}

export class ManufactureCostDto implements IManufactureCostDto {
    date?: Date;
    materialCost?: number;
    handlingCost?: number;
    total?: number;

    constructor(data?: IManufactureCostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.materialCost = _data["materialCost"];
            this.handlingCost = _data["handlingCost"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ManufactureCostDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufactureCostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["materialCost"] = this.materialCost;
        data["handlingCost"] = this.handlingCost;
        data["total"] = this.total;
        return data;
    }
}

export interface IManufactureCostDto {
    date?: Date;
    materialCost?: number;
    handlingCost?: number;
    total?: number;
}

export class MarginHistoryDto implements IMarginHistoryDto {
    date?: Date;
    sellingPrice?: number;
    totalCost?: number;
    m0?: MarginLevelDto;
    m1?: MarginLevelDto;
    m2?: MarginLevelDto;
    m3?: MarginLevelDto;

    constructor(data?: IMarginHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.sellingPrice = _data["sellingPrice"];
            this.totalCost = _data["totalCost"];
            this.m0 = _data["m0"] ? MarginLevelDto.fromJS(_data["m0"]) : <any>undefined;
            this.m1 = _data["m1"] ? MarginLevelDto.fromJS(_data["m1"]) : <any>undefined;
            this.m2 = _data["m2"] ? MarginLevelDto.fromJS(_data["m2"]) : <any>undefined;
            this.m3 = _data["m3"] ? MarginLevelDto.fromJS(_data["m3"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MarginHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarginHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["sellingPrice"] = this.sellingPrice;
        data["totalCost"] = this.totalCost;
        data["m0"] = this.m0 ? this.m0.toJSON() : <any>undefined;
        data["m1"] = this.m1 ? this.m1.toJSON() : <any>undefined;
        data["m2"] = this.m2 ? this.m2.toJSON() : <any>undefined;
        data["m3"] = this.m3 ? this.m3.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMarginHistoryDto {
    date?: Date;
    sellingPrice?: number;
    totalCost?: number;
    m0?: MarginLevelDto;
    m1?: MarginLevelDto;
    m2?: MarginLevelDto;
    m3?: MarginLevelDto;
}

export class MarginLevelDto implements IMarginLevelDto {
    percentage?: number;
    amount?: number;
    costLevel?: number;
    costTotal?: number;

    constructor(data?: IMarginLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentage = _data["percentage"];
            this.amount = _data["amount"];
            this.costLevel = _data["costLevel"];
            this.costTotal = _data["costTotal"];
        }
    }

    static fromJS(data: any): MarginLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarginLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentage"] = this.percentage;
        data["amount"] = this.amount;
        data["costLevel"] = this.costLevel;
        data["costTotal"] = this.costTotal;
        return data;
    }
}

export interface IMarginLevelDto {
    percentage?: number;
    amount?: number;
    costLevel?: number;
    costTotal?: number;
}

export class GetProductStatisticsResponse extends BaseResponse implements IGetProductStatisticsResponse {
    months?: string[];
    products?: ProductStatisticsSeriesDto[];

    constructor(data?: IGetProductStatisticsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["months"])) {
                this.months = [] as any;
                for (let item of _data["months"])
                    this.months!.push(item);
            }
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductStatisticsSeriesDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetProductStatisticsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductStatisticsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.months)) {
            data["months"] = [];
            for (let item of this.months)
                data["months"].push(item);
        }
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetProductStatisticsResponse extends IBaseResponse {
    months?: string[];
    products?: ProductStatisticsSeriesDto[];
}

export class ProductStatisticsSeriesDto implements IProductStatisticsSeriesDto {
    productCode?: string;
    productName?: string;
    values?: number[];

    constructor(data?: IProductStatisticsSeriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductStatisticsSeriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStatisticsSeriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface IProductStatisticsSeriesDto {
    productCode?: string;
    productName?: string;
    values?: number[];
}

export enum ProductStatisticsMetric {
    Sales = "Sales",
    Purchase = "Purchase",
    Consumption = "Consumption",
    Manufacture = "Manufacture",
}

export class GetProductCompositionResponse extends BaseResponse implements IGetProductCompositionResponse {
    ingredients?: IngredientDto[];

    constructor(data?: IGetProductCompositionResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(IngredientDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetProductCompositionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductCompositionResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetProductCompositionResponse extends IBaseResponse {
    ingredients?: IngredientDto[];
}

export class IngredientDto implements IIngredientDto {
    productCode?: string;
    productName?: string;
    amount?: number;
    unit?: string;
    order?: number;
    phaseLabel?: string | undefined;

    constructor(data?: IIngredientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.amount = _data["amount"];
            this.unit = _data["unit"];
            this.order = _data["order"];
            this.phaseLabel = _data["phaseLabel"];
        }
    }

    static fromJS(data: any): IngredientDto {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        data["order"] = this.order;
        data["phaseLabel"] = this.phaseLabel;
        return data;
    }
}

export interface IIngredientDto {
    productCode?: string;
    productName?: string;
    amount?: number;
    unit?: string;
    order?: number;
    phaseLabel?: string | undefined;
}

export class UpdateProductCompositionOrderResponse extends BaseResponse implements IUpdateProductCompositionOrderResponse {
    updatedCount?: number;

    constructor(data?: IUpdateProductCompositionOrderResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.updatedCount = _data["updatedCount"];
        }
    }

    static override fromJS(data: any): UpdateProductCompositionOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductCompositionOrderResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedCount"] = this.updatedCount;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateProductCompositionOrderResponse extends IBaseResponse {
    updatedCount?: number;
}

export class UpdateProductCompositionOrderRequest implements IUpdateProductCompositionOrderRequest {
    productCode!: string;
    order?: IngredientOrderItem[];

    constructor(data?: IUpdateProductCompositionOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            if (Array.isArray(_data["order"])) {
                this.order = [] as any;
                for (let item of _data["order"])
                    this.order!.push(IngredientOrderItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateProductCompositionOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductCompositionOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        if (Array.isArray(this.order)) {
            data["order"] = [];
            for (let item of this.order)
                data["order"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateProductCompositionOrderRequest {
    productCode: string;
    order?: IngredientOrderItem[];
}

export class IngredientOrderItem implements IIngredientOrderItem {
    ingredientProductCode!: string;
    sortOrder?: number;
    phaseLabel?: string | undefined;

    constructor(data?: IIngredientOrderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingredientProductCode = _data["ingredientProductCode"];
            this.sortOrder = _data["sortOrder"];
            this.phaseLabel = _data["phaseLabel"];
        }
    }

    static fromJS(data: any): IngredientOrderItem {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientOrderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingredientProductCode"] = this.ingredientProductCode;
        data["sortOrder"] = this.sortOrder;
        data["phaseLabel"] = this.phaseLabel;
        return data;
    }
}

export interface IIngredientOrderItem {
    ingredientProductCode: string;
    sortOrder?: number;
    phaseLabel?: string | undefined;
}

export class GetMaterialsForPurchaseResponse extends BaseResponse implements IGetMaterialsForPurchaseResponse {
    materials?: MaterialForPurchaseDto[];

    constructor(data?: IGetMaterialsForPurchaseResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(MaterialForPurchaseDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetMaterialsForPurchaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMaterialsForPurchaseResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetMaterialsForPurchaseResponse extends IBaseResponse {
    materials?: MaterialForPurchaseDto[];
}

export class MaterialForPurchaseDto implements IMaterialForPurchaseDto {
    productCode?: string;
    productName?: string;
    productNameSuffix?: string | undefined;
    productType?: string;
    lastPurchasePrice?: number | undefined;
    location?: string | undefined;
    currentStock?: number;
    minimalOrderQuantity?: string | undefined;

    constructor(data?: IMaterialForPurchaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.productNameSuffix = _data["productNameSuffix"];
            this.productType = _data["productType"];
            this.lastPurchasePrice = _data["lastPurchasePrice"];
            this.location = _data["location"];
            this.currentStock = _data["currentStock"];
            this.minimalOrderQuantity = _data["minimalOrderQuantity"];
        }
    }

    static fromJS(data: any): MaterialForPurchaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialForPurchaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productNameSuffix"] = this.productNameSuffix;
        data["productType"] = this.productType;
        data["lastPurchasePrice"] = this.lastPurchasePrice;
        data["location"] = this.location;
        data["currentStock"] = this.currentStock;
        data["minimalOrderQuantity"] = this.minimalOrderQuantity;
        return data;
    }
}

export interface IMaterialForPurchaseDto {
    productCode?: string;
    productName?: string;
    productNameSuffix?: string | undefined;
    productType?: string;
    lastPurchasePrice?: number | undefined;
    location?: string | undefined;
    currentStock?: number;
    minimalOrderQuantity?: string | undefined;
}

export class GetManufactureDifficultySettingsResponse extends BaseResponse implements IGetManufactureDifficultySettingsResponse {
    productCode?: string;
    settings?: ManufactureDifficultySettingDto[];
    currentSetting?: ManufactureDifficultySettingDto | undefined;

    constructor(data?: IGetManufactureDifficultySettingsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productCode = _data["productCode"];
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(ManufactureDifficultySettingDto.fromJS(item));
            }
            this.currentSetting = _data["currentSetting"] ? ManufactureDifficultySettingDto.fromJS(_data["currentSetting"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetManufactureDifficultySettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufactureDifficultySettingsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["currentSetting"] = this.currentSetting ? this.currentSetting.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetManufactureDifficultySettingsResponse extends IBaseResponse {
    productCode?: string;
    settings?: ManufactureDifficultySettingDto[];
    currentSetting?: ManufactureDifficultySettingDto | undefined;
}

export class ManufactureDifficultySettingDto implements IManufactureDifficultySettingDto {
    id?: number;
    productCode?: string;
    difficultyValue?: number;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    createdAt?: Date;
    createdBy?: string;
    isCurrent?: boolean;

    constructor(data?: IManufactureDifficultySettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productCode = _data["productCode"];
            this.difficultyValue = _data["difficultyValue"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.isCurrent = _data["isCurrent"];
        }
    }

    static fromJS(data: any): ManufactureDifficultySettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufactureDifficultySettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productCode"] = this.productCode;
        data["difficultyValue"] = this.difficultyValue;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["isCurrent"] = this.isCurrent;
        return data;
    }
}

export interface IManufactureDifficultySettingDto {
    id?: number;
    productCode?: string;
    difficultyValue?: number;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    createdAt?: Date;
    createdBy?: string;
    isCurrent?: boolean;
}

export class CreateManufactureDifficultyResponse extends BaseResponse implements ICreateManufactureDifficultyResponse {
    difficultyHistory?: ManufactureDifficultySettingDto;

    constructor(data?: ICreateManufactureDifficultyResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.difficultyHistory = _data["difficultyHistory"] ? ManufactureDifficultySettingDto.fromJS(_data["difficultyHistory"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CreateManufactureDifficultyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManufactureDifficultyResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["difficultyHistory"] = this.difficultyHistory ? this.difficultyHistory.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateManufactureDifficultyResponse extends IBaseResponse {
    difficultyHistory?: ManufactureDifficultySettingDto;
}

export class CreateManufactureDifficultyRequest implements ICreateManufactureDifficultyRequest {
    productCode!: string;
    difficultyValue!: number;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;

    constructor(data?: ICreateManufactureDifficultyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.difficultyValue = _data["difficultyValue"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateManufactureDifficultyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManufactureDifficultyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["difficultyValue"] = this.difficultyValue;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateManufactureDifficultyRequest {
    productCode: string;
    difficultyValue: number;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
}

export class UpdateManufactureDifficultyResponse extends BaseResponse implements IUpdateManufactureDifficultyResponse {
    difficultyHistory?: ManufactureDifficultySettingDto;

    constructor(data?: IUpdateManufactureDifficultyResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.difficultyHistory = _data["difficultyHistory"] ? ManufactureDifficultySettingDto.fromJS(_data["difficultyHistory"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): UpdateManufactureDifficultyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateManufactureDifficultyResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["difficultyHistory"] = this.difficultyHistory ? this.difficultyHistory.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateManufactureDifficultyResponse extends IBaseResponse {
    difficultyHistory?: ManufactureDifficultySettingDto;
}

export class UpdateManufactureDifficultyRequest implements IUpdateManufactureDifficultyRequest {
    id!: number;
    difficultyValue!: number;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;

    constructor(data?: IUpdateManufactureDifficultyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.difficultyValue = _data["difficultyValue"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateManufactureDifficultyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateManufactureDifficultyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["difficultyValue"] = this.difficultyValue;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateManufactureDifficultyRequest {
    id: number;
    difficultyValue: number;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
}

export class DeleteManufactureDifficultyResponse extends BaseResponse implements IDeleteManufactureDifficultyResponse {
    message?: string | undefined;

    constructor(data?: IDeleteManufactureDifficultyResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.message = _data["message"];
        }
    }

    static override fromJS(data: any): DeleteManufactureDifficultyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteManufactureDifficultyResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteManufactureDifficultyResponse extends IBaseResponse {
    message?: string | undefined;
}

export class GetProductUsageResponse extends BaseResponse implements IGetProductUsageResponse {
    manufactureTemplates?: ManufactureTemplate[];

    constructor(data?: IGetProductUsageResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["manufactureTemplates"])) {
                this.manufactureTemplates = [] as any;
                for (let item of _data["manufactureTemplates"])
                    this.manufactureTemplates!.push(ManufactureTemplate.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetProductUsageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductUsageResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufactureTemplates)) {
            data["manufactureTemplates"] = [];
            for (let item of this.manufactureTemplates)
                data["manufactureTemplates"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetProductUsageResponse extends IBaseResponse {
    manufactureTemplates?: ManufactureTemplate[];
}

export class ManufactureTemplate implements IManufactureTemplate {
    templateId?: number;
    productCode?: string;
    productName?: string;
    amount?: number;
    originalAmount?: number;
    ingredients?: Ingredient[];
    batchSize?: number;
    manufactureType?: ManufactureType;

    constructor(data?: IManufactureTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.amount = _data["amount"];
            this.originalAmount = _data["originalAmount"];
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(Ingredient.fromJS(item));
            }
            this.batchSize = _data["batchSize"];
            this.manufactureType = _data["manufactureType"];
        }
    }

    static fromJS(data: any): ManufactureTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ManufactureTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["amount"] = this.amount;
        data["originalAmount"] = this.originalAmount;
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item.toJSON());
        }
        data["batchSize"] = this.batchSize;
        data["manufactureType"] = this.manufactureType;
        return data;
    }
}

export interface IManufactureTemplate {
    templateId?: number;
    productCode?: string;
    productName?: string;
    amount?: number;
    originalAmount?: number;
    ingredients?: Ingredient[];
    batchSize?: number;
    manufactureType?: ManufactureType;
}

export class Ingredient implements IIngredient {
    templateId?: number;
    productCode?: string;
    productName?: string;
    amount?: number;
    originalAmount?: number;
    price?: number;
    productType?: ProductType;
    hasLots?: boolean;
    hasExpiration?: boolean;
    order?: number;
    phaseLabel?: string | undefined;

    constructor(data?: IIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.amount = _data["amount"];
            this.originalAmount = _data["originalAmount"];
            this.price = _data["price"];
            this.productType = _data["productType"];
            this.hasLots = _data["hasLots"];
            this.hasExpiration = _data["hasExpiration"];
            this.order = _data["order"];
            this.phaseLabel = _data["phaseLabel"];
        }
    }

    static fromJS(data: any): Ingredient {
        data = typeof data === 'object' ? data : {};
        let result = new Ingredient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["amount"] = this.amount;
        data["originalAmount"] = this.originalAmount;
        data["price"] = this.price;
        data["productType"] = this.productType;
        data["hasLots"] = this.hasLots;
        data["hasExpiration"] = this.hasExpiration;
        data["order"] = this.order;
        data["phaseLabel"] = this.phaseLabel;
        return data;
    }
}

export interface IIngredient {
    templateId?: number;
    productCode?: string;
    productName?: string;
    amount?: number;
    originalAmount?: number;
    price?: number;
    productType?: ProductType;
    hasLots?: boolean;
    hasExpiration?: boolean;
    order?: number;
    phaseLabel?: string | undefined;
}

export enum ManufactureType {
    MultiPhase = "MultiPhase",
    SinglePhase = "SinglePhase",
    Unavailable = "Unavailable",
}

export class GetWarehouseStatisticsResponse extends BaseResponse implements IGetWarehouseStatisticsResponse {
    totalQuantity?: number;
    totalWeight?: number;
    warehouseCapacityKg?: number;
    warehouseUtilizationPercentage?: number;
    totalProductCount?: number;
    lastUpdated?: Date;

    constructor(data?: IGetWarehouseStatisticsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalQuantity = _data["totalQuantity"];
            this.totalWeight = _data["totalWeight"];
            this.warehouseCapacityKg = _data["warehouseCapacityKg"];
            this.warehouseUtilizationPercentage = _data["warehouseUtilizationPercentage"];
            this.totalProductCount = _data["totalProductCount"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetWarehouseStatisticsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarehouseStatisticsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalQuantity"] = this.totalQuantity;
        data["totalWeight"] = this.totalWeight;
        data["warehouseCapacityKg"] = this.warehouseCapacityKg;
        data["warehouseUtilizationPercentage"] = this.warehouseUtilizationPercentage;
        data["totalProductCount"] = this.totalProductCount;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetWarehouseStatisticsResponse extends IBaseResponse {
    totalQuantity?: number;
    totalWeight?: number;
    warehouseCapacityKg?: number;
    warehouseUtilizationPercentage?: number;
    totalProductCount?: number;
    lastUpdated?: Date;
}

export class RecalculateProductWeightResponse extends BaseResponse implements IRecalculateProductWeightResponse {
    processedCount?: number;
    successCount?: number;
    errorCount?: number;
    errorMessages?: string[];

    constructor(data?: IRecalculateProductWeightResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.processedCount = _data["processedCount"];
            this.successCount = _data["successCount"];
            this.errorCount = _data["errorCount"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
        }
    }

    static override fromJS(data: any): RecalculateProductWeightResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecalculateProductWeightResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processedCount"] = this.processedCount;
        data["successCount"] = this.successCount;
        data["errorCount"] = this.errorCount;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IRecalculateProductWeightResponse extends IBaseResponse {
    processedCount?: number;
    successCount?: number;
    errorCount?: number;
    errorMessages?: string[];
}

export class RecalculateProductWeightRequest implements IRecalculateProductWeightRequest {
    productCode?: string | undefined;

    constructor(data?: IRecalculateProductWeightRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
        }
    }

    static fromJS(data: any): RecalculateProductWeightRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecalculateProductWeightRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        return data;
    }
}

export interface IRecalculateProductWeightRequest {
    productCode?: string | undefined;
}

export class SetNdResponse extends BaseResponse implements ISetNdResponse {
    productCode?: string;
    isNd?: boolean;

    constructor(data?: ISetNdResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productCode = _data["productCode"];
            this.isNd = _data["isNd"];
        }
    }

    static override fromJS(data: any): SetNdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetNdResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["isNd"] = this.isNd;
        super.toJSON(data);
        return data;
    }
}

export interface ISetNdResponse extends IBaseResponse {
    productCode?: string;
    isNd?: boolean;
}

export class SetNdRequest implements ISetNdRequest {
    productCode?: string;
    isNd?: boolean;

    constructor(data?: ISetNdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.isNd = _data["isNd"];
        }
    }

    static fromJS(data: any): SetNdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetNdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["isNd"] = this.isNd;
        return data;
    }
}

export interface ISetNdRequest {
    productCode?: string;
    isNd?: boolean;
}

export class ListCatalogDocumentsResponse extends BaseResponse implements IListCatalogDocumentsResponse {
    folderStatus?: FolderStatus;
    expectedPrefix?: string;
    basePath?: string;
    files?: CatalogDocumentDto[];

    constructor(data?: IListCatalogDocumentsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.folderStatus = _data["folderStatus"];
            this.expectedPrefix = _data["expectedPrefix"];
            this.basePath = _data["basePath"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(CatalogDocumentDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ListCatalogDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListCatalogDocumentsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderStatus"] = this.folderStatus;
        data["expectedPrefix"] = this.expectedPrefix;
        data["basePath"] = this.basePath;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IListCatalogDocumentsResponse extends IBaseResponse {
    folderStatus?: FolderStatus;
    expectedPrefix?: string;
    basePath?: string;
    files?: CatalogDocumentDto[];
}

export enum FolderStatus {
    Found = "Found",
    NotFound = "NotFound",
    MultipleMatches = "MultipleMatches",
}

export class CatalogDocumentDto implements ICatalogDocumentDto {
    name?: string;
    webUrl?: string;
    sizeBytes?: number;
    modifiedAt?: Date;

    constructor(data?: ICatalogDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.webUrl = _data["webUrl"];
            this.sizeBytes = _data["sizeBytes"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CatalogDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["webUrl"] = this.webUrl;
        data["sizeBytes"] = this.sizeBytes;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICatalogDocumentDto {
    name?: string;
    webUrl?: string;
    sizeBytes?: number;
    modifiedAt?: Date;
}

export class GetMaterialDocumentTypesResponse extends BaseResponse implements IGetMaterialDocumentTypesResponse {
    documentTypes?: MaterialDocumentTypeDto[];

    constructor(data?: IGetMaterialDocumentTypesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["documentTypes"])) {
                this.documentTypes = [] as any;
                for (let item of _data["documentTypes"])
                    this.documentTypes!.push(MaterialDocumentTypeDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetMaterialDocumentTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMaterialDocumentTypesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentTypes)) {
            data["documentTypes"] = [];
            for (let item of this.documentTypes)
                data["documentTypes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetMaterialDocumentTypesResponse extends IBaseResponse {
    documentTypes?: MaterialDocumentTypeDto[];
}

export class MaterialDocumentTypeDto implements IMaterialDocumentTypeDto {
    code?: string;
    label?: string;
    lotRequired?: boolean;

    constructor(data?: IMaterialDocumentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.label = _data["label"];
            this.lotRequired = _data["lotRequired"];
        }
    }

    static fromJS(data: any): MaterialDocumentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialDocumentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["label"] = this.label;
        data["lotRequired"] = this.lotRequired;
        return data;
    }
}

export interface IMaterialDocumentTypeDto {
    code?: string;
    label?: string;
    lotRequired?: boolean;
}

export class CatalogDocumentsUploadDocumentResponse extends BaseResponse implements ICatalogDocumentsUploadDocumentResponse {
    uploadedFilename?: string;

    constructor(data?: ICatalogDocumentsUploadDocumentResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.uploadedFilename = _data["uploadedFilename"];
        }
    }

    static override fromJS(data: any): CatalogDocumentsUploadDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogDocumentsUploadDocumentResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadedFilename"] = this.uploadedFilename;
        super.toJSON(data);
        return data;
    }
}

export interface ICatalogDocumentsUploadDocumentResponse extends IBaseResponse {
    uploadedFilename?: string;
}

export class GetConfigurationResponse extends BaseResponse implements IGetConfigurationResponse {
    version?: string;
    environment?: string;
    useMockAuth?: boolean;

    constructor(data?: IGetConfigurationResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.version = _data["version"];
            this.environment = _data["environment"];
            this.useMockAuth = _data["useMockAuth"];
        }
    }

    static override fromJS(data: any): GetConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConfigurationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["environment"] = this.environment;
        data["useMockAuth"] = this.useMockAuth;
        super.toJSON(data);
        return data;
    }
}

export interface IGetConfigurationResponse extends IBaseResponse {
    version?: string;
    environment?: string;
    useMockAuth?: boolean;
}

export class DashboardTileDto implements IDashboardTileDto {
    tileId?: string;
    title?: string;
    description?: string;
    size?: string;
    category?: string;
    defaultEnabled?: boolean;
    autoShow?: boolean;
    requiredPermissions?: string[];
    isUnauthorized?: boolean;
    data?: any | undefined;

    constructor(data?: IDashboardTileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tileId = _data["tileId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.size = _data["size"];
            this.category = _data["category"];
            this.defaultEnabled = _data["defaultEnabled"];
            this.autoShow = _data["autoShow"];
            if (Array.isArray(_data["requiredPermissions"])) {
                this.requiredPermissions = [] as any;
                for (let item of _data["requiredPermissions"])
                    this.requiredPermissions!.push(item);
            }
            this.isUnauthorized = _data["isUnauthorized"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): DashboardTileDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardTileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tileId"] = this.tileId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["size"] = this.size;
        data["category"] = this.category;
        data["defaultEnabled"] = this.defaultEnabled;
        data["autoShow"] = this.autoShow;
        if (Array.isArray(this.requiredPermissions)) {
            data["requiredPermissions"] = [];
            for (let item of this.requiredPermissions)
                data["requiredPermissions"].push(item);
        }
        data["isUnauthorized"] = this.isUnauthorized;
        data["data"] = this.data;
        return data;
    }
}

export interface IDashboardTileDto {
    tileId?: string;
    title?: string;
    description?: string;
    size?: string;
    category?: string;
    defaultEnabled?: boolean;
    autoShow?: boolean;
    requiredPermissions?: string[];
    isUnauthorized?: boolean;
    data?: any | undefined;
}

export class UserDashboardSettingsDto implements IUserDashboardSettingsDto {
    tiles?: UserDashboardTileDto[];
    lastModified?: Date;

    constructor(data?: IUserDashboardSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tiles"])) {
                this.tiles = [] as any;
                for (let item of _data["tiles"])
                    this.tiles!.push(UserDashboardTileDto.fromJS(item));
            }
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserDashboardSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDashboardSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tiles)) {
            data["tiles"] = [];
            for (let item of this.tiles)
                data["tiles"].push(item.toJSON());
        }
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserDashboardSettingsDto {
    tiles?: UserDashboardTileDto[];
    lastModified?: Date;
}

export class UserDashboardTileDto implements IUserDashboardTileDto {
    tileId?: string;
    isVisible?: boolean;
    displayOrder?: number;

    constructor(data?: IUserDashboardTileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tileId = _data["tileId"];
            this.isVisible = _data["isVisible"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): UserDashboardTileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDashboardTileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tileId"] = this.tileId;
        data["isVisible"] = this.isVisible;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IUserDashboardTileDto {
    tileId?: string;
    isVisible?: boolean;
    displayOrder?: number;
}

export class SaveUserSettingsRequest implements ISaveUserSettingsRequest {
    tiles?: UserDashboardTileDto[];

    constructor(data?: ISaveUserSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tiles"])) {
                this.tiles = [] as any;
                for (let item of _data["tiles"])
                    this.tiles!.push(UserDashboardTileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveUserSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tiles)) {
            data["tiles"] = [];
            for (let item of this.tiles)
                data["tiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveUserSettingsRequest {
    tiles?: UserDashboardTileDto[];
}

export class EnableTileResponse extends BaseResponse implements IEnableTileResponse {

    constructor(data?: IEnableTileResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): EnableTileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnableTileResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEnableTileResponse extends IBaseResponse {
}

export class DisableTileResponse extends BaseResponse implements IDisableTileResponse {

    constructor(data?: IDisableTileResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DisableTileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DisableTileResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDisableTileResponse extends IBaseResponse {
}

export class GetDqtRunsResponse extends BaseResponse implements IGetDqtRunsResponse {
    items?: DqtRunDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;

    constructor(data?: IGetDqtRunsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DqtRunDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static override fromJS(data: any): GetDqtRunsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDqtRunsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        super.toJSON(data);
        return data;
    }
}

export interface IGetDqtRunsResponse extends IBaseResponse {
    items?: DqtRunDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class DqtRunDto implements IDqtRunDto {
    id?: string;
    testType?: string;
    dateFrom?: Date;
    dateTo?: Date;
    status?: string;
    startedAt?: Date;
    completedAt?: Date | undefined;
    triggerType?: string;
    totalChecked?: number;
    totalMismatches?: number;
    errorMessage?: string | undefined;

    constructor(data?: IDqtRunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.testType = _data["testType"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : <any>undefined;
            this.triggerType = _data["triggerType"];
            this.totalChecked = _data["totalChecked"];
            this.totalMismatches = _data["totalMismatches"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): DqtRunDto {
        data = typeof data === 'object' ? data : {};
        let result = new DqtRunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["testType"] = this.testType;
        data["dateFrom"] = this.dateFrom ? formatDate(this.dateFrom) : <any>undefined;
        data["dateTo"] = this.dateTo ? formatDate(this.dateTo) : <any>undefined;
        data["status"] = this.status;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        data["triggerType"] = this.triggerType;
        data["totalChecked"] = this.totalChecked;
        data["totalMismatches"] = this.totalMismatches;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IDqtRunDto {
    id?: string;
    testType?: string;
    dateFrom?: Date;
    dateTo?: Date;
    status?: string;
    startedAt?: Date;
    completedAt?: Date | undefined;
    triggerType?: string;
    totalChecked?: number;
    totalMismatches?: number;
    errorMessage?: string | undefined;
}

export enum DqtTestType {
    IssuedInvoiceComparison = "IssuedInvoiceComparison",
    ProductPairing = "ProductPairing",
    StockWriteBackReconciliation = "StockWriteBackReconciliation",
    LotSumVsErpStock = "LotSumVsErpStock",
    PriceComparison = "PriceComparison",
}

export enum DqtRunStatus {
    Running = "Running",
    Completed = "Completed",
    Failed = "Failed",
}

export class GetDqtRunDetailResponse extends BaseResponse implements IGetDqtRunDetailResponse {
    run?: DqtRunDto | undefined;
    results?: InvoiceDqtResultDto[];
    driftResults?: DqtDriftResultDto[] | undefined;
    totalDriftResults?: number;

    constructor(data?: IGetDqtRunDetailResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.run = _data["run"] ? DqtRunDto.fromJS(_data["run"]) : <any>undefined;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(InvoiceDqtResultDto.fromJS(item));
            }
            if (Array.isArray(_data["driftResults"])) {
                this.driftResults = [] as any;
                for (let item of _data["driftResults"])
                    this.driftResults!.push(DqtDriftResultDto.fromJS(item));
            }
            this.totalDriftResults = _data["totalDriftResults"];
        }
    }

    static override fromJS(data: any): GetDqtRunDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDqtRunDetailResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["run"] = this.run ? this.run.toJSON() : <any>undefined;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.driftResults)) {
            data["driftResults"] = [];
            for (let item of this.driftResults)
                data["driftResults"].push(item.toJSON());
        }
        data["totalDriftResults"] = this.totalDriftResults;
        super.toJSON(data);
        return data;
    }
}

export interface IGetDqtRunDetailResponse extends IBaseResponse {
    run?: DqtRunDto | undefined;
    results?: InvoiceDqtResultDto[];
    driftResults?: DqtDriftResultDto[] | undefined;
    totalDriftResults?: number;
}

export class InvoiceDqtResultDto implements IInvoiceDqtResultDto {
    id?: string;
    invoiceCode?: string;
    mismatchType?: number;
    mismatchFlags?: string[];
    shoptetValue?: string | undefined;
    flexiValue?: string | undefined;
    details?: string | undefined;

    constructor(data?: IInvoiceDqtResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceCode = _data["invoiceCode"];
            this.mismatchType = _data["mismatchType"];
            if (Array.isArray(_data["mismatchFlags"])) {
                this.mismatchFlags = [] as any;
                for (let item of _data["mismatchFlags"])
                    this.mismatchFlags!.push(item);
            }
            this.shoptetValue = _data["shoptetValue"];
            this.flexiValue = _data["flexiValue"];
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): InvoiceDqtResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDqtResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceCode"] = this.invoiceCode;
        data["mismatchType"] = this.mismatchType;
        if (Array.isArray(this.mismatchFlags)) {
            data["mismatchFlags"] = [];
            for (let item of this.mismatchFlags)
                data["mismatchFlags"].push(item);
        }
        data["shoptetValue"] = this.shoptetValue;
        data["flexiValue"] = this.flexiValue;
        data["details"] = this.details;
        return data;
    }
}

export interface IInvoiceDqtResultDto {
    id?: string;
    invoiceCode?: string;
    mismatchType?: number;
    mismatchFlags?: string[];
    shoptetValue?: string | undefined;
    flexiValue?: string | undefined;
    details?: string | undefined;
}

export class DqtDriftResultDto implements IDqtDriftResultDto {
    entityKey?: string;
    mismatchCode?: number;
    testType?: string;
    hebloValue?: string | undefined;
    shoptetValue?: string | undefined;
    details?: string | undefined;

    constructor(data?: IDqtDriftResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityKey = _data["entityKey"];
            this.mismatchCode = _data["mismatchCode"];
            this.testType = _data["testType"];
            this.hebloValue = _data["hebloValue"];
            this.shoptetValue = _data["shoptetValue"];
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): DqtDriftResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DqtDriftResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityKey"] = this.entityKey;
        data["mismatchCode"] = this.mismatchCode;
        data["testType"] = this.testType;
        data["hebloValue"] = this.hebloValue;
        data["shoptetValue"] = this.shoptetValue;
        data["details"] = this.details;
        return data;
    }
}

export interface IDqtDriftResultDto {
    entityKey?: string;
    mismatchCode?: number;
    testType?: string;
    hebloValue?: string | undefined;
    shoptetValue?: string | undefined;
    details?: string | undefined;
}

export class RunDqtResponse extends BaseResponse implements IRunDqtResponse {
    dqtRunId?: string | undefined;

    constructor(data?: IRunDqtResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dqtRunId = _data["dqtRunId"];
        }
    }

    static override fromJS(data: any): RunDqtResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RunDqtResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dqtRunId"] = this.dqtRunId;
        super.toJSON(data);
        return data;
    }
}

export interface IRunDqtResponse extends IBaseResponse {
    dqtRunId?: string | undefined;
}

export class RunDqtRequest implements IRunDqtRequest {
    testType?: DqtTestType;
    dateFrom?: Date;
    dateTo?: Date;

    constructor(data?: IRunDqtRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.testType = _data["testType"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RunDqtRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RunDqtRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testType"] = this.testType;
        data["dateFrom"] = this.dateFrom ? formatDate(this.dateFrom) : <any>undefined;
        data["dateTo"] = this.dateTo ? formatDate(this.dateTo) : <any>undefined;
        return data;
    }
}

export interface IRunDqtRequest {
    testType?: DqtTestType;
    dateFrom?: Date;
    dateTo?: Date;
}

export class GetDepartmentsResponse extends BaseResponse implements IGetDepartmentsResponse {
    departments?: DepartmentDto[];

    constructor(data?: IGetDepartmentsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(DepartmentDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetDepartmentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDepartmentsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDepartmentsResponse extends IBaseResponse {
    departments?: DepartmentDto[];
}

export class DepartmentDto implements IDepartmentDto {
    id?: string;
    name?: string;

    constructor(data?: IDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DepartmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IDepartmentDto {
    id?: string;
    name?: string;
}

export class GetExpeditionDatesResponse extends BaseResponse implements IGetExpeditionDatesResponse {
    dates?: string[];
    totalCount?: number;
    page?: number;
    pageSize?: number;

    constructor(data?: IGetExpeditionDatesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates!.push(item);
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static override fromJS(data: any): GetExpeditionDatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpeditionDatesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item);
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}

export interface IGetExpeditionDatesResponse extends IBaseResponse {
    dates?: string[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export class GetExpeditionListsByDateResponse extends BaseResponse implements IGetExpeditionListsByDateResponse {
    items?: ExpeditionListItemDto[];

    constructor(data?: IGetExpeditionListsByDateResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExpeditionListItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetExpeditionListsByDateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpeditionListsByDateResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetExpeditionListsByDateResponse extends IBaseResponse {
    items?: ExpeditionListItemDto[];
}

export class ExpeditionListItemDto implements IExpeditionListItemDto {
    blobPath?: string;
    fileName?: string;
    listId?: string;
    createdOn?: Date | undefined;
    contentLength?: number | undefined;

    constructor(data?: IExpeditionListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blobPath = _data["blobPath"];
            this.fileName = _data["fileName"];
            this.listId = _data["listId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.contentLength = _data["contentLength"];
        }
    }

    static fromJS(data: any): ExpeditionListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpeditionListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blobPath"] = this.blobPath;
        data["fileName"] = this.fileName;
        data["listId"] = this.listId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["contentLength"] = this.contentLength;
        return data;
    }
}

export interface IExpeditionListItemDto {
    blobPath?: string;
    fileName?: string;
    listId?: string;
    createdOn?: Date | undefined;
    contentLength?: number | undefined;
}

export class ReprintExpeditionListResponse extends BaseResponse implements IReprintExpeditionListResponse {

    constructor(data?: IReprintExpeditionListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ReprintExpeditionListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReprintExpeditionListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IReprintExpeditionListResponse extends IBaseResponse {
}

export class ReprintExpeditionListRequest implements IReprintExpeditionListRequest {
    blobPath?: string;

    constructor(data?: IReprintExpeditionListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blobPath = _data["blobPath"];
        }
    }

    static fromJS(data: any): ReprintExpeditionListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReprintExpeditionListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blobPath"] = this.blobPath;
        return data;
    }
}

export interface IReprintExpeditionListRequest {
    blobPath?: string;
}

export class RunExpeditionListPrintFixResponse extends BaseResponse implements IRunExpeditionListPrintFixResponse {
    totalCount?: number;
    skippedCount?: number;

    constructor(data?: IRunExpeditionListPrintFixResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalCount = _data["totalCount"];
            this.skippedCount = _data["skippedCount"];
        }
    }

    static override fromJS(data: any): RunExpeditionListPrintFixResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RunExpeditionListPrintFixResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["skippedCount"] = this.skippedCount;
        super.toJSON(data);
        return data;
    }
}

export interface IRunExpeditionListPrintFixResponse extends IBaseResponse {
    totalCount?: number;
    skippedCount?: number;
}

export class PrintExpeditionOrderResponse extends BaseResponse implements IPrintExpeditionOrderResponse {

    constructor(data?: IPrintExpeditionOrderResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PrintExpeditionOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrintExpeditionOrderResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPrintExpeditionOrderResponse extends IBaseResponse {
}

export class PrintExpeditionOrderRequest implements IPrintExpeditionOrderRequest {
    orderCode?: string;

    constructor(data?: IPrintExpeditionOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderCode = _data["orderCode"];
        }
    }

    static fromJS(data: any): PrintExpeditionOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PrintExpeditionOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCode"] = this.orderCode;
        return data;
    }
}

export interface IPrintExpeditionOrderRequest {
    orderCode?: string;
}

export class EvaluateFlagsForClientResponse extends BaseResponse implements IEvaluateFlagsForClientResponse {
    flags?: { [key: string]: boolean; };

    constructor(data?: IEvaluateFlagsForClientResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["flags"]) {
                this.flags = {} as any;
                for (let key in _data["flags"]) {
                    if (_data["flags"].hasOwnProperty(key))
                        (<any>this.flags)![key] = _data["flags"][key];
                }
            }
        }
    }

    static override fromJS(data: any): EvaluateFlagsForClientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluateFlagsForClientResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.flags) {
            data["flags"] = {};
            for (let key in this.flags) {
                if (this.flags.hasOwnProperty(key))
                    (<any>data["flags"])[key] = (<any>this.flags)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEvaluateFlagsForClientResponse extends IBaseResponse {
    flags?: { [key: string]: boolean; };
}

export class ListFlagsResponse extends BaseResponse implements IListFlagsResponse {
    flags?: FlagStatusDto[];

    constructor(data?: IListFlagsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["flags"])) {
                this.flags = [] as any;
                for (let item of _data["flags"])
                    this.flags!.push(FlagStatusDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ListFlagsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListFlagsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IListFlagsResponse extends IBaseResponse {
    flags?: FlagStatusDto[];
}

export class FlagStatusDto implements IFlagStatusDto {
    key?: string;
    description?: string;
    currentValue?: boolean;
    isOverridden?: boolean;
    defaultValue?: boolean;
    updatedBy?: string | undefined;
    updatedAt?: Date | undefined;

    constructor(data?: IFlagStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.description = _data["description"];
            this.currentValue = _data["currentValue"];
            this.isOverridden = _data["isOverridden"];
            this.defaultValue = _data["defaultValue"];
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FlagStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlagStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["description"] = this.description;
        data["currentValue"] = this.currentValue;
        data["isOverridden"] = this.isOverridden;
        data["defaultValue"] = this.defaultValue;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFlagStatusDto {
    key?: string;
    description?: string;
    currentValue?: boolean;
    isOverridden?: boolean;
    defaultValue?: boolean;
    updatedBy?: string | undefined;
    updatedAt?: Date | undefined;
}

export class UpsertFlagOverrideResponse extends BaseResponse implements IUpsertFlagOverrideResponse {

    constructor(data?: IUpsertFlagOverrideResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpsertFlagOverrideResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertFlagOverrideResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertFlagOverrideResponse extends IBaseResponse {
}

export class UpsertFlagOverrideBodyDto implements IUpsertFlagOverrideBodyDto {
    isEnabled?: boolean;

    constructor(data?: IUpsertFlagOverrideBodyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): UpsertFlagOverrideBodyDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertFlagOverrideBodyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IUpsertFlagOverrideBodyDto {
    isEnabled?: boolean;
}

export class ClearFlagOverrideResponse extends BaseResponse implements IClearFlagOverrideResponse {

    constructor(data?: IClearFlagOverrideResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ClearFlagOverrideResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClearFlagOverrideResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IClearFlagOverrideResponse extends IBaseResponse {
}

export class DownloadFromUrlResponse extends BaseResponse implements IDownloadFromUrlResponse {
    blobUrl?: string | undefined;
    blobName?: string | undefined;
    containerName?: string | undefined;
    fileSizeBytes?: number;

    constructor(data?: IDownloadFromUrlResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.blobUrl = _data["blobUrl"];
            this.blobName = _data["blobName"];
            this.containerName = _data["containerName"];
            this.fileSizeBytes = _data["fileSizeBytes"];
        }
    }

    static override fromJS(data: any): DownloadFromUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadFromUrlResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blobUrl"] = this.blobUrl;
        data["blobName"] = this.blobName;
        data["containerName"] = this.containerName;
        data["fileSizeBytes"] = this.fileSizeBytes;
        super.toJSON(data);
        return data;
    }
}

export interface IDownloadFromUrlResponse extends IBaseResponse {
    blobUrl?: string | undefined;
    blobName?: string | undefined;
    containerName?: string | undefined;
    fileSizeBytes?: number;
}

export class DownloadFromUrlRequest implements IDownloadFromUrlRequest {
    fileUrl!: string;
    containerName!: string;
    blobName?: string | undefined;

    constructor(data?: IDownloadFromUrlRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUrl = _data["fileUrl"];
            this.containerName = _data["containerName"];
            this.blobName = _data["blobName"];
        }
    }

    static fromJS(data: any): DownloadFromUrlRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadFromUrlRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileUrl"] = this.fileUrl;
        data["containerName"] = this.containerName;
        data["blobName"] = this.blobName;
        return data;
    }
}

export interface IDownloadFromUrlRequest {
    fileUrl: string;
    containerName: string;
    blobName?: string | undefined;
}

export class GetFinancialOverviewResponse extends BaseResponse implements IGetFinancialOverviewResponse {
    data!: MonthlyFinancialDataDto[];
    summary!: FinancialSummaryDto;

    constructor(data?: IGetFinancialOverviewResponse) {
        super(data);
        if (!data) {
            this.data = [];
            this.summary = new FinancialSummaryDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MonthlyFinancialDataDto.fromJS(item));
            }
            this.summary = _data["summary"] ? FinancialSummaryDto.fromJS(_data["summary"]) : new FinancialSummaryDto();
        }
    }

    static override fromJS(data: any): GetFinancialOverviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialOverviewResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetFinancialOverviewResponse extends IBaseResponse {
    data: MonthlyFinancialDataDto[];
    summary: FinancialSummaryDto;
}

export class MonthlyFinancialDataDto implements IMonthlyFinancialDataDto {
    year!: number;
    month!: number;
    monthYearDisplay!: string;
    income!: number;
    expenses!: number;
    financialBalance!: number;
    stockChanges?: StockChangeDto | undefined;
    totalStockValueChange?: number | undefined;
    totalBalance?: number | undefined;
    isPartial?: boolean | undefined;
    partialDayOfMonth?: number | undefined;

    constructor(data?: IMonthlyFinancialDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.monthYearDisplay = _data["monthYearDisplay"];
            this.income = _data["income"];
            this.expenses = _data["expenses"];
            this.financialBalance = _data["financialBalance"];
            this.stockChanges = _data["stockChanges"] ? StockChangeDto.fromJS(_data["stockChanges"]) : <any>undefined;
            this.totalStockValueChange = _data["totalStockValueChange"];
            this.totalBalance = _data["totalBalance"];
            this.isPartial = _data["isPartial"];
            this.partialDayOfMonth = _data["partialDayOfMonth"];
        }
    }

    static fromJS(data: any): MonthlyFinancialDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyFinancialDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["monthYearDisplay"] = this.monthYearDisplay;
        data["income"] = this.income;
        data["expenses"] = this.expenses;
        data["financialBalance"] = this.financialBalance;
        data["stockChanges"] = this.stockChanges ? this.stockChanges.toJSON() : <any>undefined;
        data["totalStockValueChange"] = this.totalStockValueChange;
        data["totalBalance"] = this.totalBalance;
        data["isPartial"] = this.isPartial;
        data["partialDayOfMonth"] = this.partialDayOfMonth;
        return data;
    }
}

export interface IMonthlyFinancialDataDto {
    year: number;
    month: number;
    monthYearDisplay: string;
    income: number;
    expenses: number;
    financialBalance: number;
    stockChanges?: StockChangeDto | undefined;
    totalStockValueChange?: number | undefined;
    totalBalance?: number | undefined;
    isPartial?: boolean | undefined;
    partialDayOfMonth?: number | undefined;
}

export class StockChangeDto implements IStockChangeDto {
    materials?: number;
    semiProducts?: number;
    products?: number;

    constructor(data?: IStockChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materials = _data["materials"];
            this.semiProducts = _data["semiProducts"];
            this.products = _data["products"];
        }
    }

    static fromJS(data: any): StockChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materials"] = this.materials;
        data["semiProducts"] = this.semiProducts;
        data["products"] = this.products;
        return data;
    }
}

export interface IStockChangeDto {
    materials?: number;
    semiProducts?: number;
    products?: number;
}

export class FinancialSummaryDto implements IFinancialSummaryDto {
    totalIncome!: number;
    totalExpenses!: number;
    totalBalance!: number;
    averageMonthlyIncome!: number;
    averageMonthlyExpenses!: number;
    averageMonthlyBalance!: number;
    stockSummary?: StockSummaryDto | undefined;

    constructor(data?: IFinancialSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalIncome = _data["totalIncome"];
            this.totalExpenses = _data["totalExpenses"];
            this.totalBalance = _data["totalBalance"];
            this.averageMonthlyIncome = _data["averageMonthlyIncome"];
            this.averageMonthlyExpenses = _data["averageMonthlyExpenses"];
            this.averageMonthlyBalance = _data["averageMonthlyBalance"];
            this.stockSummary = _data["stockSummary"] ? StockSummaryDto.fromJS(_data["stockSummary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FinancialSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalIncome"] = this.totalIncome;
        data["totalExpenses"] = this.totalExpenses;
        data["totalBalance"] = this.totalBalance;
        data["averageMonthlyIncome"] = this.averageMonthlyIncome;
        data["averageMonthlyExpenses"] = this.averageMonthlyExpenses;
        data["averageMonthlyBalance"] = this.averageMonthlyBalance;
        data["stockSummary"] = this.stockSummary ? this.stockSummary.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFinancialSummaryDto {
    totalIncome: number;
    totalExpenses: number;
    totalBalance: number;
    averageMonthlyIncome: number;
    averageMonthlyExpenses: number;
    averageMonthlyBalance: number;
    stockSummary?: StockSummaryDto | undefined;
}

export class StockSummaryDto implements IStockSummaryDto {
    totalStockValueChange?: number;
    averageMonthlyStockChange?: number;
    totalBalanceWithStock?: number;
    averageMonthlyTotalBalance?: number;

    constructor(data?: IStockSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalStockValueChange = _data["totalStockValueChange"];
            this.averageMonthlyStockChange = _data["averageMonthlyStockChange"];
            this.totalBalanceWithStock = _data["totalBalanceWithStock"];
            this.averageMonthlyTotalBalance = _data["averageMonthlyTotalBalance"];
        }
    }

    static fromJS(data: any): StockSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalStockValueChange"] = this.totalStockValueChange;
        data["averageMonthlyStockChange"] = this.averageMonthlyStockChange;
        data["totalBalanceWithStock"] = this.totalBalanceWithStock;
        data["averageMonthlyTotalBalance"] = this.averageMonthlyTotalBalance;
        return data;
    }
}

export interface IStockSummaryDto {
    totalStockValueChange?: number;
    averageMonthlyStockChange?: number;
    totalBalanceWithStock?: number;
    averageMonthlyTotalBalance?: number;
}

export class GetFinancialComparisonResponse extends BaseResponse implements IGetFinancialComparisonResponse {
    series!: YearComparisonSeriesDto[];
    metadata!: FinancialComparisonMetadataDto;

    constructor(data?: IGetFinancialComparisonResponse) {
        super(data);
        if (!data) {
            this.series = [];
            this.metadata = new FinancialComparisonMetadataDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(YearComparisonSeriesDto.fromJS(item));
            }
            this.metadata = _data["metadata"] ? FinancialComparisonMetadataDto.fromJS(_data["metadata"]) : new FinancialComparisonMetadataDto();
        }
    }

    static override fromJS(data: any): GetFinancialComparisonResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialComparisonResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetFinancialComparisonResponse extends IBaseResponse {
    series: YearComparisonSeriesDto[];
    metadata: FinancialComparisonMetadataDto;
}

export class YearComparisonSeriesDto implements IYearComparisonSeriesDto {
    year!: number;
    months!: MonthlyFinancialDataDto[];
    ytdIncome!: number;
    ytdExpenses!: number;
    ytdFinancialBalance!: number;
    ytdStockValueChange?: number | undefined;
    ytdTotalBalance?: number | undefined;

    constructor(data?: IYearComparisonSeriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.months = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            if (Array.isArray(_data["months"])) {
                this.months = [] as any;
                for (let item of _data["months"])
                    this.months!.push(MonthlyFinancialDataDto.fromJS(item));
            }
            this.ytdIncome = _data["ytdIncome"];
            this.ytdExpenses = _data["ytdExpenses"];
            this.ytdFinancialBalance = _data["ytdFinancialBalance"];
            this.ytdStockValueChange = _data["ytdStockValueChange"];
            this.ytdTotalBalance = _data["ytdTotalBalance"];
        }
    }

    static fromJS(data: any): YearComparisonSeriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new YearComparisonSeriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        if (Array.isArray(this.months)) {
            data["months"] = [];
            for (let item of this.months)
                data["months"].push(item.toJSON());
        }
        data["ytdIncome"] = this.ytdIncome;
        data["ytdExpenses"] = this.ytdExpenses;
        data["ytdFinancialBalance"] = this.ytdFinancialBalance;
        data["ytdStockValueChange"] = this.ytdStockValueChange;
        data["ytdTotalBalance"] = this.ytdTotalBalance;
        return data;
    }
}

export interface IYearComparisonSeriesDto {
    year: number;
    months: MonthlyFinancialDataDto[];
    ytdIncome: number;
    ytdExpenses: number;
    ytdFinancialBalance: number;
    ytdStockValueChange?: number | undefined;
    ytdTotalBalance?: number | undefined;
}

export class FinancialComparisonMetadataDto implements IFinancialComparisonMetadataDto {
    cutoffDate!: Date;
    anchorYear!: number;
    partialMonth!: number;
    partialDayOfMonth!: number;
    years!: number[];
    includeStockData!: boolean;
    partialMonthIncluded!: boolean;
    lagDays!: number;

    constructor(data?: IFinancialComparisonMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.years = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cutoffDate = _data["cutoffDate"] ? new Date(_data["cutoffDate"].toString()) : <any>undefined;
            this.anchorYear = _data["anchorYear"];
            this.partialMonth = _data["partialMonth"];
            this.partialDayOfMonth = _data["partialDayOfMonth"];
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(item);
            }
            this.includeStockData = _data["includeStockData"];
            this.partialMonthIncluded = _data["partialMonthIncluded"];
            this.lagDays = _data["lagDays"];
        }
    }

    static fromJS(data: any): FinancialComparisonMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialComparisonMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cutoffDate"] = this.cutoffDate ? this.cutoffDate.toISOString() : <any>undefined;
        data["anchorYear"] = this.anchorYear;
        data["partialMonth"] = this.partialMonth;
        data["partialDayOfMonth"] = this.partialDayOfMonth;
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item);
        }
        data["includeStockData"] = this.includeStockData;
        data["partialMonthIncluded"] = this.partialMonthIncluded;
        data["lagDays"] = this.lagDays;
        return data;
    }
}

export interface IFinancialComparisonMetadataDto {
    cutoffDate: Date;
    anchorYear: number;
    partialMonth: number;
    partialDayOfMonth: number;
    years: number[];
    includeStockData: boolean;
    partialMonthIncluded: boolean;
    lagDays: number;
}

export class SetGiftSettingCommand implements ISetGiftSettingCommand {
    isEnabled?: boolean;
    thresholdCzk?: number;
    text?: string;

    constructor(data?: ISetGiftSettingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.thresholdCzk = _data["thresholdCzk"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): SetGiftSettingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetGiftSettingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["thresholdCzk"] = this.thresholdCzk;
        data["text"] = this.text;
        return data;
    }
}

export interface ISetGiftSettingCommand {
    isEnabled?: boolean;
    thresholdCzk?: number;
    text?: string;
}

export class GridLayoutDto implements IGridLayoutDto {
    gridKey?: string;
    columns?: GridColumnStateDto[];
    lastModified?: Date | undefined;

    constructor(data?: IGridLayoutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gridKey = _data["gridKey"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(GridColumnStateDto.fromJS(item));
            }
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GridLayoutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridLayoutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gridKey"] = this.gridKey;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGridLayoutDto {
    gridKey?: string;
    columns?: GridColumnStateDto[];
    lastModified?: Date | undefined;
}

export class GridColumnStateDto implements IGridColumnStateDto {
    id?: string;
    order?: number;
    width?: number | undefined;
    hidden?: boolean;

    constructor(data?: IGridColumnStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            this.width = _data["width"];
            this.hidden = _data["hidden"];
        }
    }

    static fromJS(data: any): GridColumnStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridColumnStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        data["width"] = this.width;
        data["hidden"] = this.hidden;
        return data;
    }
}

export interface IGridColumnStateDto {
    id?: string;
    order?: number;
    width?: number | undefined;
    hidden?: boolean;
}

export class SaveGridLayoutRequest implements ISaveGridLayoutRequest {
    gridKey?: string;
    columns?: GridColumnStateDto[];

    constructor(data?: ISaveGridLayoutRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gridKey = _data["gridKey"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(GridColumnStateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveGridLayoutRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveGridLayoutRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gridKey"] = this.gridKey;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveGridLayoutRequest {
    gridKey?: string;
    columns?: GridColumnStateDto[];
}

export class GetClassificationRulesResponse extends BaseResponse implements IGetClassificationRulesResponse {
    rules?: ClassificationRuleDto[];

    constructor(data?: IGetClassificationRulesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(ClassificationRuleDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetClassificationRulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetClassificationRulesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetClassificationRulesResponse extends IBaseResponse {
    rules?: ClassificationRuleDto[];
}

export class ClassificationRuleDto implements IClassificationRuleDto {
    id?: string;
    name?: string;
    ruleTypeIdentifier?: string;
    pattern?: string;
    accountingTemplateCode?: string;
    department?: string | undefined;
    order?: number;
    isActive?: boolean;
    createdAt?: Date;
    updatedAt?: Date;
    createdBy?: string;
    updatedBy?: string;

    constructor(data?: IClassificationRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.ruleTypeIdentifier = _data["ruleTypeIdentifier"];
            this.pattern = _data["pattern"];
            this.accountingTemplateCode = _data["accountingTemplateCode"];
            this.department = _data["department"];
            this.order = _data["order"];
            this.isActive = _data["isActive"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ClassificationRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassificationRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ruleTypeIdentifier"] = this.ruleTypeIdentifier;
        data["pattern"] = this.pattern;
        data["accountingTemplateCode"] = this.accountingTemplateCode;
        data["department"] = this.department;
        data["order"] = this.order;
        data["isActive"] = this.isActive;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IClassificationRuleDto {
    id?: string;
    name?: string;
    ruleTypeIdentifier?: string;
    pattern?: string;
    accountingTemplateCode?: string;
    department?: string | undefined;
    order?: number;
    isActive?: boolean;
    createdAt?: Date;
    updatedAt?: Date;
    createdBy?: string;
    updatedBy?: string;
}

export class CreateClassificationRuleResponse extends BaseResponse implements ICreateClassificationRuleResponse {
    rule?: ClassificationRuleDto;

    constructor(data?: ICreateClassificationRuleResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rule = _data["rule"] ? ClassificationRuleDto.fromJS(_data["rule"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CreateClassificationRuleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClassificationRuleResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rule"] = this.rule ? this.rule.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateClassificationRuleResponse extends IBaseResponse {
    rule?: ClassificationRuleDto;
}

export class CreateClassificationRuleRequest implements ICreateClassificationRuleRequest {
    name?: string;
    ruleTypeIdentifier?: string;
    pattern?: string;
    accountingTemplateCode?: string;
    department?: string | undefined;
    isActive?: boolean;

    constructor(data?: ICreateClassificationRuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.ruleTypeIdentifier = _data["ruleTypeIdentifier"];
            this.pattern = _data["pattern"];
            this.accountingTemplateCode = _data["accountingTemplateCode"];
            this.department = _data["department"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateClassificationRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClassificationRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ruleTypeIdentifier"] = this.ruleTypeIdentifier;
        data["pattern"] = this.pattern;
        data["accountingTemplateCode"] = this.accountingTemplateCode;
        data["department"] = this.department;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateClassificationRuleRequest {
    name?: string;
    ruleTypeIdentifier?: string;
    pattern?: string;
    accountingTemplateCode?: string;
    department?: string | undefined;
    isActive?: boolean;
}

export class ReorderClassificationRulesResponse extends BaseResponse implements IReorderClassificationRulesResponse {

    constructor(data?: IReorderClassificationRulesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ReorderClassificationRulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderClassificationRulesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IReorderClassificationRulesResponse extends IBaseResponse {
}

export class ReorderClassificationRulesRequest implements IReorderClassificationRulesRequest {
    ruleIds?: string[];

    constructor(data?: IReorderClassificationRulesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ruleIds"])) {
                this.ruleIds = [] as any;
                for (let item of _data["ruleIds"])
                    this.ruleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ReorderClassificationRulesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderClassificationRulesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ruleIds)) {
            data["ruleIds"] = [];
            for (let item of this.ruleIds)
                data["ruleIds"].push(item);
        }
        return data;
    }
}

export interface IReorderClassificationRulesRequest {
    ruleIds?: string[];
}

export class UpdateClassificationRuleResponse extends BaseResponse implements IUpdateClassificationRuleResponse {
    rule?: ClassificationRuleDto;

    constructor(data?: IUpdateClassificationRuleResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rule = _data["rule"] ? ClassificationRuleDto.fromJS(_data["rule"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): UpdateClassificationRuleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClassificationRuleResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rule"] = this.rule ? this.rule.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateClassificationRuleResponse extends IBaseResponse {
    rule?: ClassificationRuleDto;
}

export class UpdateClassificationRuleRequest implements IUpdateClassificationRuleRequest {
    id?: string;
    name?: string;
    ruleTypeIdentifier?: string;
    pattern?: string;
    accountingTemplateCode?: string;
    department?: string | undefined;
    isActive?: boolean;

    constructor(data?: IUpdateClassificationRuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.ruleTypeIdentifier = _data["ruleTypeIdentifier"];
            this.pattern = _data["pattern"];
            this.accountingTemplateCode = _data["accountingTemplateCode"];
            this.department = _data["department"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateClassificationRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClassificationRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ruleTypeIdentifier"] = this.ruleTypeIdentifier;
        data["pattern"] = this.pattern;
        data["accountingTemplateCode"] = this.accountingTemplateCode;
        data["department"] = this.department;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateClassificationRuleRequest {
    id?: string;
    name?: string;
    ruleTypeIdentifier?: string;
    pattern?: string;
    accountingTemplateCode?: string;
    department?: string | undefined;
    isActive?: boolean;
}

export class DeleteClassificationRuleResponse extends BaseResponse implements IDeleteClassificationRuleResponse {

    constructor(data?: IDeleteClassificationRuleResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DeleteClassificationRuleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteClassificationRuleResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteClassificationRuleResponse extends IBaseResponse {
}

export class ClassifyInvoicesResponse extends BaseResponse implements IClassifyInvoicesResponse {
    totalInvoicesProcessed?: number;
    successfulClassifications?: number;
    manualReviewRequired?: number;
    errors?: number;
    errorMessages?: string[];

    constructor(data?: IClassifyInvoicesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalInvoicesProcessed = _data["totalInvoicesProcessed"];
            this.successfulClassifications = _data["successfulClassifications"];
            this.manualReviewRequired = _data["manualReviewRequired"];
            this.errors = _data["errors"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
        }
    }

    static override fromJS(data: any): ClassifyInvoicesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClassifyInvoicesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalInvoicesProcessed"] = this.totalInvoicesProcessed;
        data["successfulClassifications"] = this.successfulClassifications;
        data["manualReviewRequired"] = this.manualReviewRequired;
        data["errors"] = this.errors;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IClassifyInvoicesResponse extends IBaseResponse {
    totalInvoicesProcessed?: number;
    successfulClassifications?: number;
    manualReviewRequired?: number;
    errors?: number;
    errorMessages?: string[];
}

export class ClassifyInvoicesRequest implements IClassifyInvoicesRequest {
    invoiceIds?: string[] | undefined;
    manualTrigger?: boolean;

    constructor(data?: IClassifyInvoicesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoiceIds"])) {
                this.invoiceIds = [] as any;
                for (let item of _data["invoiceIds"])
                    this.invoiceIds!.push(item);
            }
            this.manualTrigger = _data["manualTrigger"];
        }
    }

    static fromJS(data: any): ClassifyInvoicesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClassifyInvoicesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoiceIds)) {
            data["invoiceIds"] = [];
            for (let item of this.invoiceIds)
                data["invoiceIds"].push(item);
        }
        data["manualTrigger"] = this.manualTrigger;
        return data;
    }
}

export interface IClassifyInvoicesRequest {
    invoiceIds?: string[] | undefined;
    manualTrigger?: boolean;
}

export class ClassificationRuleTypeDto implements IClassificationRuleTypeDto {
    identifier?: string;
    displayName?: string;
    description?: string;

    constructor(data?: IClassificationRuleTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ClassificationRuleTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassificationRuleTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }
}

export interface IClassificationRuleTypeDto {
    identifier?: string;
    displayName?: string;
    description?: string;
}

export class GetAccountingTemplatesResponse extends BaseResponse implements IGetAccountingTemplatesResponse {
    templates?: AccountingTemplateDto[];

    constructor(data?: IGetAccountingTemplatesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(AccountingTemplateDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetAccountingTemplatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountingTemplatesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAccountingTemplatesResponse extends IBaseResponse {
    templates?: AccountingTemplateDto[];
}

export class AccountingTemplateDto implements IAccountingTemplateDto {
    code?: string;
    name?: string;
    description?: string;
    accountCode?: string;

    constructor(data?: IAccountingTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.accountCode = _data["accountCode"];
        }
    }

    static fromJS(data: any): AccountingTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountingTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["accountCode"] = this.accountCode;
        return data;
    }
}

export interface IAccountingTemplateDto {
    code?: string;
    name?: string;
    description?: string;
    accountCode?: string;
}

export class GetClassificationHistoryResponse extends BaseResponse implements IGetClassificationHistoryResponse {
    items?: ClassificationHistoryDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;

    constructor(data?: IGetClassificationHistoryResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClassificationHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static override fromJS(data: any): GetClassificationHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetClassificationHistoryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        super.toJSON(data);
        return data;
    }
}

export interface IGetClassificationHistoryResponse extends IBaseResponse {
    items?: ClassificationHistoryDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
}

export class ClassificationHistoryDto implements IClassificationHistoryDto {
    id?: string;
    invoiceId?: string;
    invoiceNumber?: string;
    invoiceDate?: Date | undefined;
    companyName?: string;
    description?: string;
    classificationRuleId?: string | undefined;
    ruleName?: string | undefined;
    result?: ClassificationResult;
    accountingTemplateCode?: string | undefined;
    department?: string | undefined;
    errorMessage?: string | undefined;
    timestamp?: Date;
    processedBy?: string;

    constructor(data?: IClassificationHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceId = _data["invoiceId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            this.companyName = _data["companyName"];
            this.description = _data["description"];
            this.classificationRuleId = _data["classificationRuleId"];
            this.ruleName = _data["ruleName"];
            this.result = _data["result"];
            this.accountingTemplateCode = _data["accountingTemplateCode"];
            this.department = _data["department"];
            this.errorMessage = _data["errorMessage"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.processedBy = _data["processedBy"];
        }
    }

    static fromJS(data: any): ClassificationHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassificationHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceId"] = this.invoiceId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["companyName"] = this.companyName;
        data["description"] = this.description;
        data["classificationRuleId"] = this.classificationRuleId;
        data["ruleName"] = this.ruleName;
        data["result"] = this.result;
        data["accountingTemplateCode"] = this.accountingTemplateCode;
        data["department"] = this.department;
        data["errorMessage"] = this.errorMessage;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["processedBy"] = this.processedBy;
        return data;
    }
}

export interface IClassificationHistoryDto {
    id?: string;
    invoiceId?: string;
    invoiceNumber?: string;
    invoiceDate?: Date | undefined;
    companyName?: string;
    description?: string;
    classificationRuleId?: string | undefined;
    ruleName?: string | undefined;
    result?: ClassificationResult;
    accountingTemplateCode?: string | undefined;
    department?: string | undefined;
    errorMessage?: string | undefined;
    timestamp?: Date;
    processedBy?: string;
}

export enum ClassificationResult {
    Success = "Success",
    ManualReviewRequired = "ManualReviewRequired",
    Error = "Error",
}

export class GetInvoiceDetailsResponse extends BaseResponse implements IGetInvoiceDetailsResponse {
    invoice?: ReceivedInvoiceDto | undefined;
    found?: boolean;

    constructor(data?: IGetInvoiceDetailsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invoice = _data["invoice"] ? ReceivedInvoiceDto.fromJS(_data["invoice"]) : <any>undefined;
            this.found = _data["found"];
        }
    }

    static override fromJS(data: any): GetInvoiceDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvoiceDetailsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["found"] = this.found;
        super.toJSON(data);
        return data;
    }
}

export interface IGetInvoiceDetailsResponse extends IBaseResponse {
    invoice?: ReceivedInvoiceDto | undefined;
    found?: boolean;
}

export class ReceivedInvoiceDto implements IReceivedInvoiceDto {
    invoiceNumber?: string;
    companyName?: string;
    companyVat?: string;
    invoiceDate?: Date | undefined;
    totalAmount?: number;
    description?: string;
    items?: ReceivedInvoiceItemDto[];
    dueDate?: Date | undefined;
    accountingTemplateCode?: string | undefined;
    departmentCode?: string | undefined;
    labels?: string[];

    constructor(data?: IReceivedInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNumber = _data["invoiceNumber"];
            this.companyName = _data["companyName"];
            this.companyVat = _data["companyVat"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            this.totalAmount = _data["totalAmount"];
            this.description = _data["description"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReceivedInvoiceItemDto.fromJS(item));
            }
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.accountingTemplateCode = _data["accountingTemplateCode"];
            this.departmentCode = _data["departmentCode"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
        }
    }

    static fromJS(data: any): ReceivedInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceivedInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["companyName"] = this.companyName;
        data["companyVat"] = this.companyVat;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["totalAmount"] = this.totalAmount;
        data["description"] = this.description;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["accountingTemplateCode"] = this.accountingTemplateCode;
        data["departmentCode"] = this.departmentCode;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        return data;
    }
}

export interface IReceivedInvoiceDto {
    invoiceNumber?: string;
    companyName?: string;
    companyVat?: string;
    invoiceDate?: Date | undefined;
    totalAmount?: number;
    description?: string;
    items?: ReceivedInvoiceItemDto[];
    dueDate?: Date | undefined;
    accountingTemplateCode?: string | undefined;
    departmentCode?: string | undefined;
    labels?: string[];
}

export class ReceivedInvoiceItemDto implements IReceivedInvoiceItemDto {
    code?: string;
    name?: string;
    amount?: number;

    constructor(data?: IReceivedInvoiceItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): ReceivedInvoiceItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceivedInvoiceItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IReceivedInvoiceItemDto {
    code?: string;
    name?: string;
    amount?: number;
}

export class GetIssuedInvoicesListResponse extends BaseResponse implements IGetIssuedInvoicesListResponse {
    items?: IssuedInvoiceDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;

    constructor(data?: IGetIssuedInvoicesListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IssuedInvoiceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static override fromJS(data: any): GetIssuedInvoicesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssuedInvoicesListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        super.toJSON(data);
        return data;
    }
}

export interface IGetIssuedInvoicesListResponse extends IBaseResponse {
    items?: IssuedInvoiceDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class IssuedInvoiceDto implements IIssuedInvoiceDto {
    id?: string;
    invoiceDate?: Date;
    dueDate?: Date;
    taxDate?: Date;
    varSymbol?: number | undefined;
    billingMethod?: BillingMethod;
    shippingMethod?: ShippingMethod;
    vatPayer?: boolean | undefined;
    itemsCount?: number;
    price?: number;
    priceC?: number;
    currency?: string;
    customerName?: string | undefined;
    isSynced?: boolean;
    lastSyncTime?: Date | undefined;
    errorMessage?: string | undefined;
    errorType?: IssuedInvoiceErrorType | undefined;
    syncHistoryCount?: number;
    isCriticalError?: boolean;
    creationTime?: Date;

    constructor(data?: IIssuedInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.taxDate = _data["taxDate"] ? new Date(_data["taxDate"].toString()) : <any>undefined;
            this.varSymbol = _data["varSymbol"];
            this.billingMethod = _data["billingMethod"];
            this.shippingMethod = _data["shippingMethod"];
            this.vatPayer = _data["vatPayer"];
            this.itemsCount = _data["itemsCount"];
            this.price = _data["price"];
            this.priceC = _data["priceC"];
            this.currency = _data["currency"];
            this.customerName = _data["customerName"];
            this.isSynced = _data["isSynced"];
            this.lastSyncTime = _data["lastSyncTime"] ? new Date(_data["lastSyncTime"].toString()) : <any>undefined;
            this.errorMessage = _data["errorMessage"];
            this.errorType = _data["errorType"];
            this.syncHistoryCount = _data["syncHistoryCount"];
            this.isCriticalError = _data["isCriticalError"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IssuedInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssuedInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["taxDate"] = this.taxDate ? this.taxDate.toISOString() : <any>undefined;
        data["varSymbol"] = this.varSymbol;
        data["billingMethod"] = this.billingMethod;
        data["shippingMethod"] = this.shippingMethod;
        data["vatPayer"] = this.vatPayer;
        data["itemsCount"] = this.itemsCount;
        data["price"] = this.price;
        data["priceC"] = this.priceC;
        data["currency"] = this.currency;
        data["customerName"] = this.customerName;
        data["isSynced"] = this.isSynced;
        data["lastSyncTime"] = this.lastSyncTime ? this.lastSyncTime.toISOString() : <any>undefined;
        data["errorMessage"] = this.errorMessage;
        data["errorType"] = this.errorType;
        data["syncHistoryCount"] = this.syncHistoryCount;
        data["isCriticalError"] = this.isCriticalError;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IIssuedInvoiceDto {
    id?: string;
    invoiceDate?: Date;
    dueDate?: Date;
    taxDate?: Date;
    varSymbol?: number | undefined;
    billingMethod?: BillingMethod;
    shippingMethod?: ShippingMethod;
    vatPayer?: boolean | undefined;
    itemsCount?: number;
    price?: number;
    priceC?: number;
    currency?: string;
    customerName?: string | undefined;
    isSynced?: boolean;
    lastSyncTime?: Date | undefined;
    errorMessage?: string | undefined;
    errorType?: IssuedInvoiceErrorType | undefined;
    syncHistoryCount?: number;
    isCriticalError?: boolean;
    creationTime?: Date;
}

export enum BillingMethod {
    BankTransfer = "BankTransfer",
    Cash = "Cash",
    CoD = "CoD",
    Comgate = "Comgate",
    CreditCard = "CreditCard",
}

export enum ShippingMethod {
    PickUp = "PickUp",
    PPL = "PPL",
    PPLParcelShop = "PPLParcelShop",
    ZasilkovnaDoRuky = "ZasilkovnaDoRuky",
    Zasilkovna = "Zasilkovna",
    GLS = "GLS",
}

export enum IssuedInvoiceErrorType {
    General = "General",
    InvoicePaired = "InvoicePaired",
    ProductNotFound = "ProductNotFound",
}

export class GetIssuedInvoiceDetailResponse extends BaseResponse implements IGetIssuedInvoiceDetailResponse {
    invoice?: IssuedInvoiceDetailDto | undefined;

    constructor(data?: IGetIssuedInvoiceDetailResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invoice = _data["invoice"] ? IssuedInvoiceDetailDto.fromJS(_data["invoice"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetIssuedInvoiceDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssuedInvoiceDetailResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetIssuedInvoiceDetailResponse extends IBaseResponse {
    invoice?: IssuedInvoiceDetailDto | undefined;
}

export class IssuedInvoiceDetailDto extends IssuedInvoiceDto implements IIssuedInvoiceDetailDto {
    syncHistory?: IssuedInvoiceSyncDataDto[];
    concurrencyStamp?: string | undefined;
    lastModificationTime?: Date | undefined;
    creatorId?: string | undefined;
    lastModifierId?: string | undefined;

    constructor(data?: IIssuedInvoiceDetailDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["syncHistory"])) {
                this.syncHistory = [] as any;
                for (let item of _data["syncHistory"])
                    this.syncHistory!.push(IssuedInvoiceSyncDataDto.fromJS(item));
            }
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.creatorId = _data["creatorId"];
            this.lastModifierId = _data["lastModifierId"];
        }
    }

    static override fromJS(data: any): IssuedInvoiceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssuedInvoiceDetailDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.syncHistory)) {
            data["syncHistory"] = [];
            for (let item of this.syncHistory)
                data["syncHistory"].push(item.toJSON());
        }
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["lastModifierId"] = this.lastModifierId;
        super.toJSON(data);
        return data;
    }
}

export interface IIssuedInvoiceDetailDto extends IIssuedInvoiceDto {
    syncHistory?: IssuedInvoiceSyncDataDto[];
    concurrencyStamp?: string | undefined;
    lastModificationTime?: Date | undefined;
    creatorId?: string | undefined;
    lastModifierId?: string | undefined;
}

export class IssuedInvoiceSyncDataDto implements IIssuedInvoiceSyncDataDto {
    id?: number;
    data?: string | undefined;
    isSuccess?: boolean;
    syncTime?: Date;
    error?: IssuedInvoiceErrorDto | undefined;
    adapterResponse?: string | undefined;

    constructor(data?: IIssuedInvoiceSyncDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.data = _data["data"];
            this.isSuccess = _data["isSuccess"];
            this.syncTime = _data["syncTime"] ? new Date(_data["syncTime"].toString()) : <any>undefined;
            this.error = _data["error"] ? IssuedInvoiceErrorDto.fromJS(_data["error"]) : <any>undefined;
            this.adapterResponse = _data["adapterResponse"];
        }
    }

    static fromJS(data: any): IssuedInvoiceSyncDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssuedInvoiceSyncDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["data"] = this.data;
        data["isSuccess"] = this.isSuccess;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["adapterResponse"] = this.adapterResponse;
        return data;
    }
}

export interface IIssuedInvoiceSyncDataDto {
    id?: number;
    data?: string | undefined;
    isSuccess?: boolean;
    syncTime?: Date;
    error?: IssuedInvoiceErrorDto | undefined;
    adapterResponse?: string | undefined;
}

export class IssuedInvoiceErrorDto implements IIssuedInvoiceErrorDto {
    errorType?: string;
    message?: string;

    constructor(data?: IIssuedInvoiceErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorType = _data["errorType"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): IssuedInvoiceErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssuedInvoiceErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorType"] = this.errorType;
        data["message"] = this.message;
        return data;
    }
}

export interface IIssuedInvoiceErrorDto {
    errorType?: string;
    message?: string;
}

export class GetIssuedInvoiceSyncStatsResponse extends BaseResponse implements IGetIssuedInvoiceSyncStatsResponse {
    totalInvoices?: number;
    syncedInvoices?: number;
    unsyncedInvoices?: number;
    invoicesWithErrors?: number;
    criticalErrors?: number;
    lastSyncTime?: Date | undefined;
    syncSuccessRate?: number;

    constructor(data?: IGetIssuedInvoiceSyncStatsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalInvoices = _data["totalInvoices"];
            this.syncedInvoices = _data["syncedInvoices"];
            this.unsyncedInvoices = _data["unsyncedInvoices"];
            this.invoicesWithErrors = _data["invoicesWithErrors"];
            this.criticalErrors = _data["criticalErrors"];
            this.lastSyncTime = _data["lastSyncTime"] ? new Date(_data["lastSyncTime"].toString()) : <any>undefined;
            this.syncSuccessRate = _data["syncSuccessRate"];
        }
    }

    static override fromJS(data: any): GetIssuedInvoiceSyncStatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssuedInvoiceSyncStatsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalInvoices"] = this.totalInvoices;
        data["syncedInvoices"] = this.syncedInvoices;
        data["unsyncedInvoices"] = this.unsyncedInvoices;
        data["invoicesWithErrors"] = this.invoicesWithErrors;
        data["criticalErrors"] = this.criticalErrors;
        data["lastSyncTime"] = this.lastSyncTime ? this.lastSyncTime.toISOString() : <any>undefined;
        data["syncSuccessRate"] = this.syncSuccessRate;
        super.toJSON(data);
        return data;
    }
}

export interface IGetIssuedInvoiceSyncStatsResponse extends IBaseResponse {
    totalInvoices?: number;
    syncedInvoices?: number;
    unsyncedInvoices?: number;
    invoicesWithErrors?: number;
    criticalErrors?: number;
    lastSyncTime?: Date | undefined;
    syncSuccessRate?: number;
}

export class EnqueueImportInvoicesResponse extends BaseResponse implements IEnqueueImportInvoicesResponse {
    jobId?: string | undefined;

    constructor(data?: IEnqueueImportInvoicesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobId = _data["jobId"];
        }
    }

    static override fromJS(data: any): EnqueueImportInvoicesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnqueueImportInvoicesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        super.toJSON(data);
        return data;
    }
}

export interface IEnqueueImportInvoicesResponse extends IBaseResponse {
    jobId?: string | undefined;
}

export class EnqueueImportInvoicesRequest implements IEnqueueImportInvoicesRequest {
    query?: IssuedInvoiceSourceQuery;

    constructor(data?: IEnqueueImportInvoicesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] ? IssuedInvoiceSourceQuery.fromJS(_data["query"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EnqueueImportInvoicesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnqueueImportInvoicesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEnqueueImportInvoicesRequest {
    query?: IssuedInvoiceSourceQuery;
}

export class IssuedInvoiceSourceQuery implements IIssuedInvoiceSourceQuery {
    requestId?: string;
    invoiceId?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    currency?: string;
    queryByInvoice?: boolean;
    queryByDate?: boolean;
    dateFromString?: string;
    dateToString?: string;

    constructor(data?: IIssuedInvoiceSourceQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.invoiceId = _data["invoiceId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.currency = _data["currency"];
            this.queryByInvoice = _data["queryByInvoice"];
            this.queryByDate = _data["queryByDate"];
            this.dateFromString = _data["dateFromString"];
            this.dateToString = _data["dateToString"];
        }
    }

    static fromJS(data: any): IssuedInvoiceSourceQuery {
        data = typeof data === 'object' ? data : {};
        let result = new IssuedInvoiceSourceQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["invoiceId"] = this.invoiceId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["currency"] = this.currency;
        data["queryByInvoice"] = this.queryByInvoice;
        data["queryByDate"] = this.queryByDate;
        data["dateFromString"] = this.dateFromString;
        data["dateToString"] = this.dateToString;
        return data;
    }
}

export interface IIssuedInvoiceSourceQuery {
    requestId?: string;
    invoiceId?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    currency?: string;
    queryByInvoice?: boolean;
    queryByDate?: boolean;
    dateFromString?: string;
    dateToString?: string;
}

export class BackgroundJobInfo implements IBackgroundJobInfo {
    id?: string;
    jobName?: string;
    state?: string;
    createdAt?: Date | undefined;
    startedAt?: Date | undefined;
    queue?: string;

    constructor(data?: IBackgroundJobInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobName = _data["jobName"];
            this.state = _data["state"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.queue = _data["queue"];
        }
    }

    static fromJS(data: any): BackgroundJobInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundJobInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobName"] = this.jobName;
        data["state"] = this.state;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["queue"] = this.queue;
        return data;
    }
}

export interface IBackgroundJobInfo {
    id?: string;
    jobName?: string;
    state?: string;
    createdAt?: Date | undefined;
    startedAt?: Date | undefined;
    queue?: string;
}

export class GetJournalEntriesResponse extends BaseResponse implements IGetJournalEntriesResponse {
    entries?: JournalEntryDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;

    constructor(data?: IGetJournalEntriesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(JournalEntryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static override fromJS(data: any): GetJournalEntriesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetJournalEntriesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        super.toJSON(data);
        return data;
    }
}

export interface IGetJournalEntriesResponse extends IBaseResponse {
    entries?: JournalEntryDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
}

export class JournalEntryDto implements IJournalEntryDto {
    id?: number;
    title?: string;
    content?: string;
    entryDate?: Date;
    createdAt?: Date;
    modifiedAt?: Date;
    createdByUserId?: string;
    createdByUsername?: string | undefined;
    modifiedByUserId?: string | undefined;
    modifiedByUsername?: string | undefined;
    associatedProducts?: string[];
    tags?: JournalEntryTagDto[];

    constructor(data?: IJournalEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : <any>undefined;
            this.createdByUserId = _data["createdByUserId"];
            this.createdByUsername = _data["createdByUsername"];
            this.modifiedByUserId = _data["modifiedByUserId"];
            this.modifiedByUsername = _data["modifiedByUsername"];
            if (Array.isArray(_data["associatedProducts"])) {
                this.associatedProducts = [] as any;
                for (let item of _data["associatedProducts"])
                    this.associatedProducts!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(JournalEntryTagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JournalEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new JournalEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["content"] = this.content;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : <any>undefined;
        data["createdByUserId"] = this.createdByUserId;
        data["createdByUsername"] = this.createdByUsername;
        data["modifiedByUserId"] = this.modifiedByUserId;
        data["modifiedByUsername"] = this.modifiedByUsername;
        if (Array.isArray(this.associatedProducts)) {
            data["associatedProducts"] = [];
            for (let item of this.associatedProducts)
                data["associatedProducts"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJournalEntryDto {
    id?: number;
    title?: string;
    content?: string;
    entryDate?: Date;
    createdAt?: Date;
    modifiedAt?: Date;
    createdByUserId?: string;
    createdByUsername?: string | undefined;
    modifiedByUserId?: string | undefined;
    modifiedByUsername?: string | undefined;
    associatedProducts?: string[];
    tags?: JournalEntryTagDto[];
}

export class JournalEntryTagDto implements IJournalEntryTagDto {
    id?: number;
    name?: string;
    color?: string;

    constructor(data?: IJournalEntryTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): JournalEntryTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new JournalEntryTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        return data;
    }
}

export interface IJournalEntryTagDto {
    id?: number;
    name?: string;
    color?: string;
}

export class SearchJournalEntriesResponse extends BaseResponse implements ISearchJournalEntriesResponse {
    entries?: JournalEntryDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;

    constructor(data?: ISearchJournalEntriesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(JournalEntryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static override fromJS(data: any): SearchJournalEntriesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchJournalEntriesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchJournalEntriesResponse extends IBaseResponse {
    entries?: JournalEntryDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
}

export class GetJournalEntryResponse extends BaseResponse implements IGetJournalEntryResponse {
    entry?: JournalEntryDto | undefined;

    constructor(data?: IGetJournalEntryResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entry = _data["entry"] ? JournalEntryDto.fromJS(_data["entry"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetJournalEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetJournalEntryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entry"] = this.entry ? this.entry.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetJournalEntryResponse extends IBaseResponse {
    entry?: JournalEntryDto | undefined;
}

export class CreateJournalEntryResponse extends BaseResponse implements ICreateJournalEntryResponse {
    id?: number;
    createdAt?: Date;
    message?: string;

    constructor(data?: ICreateJournalEntryResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static override fromJS(data: any): CreateJournalEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJournalEntryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateJournalEntryResponse extends IBaseResponse {
    id?: number;
    createdAt?: Date;
    message?: string;
}

export class CreateJournalEntryRequest implements ICreateJournalEntryRequest {
    title!: string;
    content!: string;
    entryDate!: Date;
    associatedProducts?: string[] | undefined;
    tagIds?: number[] | undefined;

    constructor(data?: ICreateJournalEntryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.content = _data["content"];
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["associatedProducts"])) {
                this.associatedProducts = [] as any;
                for (let item of _data["associatedProducts"])
                    this.associatedProducts!.push(item);
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateJournalEntryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJournalEntryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["content"] = this.content;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        if (Array.isArray(this.associatedProducts)) {
            data["associatedProducts"] = [];
            for (let item of this.associatedProducts)
                data["associatedProducts"].push(item);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        return data;
    }
}

export interface ICreateJournalEntryRequest {
    title: string;
    content: string;
    entryDate: Date;
    associatedProducts?: string[] | undefined;
    tagIds?: number[] | undefined;
}

export class UpdateJournalEntryResponse extends BaseResponse implements IUpdateJournalEntryResponse {
    id?: number;
    modifiedAt?: Date;
    message?: string;

    constructor(data?: IUpdateJournalEntryResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static override fromJS(data: any): UpdateJournalEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJournalEntryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : <any>undefined;
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateJournalEntryResponse extends IBaseResponse {
    id?: number;
    modifiedAt?: Date;
    message?: string;
}

export class UpdateJournalEntryRequest implements IUpdateJournalEntryRequest {
    id?: number;
    title!: string;
    content!: string;
    entryDate!: Date;
    associatedProducts?: string[] | undefined;
    tagIds?: number[] | undefined;

    constructor(data?: IUpdateJournalEntryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["associatedProducts"])) {
                this.associatedProducts = [] as any;
                for (let item of _data["associatedProducts"])
                    this.associatedProducts!.push(item);
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateJournalEntryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJournalEntryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["content"] = this.content;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        if (Array.isArray(this.associatedProducts)) {
            data["associatedProducts"] = [];
            for (let item of this.associatedProducts)
                data["associatedProducts"].push(item);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateJournalEntryRequest {
    id?: number;
    title: string;
    content: string;
    entryDate: Date;
    associatedProducts?: string[] | undefined;
    tagIds?: number[] | undefined;
}

export class DeleteJournalEntryResponse extends BaseResponse implements IDeleteJournalEntryResponse {
    id?: number;
    message?: string;

    constructor(data?: IDeleteJournalEntryResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
        }
    }

    static override fromJS(data: any): DeleteJournalEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteJournalEntryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteJournalEntryResponse extends IBaseResponse {
    id?: number;
    message?: string;
}

export class GetJournalTagsResponse extends BaseResponse implements IGetJournalTagsResponse {
    tags?: JournalEntryTagDto[];

    constructor(data?: IGetJournalTagsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(JournalEntryTagDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetJournalTagsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetJournalTagsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetJournalTagsResponse extends IBaseResponse {
    tags?: JournalEntryTagDto[];
}

export class CreateJournalTagResponse extends BaseResponse implements ICreateJournalTagResponse {
    id?: number;
    name?: string;
    color?: string;

    constructor(data?: ICreateJournalTagResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
        }
    }

    static override fromJS(data: any): CreateJournalTagResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJournalTagResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateJournalTagResponse extends IBaseResponse {
    id?: number;
    name?: string;
    color?: string;
}

export class CreateJournalTagRequest implements ICreateJournalTagRequest {
    name!: string;
    color?: string;

    constructor(data?: ICreateJournalTagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): CreateJournalTagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJournalTagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["color"] = this.color;
        return data;
    }
}

export interface ICreateJournalTagRequest {
    name: string;
    color?: string;
}

export class GetDocumentsResponse extends BaseResponse implements IGetDocumentsResponse {
    documents?: DocumentSummary[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;

    constructor(data?: IGetDocumentsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentSummary.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static override fromJS(data: any): GetDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        super.toJSON(data);
        return data;
    }
}

export interface IGetDocumentsResponse extends IBaseResponse {
    documents?: DocumentSummary[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class DocumentSummary implements IDocumentSummary {
    id?: string;
    filename?: string;
    status?: string;
    contentType?: string;
    createdAt?: Date;
    indexedAt?: Date | undefined;
    firstChunkId?: string | undefined;

    constructor(data?: IDocumentSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.filename = _data["filename"];
            this.status = _data["status"];
            this.contentType = _data["contentType"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.indexedAt = _data["indexedAt"] ? new Date(_data["indexedAt"].toString()) : <any>undefined;
            this.firstChunkId = _data["firstChunkId"];
        }
    }

    static fromJS(data: any): DocumentSummary {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filename"] = this.filename;
        data["status"] = this.status;
        data["contentType"] = this.contentType;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["indexedAt"] = this.indexedAt ? this.indexedAt.toISOString() : <any>undefined;
        data["firstChunkId"] = this.firstChunkId;
        return data;
    }
}

export interface IDocumentSummary {
    id?: string;
    filename?: string;
    status?: string;
    contentType?: string;
    createdAt?: Date;
    indexedAt?: Date | undefined;
    firstChunkId?: string | undefined;
}

export class GetDocumentContentTypesResponse extends BaseResponse implements IGetDocumentContentTypesResponse {
    contentTypes?: string[];

    constructor(data?: IGetDocumentContentTypesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contentTypes"])) {
                this.contentTypes = [] as any;
                for (let item of _data["contentTypes"])
                    this.contentTypes!.push(item);
            }
        }
    }

    static override fromJS(data: any): GetDocumentContentTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentContentTypesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contentTypes)) {
            data["contentTypes"] = [];
            for (let item of this.contentTypes)
                data["contentTypes"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDocumentContentTypesResponse extends IBaseResponse {
    contentTypes?: string[];
}

export class SearchDocumentsResponse extends BaseResponse implements ISearchDocumentsResponse {
    chunks?: ChunkResult[];
    belowThresholdCount?: number;

    constructor(data?: ISearchDocumentsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["chunks"])) {
                this.chunks = [] as any;
                for (let item of _data["chunks"])
                    this.chunks!.push(ChunkResult.fromJS(item));
            }
            this.belowThresholdCount = _data["belowThresholdCount"];
        }
    }

    static override fromJS(data: any): SearchDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDocumentsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.chunks)) {
            data["chunks"] = [];
            for (let item of this.chunks)
                data["chunks"].push(item.toJSON());
        }
        data["belowThresholdCount"] = this.belowThresholdCount;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchDocumentsResponse extends IBaseResponse {
    chunks?: ChunkResult[];
    belowThresholdCount?: number;
}

export class ChunkResult implements IChunkResult {
    chunkId?: string;
    documentId?: string;
    content?: string;
    score?: number;
    sourceFilename?: string;
    sourcePath?: string;

    constructor(data?: IChunkResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chunkId = _data["chunkId"];
            this.documentId = _data["documentId"];
            this.content = _data["content"];
            this.score = _data["score"];
            this.sourceFilename = _data["sourceFilename"];
            this.sourcePath = _data["sourcePath"];
        }
    }

    static fromJS(data: any): ChunkResult {
        data = typeof data === 'object' ? data : {};
        let result = new ChunkResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chunkId"] = this.chunkId;
        data["documentId"] = this.documentId;
        data["content"] = this.content;
        data["score"] = this.score;
        data["sourceFilename"] = this.sourceFilename;
        data["sourcePath"] = this.sourcePath;
        return data;
    }
}

export interface IChunkResult {
    chunkId?: string;
    documentId?: string;
    content?: string;
    score?: number;
    sourceFilename?: string;
    sourcePath?: string;
}

export class SearchDocumentsRequest implements ISearchDocumentsRequest {
    query!: string;
    topK?: number;

    constructor(data?: ISearchDocumentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.topK = _data["topK"];
        }
    }

    static fromJS(data: any): SearchDocumentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDocumentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["topK"] = this.topK;
        return data;
    }
}

export interface ISearchDocumentsRequest {
    query: string;
    topK?: number;
}

export class GetChunkDetailResponse extends BaseResponse implements IGetChunkDetailResponse {
    chunkId?: string;
    documentId?: string;
    filename?: string;
    documentType?: DocumentType;
    indexedAt?: Date | undefined;
    chunkIndex?: number;
    summary?: string;
    content?: string;
    sourcePath?: string | undefined;

    constructor(data?: IGetChunkDetailResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.chunkId = _data["chunkId"];
            this.documentId = _data["documentId"];
            this.filename = _data["filename"];
            this.documentType = _data["documentType"];
            this.indexedAt = _data["indexedAt"] ? new Date(_data["indexedAt"].toString()) : <any>undefined;
            this.chunkIndex = _data["chunkIndex"];
            this.summary = _data["summary"];
            this.content = _data["content"];
            this.sourcePath = _data["sourcePath"];
        }
    }

    static override fromJS(data: any): GetChunkDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetChunkDetailResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chunkId"] = this.chunkId;
        data["documentId"] = this.documentId;
        data["filename"] = this.filename;
        data["documentType"] = this.documentType;
        data["indexedAt"] = this.indexedAt ? this.indexedAt.toISOString() : <any>undefined;
        data["chunkIndex"] = this.chunkIndex;
        data["summary"] = this.summary;
        data["content"] = this.content;
        data["sourcePath"] = this.sourcePath;
        super.toJSON(data);
        return data;
    }
}

export interface IGetChunkDetailResponse extends IBaseResponse {
    chunkId?: string;
    documentId?: string;
    filename?: string;
    documentType?: DocumentType;
    indexedAt?: Date | undefined;
    chunkIndex?: number;
    summary?: string;
    content?: string;
    sourcePath?: string | undefined;
}

export enum DocumentType {
    KnowledgeBase = "KnowledgeBase",
    Conversation = "Conversation",
    Leaflet = "Leaflet",
    Article = "Article",
}

export class AskQuestionResponse extends BaseResponse implements IAskQuestionResponse {
    id?: string | undefined;
    answer?: string;
    sources?: SourceReference[];

    constructor(data?: IAskQuestionResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.answer = _data["answer"];
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(SourceReference.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AskQuestionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AskQuestionResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["answer"] = this.answer;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAskQuestionResponse extends IBaseResponse {
    id?: string | undefined;
    answer?: string;
    sources?: SourceReference[];
}

export class SourceReference implements ISourceReference {
    chunkId?: string;
    documentId?: string;
    filename?: string;
    excerpt?: string;
    score?: number;

    constructor(data?: ISourceReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chunkId = _data["chunkId"];
            this.documentId = _data["documentId"];
            this.filename = _data["filename"];
            this.excerpt = _data["excerpt"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): SourceReference {
        data = typeof data === 'object' ? data : {};
        let result = new SourceReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chunkId"] = this.chunkId;
        data["documentId"] = this.documentId;
        data["filename"] = this.filename;
        data["excerpt"] = this.excerpt;
        data["score"] = this.score;
        return data;
    }
}

export interface ISourceReference {
    chunkId?: string;
    documentId?: string;
    filename?: string;
    excerpt?: string;
    score?: number;
}

export class AskQuestionRequest implements IAskQuestionRequest {
    question!: string;
    topK?: number;

    constructor(data?: IAskQuestionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
            this.topK = _data["topK"];
        }
    }

    static fromJS(data: any): AskQuestionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AskQuestionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        data["topK"] = this.topK;
        return data;
    }
}

export interface IAskQuestionRequest {
    question: string;
    topK?: number;
}

export class DeleteDocumentResponse extends BaseResponse implements IDeleteDocumentResponse {

    constructor(data?: IDeleteDocumentResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DeleteDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDocumentResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteDocumentResponse extends IBaseResponse {
}

export class GetFeedbackListResponse extends BaseResponse implements IGetFeedbackListResponse {
    logs?: RagFeedbackLogSummary[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    stats?: RagFeedbackStatsDto;

    constructor(data?: IGetFeedbackListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(RagFeedbackLogSummary.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.stats = _data["stats"] ? RagFeedbackStatsDto.fromJS(_data["stats"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetFeedbackListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["stats"] = this.stats ? this.stats.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetFeedbackListResponse extends IBaseResponse {
    logs?: RagFeedbackLogSummary[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    stats?: RagFeedbackStatsDto;
}

export class RagFeedbackLogSummary implements IRagFeedbackLogSummary {
    id?: string;
    feature?: RagFeature;
    question?: string;
    answer?: string;
    expandedQuery?: string | undefined;
    systemPrompt?: string;
    retrievedChunks?: RagFeedbackChunkDto[];
    topK?: number;
    sourceCount?: number;
    durationMs?: number;
    createdAt?: Date;
    userId?: string | undefined;
    userName?: string | undefined;
    conversationId?: string | undefined;
    topic?: string | undefined;
    sentAnswer?: string | undefined;
    wasEdited?: boolean | undefined;
    sentAt?: Date | undefined;
    precisionScore?: number | undefined;
    styleScore?: number | undefined;
    feedbackComment?: string | undefined;
    problemTags?: string[];
    productTags?: string[];
    recommendedProductCodes?: string[];
    hasFeedback?: boolean;

    constructor(data?: IRagFeedbackLogSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.feature = _data["feature"];
            this.question = _data["question"];
            this.answer = _data["answer"];
            this.expandedQuery = _data["expandedQuery"];
            this.systemPrompt = _data["systemPrompt"];
            if (Array.isArray(_data["retrievedChunks"])) {
                this.retrievedChunks = [] as any;
                for (let item of _data["retrievedChunks"])
                    this.retrievedChunks!.push(RagFeedbackChunkDto.fromJS(item));
            }
            this.topK = _data["topK"];
            this.sourceCount = _data["sourceCount"];
            this.durationMs = _data["durationMs"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.conversationId = _data["conversationId"];
            this.topic = _data["topic"];
            this.sentAnswer = _data["sentAnswer"];
            this.wasEdited = _data["wasEdited"];
            this.sentAt = _data["sentAt"] ? new Date(_data["sentAt"].toString()) : <any>undefined;
            this.precisionScore = _data["precisionScore"];
            this.styleScore = _data["styleScore"];
            this.feedbackComment = _data["feedbackComment"];
            if (Array.isArray(_data["problemTags"])) {
                this.problemTags = [] as any;
                for (let item of _data["problemTags"])
                    this.problemTags!.push(item);
            }
            if (Array.isArray(_data["productTags"])) {
                this.productTags = [] as any;
                for (let item of _data["productTags"])
                    this.productTags!.push(item);
            }
            if (Array.isArray(_data["recommendedProductCodes"])) {
                this.recommendedProductCodes = [] as any;
                for (let item of _data["recommendedProductCodes"])
                    this.recommendedProductCodes!.push(item);
            }
            this.hasFeedback = _data["hasFeedback"];
        }
    }

    static fromJS(data: any): RagFeedbackLogSummary {
        data = typeof data === 'object' ? data : {};
        let result = new RagFeedbackLogSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["feature"] = this.feature;
        data["question"] = this.question;
        data["answer"] = this.answer;
        data["expandedQuery"] = this.expandedQuery;
        data["systemPrompt"] = this.systemPrompt;
        if (Array.isArray(this.retrievedChunks)) {
            data["retrievedChunks"] = [];
            for (let item of this.retrievedChunks)
                data["retrievedChunks"].push(item.toJSON());
        }
        data["topK"] = this.topK;
        data["sourceCount"] = this.sourceCount;
        data["durationMs"] = this.durationMs;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["conversationId"] = this.conversationId;
        data["topic"] = this.topic;
        data["sentAnswer"] = this.sentAnswer;
        data["wasEdited"] = this.wasEdited;
        data["sentAt"] = this.sentAt ? this.sentAt.toISOString() : <any>undefined;
        data["precisionScore"] = this.precisionScore;
        data["styleScore"] = this.styleScore;
        data["feedbackComment"] = this.feedbackComment;
        if (Array.isArray(this.problemTags)) {
            data["problemTags"] = [];
            for (let item of this.problemTags)
                data["problemTags"].push(item);
        }
        if (Array.isArray(this.productTags)) {
            data["productTags"] = [];
            for (let item of this.productTags)
                data["productTags"].push(item);
        }
        if (Array.isArray(this.recommendedProductCodes)) {
            data["recommendedProductCodes"] = [];
            for (let item of this.recommendedProductCodes)
                data["recommendedProductCodes"].push(item);
        }
        data["hasFeedback"] = this.hasFeedback;
        return data;
    }
}

export interface IRagFeedbackLogSummary {
    id?: string;
    feature?: RagFeature;
    question?: string;
    answer?: string;
    expandedQuery?: string | undefined;
    systemPrompt?: string;
    retrievedChunks?: RagFeedbackChunkDto[];
    topK?: number;
    sourceCount?: number;
    durationMs?: number;
    createdAt?: Date;
    userId?: string | undefined;
    userName?: string | undefined;
    conversationId?: string | undefined;
    topic?: string | undefined;
    sentAnswer?: string | undefined;
    wasEdited?: boolean | undefined;
    sentAt?: Date | undefined;
    precisionScore?: number | undefined;
    styleScore?: number | undefined;
    feedbackComment?: string | undefined;
    problemTags?: string[];
    productTags?: string[];
    recommendedProductCodes?: string[];
    hasFeedback?: boolean;
}

export enum RagFeature {
    KnowledgeBase = "KnowledgeBase",
    SmartsuppDraftReply = "SmartsuppDraftReply",
}

export class RagFeedbackChunkDto implements IRagFeedbackChunkDto {
    chunkId?: string;
    documentId?: string;
    filename?: string;
    score?: number;
    content?: string;

    constructor(data?: IRagFeedbackChunkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chunkId = _data["chunkId"];
            this.documentId = _data["documentId"];
            this.filename = _data["filename"];
            this.score = _data["score"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): RagFeedbackChunkDto {
        data = typeof data === 'object' ? data : {};
        let result = new RagFeedbackChunkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chunkId"] = this.chunkId;
        data["documentId"] = this.documentId;
        data["filename"] = this.filename;
        data["score"] = this.score;
        data["content"] = this.content;
        return data;
    }
}

export interface IRagFeedbackChunkDto {
    chunkId?: string;
    documentId?: string;
    filename?: string;
    score?: number;
    content?: string;
}

export class RagFeedbackStatsDto implements IRagFeedbackStatsDto {
    totalQuestions?: number;
    totalWithFeedback?: number;
    avgPrecisionScore?: number | undefined;
    avgStyleScore?: number | undefined;

    constructor(data?: IRagFeedbackStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalQuestions = _data["totalQuestions"];
            this.totalWithFeedback = _data["totalWithFeedback"];
            this.avgPrecisionScore = _data["avgPrecisionScore"];
            this.avgStyleScore = _data["avgStyleScore"];
        }
    }

    static fromJS(data: any): RagFeedbackStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RagFeedbackStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalQuestions"] = this.totalQuestions;
        data["totalWithFeedback"] = this.totalWithFeedback;
        data["avgPrecisionScore"] = this.avgPrecisionScore;
        data["avgStyleScore"] = this.avgStyleScore;
        return data;
    }
}

export interface IRagFeedbackStatsDto {
    totalQuestions?: number;
    totalWithFeedback?: number;
    avgPrecisionScore?: number | undefined;
    avgStyleScore?: number | undefined;
}

export class GetQuestionTagStatsResponse extends BaseResponse implements IGetQuestionTagStatsResponse {
    problemTags?: QuestionTagCountDto[];
    productTags?: QuestionTagCountDto[];
    recommendedProducts?: QuestionTagCountDto[];

    constructor(data?: IGetQuestionTagStatsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["problemTags"])) {
                this.problemTags = [] as any;
                for (let item of _data["problemTags"])
                    this.problemTags!.push(QuestionTagCountDto.fromJS(item));
            }
            if (Array.isArray(_data["productTags"])) {
                this.productTags = [] as any;
                for (let item of _data["productTags"])
                    this.productTags!.push(QuestionTagCountDto.fromJS(item));
            }
            if (Array.isArray(_data["recommendedProducts"])) {
                this.recommendedProducts = [] as any;
                for (let item of _data["recommendedProducts"])
                    this.recommendedProducts!.push(QuestionTagCountDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetQuestionTagStatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuestionTagStatsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.problemTags)) {
            data["problemTags"] = [];
            for (let item of this.problemTags)
                data["problemTags"].push(item.toJSON());
        }
        if (Array.isArray(this.productTags)) {
            data["productTags"] = [];
            for (let item of this.productTags)
                data["productTags"].push(item.toJSON());
        }
        if (Array.isArray(this.recommendedProducts)) {
            data["recommendedProducts"] = [];
            for (let item of this.recommendedProducts)
                data["recommendedProducts"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetQuestionTagStatsResponse extends IBaseResponse {
    problemTags?: QuestionTagCountDto[];
    productTags?: QuestionTagCountDto[];
    recommendedProducts?: QuestionTagCountDto[];
}

export class QuestionTagCountDto implements IQuestionTagCountDto {
    tag?: string;
    label?: string;
    count?: number;

    constructor(data?: IQuestionTagCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["tag"];
            this.label = _data["label"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): QuestionTagCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionTagCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        data["label"] = this.label;
        data["count"] = this.count;
        return data;
    }
}

export interface IQuestionTagCountDto {
    tag?: string;
    label?: string;
    count?: number;
}

export class SubmitFeedbackResponse extends BaseResponse implements ISubmitFeedbackResponse {

    constructor(data?: ISubmitFeedbackResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SubmitFeedbackResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitFeedbackResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISubmitFeedbackResponse extends IBaseResponse {
}

export class SubmitFeedbackRequest implements ISubmitFeedbackRequest {
    logId?: string;
    precisionScore?: number;
    styleScore?: number;
    comment?: string | undefined;

    constructor(data?: ISubmitFeedbackRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logId = _data["logId"];
            this.precisionScore = _data["precisionScore"];
            this.styleScore = _data["styleScore"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): SubmitFeedbackRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitFeedbackRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logId"] = this.logId;
        data["precisionScore"] = this.precisionScore;
        data["styleScore"] = this.styleScore;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ISubmitFeedbackRequest {
    logId?: string;
    precisionScore?: number;
    styleScore?: number;
    comment?: string | undefined;
}

export class KnowledgeBaseUploadDocumentResponse extends BaseResponse implements IKnowledgeBaseUploadDocumentResponse {
    document?: DocumentSummary | undefined;

    constructor(data?: IKnowledgeBaseUploadDocumentResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.document = _data["document"] ? DocumentSummary.fromJS(_data["document"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): KnowledgeBaseUploadDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeBaseUploadDocumentResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IKnowledgeBaseUploadDocumentResponse extends IBaseResponse {
    document?: DocumentSummary | undefined;
}

export class IdentifyLabelResponse extends BaseResponse implements IIdentifyLabelResponse {
    rawText?: string;
    decision?: LabelMatchDecision;
    candidates?: LabelCandidateDto[];

    constructor(data?: IIdentifyLabelResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rawText = _data["rawText"];
            this.decision = _data["decision"];
            if (Array.isArray(_data["candidates"])) {
                this.candidates = [] as any;
                for (let item of _data["candidates"])
                    this.candidates!.push(LabelCandidateDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): IdentifyLabelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IdentifyLabelResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawText"] = this.rawText;
        data["decision"] = this.decision;
        if (Array.isArray(this.candidates)) {
            data["candidates"] = [];
            for (let item of this.candidates)
                data["candidates"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IIdentifyLabelResponse extends IBaseResponse {
    rawText?: string;
    decision?: LabelMatchDecision;
    candidates?: LabelCandidateDto[];
}

export enum LabelMatchDecision {
    Auto = "Auto",
    Choose = "Choose",
    Low = "Low",
}

export class LabelCandidateDto implements ILabelCandidateDto {
    family?: string;
    score?: number;
    variants?: LabelVariantDto[];

    constructor(data?: ILabelCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.family = _data["family"];
            this.score = _data["score"];
            if (Array.isArray(_data["variants"])) {
                this.variants = [] as any;
                for (let item of _data["variants"])
                    this.variants!.push(LabelVariantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LabelCandidateDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabelCandidateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["family"] = this.family;
        data["score"] = this.score;
        if (Array.isArray(this.variants)) {
            data["variants"] = [];
            for (let item of this.variants)
                data["variants"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILabelCandidateDto {
    family?: string;
    score?: number;
    variants?: LabelVariantDto[];
}

export class LabelVariantDto implements ILabelVariantDto {
    productCode?: string;
    productName?: string;

    constructor(data?: ILabelVariantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
        }
    }

    static fromJS(data: any): LabelVariantDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabelVariantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        return data;
    }
}

export interface ILabelVariantDto {
    productCode?: string;
    productName?: string;
}

export class GenerateLeafletResponse extends BaseResponse implements IGenerateLeafletResponse {
    content?: string;
    id?: string | undefined;
    kbSourceCount?: number;
    leafletSourceCount?: number;

    constructor(data?: IGenerateLeafletResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.content = _data["content"];
            this.id = _data["id"];
            this.kbSourceCount = _data["kbSourceCount"];
            this.leafletSourceCount = _data["leafletSourceCount"];
        }
    }

    static override fromJS(data: any): GenerateLeafletResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateLeafletResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["id"] = this.id;
        data["kbSourceCount"] = this.kbSourceCount;
        data["leafletSourceCount"] = this.leafletSourceCount;
        super.toJSON(data);
        return data;
    }
}

export interface IGenerateLeafletResponse extends IBaseResponse {
    content?: string;
    id?: string | undefined;
    kbSourceCount?: number;
    leafletSourceCount?: number;
}

export class GenerateLeafletRequest implements IGenerateLeafletRequest {
    topic!: string;
    audience!: AudienceType;
    length!: LeafletLength;

    constructor(data?: IGenerateLeafletRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topic = _data["topic"];
            this.audience = _data["audience"];
            this.length = _data["length"];
        }
    }

    static fromJS(data: any): GenerateLeafletRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateLeafletRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topic"] = this.topic;
        data["audience"] = this.audience;
        data["length"] = this.length;
        return data;
    }
}

export interface IGenerateLeafletRequest {
    topic: string;
    audience: AudienceType;
    length: LeafletLength;
}

export enum AudienceType {
    EndConsumer = "EndConsumer",
    B2B = "B2B",
}

export enum LeafletLength {
    Short = "Short",
    Medium = "Medium",
    Long = "Long",
}

export class GetLeafletDocumentsResponse extends BaseResponse implements IGetLeafletDocumentsResponse {
    documents?: LeafletDocumentSummary[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;

    constructor(data?: IGetLeafletDocumentsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(LeafletDocumentSummary.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static override fromJS(data: any): GetLeafletDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeafletDocumentsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        super.toJSON(data);
        return data;
    }
}

export interface IGetLeafletDocumentsResponse extends IBaseResponse {
    documents?: LeafletDocumentSummary[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class LeafletDocumentSummary implements ILeafletDocumentSummary {
    id?: string;
    filename?: string;
    status?: string;
    contentType?: string;
    ingestedAt?: Date;
    indexedAt?: Date | undefined;
    firstChunkId?: string | undefined;

    constructor(data?: ILeafletDocumentSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.filename = _data["filename"];
            this.status = _data["status"];
            this.contentType = _data["contentType"];
            this.ingestedAt = _data["ingestedAt"] ? new Date(_data["ingestedAt"].toString()) : <any>undefined;
            this.indexedAt = _data["indexedAt"] ? new Date(_data["indexedAt"].toString()) : <any>undefined;
            this.firstChunkId = _data["firstChunkId"];
        }
    }

    static fromJS(data: any): LeafletDocumentSummary {
        data = typeof data === 'object' ? data : {};
        let result = new LeafletDocumentSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filename"] = this.filename;
        data["status"] = this.status;
        data["contentType"] = this.contentType;
        data["ingestedAt"] = this.ingestedAt ? this.ingestedAt.toISOString() : <any>undefined;
        data["indexedAt"] = this.indexedAt ? this.indexedAt.toISOString() : <any>undefined;
        data["firstChunkId"] = this.firstChunkId;
        return data;
    }
}

export interface ILeafletDocumentSummary {
    id?: string;
    filename?: string;
    status?: string;
    contentType?: string;
    ingestedAt?: Date;
    indexedAt?: Date | undefined;
    firstChunkId?: string | undefined;
}

export class GetLeafletDocumentContentTypesResponse extends BaseResponse implements IGetLeafletDocumentContentTypesResponse {
    contentTypes?: string[];

    constructor(data?: IGetLeafletDocumentContentTypesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contentTypes"])) {
                this.contentTypes = [] as any;
                for (let item of _data["contentTypes"])
                    this.contentTypes!.push(item);
            }
        }
    }

    static override fromJS(data: any): GetLeafletDocumentContentTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeafletDocumentContentTypesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contentTypes)) {
            data["contentTypes"] = [];
            for (let item of this.contentTypes)
                data["contentTypes"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetLeafletDocumentContentTypesResponse extends IBaseResponse {
    contentTypes?: string[];
}

export class GetLeafletChunkDetailResponse extends BaseResponse implements IGetLeafletChunkDetailResponse {
    chunkId?: string;
    documentId?: string;
    filename?: string;
    indexedAt?: Date | undefined;
    chunkIndex?: number;
    content?: string;
    summary?: string;
    sourcePath?: string | undefined;

    constructor(data?: IGetLeafletChunkDetailResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.chunkId = _data["chunkId"];
            this.documentId = _data["documentId"];
            this.filename = _data["filename"];
            this.indexedAt = _data["indexedAt"] ? new Date(_data["indexedAt"].toString()) : <any>undefined;
            this.chunkIndex = _data["chunkIndex"];
            this.content = _data["content"];
            this.summary = _data["summary"];
            this.sourcePath = _data["sourcePath"];
        }
    }

    static override fromJS(data: any): GetLeafletChunkDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeafletChunkDetailResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chunkId"] = this.chunkId;
        data["documentId"] = this.documentId;
        data["filename"] = this.filename;
        data["indexedAt"] = this.indexedAt ? this.indexedAt.toISOString() : <any>undefined;
        data["chunkIndex"] = this.chunkIndex;
        data["content"] = this.content;
        data["summary"] = this.summary;
        data["sourcePath"] = this.sourcePath;
        super.toJSON(data);
        return data;
    }
}

export interface IGetLeafletChunkDetailResponse extends IBaseResponse {
    chunkId?: string;
    documentId?: string;
    filename?: string;
    indexedAt?: Date | undefined;
    chunkIndex?: number;
    content?: string;
    summary?: string;
    sourcePath?: string | undefined;
}

export class DeleteLeafletDocumentResponse extends BaseResponse implements IDeleteLeafletDocumentResponse {

    constructor(data?: IDeleteLeafletDocumentResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DeleteLeafletDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteLeafletDocumentResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteLeafletDocumentResponse extends IBaseResponse {
}

export class UploadLeafletResponse extends BaseResponse implements IUploadLeafletResponse {
    document?: LeafletDocumentSummary | undefined;

    constructor(data?: IUploadLeafletResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.document = _data["document"] ? LeafletDocumentSummary.fromJS(_data["document"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): UploadLeafletResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadLeafletResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUploadLeafletResponse extends IBaseResponse {
    document?: LeafletDocumentSummary | undefined;
}

export class SubmitLeafletFeedbackResponse extends BaseResponse implements ISubmitLeafletFeedbackResponse {

    constructor(data?: ISubmitLeafletFeedbackResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SubmitLeafletFeedbackResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitLeafletFeedbackResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISubmitLeafletFeedbackResponse extends IBaseResponse {
}

export class SubmitLeafletFeedbackRequest implements ISubmitLeafletFeedbackRequest {
    generationId?: string;
    precisionScore?: number;
    styleScore?: number;
    comment?: string | undefined;

    constructor(data?: ISubmitLeafletFeedbackRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generationId = _data["generationId"];
            this.precisionScore = _data["precisionScore"];
            this.styleScore = _data["styleScore"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): SubmitLeafletFeedbackRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitLeafletFeedbackRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generationId"] = this.generationId;
        data["precisionScore"] = this.precisionScore;
        data["styleScore"] = this.styleScore;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ISubmitLeafletFeedbackRequest {
    generationId?: string;
    precisionScore?: number;
    styleScore?: number;
    comment?: string | undefined;
}

export class GetLeafletFeedbackListResponse extends BaseResponse implements IGetLeafletFeedbackListResponse {
    items?: LeafletFeedbackSummary[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    stats?: LeafletFeedbackStatsDto;

    constructor(data?: IGetLeafletFeedbackListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LeafletFeedbackSummary.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.stats = _data["stats"] ? LeafletFeedbackStatsDto.fromJS(_data["stats"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetLeafletFeedbackListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeafletFeedbackListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["stats"] = this.stats ? this.stats.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetLeafletFeedbackListResponse extends IBaseResponse {
    items?: LeafletFeedbackSummary[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    stats?: LeafletFeedbackStatsDto;
}

export class LeafletFeedbackSummary implements ILeafletFeedbackSummary {
    id?: string;
    topic?: string;
    audience?: string;
    length?: string;
    finalMarkdown?: string;
    kbSourceCount?: number;
    leafletSourceCount?: number;
    durationMs?: number;
    createdAt?: Date;
    userId?: string | undefined;
    userName?: string | undefined;
    precisionScore?: number | undefined;
    styleScore?: number | undefined;
    feedbackComment?: string | undefined;
    hasFeedback?: boolean;

    constructor(data?: ILeafletFeedbackSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.topic = _data["topic"];
            this.audience = _data["audience"];
            this.length = _data["length"];
            this.finalMarkdown = _data["finalMarkdown"];
            this.kbSourceCount = _data["kbSourceCount"];
            this.leafletSourceCount = _data["leafletSourceCount"];
            this.durationMs = _data["durationMs"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.precisionScore = _data["precisionScore"];
            this.styleScore = _data["styleScore"];
            this.feedbackComment = _data["feedbackComment"];
            this.hasFeedback = _data["hasFeedback"];
        }
    }

    static fromJS(data: any): LeafletFeedbackSummary {
        data = typeof data === 'object' ? data : {};
        let result = new LeafletFeedbackSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["topic"] = this.topic;
        data["audience"] = this.audience;
        data["length"] = this.length;
        data["finalMarkdown"] = this.finalMarkdown;
        data["kbSourceCount"] = this.kbSourceCount;
        data["leafletSourceCount"] = this.leafletSourceCount;
        data["durationMs"] = this.durationMs;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["precisionScore"] = this.precisionScore;
        data["styleScore"] = this.styleScore;
        data["feedbackComment"] = this.feedbackComment;
        data["hasFeedback"] = this.hasFeedback;
        return data;
    }
}

export interface ILeafletFeedbackSummary {
    id?: string;
    topic?: string;
    audience?: string;
    length?: string;
    finalMarkdown?: string;
    kbSourceCount?: number;
    leafletSourceCount?: number;
    durationMs?: number;
    createdAt?: Date;
    userId?: string | undefined;
    userName?: string | undefined;
    precisionScore?: number | undefined;
    styleScore?: number | undefined;
    feedbackComment?: string | undefined;
    hasFeedback?: boolean;
}

export class LeafletFeedbackStatsDto implements ILeafletFeedbackStatsDto {
    totalGenerations?: number;
    totalWithFeedback?: number;
    avgPrecisionScore?: number | undefined;
    avgStyleScore?: number | undefined;

    constructor(data?: ILeafletFeedbackStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalGenerations = _data["totalGenerations"];
            this.totalWithFeedback = _data["totalWithFeedback"];
            this.avgPrecisionScore = _data["avgPrecisionScore"];
            this.avgStyleScore = _data["avgStyleScore"];
        }
    }

    static fromJS(data: any): LeafletFeedbackStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeafletFeedbackStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalGenerations"] = this.totalGenerations;
        data["totalWithFeedback"] = this.totalWithFeedback;
        data["avgPrecisionScore"] = this.avgPrecisionScore;
        data["avgStyleScore"] = this.avgStyleScore;
        return data;
    }
}

export interface ILeafletFeedbackStatsDto {
    totalGenerations?: number;
    totalWithFeedback?: number;
    avgPrecisionScore?: number | undefined;
    avgStyleScore?: number | undefined;
}

export class GetLeafletGenerationResponse extends BaseResponse implements IGetLeafletGenerationResponse {
    id?: string;
    topic?: string;
    audience?: string;
    length?: string;
    finalMarkdown?: string;
    kbSourceCount?: number;
    leafletSourceCount?: number;
    durationMs?: number;
    createdAt?: Date;
    userId?: string | undefined;
    precisionScore?: number | undefined;
    styleScore?: number | undefined;
    feedbackComment?: string | undefined;

    constructor(data?: IGetLeafletGenerationResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.topic = _data["topic"];
            this.audience = _data["audience"];
            this.length = _data["length"];
            this.finalMarkdown = _data["finalMarkdown"];
            this.kbSourceCount = _data["kbSourceCount"];
            this.leafletSourceCount = _data["leafletSourceCount"];
            this.durationMs = _data["durationMs"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.precisionScore = _data["precisionScore"];
            this.styleScore = _data["styleScore"];
            this.feedbackComment = _data["feedbackComment"];
        }
    }

    static override fromJS(data: any): GetLeafletGenerationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeafletGenerationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["topic"] = this.topic;
        data["audience"] = this.audience;
        data["length"] = this.length;
        data["finalMarkdown"] = this.finalMarkdown;
        data["kbSourceCount"] = this.kbSourceCount;
        data["leafletSourceCount"] = this.leafletSourceCount;
        data["durationMs"] = this.durationMs;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["precisionScore"] = this.precisionScore;
        data["styleScore"] = this.styleScore;
        data["feedbackComment"] = this.feedbackComment;
        super.toJSON(data);
        return data;
    }
}

export interface IGetLeafletGenerationResponse extends IBaseResponse {
    id?: string;
    topic?: string;
    audience?: string;
    length?: string;
    finalMarkdown?: string;
    kbSourceCount?: number;
    leafletSourceCount?: number;
    durationMs?: number;
    createdAt?: Date;
    userId?: string | undefined;
    precisionScore?: number | undefined;
    styleScore?: number | undefined;
    feedbackComment?: string | undefined;
}

export class GetAvailableGiftPackagesResponse extends BaseResponse implements IGetAvailableGiftPackagesResponse {
    giftPackages?: GiftPackageDto[];

    constructor(data?: IGetAvailableGiftPackagesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["giftPackages"])) {
                this.giftPackages = [] as any;
                for (let item of _data["giftPackages"])
                    this.giftPackages!.push(GiftPackageDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetAvailableGiftPackagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableGiftPackagesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.giftPackages)) {
            data["giftPackages"] = [];
            for (let item of this.giftPackages)
                data["giftPackages"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAvailableGiftPackagesResponse extends IBaseResponse {
    giftPackages?: GiftPackageDto[];
}

export class GiftPackageDto implements IGiftPackageDto {
    code?: string;
    name?: string;
    availableStock?: number;
    dailySales?: number;
    overstockOptimal?: number;
    overstockMinimal?: number;
    suggestedQuantity?: number;
    severity?: GiftPackageSeverity;
    stockCoveragePercent?: number;
    ingredients?: GiftPackageIngredientDto[] | undefined;

    constructor(data?: IGiftPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.availableStock = _data["availableStock"];
            this.dailySales = _data["dailySales"];
            this.overstockOptimal = _data["overstockOptimal"];
            this.overstockMinimal = _data["overstockMinimal"];
            this.suggestedQuantity = _data["suggestedQuantity"];
            this.severity = _data["severity"];
            this.stockCoveragePercent = _data["stockCoveragePercent"];
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(GiftPackageIngredientDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GiftPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["availableStock"] = this.availableStock;
        data["dailySales"] = this.dailySales;
        data["overstockOptimal"] = this.overstockOptimal;
        data["overstockMinimal"] = this.overstockMinimal;
        data["suggestedQuantity"] = this.suggestedQuantity;
        data["severity"] = this.severity;
        data["stockCoveragePercent"] = this.stockCoveragePercent;
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGiftPackageDto {
    code?: string;
    name?: string;
    availableStock?: number;
    dailySales?: number;
    overstockOptimal?: number;
    overstockMinimal?: number;
    suggestedQuantity?: number;
    severity?: GiftPackageSeverity;
    stockCoveragePercent?: number;
    ingredients?: GiftPackageIngredientDto[] | undefined;
}

export enum GiftPackageSeverity {
    Critical = "Critical",
    Severe = "Severe",
    Optimal = "Optimal",
}

export class GiftPackageIngredientDto implements IGiftPackageIngredientDto {
    productCode?: string;
    productName?: string;
    requiredQuantity?: number;
    availableStock?: number;
    image?: string | undefined;
    hasSufficientStock?: boolean;

    constructor(data?: IGiftPackageIngredientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.requiredQuantity = _data["requiredQuantity"];
            this.availableStock = _data["availableStock"];
            this.image = _data["image"];
            this.hasSufficientStock = _data["hasSufficientStock"];
        }
    }

    static fromJS(data: any): GiftPackageIngredientDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftPackageIngredientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["requiredQuantity"] = this.requiredQuantity;
        data["availableStock"] = this.availableStock;
        data["image"] = this.image;
        data["hasSufficientStock"] = this.hasSufficientStock;
        return data;
    }
}

export interface IGiftPackageIngredientDto {
    productCode?: string;
    productName?: string;
    requiredQuantity?: number;
    availableStock?: number;
    image?: string | undefined;
    hasSufficientStock?: boolean;
}

export class GetGiftPackageDetailResponse extends BaseResponse implements IGetGiftPackageDetailResponse {
    giftPackage?: GiftPackageDto | undefined;

    constructor(data?: IGetGiftPackageDetailResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.giftPackage = _data["giftPackage"] ? GiftPackageDto.fromJS(_data["giftPackage"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetGiftPackageDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftPackageDetailResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftPackage"] = this.giftPackage ? this.giftPackage.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetGiftPackageDetailResponse extends IBaseResponse {
    giftPackage?: GiftPackageDto | undefined;
}

export class CreateGiftPackageManufactureResponse extends BaseResponse implements ICreateGiftPackageManufactureResponse {
    manufacture?: GiftPackageManufactureDto;

    constructor(data?: ICreateGiftPackageManufactureResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.manufacture = _data["manufacture"] ? GiftPackageManufactureDto.fromJS(_data["manufacture"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CreateGiftPackageManufactureResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGiftPackageManufactureResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacture"] = this.manufacture ? this.manufacture.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateGiftPackageManufactureResponse extends IBaseResponse {
    manufacture?: GiftPackageManufactureDto;
}

export class GiftPackageManufactureDto implements IGiftPackageManufactureDto {
    id?: number;
    giftPackageCode?: string;
    quantityCreated?: number;
    stockOverrideApplied?: boolean;
    createdAt?: Date;
    createdBy?: string;
    consumedItems?: GiftPackageManufactureItemDto[];

    constructor(data?: IGiftPackageManufactureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.giftPackageCode = _data["giftPackageCode"];
            this.quantityCreated = _data["quantityCreated"];
            this.stockOverrideApplied = _data["stockOverrideApplied"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            if (Array.isArray(_data["consumedItems"])) {
                this.consumedItems = [] as any;
                for (let item of _data["consumedItems"])
                    this.consumedItems!.push(GiftPackageManufactureItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GiftPackageManufactureDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftPackageManufactureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["giftPackageCode"] = this.giftPackageCode;
        data["quantityCreated"] = this.quantityCreated;
        data["stockOverrideApplied"] = this.stockOverrideApplied;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        if (Array.isArray(this.consumedItems)) {
            data["consumedItems"] = [];
            for (let item of this.consumedItems)
                data["consumedItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGiftPackageManufactureDto {
    id?: number;
    giftPackageCode?: string;
    quantityCreated?: number;
    stockOverrideApplied?: boolean;
    createdAt?: Date;
    createdBy?: string;
    consumedItems?: GiftPackageManufactureItemDto[];
}

export class GiftPackageManufactureItemDto implements IGiftPackageManufactureItemDto {
    productCode?: string;
    quantityConsumed?: number;

    constructor(data?: IGiftPackageManufactureItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.quantityConsumed = _data["quantityConsumed"];
        }
    }

    static fromJS(data: any): GiftPackageManufactureItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftPackageManufactureItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["quantityConsumed"] = this.quantityConsumed;
        return data;
    }
}

export interface IGiftPackageManufactureItemDto {
    productCode?: string;
    quantityConsumed?: number;
}

export class CreateGiftPackageManufactureRequest implements ICreateGiftPackageManufactureRequest {
    giftPackageCode?: string;
    quantity?: number;
    allowStockOverride?: boolean;

    constructor(data?: ICreateGiftPackageManufactureRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giftPackageCode = _data["giftPackageCode"];
            this.quantity = _data["quantity"];
            this.allowStockOverride = _data["allowStockOverride"];
        }
    }

    static fromJS(data: any): CreateGiftPackageManufactureRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGiftPackageManufactureRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftPackageCode"] = this.giftPackageCode;
        data["quantity"] = this.quantity;
        data["allowStockOverride"] = this.allowStockOverride;
        return data;
    }
}

export interface ICreateGiftPackageManufactureRequest {
    giftPackageCode?: string;
    quantity?: number;
    allowStockOverride?: boolean;
}

export class DisassembleGiftPackageResponse extends BaseResponse implements IDisassembleGiftPackageResponse {
    disassembly?: GiftPackageDisassemblyDto;

    constructor(data?: IDisassembleGiftPackageResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.disassembly = _data["disassembly"] ? GiftPackageDisassemblyDto.fromJS(_data["disassembly"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): DisassembleGiftPackageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DisassembleGiftPackageResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disassembly"] = this.disassembly ? this.disassembly.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDisassembleGiftPackageResponse extends IBaseResponse {
    disassembly?: GiftPackageDisassemblyDto;
}

export class GiftPackageDisassemblyDto implements IGiftPackageDisassemblyDto {
    giftPackageCode?: string;
    quantityDisassembled?: number;
    disassembledAt?: Date;
    disassembledBy?: string;
    returnedComponents?: GiftPackageDisassemblyItemDto[];

    constructor(data?: IGiftPackageDisassemblyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giftPackageCode = _data["giftPackageCode"];
            this.quantityDisassembled = _data["quantityDisassembled"];
            this.disassembledAt = _data["disassembledAt"] ? new Date(_data["disassembledAt"].toString()) : <any>undefined;
            this.disassembledBy = _data["disassembledBy"];
            if (Array.isArray(_data["returnedComponents"])) {
                this.returnedComponents = [] as any;
                for (let item of _data["returnedComponents"])
                    this.returnedComponents!.push(GiftPackageDisassemblyItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GiftPackageDisassemblyDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftPackageDisassemblyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftPackageCode"] = this.giftPackageCode;
        data["quantityDisassembled"] = this.quantityDisassembled;
        data["disassembledAt"] = this.disassembledAt ? this.disassembledAt.toISOString() : <any>undefined;
        data["disassembledBy"] = this.disassembledBy;
        if (Array.isArray(this.returnedComponents)) {
            data["returnedComponents"] = [];
            for (let item of this.returnedComponents)
                data["returnedComponents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGiftPackageDisassemblyDto {
    giftPackageCode?: string;
    quantityDisassembled?: number;
    disassembledAt?: Date;
    disassembledBy?: string;
    returnedComponents?: GiftPackageDisassemblyItemDto[];
}

export class GiftPackageDisassemblyItemDto implements IGiftPackageDisassemblyItemDto {
    productCode?: string;
    quantityReturned?: number;

    constructor(data?: IGiftPackageDisassemblyItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.quantityReturned = _data["quantityReturned"];
        }
    }

    static fromJS(data: any): GiftPackageDisassemblyItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftPackageDisassemblyItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["quantityReturned"] = this.quantityReturned;
        return data;
    }
}

export interface IGiftPackageDisassemblyItemDto {
    productCode?: string;
    quantityReturned?: number;
}

export class DisassembleGiftPackageRequest implements IDisassembleGiftPackageRequest {
    giftPackageCode?: string;
    quantity?: number;

    constructor(data?: IDisassembleGiftPackageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giftPackageCode = _data["giftPackageCode"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): DisassembleGiftPackageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DisassembleGiftPackageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftPackageCode"] = this.giftPackageCode;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IDisassembleGiftPackageRequest {
    giftPackageCode?: string;
    quantity?: number;
}

export class GetManufactureLogResponse extends BaseResponse implements IGetManufactureLogResponse {
    manufactureLogs?: GiftPackageManufactureDto[];

    constructor(data?: IGetManufactureLogResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["manufactureLogs"])) {
                this.manufactureLogs = [] as any;
                for (let item of _data["manufactureLogs"])
                    this.manufactureLogs!.push(GiftPackageManufactureDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetManufactureLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufactureLogResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufactureLogs)) {
            data["manufactureLogs"] = [];
            for (let item of this.manufactureLogs)
                data["manufactureLogs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetManufactureLogResponse extends IBaseResponse {
    manufactureLogs?: GiftPackageManufactureDto[];
}

export class ListLotsResponse extends BaseResponse implements IListLotsResponse {
    lots?: LotDto2[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IListLotsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["lots"])) {
                this.lots = [] as any;
                for (let item of _data["lots"])
                    this.lots!.push(LotDto2.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static override fromJS(data: any): ListLotsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListLotsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lots)) {
            data["lots"] = [];
            for (let item of this.lots)
                data["lots"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}

export interface IListLotsResponse extends IBaseResponse {
    lots?: LotDto2[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class LotDto2 implements ILotDto2 {
    id?: number;
    materialCode?: string;
    lotCode?: string;
    expiration?: Date | undefined;
    receivedDate?: Date;
    notes?: string | undefined;
    createdAt?: Date;
    createdBy?: string;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;

    constructor(data?: ILotDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialCode = _data["materialCode"];
            this.lotCode = _data["lotCode"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): LotDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new LotDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialCode"] = this.materialCode;
        data["lotCode"] = this.lotCode;
        data["expiration"] = this.expiration ? formatDate(this.expiration) : <any>undefined;
        data["receivedDate"] = this.receivedDate ? formatDate(this.receivedDate) : <any>undefined;
        data["notes"] = this.notes;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ILotDto2 {
    id?: number;
    materialCode?: string;
    lotCode?: string;
    expiration?: Date | undefined;
    receivedDate?: Date;
    notes?: string | undefined;
    createdAt?: Date;
    createdBy?: string;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;
}

export class GetLotResponse extends BaseResponse implements IGetLotResponse {
    lot?: LotDto2;
    containers?: MaterialContainerDto[];

    constructor(data?: IGetLotResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lot = _data["lot"] ? LotDto2.fromJS(_data["lot"]) : <any>undefined;
            if (Array.isArray(_data["containers"])) {
                this.containers = [] as any;
                for (let item of _data["containers"])
                    this.containers!.push(MaterialContainerDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetLotResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLotResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lot"] = this.lot ? this.lot.toJSON() : <any>undefined;
        if (Array.isArray(this.containers)) {
            data["containers"] = [];
            for (let item of this.containers)
                data["containers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetLotResponse extends IBaseResponse {
    lot?: LotDto2;
    containers?: MaterialContainerDto[];
}

export class MaterialContainerDto implements IMaterialContainerDto {
    id?: number;
    code?: string;
    materialCode?: string | undefined;
    lotCode?: string | undefined;
    status?: string;
    amount?: number | undefined;
    unit?: string | undefined;
    createdAt?: Date;
    createdBy?: string;
    purchaseOrderLineId?: number | undefined;

    constructor(data?: IMaterialContainerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.materialCode = _data["materialCode"];
            this.lotCode = _data["lotCode"];
            this.status = _data["status"];
            this.amount = _data["amount"];
            this.unit = _data["unit"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.purchaseOrderLineId = _data["purchaseOrderLineId"];
        }
    }

    static fromJS(data: any): MaterialContainerDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialContainerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["materialCode"] = this.materialCode;
        data["lotCode"] = this.lotCode;
        data["status"] = this.status;
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["purchaseOrderLineId"] = this.purchaseOrderLineId;
        return data;
    }
}

export interface IMaterialContainerDto {
    id?: number;
    code?: string;
    materialCode?: string | undefined;
    lotCode?: string | undefined;
    status?: string;
    amount?: number | undefined;
    unit?: string | undefined;
    createdAt?: Date;
    createdBy?: string;
    purchaseOrderLineId?: number | undefined;
}

export class CreateLotResponse extends BaseResponse implements ICreateLotResponse {
    lot?: LotDto2;

    constructor(data?: ICreateLotResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lot = _data["lot"] ? LotDto2.fromJS(_data["lot"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CreateLotResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLotResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lot"] = this.lot ? this.lot.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateLotResponse extends IBaseResponse {
    lot?: LotDto2;
}

export class CreateLotRequest implements ICreateLotRequest {
    materialCode?: string;
    lotCode?: string;
    expiration?: Date | undefined;
    receivedDate?: Date;
    notes?: string | undefined;

    constructor(data?: ICreateLotRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialCode = _data["materialCode"];
            this.lotCode = _data["lotCode"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateLotRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLotRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialCode"] = this.materialCode;
        data["lotCode"] = this.lotCode;
        data["expiration"] = this.expiration ? formatDate(this.expiration) : <any>undefined;
        data["receivedDate"] = this.receivedDate ? formatDate(this.receivedDate) : <any>undefined;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateLotRequest {
    materialCode?: string;
    lotCode?: string;
    expiration?: Date | undefined;
    receivedDate?: Date;
    notes?: string | undefined;
}

export class UpdateLotResponse extends BaseResponse implements IUpdateLotResponse {
    lot?: LotDto2;

    constructor(data?: IUpdateLotResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lot = _data["lot"] ? LotDto2.fromJS(_data["lot"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): UpdateLotResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLotResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lot"] = this.lot ? this.lot.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateLotResponse extends IBaseResponse {
    lot?: LotDto2;
}

export class UpdateLotRequest implements IUpdateLotRequest {
    id?: number;
    expiration?: Date | undefined;
    receivedDate?: Date;
    notes?: string | undefined;

    constructor(data?: IUpdateLotRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateLotRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLotRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expiration"] = this.expiration ? formatDate(this.expiration) : <any>undefined;
        data["receivedDate"] = this.receivedDate ? formatDate(this.receivedDate) : <any>undefined;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateLotRequest {
    id?: number;
    expiration?: Date | undefined;
    receivedDate?: Date;
    notes?: string | undefined;
}

export class DeleteLotResponse extends BaseResponse implements IDeleteLotResponse {

    constructor(data?: IDeleteLotResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DeleteLotResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteLotResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteLotResponse extends IBaseResponse {
}

export class PrintLotLabelsResponse extends BaseResponse implements IPrintLotLabelsResponse {
    lotNumber?: string;
    expiration?: string;
    count?: number;
    requiresMediaChangeConfirmation?: boolean;

    constructor(data?: IPrintLotLabelsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lotNumber = _data["lotNumber"];
            this.expiration = _data["expiration"];
            this.count = _data["count"];
            this.requiresMediaChangeConfirmation = _data["requiresMediaChangeConfirmation"];
        }
    }

    static override fromJS(data: any): PrintLotLabelsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrintLotLabelsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lotNumber"] = this.lotNumber;
        data["expiration"] = this.expiration;
        data["count"] = this.count;
        data["requiresMediaChangeConfirmation"] = this.requiresMediaChangeConfirmation;
        super.toJSON(data);
        return data;
    }
}

export interface IPrintLotLabelsResponse extends IBaseResponse {
    lotNumber?: string;
    expiration?: string;
    count?: number;
    requiresMediaChangeConfirmation?: boolean;
}

export class PrintLotLabelsRequest implements IPrintLotLabelsRequest {
    lotNumber?: string;
    expiration?: string;
    count?: number;
    mediaChangeConfirmed?: boolean;

    constructor(data?: IPrintLotLabelsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lotNumber = _data["lotNumber"];
            this.expiration = _data["expiration"];
            this.count = _data["count"];
            this.mediaChangeConfirmed = _data["mediaChangeConfirmed"];
        }
    }

    static fromJS(data: any): PrintLotLabelsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PrintLotLabelsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lotNumber"] = this.lotNumber;
        data["expiration"] = this.expiration;
        data["count"] = this.count;
        data["mediaChangeConfirmed"] = this.mediaChangeConfirmed;
        return data;
    }
}

export interface IPrintLotLabelsRequest {
    lotNumber?: string;
    expiration?: string;
    count?: number;
    mediaChangeConfirmed?: boolean;
}

export class PrintLotCalibrationLabelResponse extends BaseResponse implements IPrintLotCalibrationLabelResponse {
    requiresMediaChangeConfirmation?: boolean;

    constructor(data?: IPrintLotCalibrationLabelResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requiresMediaChangeConfirmation = _data["requiresMediaChangeConfirmation"];
        }
    }

    static override fromJS(data: any): PrintLotCalibrationLabelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrintLotCalibrationLabelResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requiresMediaChangeConfirmation"] = this.requiresMediaChangeConfirmation;
        super.toJSON(data);
        return data;
    }
}

export interface IPrintLotCalibrationLabelResponse extends IBaseResponse {
    requiresMediaChangeConfirmation?: boolean;
}

export class PrintLotCalibrationLabelRequest implements IPrintLotCalibrationLabelRequest {
    mediaChangeConfirmed?: boolean;

    constructor(data?: IPrintLotCalibrationLabelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mediaChangeConfirmed = _data["mediaChangeConfirmed"];
        }
    }

    static fromJS(data: any): PrintLotCalibrationLabelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PrintLotCalibrationLabelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mediaChangeConfirmed"] = this.mediaChangeConfirmed;
        return data;
    }
}

export interface IPrintLotCalibrationLabelRequest {
    mediaChangeConfirmed?: boolean;
}

export class FeedLotMediaResponse extends BaseResponse implements IFeedLotMediaResponse {
    requiresMediaChangeConfirmation?: boolean;

    constructor(data?: IFeedLotMediaResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requiresMediaChangeConfirmation = _data["requiresMediaChangeConfirmation"];
        }
    }

    static override fromJS(data: any): FeedLotMediaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FeedLotMediaResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requiresMediaChangeConfirmation"] = this.requiresMediaChangeConfirmation;
        super.toJSON(data);
        return data;
    }
}

export interface IFeedLotMediaResponse extends IBaseResponse {
    requiresMediaChangeConfirmation?: boolean;
}

export class FeedLotMediaRequest implements IFeedLotMediaRequest {
    dots?: number;
    mediaChangeConfirmed?: boolean;

    constructor(data?: IFeedLotMediaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dots = _data["dots"];
            this.mediaChangeConfirmed = _data["mediaChangeConfirmed"];
        }
    }

    static fromJS(data: any): FeedLotMediaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FeedLotMediaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dots"] = this.dots;
        data["mediaChangeConfirmed"] = this.mediaChangeConfirmed;
        return data;
    }
}

export interface IFeedLotMediaRequest {
    dots?: number;
    mediaChangeConfirmed?: boolean;
}

export class GetLotLabelCalibrationResponse extends BaseResponse implements IGetLotLabelCalibrationResponse {
    pitchDots?: number;
    minPitchDots?: number;
    maxPitchDots?: number;
    driftDotsPer100Labels?: number;
    minDriftDotsPer100Labels?: number;
    maxDriftDotsPer100Labels?: number;

    constructor(data?: IGetLotLabelCalibrationResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pitchDots = _data["pitchDots"];
            this.minPitchDots = _data["minPitchDots"];
            this.maxPitchDots = _data["maxPitchDots"];
            this.driftDotsPer100Labels = _data["driftDotsPer100Labels"];
            this.minDriftDotsPer100Labels = _data["minDriftDotsPer100Labels"];
            this.maxDriftDotsPer100Labels = _data["maxDriftDotsPer100Labels"];
        }
    }

    static override fromJS(data: any): GetLotLabelCalibrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLotLabelCalibrationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pitchDots"] = this.pitchDots;
        data["minPitchDots"] = this.minPitchDots;
        data["maxPitchDots"] = this.maxPitchDots;
        data["driftDotsPer100Labels"] = this.driftDotsPer100Labels;
        data["minDriftDotsPer100Labels"] = this.minDriftDotsPer100Labels;
        data["maxDriftDotsPer100Labels"] = this.maxDriftDotsPer100Labels;
        super.toJSON(data);
        return data;
    }
}

export interface IGetLotLabelCalibrationResponse extends IBaseResponse {
    pitchDots?: number;
    minPitchDots?: number;
    maxPitchDots?: number;
    driftDotsPer100Labels?: number;
    minDriftDotsPer100Labels?: number;
    maxDriftDotsPer100Labels?: number;
}

export class SetLotLabelCalibrationResponse extends BaseResponse implements ISetLotLabelCalibrationResponse {
    pitchDots?: number;
    driftDotsPer100Labels?: number;

    constructor(data?: ISetLotLabelCalibrationResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pitchDots = _data["pitchDots"];
            this.driftDotsPer100Labels = _data["driftDotsPer100Labels"];
        }
    }

    static override fromJS(data: any): SetLotLabelCalibrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetLotLabelCalibrationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pitchDots"] = this.pitchDots;
        data["driftDotsPer100Labels"] = this.driftDotsPer100Labels;
        super.toJSON(data);
        return data;
    }
}

export interface ISetLotLabelCalibrationResponse extends IBaseResponse {
    pitchDots?: number;
    driftDotsPer100Labels?: number;
}

export class SetLotLabelCalibrationRequest implements ISetLotLabelCalibrationRequest {
    pitchDots?: number;
    driftDotsPer100Labels?: number;

    constructor(data?: ISetLotLabelCalibrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pitchDots = _data["pitchDots"];
            this.driftDotsPer100Labels = _data["driftDotsPer100Labels"];
        }
    }

    static fromJS(data: any): SetLotLabelCalibrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetLotLabelCalibrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pitchDots"] = this.pitchDots;
        data["driftDotsPer100Labels"] = this.driftDotsPer100Labels;
        return data;
    }
}

export interface ISetLotLabelCalibrationRequest {
    pitchDots?: number;
    driftDotsPer100Labels?: number;
}

export class NudgeLotLabelCalibrationResponse extends BaseResponse implements INudgeLotLabelCalibrationResponse {
    isAtLimit?: boolean;

    constructor(data?: INudgeLotLabelCalibrationResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isAtLimit = _data["isAtLimit"];
        }
    }

    static override fromJS(data: any): NudgeLotLabelCalibrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NudgeLotLabelCalibrationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAtLimit"] = this.isAtLimit;
        super.toJSON(data);
        return data;
    }
}

export interface INudgeLotLabelCalibrationResponse extends IBaseResponse {
    isAtLimit?: boolean;
}

export class NudgeLotLabelCalibrationRequest implements INudgeLotLabelCalibrationRequest {
    direction?: LabelDriftDirection;
    speed?: LabelDriftSpeed;

    constructor(data?: INudgeLotLabelCalibrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.direction = _data["direction"];
            this.speed = _data["speed"];
        }
    }

    static fromJS(data: any): NudgeLotLabelCalibrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NudgeLotLabelCalibrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction;
        data["speed"] = this.speed;
        return data;
    }
}

export interface INudgeLotLabelCalibrationRequest {
    direction?: LabelDriftDirection;
    speed?: LabelDriftSpeed;
}

export enum LabelDriftDirection {
    Up = "Up",
    Down = "Down",
}

export enum LabelDriftSpeed {
    Fast = "Fast",
    Slow = "Slow",
}

export class CalculatedBatchSizeResponse extends BaseResponse implements ICalculatedBatchSizeResponse {
    productCode?: string;
    productName?: string;
    originalBatchSize?: number;
    newBatchSize?: number;
    scaleFactor?: number;
    ingredients?: CalculatedIngredientDto[];

    constructor(data?: ICalculatedBatchSizeResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.originalBatchSize = _data["originalBatchSize"];
            this.newBatchSize = _data["newBatchSize"];
            this.scaleFactor = _data["scaleFactor"];
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(CalculatedIngredientDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CalculatedBatchSizeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CalculatedBatchSizeResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["originalBatchSize"] = this.originalBatchSize;
        data["newBatchSize"] = this.newBatchSize;
        data["scaleFactor"] = this.scaleFactor;
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICalculatedBatchSizeResponse extends IBaseResponse {
    productCode?: string;
    productName?: string;
    originalBatchSize?: number;
    newBatchSize?: number;
    scaleFactor?: number;
    ingredients?: CalculatedIngredientDto[];
}

export class CalculatedIngredientDto implements ICalculatedIngredientDto {
    productCode?: string;
    productName?: string;
    originalAmount?: number;
    calculatedAmount?: number;
    price?: number;
    stockTotal?: number;
    lastStockTaking?: Date | undefined;
    phaseLabel?: string | undefined;

    constructor(data?: ICalculatedIngredientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.originalAmount = _data["originalAmount"];
            this.calculatedAmount = _data["calculatedAmount"];
            this.price = _data["price"];
            this.stockTotal = _data["stockTotal"];
            this.lastStockTaking = _data["lastStockTaking"] ? new Date(_data["lastStockTaking"].toString()) : <any>undefined;
            this.phaseLabel = _data["phaseLabel"];
        }
    }

    static fromJS(data: any): CalculatedIngredientDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculatedIngredientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["originalAmount"] = this.originalAmount;
        data["calculatedAmount"] = this.calculatedAmount;
        data["price"] = this.price;
        data["stockTotal"] = this.stockTotal;
        data["lastStockTaking"] = this.lastStockTaking ? this.lastStockTaking.toISOString() : <any>undefined;
        data["phaseLabel"] = this.phaseLabel;
        return data;
    }
}

export interface ICalculatedIngredientDto {
    productCode?: string;
    productName?: string;
    originalAmount?: number;
    calculatedAmount?: number;
    price?: number;
    stockTotal?: number;
    lastStockTaking?: Date | undefined;
    phaseLabel?: string | undefined;
}

export class CalculatedBatchSizeRequest implements ICalculatedBatchSizeRequest {
    productCode?: string;
    desiredBatchSize?: number | undefined;

    constructor(data?: ICalculatedBatchSizeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.desiredBatchSize = _data["desiredBatchSize"];
        }
    }

    static fromJS(data: any): CalculatedBatchSizeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculatedBatchSizeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["desiredBatchSize"] = this.desiredBatchSize;
        return data;
    }
}

export interface ICalculatedBatchSizeRequest {
    productCode?: string;
    desiredBatchSize?: number | undefined;
}

export class CalculateBatchByIngredientResponse extends BaseResponse implements ICalculateBatchByIngredientResponse {
    productCode?: string;
    productName?: string;
    originalBatchSize?: number;
    newBatchSize?: number;
    scaleFactor?: number;
    scaledIngredientCode?: string;
    scaledIngredientName?: string;
    scaledIngredientOriginalAmount?: number;
    scaledIngredientNewAmount?: number;
    ingredients?: CalculatedIngredientDto[];

    constructor(data?: ICalculateBatchByIngredientResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.originalBatchSize = _data["originalBatchSize"];
            this.newBatchSize = _data["newBatchSize"];
            this.scaleFactor = _data["scaleFactor"];
            this.scaledIngredientCode = _data["scaledIngredientCode"];
            this.scaledIngredientName = _data["scaledIngredientName"];
            this.scaledIngredientOriginalAmount = _data["scaledIngredientOriginalAmount"];
            this.scaledIngredientNewAmount = _data["scaledIngredientNewAmount"];
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(CalculatedIngredientDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CalculateBatchByIngredientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateBatchByIngredientResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["originalBatchSize"] = this.originalBatchSize;
        data["newBatchSize"] = this.newBatchSize;
        data["scaleFactor"] = this.scaleFactor;
        data["scaledIngredientCode"] = this.scaledIngredientCode;
        data["scaledIngredientName"] = this.scaledIngredientName;
        data["scaledIngredientOriginalAmount"] = this.scaledIngredientOriginalAmount;
        data["scaledIngredientNewAmount"] = this.scaledIngredientNewAmount;
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICalculateBatchByIngredientResponse extends IBaseResponse {
    productCode?: string;
    productName?: string;
    originalBatchSize?: number;
    newBatchSize?: number;
    scaleFactor?: number;
    scaledIngredientCode?: string;
    scaledIngredientName?: string;
    scaledIngredientOriginalAmount?: number;
    scaledIngredientNewAmount?: number;
    ingredients?: CalculatedIngredientDto[];
}

export class CalculateBatchByIngredientRequest implements ICalculateBatchByIngredientRequest {
    productCode?: string;
    ingredientCode?: string;
    desiredIngredientAmount?: number;

    constructor(data?: ICalculateBatchByIngredientRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.ingredientCode = _data["ingredientCode"];
            this.desiredIngredientAmount = _data["desiredIngredientAmount"];
        }
    }

    static fromJS(data: any): CalculateBatchByIngredientRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateBatchByIngredientRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["ingredientCode"] = this.ingredientCode;
        data["desiredIngredientAmount"] = this.desiredIngredientAmount;
        return data;
    }
}

export interface ICalculateBatchByIngredientRequest {
    productCode?: string;
    ingredientCode?: string;
    desiredIngredientAmount?: number;
}

export class CalculateBatchPlanResponse extends BaseResponse implements ICalculateBatchPlanResponse {
    semiproduct?: SemiproductInfoDto;
    productSizes?: BatchPlanItemDto[];
    summary?: BatchPlanSummaryDto;
    targetDaysCoverage?: number;
    totalVolumeUsed?: number;
    totalVolumeAvailable?: number;
    manufactureType?: ManufactureType;
    directSemiproductAmount?: number;

    constructor(data?: ICalculateBatchPlanResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.semiproduct = _data["semiproduct"] ? SemiproductInfoDto.fromJS(_data["semiproduct"]) : <any>undefined;
            if (Array.isArray(_data["productSizes"])) {
                this.productSizes = [] as any;
                for (let item of _data["productSizes"])
                    this.productSizes!.push(BatchPlanItemDto.fromJS(item));
            }
            this.summary = _data["summary"] ? BatchPlanSummaryDto.fromJS(_data["summary"]) : <any>undefined;
            this.targetDaysCoverage = _data["targetDaysCoverage"];
            this.totalVolumeUsed = _data["totalVolumeUsed"];
            this.totalVolumeAvailable = _data["totalVolumeAvailable"];
            this.manufactureType = _data["manufactureType"];
            this.directSemiproductAmount = _data["directSemiproductAmount"];
        }
    }

    static override fromJS(data: any): CalculateBatchPlanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateBatchPlanResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["semiproduct"] = this.semiproduct ? this.semiproduct.toJSON() : <any>undefined;
        if (Array.isArray(this.productSizes)) {
            data["productSizes"] = [];
            for (let item of this.productSizes)
                data["productSizes"].push(item.toJSON());
        }
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["targetDaysCoverage"] = this.targetDaysCoverage;
        data["totalVolumeUsed"] = this.totalVolumeUsed;
        data["totalVolumeAvailable"] = this.totalVolumeAvailable;
        data["manufactureType"] = this.manufactureType;
        data["directSemiproductAmount"] = this.directSemiproductAmount;
        super.toJSON(data);
        return data;
    }
}

export interface ICalculateBatchPlanResponse extends IBaseResponse {
    semiproduct?: SemiproductInfoDto;
    productSizes?: BatchPlanItemDto[];
    summary?: BatchPlanSummaryDto;
    targetDaysCoverage?: number;
    totalVolumeUsed?: number;
    totalVolumeAvailable?: number;
    manufactureType?: ManufactureType;
    directSemiproductAmount?: number;
}

export class SemiproductInfoDto implements ISemiproductInfoDto {
    productCode?: string;
    productName?: string;
    availableStock?: number;
    minimalManufactureQuantity?: number;

    constructor(data?: ISemiproductInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.availableStock = _data["availableStock"];
            this.minimalManufactureQuantity = _data["minimalManufactureQuantity"];
        }
    }

    static fromJS(data: any): SemiproductInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SemiproductInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["availableStock"] = this.availableStock;
        data["minimalManufactureQuantity"] = this.minimalManufactureQuantity;
        return data;
    }
}

export interface ISemiproductInfoDto {
    productCode?: string;
    productName?: string;
    availableStock?: number;
    minimalManufactureQuantity?: number;
}

export class BatchPlanItemDto implements IBatchPlanItemDto {
    productCode?: string;
    productName?: string;
    productSize?: string;
    currentStock?: number;
    plannedQuantity?: number;
    dailySalesRate?: number;
    currentDaysCoverage?: number;
    recommendedUnitsToProduceHumanReadable?: number;
    weightPerUnit?: number;
    totalVolumeRequired?: number;
    futureStock?: number;
    futureDaysCoverage?: number;
    isFixed?: boolean;
    userFixedQuantity?: number | undefined;
    wasOptimized?: boolean;
    optimizationNote?: string;
    enabled?: boolean;
    isNd?: boolean;

    constructor(data?: IBatchPlanItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.productSize = _data["productSize"];
            this.currentStock = _data["currentStock"];
            this.plannedQuantity = _data["plannedQuantity"];
            this.dailySalesRate = _data["dailySalesRate"];
            this.currentDaysCoverage = _data["currentDaysCoverage"];
            this.recommendedUnitsToProduceHumanReadable = _data["recommendedUnitsToProduceHumanReadable"];
            this.weightPerUnit = _data["weightPerUnit"];
            this.totalVolumeRequired = _data["totalVolumeRequired"];
            this.futureStock = _data["futureStock"];
            this.futureDaysCoverage = _data["futureDaysCoverage"];
            this.isFixed = _data["isFixed"];
            this.userFixedQuantity = _data["userFixedQuantity"];
            this.wasOptimized = _data["wasOptimized"];
            this.optimizationNote = _data["optimizationNote"];
            this.enabled = _data["enabled"];
            this.isNd = _data["isNd"];
        }
    }

    static fromJS(data: any): BatchPlanItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchPlanItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productSize"] = this.productSize;
        data["currentStock"] = this.currentStock;
        data["plannedQuantity"] = this.plannedQuantity;
        data["dailySalesRate"] = this.dailySalesRate;
        data["currentDaysCoverage"] = this.currentDaysCoverage;
        data["recommendedUnitsToProduceHumanReadable"] = this.recommendedUnitsToProduceHumanReadable;
        data["weightPerUnit"] = this.weightPerUnit;
        data["totalVolumeRequired"] = this.totalVolumeRequired;
        data["futureStock"] = this.futureStock;
        data["futureDaysCoverage"] = this.futureDaysCoverage;
        data["isFixed"] = this.isFixed;
        data["userFixedQuantity"] = this.userFixedQuantity;
        data["wasOptimized"] = this.wasOptimized;
        data["optimizationNote"] = this.optimizationNote;
        data["enabled"] = this.enabled;
        data["isNd"] = this.isNd;
        return data;
    }
}

export interface IBatchPlanItemDto {
    productCode?: string;
    productName?: string;
    productSize?: string;
    currentStock?: number;
    plannedQuantity?: number;
    dailySalesRate?: number;
    currentDaysCoverage?: number;
    recommendedUnitsToProduceHumanReadable?: number;
    weightPerUnit?: number;
    totalVolumeRequired?: number;
    futureStock?: number;
    futureDaysCoverage?: number;
    isFixed?: boolean;
    userFixedQuantity?: number | undefined;
    wasOptimized?: boolean;
    optimizationNote?: string;
    enabled?: boolean;
    isNd?: boolean;
}

export class BatchPlanSummaryDto implements IBatchPlanSummaryDto {
    totalProductSizes?: number;
    totalVolumeUsed?: number;
    totalVolumeAvailable?: number;
    volumeUtilizationPercentage?: number;
    usedControlMode?: BatchPlanControlMode;
    effectiveMmqMultiplier?: number;
    actualTotalWeight?: number;
    achievedAverageCoverage?: number;
    fixedProductsCount?: number;
    optimizedProductsCount?: number;

    constructor(data?: IBatchPlanSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProductSizes = _data["totalProductSizes"];
            this.totalVolumeUsed = _data["totalVolumeUsed"];
            this.totalVolumeAvailable = _data["totalVolumeAvailable"];
            this.volumeUtilizationPercentage = _data["volumeUtilizationPercentage"];
            this.usedControlMode = _data["usedControlMode"];
            this.effectiveMmqMultiplier = _data["effectiveMmqMultiplier"];
            this.actualTotalWeight = _data["actualTotalWeight"];
            this.achievedAverageCoverage = _data["achievedAverageCoverage"];
            this.fixedProductsCount = _data["fixedProductsCount"];
            this.optimizedProductsCount = _data["optimizedProductsCount"];
        }
    }

    static fromJS(data: any): BatchPlanSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchPlanSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProductSizes"] = this.totalProductSizes;
        data["totalVolumeUsed"] = this.totalVolumeUsed;
        data["totalVolumeAvailable"] = this.totalVolumeAvailable;
        data["volumeUtilizationPercentage"] = this.volumeUtilizationPercentage;
        data["usedControlMode"] = this.usedControlMode;
        data["effectiveMmqMultiplier"] = this.effectiveMmqMultiplier;
        data["actualTotalWeight"] = this.actualTotalWeight;
        data["achievedAverageCoverage"] = this.achievedAverageCoverage;
        data["fixedProductsCount"] = this.fixedProductsCount;
        data["optimizedProductsCount"] = this.optimizedProductsCount;
        return data;
    }
}

export interface IBatchPlanSummaryDto {
    totalProductSizes?: number;
    totalVolumeUsed?: number;
    totalVolumeAvailable?: number;
    volumeUtilizationPercentage?: number;
    usedControlMode?: BatchPlanControlMode;
    effectiveMmqMultiplier?: number;
    actualTotalWeight?: number;
    achievedAverageCoverage?: number;
    fixedProductsCount?: number;
    optimizedProductsCount?: number;
}

export enum BatchPlanControlMode {
    MmqMultiplier = "MmqMultiplier",
    TotalWeight = "TotalWeight",
    TargetDaysCoverage = "TargetDaysCoverage",
}

export class CalculateBatchPlanRequest implements ICalculateBatchPlanRequest {
    productCode!: string;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    timePeriod?: TimePeriod | undefined;
    salesMultiplier?: number | undefined;
    ndCoverageFactor?: number | undefined;
    controlMode?: BatchPlanControlMode;
    mmqMultiplier?: number | undefined;
    totalWeightToUse?: number | undefined;
    targetDaysCoverage?: number | undefined;
    productConstraints?: ProductSizeConstraint[];
    directSemiproductAmount?: number | undefined;
    manufactureType?: ManufactureType | undefined;

    constructor(data?: ICalculateBatchPlanRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.timePeriod = _data["timePeriod"];
            this.salesMultiplier = _data["salesMultiplier"];
            this.ndCoverageFactor = _data["ndCoverageFactor"];
            this.controlMode = _data["controlMode"];
            this.mmqMultiplier = _data["mmqMultiplier"];
            this.totalWeightToUse = _data["totalWeightToUse"];
            this.targetDaysCoverage = _data["targetDaysCoverage"];
            if (Array.isArray(_data["productConstraints"])) {
                this.productConstraints = [] as any;
                for (let item of _data["productConstraints"])
                    this.productConstraints!.push(ProductSizeConstraint.fromJS(item));
            }
            this.directSemiproductAmount = _data["directSemiproductAmount"];
            this.manufactureType = _data["manufactureType"];
        }
    }

    static fromJS(data: any): CalculateBatchPlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateBatchPlanRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["timePeriod"] = this.timePeriod;
        data["salesMultiplier"] = this.salesMultiplier;
        data["ndCoverageFactor"] = this.ndCoverageFactor;
        data["controlMode"] = this.controlMode;
        data["mmqMultiplier"] = this.mmqMultiplier;
        data["totalWeightToUse"] = this.totalWeightToUse;
        data["targetDaysCoverage"] = this.targetDaysCoverage;
        if (Array.isArray(this.productConstraints)) {
            data["productConstraints"] = [];
            for (let item of this.productConstraints)
                data["productConstraints"].push(item.toJSON());
        }
        data["directSemiproductAmount"] = this.directSemiproductAmount;
        data["manufactureType"] = this.manufactureType;
        return data;
    }
}

export interface ICalculateBatchPlanRequest {
    productCode: string;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    timePeriod?: TimePeriod | undefined;
    salesMultiplier?: number | undefined;
    ndCoverageFactor?: number | undefined;
    controlMode?: BatchPlanControlMode;
    mmqMultiplier?: number | undefined;
    totalWeightToUse?: number | undefined;
    targetDaysCoverage?: number | undefined;
    productConstraints?: ProductSizeConstraint[];
    directSemiproductAmount?: number | undefined;
    manufactureType?: ManufactureType | undefined;
}

export enum TimePeriod {
    PreviousQuarter = "PreviousQuarter",
    FutureQuarter = "FutureQuarter",
    Y2Y = "Y2Y",
    PreviousSeason = "PreviousSeason",
    Q9M = "Q9M",
    CustomPeriod = "CustomPeriod",
}

export class ProductSizeConstraint implements IProductSizeConstraint {
    productCode?: string;
    isFixed?: boolean;
    fixedQuantity?: number | undefined;

    constructor(data?: IProductSizeConstraint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.isFixed = _data["isFixed"];
            this.fixedQuantity = _data["fixedQuantity"];
        }
    }

    static fromJS(data: any): ProductSizeConstraint {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSizeConstraint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["isFixed"] = this.isFixed;
        data["fixedQuantity"] = this.fixedQuantity;
        return data;
    }
}

export interface IProductSizeConstraint {
    productCode?: string;
    isFixed?: boolean;
    fixedQuantity?: number | undefined;
}

export class GetManufacturedInventoryResponse extends BaseResponse implements IGetManufacturedInventoryResponse {
    items?: ManufacturedProductInventoryItemDto[];
    totalCount?: number;

    constructor(data?: IGetManufacturedInventoryResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ManufacturedProductInventoryItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static override fromJS(data: any): GetManufacturedInventoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturedInventoryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        super.toJSON(data);
        return data;
    }
}

export interface IGetManufacturedInventoryResponse extends IBaseResponse {
    items?: ManufacturedProductInventoryItemDto[];
    totalCount?: number;
}

export class ManufacturedProductInventoryItemDto implements IManufacturedProductInventoryItemDto {
    id?: number;
    productCode?: string;
    productName?: string;
    lotNumber?: string | undefined;
    expirationDate?: Date | undefined;
    amount?: number;
    manufactureOrderId?: number | undefined;
    createdAt?: Date;
    createdBy?: string;
    lastModifiedAt?: Date | undefined;
    lastModifiedBy?: string | undefined;
    log?: ManufacturedProductInventoryLogDto[];

    constructor(data?: IManufacturedProductInventoryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.lotNumber = _data["lotNumber"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.manufactureOrderId = _data["manufactureOrderId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            if (Array.isArray(_data["log"])) {
                this.log = [] as any;
                for (let item of _data["log"])
                    this.log!.push(ManufacturedProductInventoryLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ManufacturedProductInventoryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturedProductInventoryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["lotNumber"] = this.lotNumber;
        data["expirationDate"] = this.expirationDate ? formatDate(this.expirationDate) : <any>undefined;
        data["amount"] = this.amount;
        data["manufactureOrderId"] = this.manufactureOrderId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        if (Array.isArray(this.log)) {
            data["log"] = [];
            for (let item of this.log)
                data["log"].push(item.toJSON());
        }
        return data;
    }
}

export interface IManufacturedProductInventoryItemDto {
    id?: number;
    productCode?: string;
    productName?: string;
    lotNumber?: string | undefined;
    expirationDate?: Date | undefined;
    amount?: number;
    manufactureOrderId?: number | undefined;
    createdAt?: Date;
    createdBy?: string;
    lastModifiedAt?: Date | undefined;
    lastModifiedBy?: string | undefined;
    log?: ManufacturedProductInventoryLogDto[];
}

export class ManufacturedProductInventoryLogDto implements IManufacturedProductInventoryLogDto {
    id?: number;
    inventoryItemId?: number;
    changeType?: InventoryChangeType;
    amountDelta?: number;
    amountAfter?: number;
    referenceType?: string | undefined;
    referenceId?: string | undefined;
    note?: string | undefined;
    timestamp?: Date;
    user?: string;

    constructor(data?: IManufacturedProductInventoryLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inventoryItemId = _data["inventoryItemId"];
            this.changeType = _data["changeType"];
            this.amountDelta = _data["amountDelta"];
            this.amountAfter = _data["amountAfter"];
            this.referenceType = _data["referenceType"];
            this.referenceId = _data["referenceId"];
            this.note = _data["note"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.user = _data["user"];
        }
    }

    static fromJS(data: any): ManufacturedProductInventoryLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturedProductInventoryLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inventoryItemId"] = this.inventoryItemId;
        data["changeType"] = this.changeType;
        data["amountDelta"] = this.amountDelta;
        data["amountAfter"] = this.amountAfter;
        data["referenceType"] = this.referenceType;
        data["referenceId"] = this.referenceId;
        data["note"] = this.note;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["user"] = this.user;
        return data;
    }
}

export interface IManufacturedProductInventoryLogDto {
    id?: number;
    inventoryItemId?: number;
    changeType?: InventoryChangeType;
    amountDelta?: number;
    amountAfter?: number;
    referenceType?: string | undefined;
    referenceId?: string | undefined;
    note?: string | undefined;
    timestamp?: Date;
    user?: string;
}

export enum InventoryChangeType {
    InitialWriteDown = "InitialWriteDown",
    ConsumedByTransportBox = "ConsumedByTransportBox",
    RestoredFromTransportBox = "RestoredFromTransportBox",
    ManualAdjustment = "ManualAdjustment",
    ManualRemoval = "ManualRemoval",
    ManualAddition = "ManualAddition",
}

export class CreateManufacturedInventoryItemResponse extends BaseResponse implements ICreateManufacturedInventoryItemResponse {
    item?: ManufacturedProductInventoryItemDto | undefined;

    constructor(data?: ICreateManufacturedInventoryItemResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.item = _data["item"] ? ManufacturedProductInventoryItemDto.fromJS(_data["item"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CreateManufacturedInventoryItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManufacturedInventoryItemResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateManufacturedInventoryItemResponse extends IBaseResponse {
    item?: ManufacturedProductInventoryItemDto | undefined;
}

export class CreateManufacturedInventoryItemRequest implements ICreateManufacturedInventoryItemRequest {
    productCode?: string;
    productName?: string;
    amount?: number;
    lotNumber?: string | undefined;
    expirationDate?: Date | undefined;
    manufactureOrderId?: number | undefined;

    constructor(data?: ICreateManufacturedInventoryItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.amount = _data["amount"];
            this.lotNumber = _data["lotNumber"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.manufactureOrderId = _data["manufactureOrderId"];
        }
    }

    static fromJS(data: any): CreateManufacturedInventoryItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManufacturedInventoryItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["amount"] = this.amount;
        data["lotNumber"] = this.lotNumber;
        data["expirationDate"] = this.expirationDate ? formatDate(this.expirationDate) : <any>undefined;
        data["manufactureOrderId"] = this.manufactureOrderId;
        return data;
    }
}

export interface ICreateManufacturedInventoryItemRequest {
    productCode?: string;
    productName?: string;
    amount?: number;
    lotNumber?: string | undefined;
    expirationDate?: Date | undefined;
    manufactureOrderId?: number | undefined;
}

export class UpdateManufacturedInventoryItemResponse extends BaseResponse implements IUpdateManufacturedInventoryItemResponse {
    item?: ManufacturedProductInventoryItemDto | undefined;

    constructor(data?: IUpdateManufacturedInventoryItemResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.item = _data["item"] ? ManufacturedProductInventoryItemDto.fromJS(_data["item"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): UpdateManufacturedInventoryItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateManufacturedInventoryItemResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateManufacturedInventoryItemResponse extends IBaseResponse {
    item?: ManufacturedProductInventoryItemDto | undefined;
}

export class UpdateManufacturedInventoryItemBody implements IUpdateManufacturedInventoryItemBody {
    newAmount?: number;
    note?: string | undefined;

    constructor(data?: IUpdateManufacturedInventoryItemBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newAmount = _data["newAmount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateManufacturedInventoryItemBody {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateManufacturedInventoryItemBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newAmount"] = this.newAmount;
        data["note"] = this.note;
        return data;
    }
}

export interface IUpdateManufacturedInventoryItemBody {
    newAmount?: number;
    note?: string | undefined;
}

export class DeleteManufacturedInventoryItemResponse extends BaseResponse implements IDeleteManufacturedInventoryItemResponse {

    constructor(data?: IDeleteManufacturedInventoryItemResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DeleteManufacturedInventoryItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteManufacturedInventoryItemResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteManufacturedInventoryItemResponse extends IBaseResponse {
}

export class GetManufactureOrdersResponse extends BaseResponse implements IGetManufactureOrdersResponse {
    orders?: ManufactureOrderDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;

    constructor(data?: IGetManufactureOrdersResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(ManufactureOrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static override fromJS(data: any): GetManufactureOrdersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufactureOrdersResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        super.toJSON(data);
        return data;
    }
}

export interface IGetManufactureOrdersResponse extends IBaseResponse {
    orders?: ManufactureOrderDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class ManufactureOrderDto implements IManufactureOrderDto {
    id?: number;
    orderNumber?: string;
    erpOrderNumberSemiproduct?: string | undefined;
    erpOrderNumberSemiproductDate?: Date | undefined;
    erpOrderNumberProduct?: string | undefined;
    erpOrderNumberProductDate?: Date | undefined;
    erpDiscardResidueDocumentNumber?: string | undefined;
    erpDiscardResidueDocumentNumberDate?: Date | undefined;
    docMaterialIssueForSemiProduct?: string | undefined;
    docMaterialIssueForSemiProductDate?: Date | undefined;
    docSemiProductReceipt?: string | undefined;
    docSemiProductReceiptDate?: Date | undefined;
    docSemiProductIssueForProduct?: string | undefined;
    docSemiProductIssueForProductDate?: Date | undefined;
    docMaterialIssueForProduct?: string | undefined;
    docMaterialIssueForProductDate?: Date | undefined;
    docProductReceipt?: string | undefined;
    docProductReceiptDate?: Date | undefined;
    createdDate?: Date;
    createdByUser?: string;
    responsiblePerson?: string | undefined;
    plannedDate?: Date;
    manufactureType?: ManufactureType;
    state?: ManufactureOrderState;
    stateChangedAt?: Date;
    manualActionRequired?: boolean;
    weightWithinTolerance?: boolean | undefined;
    weightDifference?: number | undefined;
    stateChangedByUser?: string;
    semiProduct?: ManufactureOrderSemiProductDto | undefined;
    products?: ManufactureOrderProductDto[];
    notes?: ManufactureOrderNoteDto[];
    conditionsReadings?: ManufactureOrderConditionsReadingDto[];

    constructor(data?: IManufactureOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.erpOrderNumberSemiproduct = _data["erpOrderNumberSemiproduct"];
            this.erpOrderNumberSemiproductDate = _data["erpOrderNumberSemiproductDate"] ? new Date(_data["erpOrderNumberSemiproductDate"].toString()) : <any>undefined;
            this.erpOrderNumberProduct = _data["erpOrderNumberProduct"];
            this.erpOrderNumberProductDate = _data["erpOrderNumberProductDate"] ? new Date(_data["erpOrderNumberProductDate"].toString()) : <any>undefined;
            this.erpDiscardResidueDocumentNumber = _data["erpDiscardResidueDocumentNumber"];
            this.erpDiscardResidueDocumentNumberDate = _data["erpDiscardResidueDocumentNumberDate"] ? new Date(_data["erpDiscardResidueDocumentNumberDate"].toString()) : <any>undefined;
            this.docMaterialIssueForSemiProduct = _data["docMaterialIssueForSemiProduct"];
            this.docMaterialIssueForSemiProductDate = _data["docMaterialIssueForSemiProductDate"] ? new Date(_data["docMaterialIssueForSemiProductDate"].toString()) : <any>undefined;
            this.docSemiProductReceipt = _data["docSemiProductReceipt"];
            this.docSemiProductReceiptDate = _data["docSemiProductReceiptDate"] ? new Date(_data["docSemiProductReceiptDate"].toString()) : <any>undefined;
            this.docSemiProductIssueForProduct = _data["docSemiProductIssueForProduct"];
            this.docSemiProductIssueForProductDate = _data["docSemiProductIssueForProductDate"] ? new Date(_data["docSemiProductIssueForProductDate"].toString()) : <any>undefined;
            this.docMaterialIssueForProduct = _data["docMaterialIssueForProduct"];
            this.docMaterialIssueForProductDate = _data["docMaterialIssueForProductDate"] ? new Date(_data["docMaterialIssueForProductDate"].toString()) : <any>undefined;
            this.docProductReceipt = _data["docProductReceipt"];
            this.docProductReceiptDate = _data["docProductReceiptDate"] ? new Date(_data["docProductReceiptDate"].toString()) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.createdByUser = _data["createdByUser"];
            this.responsiblePerson = _data["responsiblePerson"];
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : <any>undefined;
            this.manufactureType = _data["manufactureType"];
            this.state = _data["state"];
            this.stateChangedAt = _data["stateChangedAt"] ? new Date(_data["stateChangedAt"].toString()) : <any>undefined;
            this.manualActionRequired = _data["manualActionRequired"];
            this.weightWithinTolerance = _data["weightWithinTolerance"];
            this.weightDifference = _data["weightDifference"];
            this.stateChangedByUser = _data["stateChangedByUser"];
            this.semiProduct = _data["semiProduct"] ? ManufactureOrderSemiProductDto.fromJS(_data["semiProduct"]) : <any>undefined;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ManufactureOrderProductDto.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(ManufactureOrderNoteDto.fromJS(item));
            }
            if (Array.isArray(_data["conditionsReadings"])) {
                this.conditionsReadings = [] as any;
                for (let item of _data["conditionsReadings"])
                    this.conditionsReadings!.push(ManufactureOrderConditionsReadingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ManufactureOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufactureOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["erpOrderNumberSemiproduct"] = this.erpOrderNumberSemiproduct;
        data["erpOrderNumberSemiproductDate"] = this.erpOrderNumberSemiproductDate ? this.erpOrderNumberSemiproductDate.toISOString() : <any>undefined;
        data["erpOrderNumberProduct"] = this.erpOrderNumberProduct;
        data["erpOrderNumberProductDate"] = this.erpOrderNumberProductDate ? this.erpOrderNumberProductDate.toISOString() : <any>undefined;
        data["erpDiscardResidueDocumentNumber"] = this.erpDiscardResidueDocumentNumber;
        data["erpDiscardResidueDocumentNumberDate"] = this.erpDiscardResidueDocumentNumberDate ? this.erpDiscardResidueDocumentNumberDate.toISOString() : <any>undefined;
        data["docMaterialIssueForSemiProduct"] = this.docMaterialIssueForSemiProduct;
        data["docMaterialIssueForSemiProductDate"] = this.docMaterialIssueForSemiProductDate ? this.docMaterialIssueForSemiProductDate.toISOString() : <any>undefined;
        data["docSemiProductReceipt"] = this.docSemiProductReceipt;
        data["docSemiProductReceiptDate"] = this.docSemiProductReceiptDate ? this.docSemiProductReceiptDate.toISOString() : <any>undefined;
        data["docSemiProductIssueForProduct"] = this.docSemiProductIssueForProduct;
        data["docSemiProductIssueForProductDate"] = this.docSemiProductIssueForProductDate ? this.docSemiProductIssueForProductDate.toISOString() : <any>undefined;
        data["docMaterialIssueForProduct"] = this.docMaterialIssueForProduct;
        data["docMaterialIssueForProductDate"] = this.docMaterialIssueForProductDate ? this.docMaterialIssueForProductDate.toISOString() : <any>undefined;
        data["docProductReceipt"] = this.docProductReceipt;
        data["docProductReceiptDate"] = this.docProductReceiptDate ? this.docProductReceiptDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdByUser"] = this.createdByUser;
        data["responsiblePerson"] = this.responsiblePerson;
        data["plannedDate"] = this.plannedDate ? formatDate(this.plannedDate) : <any>undefined;
        data["manufactureType"] = this.manufactureType;
        data["state"] = this.state;
        data["stateChangedAt"] = this.stateChangedAt ? this.stateChangedAt.toISOString() : <any>undefined;
        data["manualActionRequired"] = this.manualActionRequired;
        data["weightWithinTolerance"] = this.weightWithinTolerance;
        data["weightDifference"] = this.weightDifference;
        data["stateChangedByUser"] = this.stateChangedByUser;
        data["semiProduct"] = this.semiProduct ? this.semiProduct.toJSON() : <any>undefined;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (Array.isArray(this.conditionsReadings)) {
            data["conditionsReadings"] = [];
            for (let item of this.conditionsReadings)
                data["conditionsReadings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IManufactureOrderDto {
    id?: number;
    orderNumber?: string;
    erpOrderNumberSemiproduct?: string | undefined;
    erpOrderNumberSemiproductDate?: Date | undefined;
    erpOrderNumberProduct?: string | undefined;
    erpOrderNumberProductDate?: Date | undefined;
    erpDiscardResidueDocumentNumber?: string | undefined;
    erpDiscardResidueDocumentNumberDate?: Date | undefined;
    docMaterialIssueForSemiProduct?: string | undefined;
    docMaterialIssueForSemiProductDate?: Date | undefined;
    docSemiProductReceipt?: string | undefined;
    docSemiProductReceiptDate?: Date | undefined;
    docSemiProductIssueForProduct?: string | undefined;
    docSemiProductIssueForProductDate?: Date | undefined;
    docMaterialIssueForProduct?: string | undefined;
    docMaterialIssueForProductDate?: Date | undefined;
    docProductReceipt?: string | undefined;
    docProductReceiptDate?: Date | undefined;
    createdDate?: Date;
    createdByUser?: string;
    responsiblePerson?: string | undefined;
    plannedDate?: Date;
    manufactureType?: ManufactureType;
    state?: ManufactureOrderState;
    stateChangedAt?: Date;
    manualActionRequired?: boolean;
    weightWithinTolerance?: boolean | undefined;
    weightDifference?: number | undefined;
    stateChangedByUser?: string;
    semiProduct?: ManufactureOrderSemiProductDto | undefined;
    products?: ManufactureOrderProductDto[];
    notes?: ManufactureOrderNoteDto[];
    conditionsReadings?: ManufactureOrderConditionsReadingDto[];
}

export enum ManufactureOrderState {
    Draft = "Draft",
    Planned = "Planned",
    SemiProductManufactured = "SemiProductManufactured",
    Completed = "Completed",
    Cancelled = "Cancelled",
}

export class ManufactureOrderSemiProductDto implements IManufactureOrderSemiProductDto {
    id?: number;
    productCode?: string;
    productName?: string;
    plannedQuantity?: number;
    actualQuantity?: number | undefined;
    batchMultiplier?: number;
    lotNumber?: string | undefined;
    expirationDate?: Date | undefined;
    expirationMonths?: number;

    constructor(data?: IManufactureOrderSemiProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.plannedQuantity = _data["plannedQuantity"];
            this.actualQuantity = _data["actualQuantity"];
            this.batchMultiplier = _data["batchMultiplier"];
            this.lotNumber = _data["lotNumber"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.expirationMonths = _data["expirationMonths"];
        }
    }

    static fromJS(data: any): ManufactureOrderSemiProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufactureOrderSemiProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["plannedQuantity"] = this.plannedQuantity;
        data["actualQuantity"] = this.actualQuantity;
        data["batchMultiplier"] = this.batchMultiplier;
        data["lotNumber"] = this.lotNumber;
        data["expirationDate"] = this.expirationDate ? formatDate(this.expirationDate) : <any>undefined;
        data["expirationMonths"] = this.expirationMonths;
        return data;
    }
}

export interface IManufactureOrderSemiProductDto {
    id?: number;
    productCode?: string;
    productName?: string;
    plannedQuantity?: number;
    actualQuantity?: number | undefined;
    batchMultiplier?: number;
    lotNumber?: string | undefined;
    expirationDate?: Date | undefined;
    expirationMonths?: number;
}

export class ManufactureOrderProductDto implements IManufactureOrderProductDto {
    id?: number;
    productCode?: string;
    productName?: string;
    semiProductCode?: string;
    plannedQuantity?: number;
    actualQuantity?: number | undefined;

    constructor(data?: IManufactureOrderProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.semiProductCode = _data["semiProductCode"];
            this.plannedQuantity = _data["plannedQuantity"];
            this.actualQuantity = _data["actualQuantity"];
        }
    }

    static fromJS(data: any): ManufactureOrderProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufactureOrderProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["semiProductCode"] = this.semiProductCode;
        data["plannedQuantity"] = this.plannedQuantity;
        data["actualQuantity"] = this.actualQuantity;
        return data;
    }
}

export interface IManufactureOrderProductDto {
    id?: number;
    productCode?: string;
    productName?: string;
    semiProductCode?: string;
    plannedQuantity?: number;
    actualQuantity?: number | undefined;
}

export class ManufactureOrderNoteDto implements IManufactureOrderNoteDto {
    id?: number;
    text?: string;
    createdAt?: Date;
    createdByUser?: string;

    constructor(data?: IManufactureOrderNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdByUser = _data["createdByUser"];
        }
    }

    static fromJS(data: any): ManufactureOrderNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufactureOrderNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdByUser"] = this.createdByUser;
        return data;
    }
}

export interface IManufactureOrderNoteDto {
    id?: number;
    text?: string;
    createdAt?: Date;
    createdByUser?: string;
}

export class ManufactureOrderConditionsReadingDto implements IManufactureOrderConditionsReadingDto {
    id?: number;
    stage?: ManufactureOrderState;
    innerTemperature?: number | undefined;
    innerHumidity?: number | undefined;
    outerTemperature?: number | undefined;
    outerHumidity?: number | undefined;
    recordedAt?: Date;
    source?: number;

    constructor(data?: IManufactureOrderConditionsReadingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stage = _data["stage"];
            this.innerTemperature = _data["innerTemperature"];
            this.innerHumidity = _data["innerHumidity"];
            this.outerTemperature = _data["outerTemperature"];
            this.outerHumidity = _data["outerHumidity"];
            this.recordedAt = _data["recordedAt"] ? new Date(_data["recordedAt"].toString()) : <any>undefined;
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): ManufactureOrderConditionsReadingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufactureOrderConditionsReadingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stage"] = this.stage;
        data["innerTemperature"] = this.innerTemperature;
        data["innerHumidity"] = this.innerHumidity;
        data["outerTemperature"] = this.outerTemperature;
        data["outerHumidity"] = this.outerHumidity;
        data["recordedAt"] = this.recordedAt ? this.recordedAt.toISOString() : <any>undefined;
        data["source"] = this.source;
        return data;
    }
}

export interface IManufactureOrderConditionsReadingDto {
    id?: number;
    stage?: ManufactureOrderState;
    innerTemperature?: number | undefined;
    innerHumidity?: number | undefined;
    outerTemperature?: number | undefined;
    outerHumidity?: number | undefined;
    recordedAt?: Date;
    source?: number;
}

export class GetManufactureOrderResponse extends BaseResponse implements IGetManufactureOrderResponse {
    order?: ManufactureOrderDto | undefined;
    availableTransitions?: ManufactureOrderState[];

    constructor(data?: IGetManufactureOrderResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.order = _data["order"] ? ManufactureOrderDto.fromJS(_data["order"]) : <any>undefined;
            if (Array.isArray(_data["availableTransitions"])) {
                this.availableTransitions = [] as any;
                for (let item of _data["availableTransitions"])
                    this.availableTransitions!.push(item);
            }
        }
    }

    static override fromJS(data: any): GetManufactureOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufactureOrderResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        if (Array.isArray(this.availableTransitions)) {
            data["availableTransitions"] = [];
            for (let item of this.availableTransitions)
                data["availableTransitions"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetManufactureOrderResponse extends IBaseResponse {
    order?: ManufactureOrderDto | undefined;
    availableTransitions?: ManufactureOrderState[];
}

export class CreateManufactureOrderResponse extends BaseResponse implements ICreateManufactureOrderResponse {
    id?: number;
    orderNumber?: string;

    constructor(data?: ICreateManufactureOrderResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
        }
    }

    static override fromJS(data: any): CreateManufactureOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManufactureOrderResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateManufactureOrderResponse extends IBaseResponse {
    id?: number;
    orderNumber?: string;
}

export class CreateManufactureOrderRequest implements ICreateManufactureOrderRequest {
    productCode!: string;
    productName!: string;
    originalBatchSize!: number;
    newBatchSize!: number;
    scaleFactor!: number;
    products?: CreateManufactureOrderProductRequest[];
    plannedDate!: Date;
    responsiblePerson?: string | undefined;
    manufactureType?: ManufactureType;
    directSemiproductAmount?: number | undefined;

    constructor(data?: ICreateManufactureOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.originalBatchSize = _data["originalBatchSize"];
            this.newBatchSize = _data["newBatchSize"];
            this.scaleFactor = _data["scaleFactor"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(CreateManufactureOrderProductRequest.fromJS(item));
            }
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : <any>undefined;
            this.responsiblePerson = _data["responsiblePerson"];
            this.manufactureType = _data["manufactureType"];
            this.directSemiproductAmount = _data["directSemiproductAmount"];
        }
    }

    static fromJS(data: any): CreateManufactureOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManufactureOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["originalBatchSize"] = this.originalBatchSize;
        data["newBatchSize"] = this.newBatchSize;
        data["scaleFactor"] = this.scaleFactor;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["plannedDate"] = this.plannedDate ? formatDate(this.plannedDate) : <any>undefined;
        data["responsiblePerson"] = this.responsiblePerson;
        data["manufactureType"] = this.manufactureType;
        data["directSemiproductAmount"] = this.directSemiproductAmount;
        return data;
    }
}

export interface ICreateManufactureOrderRequest {
    productCode: string;
    productName: string;
    originalBatchSize: number;
    newBatchSize: number;
    scaleFactor: number;
    products?: CreateManufactureOrderProductRequest[];
    plannedDate: Date;
    responsiblePerson?: string | undefined;
    manufactureType?: ManufactureType;
    directSemiproductAmount?: number | undefined;
}

export class CreateManufactureOrderProductRequest implements ICreateManufactureOrderProductRequest {
    productCode!: string;
    productName!: string;
    plannedQuantity!: number;

    constructor(data?: ICreateManufactureOrderProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.plannedQuantity = _data["plannedQuantity"];
        }
    }

    static fromJS(data: any): CreateManufactureOrderProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManufactureOrderProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["plannedQuantity"] = this.plannedQuantity;
        return data;
    }
}

export interface ICreateManufactureOrderProductRequest {
    productCode: string;
    productName: string;
    plannedQuantity: number;
}

export class UpdateManufactureOrderResponse extends BaseResponse implements IUpdateManufactureOrderResponse {
    order?: UpdateManufactureOrderDto | undefined;

    constructor(data?: IUpdateManufactureOrderResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.order = _data["order"] ? UpdateManufactureOrderDto.fromJS(_data["order"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): UpdateManufactureOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateManufactureOrderResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateManufactureOrderResponse extends IBaseResponse {
    order?: UpdateManufactureOrderDto | undefined;
}

export class UpdateManufactureOrderDto implements IUpdateManufactureOrderDto {
    id?: number;
    orderNumber?: string;
    createdDate?: Date;
    createdByUser?: string;
    responsiblePerson?: string | undefined;
    plannedDate?: Date;
    manufactureType?: ManufactureType;
    state?: string;
    stateChangedAt?: Date;
    stateChangedByUser?: string;
    semiProduct?: UpdateManufactureOrderSemiProductDto | undefined;
    products?: UpdateManufactureOrderProductDto[];
    notes?: UpdateManufactureOrderNoteDto[];

    constructor(data?: IUpdateManufactureOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.createdByUser = _data["createdByUser"];
            this.responsiblePerson = _data["responsiblePerson"];
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : <any>undefined;
            this.manufactureType = _data["manufactureType"];
            this.state = _data["state"];
            this.stateChangedAt = _data["stateChangedAt"] ? new Date(_data["stateChangedAt"].toString()) : <any>undefined;
            this.stateChangedByUser = _data["stateChangedByUser"];
            this.semiProduct = _data["semiProduct"] ? UpdateManufactureOrderSemiProductDto.fromJS(_data["semiProduct"]) : <any>undefined;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(UpdateManufactureOrderProductDto.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(UpdateManufactureOrderNoteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateManufactureOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateManufactureOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdByUser"] = this.createdByUser;
        data["responsiblePerson"] = this.responsiblePerson;
        data["plannedDate"] = this.plannedDate ? formatDate(this.plannedDate) : <any>undefined;
        data["manufactureType"] = this.manufactureType;
        data["state"] = this.state;
        data["stateChangedAt"] = this.stateChangedAt ? this.stateChangedAt.toISOString() : <any>undefined;
        data["stateChangedByUser"] = this.stateChangedByUser;
        data["semiProduct"] = this.semiProduct ? this.semiProduct.toJSON() : <any>undefined;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateManufactureOrderDto {
    id?: number;
    orderNumber?: string;
    createdDate?: Date;
    createdByUser?: string;
    responsiblePerson?: string | undefined;
    plannedDate?: Date;
    manufactureType?: ManufactureType;
    state?: string;
    stateChangedAt?: Date;
    stateChangedByUser?: string;
    semiProduct?: UpdateManufactureOrderSemiProductDto | undefined;
    products?: UpdateManufactureOrderProductDto[];
    notes?: UpdateManufactureOrderNoteDto[];
}

export class UpdateManufactureOrderSemiProductDto implements IUpdateManufactureOrderSemiProductDto {
    id?: number;
    productCode?: string;
    productName?: string;
    plannedQuantity?: number;
    actualQuantity?: number | undefined;
    lotNumber?: string | undefined;
    expirationDate?: Date | undefined;

    constructor(data?: IUpdateManufactureOrderSemiProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.plannedQuantity = _data["plannedQuantity"];
            this.actualQuantity = _data["actualQuantity"];
            this.lotNumber = _data["lotNumber"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateManufactureOrderSemiProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateManufactureOrderSemiProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["plannedQuantity"] = this.plannedQuantity;
        data["actualQuantity"] = this.actualQuantity;
        data["lotNumber"] = this.lotNumber;
        data["expirationDate"] = this.expirationDate ? formatDate(this.expirationDate) : <any>undefined;
        return data;
    }
}

export interface IUpdateManufactureOrderSemiProductDto {
    id?: number;
    productCode?: string;
    productName?: string;
    plannedQuantity?: number;
    actualQuantity?: number | undefined;
    lotNumber?: string | undefined;
    expirationDate?: Date | undefined;
}

export class UpdateManufactureOrderProductDto implements IUpdateManufactureOrderProductDto {
    id?: number;
    productCode?: string;
    productName?: string;
    semiProductCode?: string;
    plannedQuantity?: number;
    actualQuantity?: number | undefined;

    constructor(data?: IUpdateManufactureOrderProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.semiProductCode = _data["semiProductCode"];
            this.plannedQuantity = _data["plannedQuantity"];
            this.actualQuantity = _data["actualQuantity"];
        }
    }

    static fromJS(data: any): UpdateManufactureOrderProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateManufactureOrderProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["semiProductCode"] = this.semiProductCode;
        data["plannedQuantity"] = this.plannedQuantity;
        data["actualQuantity"] = this.actualQuantity;
        return data;
    }
}

export interface IUpdateManufactureOrderProductDto {
    id?: number;
    productCode?: string;
    productName?: string;
    semiProductCode?: string;
    plannedQuantity?: number;
    actualQuantity?: number | undefined;
}

export class UpdateManufactureOrderNoteDto implements IUpdateManufactureOrderNoteDto {
    id?: number;
    text?: string;
    createdAt?: Date;
    createdByUser?: string;

    constructor(data?: IUpdateManufactureOrderNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdByUser = _data["createdByUser"];
        }
    }

    static fromJS(data: any): UpdateManufactureOrderNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateManufactureOrderNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdByUser"] = this.createdByUser;
        return data;
    }
}

export interface IUpdateManufactureOrderNoteDto {
    id?: number;
    text?: string;
    createdAt?: Date;
    createdByUser?: string;
}

export class UpdateManufactureOrderRequest implements IUpdateManufactureOrderRequest {
    id!: number;
    plannedDate?: Date | undefined;
    responsiblePerson?: string | undefined;
    erpOrderNumberSemiproduct?: string | undefined;
    erpOrderNumberProduct?: string | undefined;
    erpDiscardResidueDocumentNumber?: string | undefined;
    semiProduct?: UpdateManufactureOrderSemiProductRequest | undefined;
    products?: UpdateManufactureOrderProductRequest[];
    newNote?: string | undefined;
    manualActionRequired?: boolean | undefined;

    constructor(data?: IUpdateManufactureOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : <any>undefined;
            this.responsiblePerson = _data["responsiblePerson"];
            this.erpOrderNumberSemiproduct = _data["erpOrderNumberSemiproduct"];
            this.erpOrderNumberProduct = _data["erpOrderNumberProduct"];
            this.erpDiscardResidueDocumentNumber = _data["erpDiscardResidueDocumentNumber"];
            this.semiProduct = _data["semiProduct"] ? UpdateManufactureOrderSemiProductRequest.fromJS(_data["semiProduct"]) : <any>undefined;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(UpdateManufactureOrderProductRequest.fromJS(item));
            }
            this.newNote = _data["newNote"];
            this.manualActionRequired = _data["manualActionRequired"];
        }
    }

    static fromJS(data: any): UpdateManufactureOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateManufactureOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plannedDate"] = this.plannedDate ? formatDate(this.plannedDate) : <any>undefined;
        data["responsiblePerson"] = this.responsiblePerson;
        data["erpOrderNumberSemiproduct"] = this.erpOrderNumberSemiproduct;
        data["erpOrderNumberProduct"] = this.erpOrderNumberProduct;
        data["erpDiscardResidueDocumentNumber"] = this.erpDiscardResidueDocumentNumber;
        data["semiProduct"] = this.semiProduct ? this.semiProduct.toJSON() : <any>undefined;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["newNote"] = this.newNote;
        data["manualActionRequired"] = this.manualActionRequired;
        return data;
    }
}

export interface IUpdateManufactureOrderRequest {
    id: number;
    plannedDate?: Date | undefined;
    responsiblePerson?: string | undefined;
    erpOrderNumberSemiproduct?: string | undefined;
    erpOrderNumberProduct?: string | undefined;
    erpDiscardResidueDocumentNumber?: string | undefined;
    semiProduct?: UpdateManufactureOrderSemiProductRequest | undefined;
    products?: UpdateManufactureOrderProductRequest[];
    newNote?: string | undefined;
    manualActionRequired?: boolean | undefined;
}

export class UpdateManufactureOrderSemiProductRequest implements IUpdateManufactureOrderSemiProductRequest {
    plannedQuantity?: number | undefined;
    lotNumber?: string | undefined;
    expirationDate?: Date | undefined;
    actualQuantity?: number | undefined;

    constructor(data?: IUpdateManufactureOrderSemiProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedQuantity = _data["plannedQuantity"];
            this.lotNumber = _data["lotNumber"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.actualQuantity = _data["actualQuantity"];
        }
    }

    static fromJS(data: any): UpdateManufactureOrderSemiProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateManufactureOrderSemiProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedQuantity"] = this.plannedQuantity;
        data["lotNumber"] = this.lotNumber;
        data["expirationDate"] = this.expirationDate ? formatDate(this.expirationDate) : <any>undefined;
        data["actualQuantity"] = this.actualQuantity;
        return data;
    }
}

export interface IUpdateManufactureOrderSemiProductRequest {
    plannedQuantity?: number | undefined;
    lotNumber?: string | undefined;
    expirationDate?: Date | undefined;
    actualQuantity?: number | undefined;
}

export class UpdateManufactureOrderProductRequest implements IUpdateManufactureOrderProductRequest {
    id?: number | undefined;
    productCode?: string | undefined;
    productName?: string | undefined;
    plannedQuantity?: number | undefined;
    actualQuantity?: number | undefined;

    constructor(data?: IUpdateManufactureOrderProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.plannedQuantity = _data["plannedQuantity"];
            this.actualQuantity = _data["actualQuantity"];
        }
    }

    static fromJS(data: any): UpdateManufactureOrderProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateManufactureOrderProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["plannedQuantity"] = this.plannedQuantity;
        data["actualQuantity"] = this.actualQuantity;
        return data;
    }
}

export interface IUpdateManufactureOrderProductRequest {
    id?: number | undefined;
    productCode?: string | undefined;
    productName?: string | undefined;
    plannedQuantity?: number | undefined;
    actualQuantity?: number | undefined;
}

export class UpdateManufactureOrderStatusResponse extends BaseResponse implements IUpdateManufactureOrderStatusResponse {
    oldState?: string | undefined;
    newState?: string | undefined;
    stateChangedAt?: Date;
    stateChangedByUser?: string | undefined;

    constructor(data?: IUpdateManufactureOrderStatusResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.oldState = _data["oldState"];
            this.newState = _data["newState"];
            this.stateChangedAt = _data["stateChangedAt"] ? new Date(_data["stateChangedAt"].toString()) : <any>undefined;
            this.stateChangedByUser = _data["stateChangedByUser"];
        }
    }

    static override fromJS(data: any): UpdateManufactureOrderStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateManufactureOrderStatusResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldState"] = this.oldState;
        data["newState"] = this.newState;
        data["stateChangedAt"] = this.stateChangedAt ? this.stateChangedAt.toISOString() : <any>undefined;
        data["stateChangedByUser"] = this.stateChangedByUser;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateManufactureOrderStatusResponse extends IBaseResponse {
    oldState?: string | undefined;
    newState?: string | undefined;
    stateChangedAt?: Date;
    stateChangedByUser?: string | undefined;
}

export class UpdateManufactureOrderStatusRequest implements IUpdateManufactureOrderStatusRequest {
    id!: number;
    newState!: ManufactureOrderState;
    changeReason?: string | undefined;
    note?: string | undefined;
    manualActionRequired?: boolean | undefined;
    semiProductOrderCode?: string | undefined;
    productOrderCode?: string | undefined;
    weightWithinTolerance?: boolean | undefined;
    weightDifference?: number | undefined;
    flexiDocMaterialIssueForSemiProduct?: string | undefined;
    flexiDocSemiProductReceipt?: string | undefined;
    flexiDocSemiProductIssueForProduct?: string | undefined;
    flexiDocMaterialIssueForProduct?: string | undefined;
    flexiDocProductReceipt?: string | undefined;

    constructor(data?: IUpdateManufactureOrderStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newState = _data["newState"];
            this.changeReason = _data["changeReason"];
            this.note = _data["note"];
            this.manualActionRequired = _data["manualActionRequired"];
            this.semiProductOrderCode = _data["semiProductOrderCode"];
            this.productOrderCode = _data["productOrderCode"];
            this.weightWithinTolerance = _data["weightWithinTolerance"];
            this.weightDifference = _data["weightDifference"];
            this.flexiDocMaterialIssueForSemiProduct = _data["flexiDocMaterialIssueForSemiProduct"];
            this.flexiDocSemiProductReceipt = _data["flexiDocSemiProductReceipt"];
            this.flexiDocSemiProductIssueForProduct = _data["flexiDocSemiProductIssueForProduct"];
            this.flexiDocMaterialIssueForProduct = _data["flexiDocMaterialIssueForProduct"];
            this.flexiDocProductReceipt = _data["flexiDocProductReceipt"];
        }
    }

    static fromJS(data: any): UpdateManufactureOrderStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateManufactureOrderStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newState"] = this.newState;
        data["changeReason"] = this.changeReason;
        data["note"] = this.note;
        data["manualActionRequired"] = this.manualActionRequired;
        data["semiProductOrderCode"] = this.semiProductOrderCode;
        data["productOrderCode"] = this.productOrderCode;
        data["weightWithinTolerance"] = this.weightWithinTolerance;
        data["weightDifference"] = this.weightDifference;
        data["flexiDocMaterialIssueForSemiProduct"] = this.flexiDocMaterialIssueForSemiProduct;
        data["flexiDocSemiProductReceipt"] = this.flexiDocSemiProductReceipt;
        data["flexiDocSemiProductIssueForProduct"] = this.flexiDocSemiProductIssueForProduct;
        data["flexiDocMaterialIssueForProduct"] = this.flexiDocMaterialIssueForProduct;
        data["flexiDocProductReceipt"] = this.flexiDocProductReceipt;
        return data;
    }
}

export interface IUpdateManufactureOrderStatusRequest {
    id: number;
    newState: ManufactureOrderState;
    changeReason?: string | undefined;
    note?: string | undefined;
    manualActionRequired?: boolean | undefined;
    semiProductOrderCode?: string | undefined;
    productOrderCode?: string | undefined;
    weightWithinTolerance?: boolean | undefined;
    weightDifference?: number | undefined;
    flexiDocMaterialIssueForSemiProduct?: string | undefined;
    flexiDocSemiProductReceipt?: string | undefined;
    flexiDocSemiProductIssueForProduct?: string | undefined;
    flexiDocMaterialIssueForProduct?: string | undefined;
    flexiDocProductReceipt?: string | undefined;
}

export class ConfirmSemiProductManufactureResponse extends BaseResponse implements IConfirmSemiProductManufactureResponse {
    message?: string | undefined;

    constructor(data?: IConfirmSemiProductManufactureResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.message = _data["message"];
        }
    }

    static override fromJS(data: any): ConfirmSemiProductManufactureResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmSemiProductManufactureResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }
}

export interface IConfirmSemiProductManufactureResponse extends IBaseResponse {
    message?: string | undefined;
}

export class ConfirmSemiProductManufactureRequest implements IConfirmSemiProductManufactureRequest {
    id!: number;
    actualQuantity!: number;
    changeReason?: string | undefined;

    constructor(data?: IConfirmSemiProductManufactureRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actualQuantity = _data["actualQuantity"];
            this.changeReason = _data["changeReason"];
        }
    }

    static fromJS(data: any): ConfirmSemiProductManufactureRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmSemiProductManufactureRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actualQuantity"] = this.actualQuantity;
        data["changeReason"] = this.changeReason;
        return data;
    }
}

export interface IConfirmSemiProductManufactureRequest {
    id: number;
    actualQuantity: number;
    changeReason?: string | undefined;
}

export class ConfirmProductCompletionResponse extends BaseResponse implements IConfirmProductCompletionResponse {
    message?: string | undefined;
    requiresConfirmation?: boolean;
    distribution?: ResidueDistributionDto | undefined;

    constructor(data?: IConfirmProductCompletionResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.message = _data["message"];
            this.requiresConfirmation = _data["requiresConfirmation"];
            this.distribution = _data["distribution"] ? ResidueDistributionDto.fromJS(_data["distribution"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ConfirmProductCompletionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmProductCompletionResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["requiresConfirmation"] = this.requiresConfirmation;
        data["distribution"] = this.distribution ? this.distribution.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IConfirmProductCompletionResponse extends IBaseResponse {
    message?: string | undefined;
    requiresConfirmation?: boolean;
    distribution?: ResidueDistributionDto | undefined;
}

export class ResidueDistributionDto implements IResidueDistributionDto {
    actualSemiProductQuantity?: number;
    theoreticalConsumption?: number;
    difference?: number;
    differencePercentage?: number;
    isWithinAllowedThreshold?: boolean;
    allowedResiduePercentage?: number;
    products?: ProductConsumptionDistributionDto[];

    constructor(data?: IResidueDistributionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actualSemiProductQuantity = _data["actualSemiProductQuantity"];
            this.theoreticalConsumption = _data["theoreticalConsumption"];
            this.difference = _data["difference"];
            this.differencePercentage = _data["differencePercentage"];
            this.isWithinAllowedThreshold = _data["isWithinAllowedThreshold"];
            this.allowedResiduePercentage = _data["allowedResiduePercentage"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductConsumptionDistributionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResidueDistributionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResidueDistributionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actualSemiProductQuantity"] = this.actualSemiProductQuantity;
        data["theoreticalConsumption"] = this.theoreticalConsumption;
        data["difference"] = this.difference;
        data["differencePercentage"] = this.differencePercentage;
        data["isWithinAllowedThreshold"] = this.isWithinAllowedThreshold;
        data["allowedResiduePercentage"] = this.allowedResiduePercentage;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResidueDistributionDto {
    actualSemiProductQuantity?: number;
    theoreticalConsumption?: number;
    difference?: number;
    differencePercentage?: number;
    isWithinAllowedThreshold?: boolean;
    allowedResiduePercentage?: number;
    products?: ProductConsumptionDistributionDto[];
}

export class ProductConsumptionDistributionDto implements IProductConsumptionDistributionDto {
    productCode?: string;
    productName?: string;
    actualPieces?: number;
    theoreticalGramsPerUnit?: number;
    theoreticalConsumption?: number;
    adjustedConsumption?: number;
    adjustedGramsPerUnit?: number;
    proportionRatio?: number;

    constructor(data?: IProductConsumptionDistributionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.actualPieces = _data["actualPieces"];
            this.theoreticalGramsPerUnit = _data["theoreticalGramsPerUnit"];
            this.theoreticalConsumption = _data["theoreticalConsumption"];
            this.adjustedConsumption = _data["adjustedConsumption"];
            this.adjustedGramsPerUnit = _data["adjustedGramsPerUnit"];
            this.proportionRatio = _data["proportionRatio"];
        }
    }

    static fromJS(data: any): ProductConsumptionDistributionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductConsumptionDistributionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["actualPieces"] = this.actualPieces;
        data["theoreticalGramsPerUnit"] = this.theoreticalGramsPerUnit;
        data["theoreticalConsumption"] = this.theoreticalConsumption;
        data["adjustedConsumption"] = this.adjustedConsumption;
        data["adjustedGramsPerUnit"] = this.adjustedGramsPerUnit;
        data["proportionRatio"] = this.proportionRatio;
        return data;
    }
}

export interface IProductConsumptionDistributionDto {
    productCode?: string;
    productName?: string;
    actualPieces?: number;
    theoreticalGramsPerUnit?: number;
    theoreticalConsumption?: number;
    adjustedConsumption?: number;
    adjustedGramsPerUnit?: number;
    proportionRatio?: number;
}

export class ConfirmProductCompletionRequest implements IConfirmProductCompletionRequest {
    id!: number;
    products!: ProductActualQuantityRequest[];
    overrideConfirmed?: boolean;
    changeReason?: string | undefined;

    constructor(data?: IConfirmProductCompletionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.products = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductActualQuantityRequest.fromJS(item));
            }
            this.overrideConfirmed = _data["overrideConfirmed"];
            this.changeReason = _data["changeReason"];
        }
    }

    static fromJS(data: any): ConfirmProductCompletionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmProductCompletionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["overrideConfirmed"] = this.overrideConfirmed;
        data["changeReason"] = this.changeReason;
        return data;
    }
}

export interface IConfirmProductCompletionRequest {
    id: number;
    products: ProductActualQuantityRequest[];
    overrideConfirmed?: boolean;
    changeReason?: string | undefined;
}

export class ProductActualQuantityRequest implements IProductActualQuantityRequest {
    id!: number;
    actualQuantity!: number;

    constructor(data?: IProductActualQuantityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actualQuantity = _data["actualQuantity"];
        }
    }

    static fromJS(data: any): ProductActualQuantityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProductActualQuantityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actualQuantity"] = this.actualQuantity;
        return data;
    }
}

export interface IProductActualQuantityRequest {
    id: number;
    actualQuantity: number;
}

export class GetCalendarViewResponse extends BaseResponse implements IGetCalendarViewResponse {
    events?: CalendarEventDto[];

    constructor(data?: IGetCalendarViewResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(CalendarEventDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetCalendarViewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarViewResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetCalendarViewResponse extends IBaseResponse {
    events?: CalendarEventDto[];
}

export class CalendarEventDto implements ICalendarEventDto {
    id?: number;
    orderNumber?: string;
    title?: string;
    date?: Date;
    manufactureType?: ManufactureType;
    state?: ManufactureOrderState;
    responsiblePerson?: string | undefined;
    manualActionRequired?: boolean;
    erpOrderNumberSemiproduct?: string | undefined;
    erpOrderNumberSemiproductDate?: Date | undefined;
    erpOrderNumberProduct?: string | undefined;
    erpOrderNumberProductDate?: Date | undefined;
    erpDiscardResidueDocumentNumber?: string | undefined;
    erpDiscardResidueDocumentNumberDate?: Date | undefined;
    weightWithinTolerance?: boolean | undefined;
    semiProduct?: CalendarEventSemiProductDto | undefined;
    products?: CalendarEventProductDto[];

    constructor(data?: ICalendarEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.title = _data["title"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.manufactureType = _data["manufactureType"];
            this.state = _data["state"];
            this.responsiblePerson = _data["responsiblePerson"];
            this.manualActionRequired = _data["manualActionRequired"];
            this.erpOrderNumberSemiproduct = _data["erpOrderNumberSemiproduct"];
            this.erpOrderNumberSemiproductDate = _data["erpOrderNumberSemiproductDate"] ? new Date(_data["erpOrderNumberSemiproductDate"].toString()) : <any>undefined;
            this.erpOrderNumberProduct = _data["erpOrderNumberProduct"];
            this.erpOrderNumberProductDate = _data["erpOrderNumberProductDate"] ? new Date(_data["erpOrderNumberProductDate"].toString()) : <any>undefined;
            this.erpDiscardResidueDocumentNumber = _data["erpDiscardResidueDocumentNumber"];
            this.erpDiscardResidueDocumentNumberDate = _data["erpDiscardResidueDocumentNumberDate"] ? new Date(_data["erpDiscardResidueDocumentNumberDate"].toString()) : <any>undefined;
            this.weightWithinTolerance = _data["weightWithinTolerance"];
            this.semiProduct = _data["semiProduct"] ? CalendarEventSemiProductDto.fromJS(_data["semiProduct"]) : <any>undefined;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(CalendarEventProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalendarEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["title"] = this.title;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["manufactureType"] = this.manufactureType;
        data["state"] = this.state;
        data["responsiblePerson"] = this.responsiblePerson;
        data["manualActionRequired"] = this.manualActionRequired;
        data["erpOrderNumberSemiproduct"] = this.erpOrderNumberSemiproduct;
        data["erpOrderNumberSemiproductDate"] = this.erpOrderNumberSemiproductDate ? this.erpOrderNumberSemiproductDate.toISOString() : <any>undefined;
        data["erpOrderNumberProduct"] = this.erpOrderNumberProduct;
        data["erpOrderNumberProductDate"] = this.erpOrderNumberProductDate ? this.erpOrderNumberProductDate.toISOString() : <any>undefined;
        data["erpDiscardResidueDocumentNumber"] = this.erpDiscardResidueDocumentNumber;
        data["erpDiscardResidueDocumentNumberDate"] = this.erpDiscardResidueDocumentNumberDate ? this.erpDiscardResidueDocumentNumberDate.toISOString() : <any>undefined;
        data["weightWithinTolerance"] = this.weightWithinTolerance;
        data["semiProduct"] = this.semiProduct ? this.semiProduct.toJSON() : <any>undefined;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalendarEventDto {
    id?: number;
    orderNumber?: string;
    title?: string;
    date?: Date;
    manufactureType?: ManufactureType;
    state?: ManufactureOrderState;
    responsiblePerson?: string | undefined;
    manualActionRequired?: boolean;
    erpOrderNumberSemiproduct?: string | undefined;
    erpOrderNumberSemiproductDate?: Date | undefined;
    erpOrderNumberProduct?: string | undefined;
    erpOrderNumberProductDate?: Date | undefined;
    erpDiscardResidueDocumentNumber?: string | undefined;
    erpDiscardResidueDocumentNumberDate?: Date | undefined;
    weightWithinTolerance?: boolean | undefined;
    semiProduct?: CalendarEventSemiProductDto | undefined;
    products?: CalendarEventProductDto[];
}

export class CalendarEventSemiProductDto implements ICalendarEventSemiProductDto {
    productCode?: string;
    productName?: string;
    plannedQuantity?: number;
    actualQuantity?: number | undefined;
    batchMultiplier?: number;

    constructor(data?: ICalendarEventSemiProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.plannedQuantity = _data["plannedQuantity"];
            this.actualQuantity = _data["actualQuantity"];
            this.batchMultiplier = _data["batchMultiplier"];
        }
    }

    static fromJS(data: any): CalendarEventSemiProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarEventSemiProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["plannedQuantity"] = this.plannedQuantity;
        data["actualQuantity"] = this.actualQuantity;
        data["batchMultiplier"] = this.batchMultiplier;
        return data;
    }
}

export interface ICalendarEventSemiProductDto {
    productCode?: string;
    productName?: string;
    plannedQuantity?: number;
    actualQuantity?: number | undefined;
    batchMultiplier?: number;
}

export class CalendarEventProductDto implements ICalendarEventProductDto {
    productCode?: string;
    productName?: string;
    plannedQuantity?: number;
    actualQuantity?: number | undefined;

    constructor(data?: ICalendarEventProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.plannedQuantity = _data["plannedQuantity"];
            this.actualQuantity = _data["actualQuantity"];
        }
    }

    static fromJS(data: any): CalendarEventProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarEventProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["plannedQuantity"] = this.plannedQuantity;
        data["actualQuantity"] = this.actualQuantity;
        return data;
    }
}

export interface ICalendarEventProductDto {
    productCode?: string;
    productName?: string;
    plannedQuantity?: number;
    actualQuantity?: number | undefined;
}

export class DuplicateManufactureOrderResponse extends BaseResponse implements IDuplicateManufactureOrderResponse {
    id?: number;
    orderNumber?: string | undefined;

    constructor(data?: IDuplicateManufactureOrderResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
        }
    }

    static override fromJS(data: any): DuplicateManufactureOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateManufactureOrderResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IDuplicateManufactureOrderResponse extends IBaseResponse {
    id?: number;
    orderNumber?: string | undefined;
}

export class ResolveManualActionResponse extends BaseResponse implements IResolveManualActionResponse {

    constructor(data?: IResolveManualActionResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResolveManualActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveManualActionResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResolveManualActionResponse extends IBaseResponse {
}

export class ResolveManualActionRequest implements IResolveManualActionRequest {
    orderId!: number;
    erpOrderNumberSemiproduct?: string | undefined;
    erpOrderNumberProduct?: string | undefined;
    erpDiscardResidueDocumentNumber?: string | undefined;
    note?: string | undefined;

    constructor(data?: IResolveManualActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.erpOrderNumberSemiproduct = _data["erpOrderNumberSemiproduct"];
            this.erpOrderNumberProduct = _data["erpOrderNumberProduct"];
            this.erpDiscardResidueDocumentNumber = _data["erpDiscardResidueDocumentNumber"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ResolveManualActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveManualActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["erpOrderNumberSemiproduct"] = this.erpOrderNumberSemiproduct;
        data["erpOrderNumberProduct"] = this.erpOrderNumberProduct;
        data["erpDiscardResidueDocumentNumber"] = this.erpDiscardResidueDocumentNumber;
        data["note"] = this.note;
        return data;
    }
}

export interface IResolveManualActionRequest {
    orderId: number;
    erpOrderNumberSemiproduct?: string | undefined;
    erpOrderNumberProduct?: string | undefined;
    erpDiscardResidueDocumentNumber?: string | undefined;
    note?: string | undefined;
}

export class GetManufactureProtocolResponse extends BaseResponse implements IGetManufactureProtocolResponse {
    pdfBytes?: string;
    fileName?: string;

    constructor(data?: IGetManufactureProtocolResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pdfBytes = _data["pdfBytes"];
            this.fileName = _data["fileName"];
        }
    }

    static override fromJS(data: any): GetManufactureProtocolResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufactureProtocolResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pdfBytes"] = this.pdfBytes;
        data["fileName"] = this.fileName;
        super.toJSON(data);
        return data;
    }
}

export interface IGetManufactureProtocolResponse extends IBaseResponse {
    pdfBytes?: string;
    fileName?: string;
}

export class UpdateManufactureOrderScheduleResponse extends BaseResponse implements IUpdateManufactureOrderScheduleResponse {
    message?: string | undefined;

    constructor(data?: IUpdateManufactureOrderScheduleResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.message = _data["message"];
        }
    }

    static override fromJS(data: any): UpdateManufactureOrderScheduleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateManufactureOrderScheduleResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateManufactureOrderScheduleResponse extends IBaseResponse {
    message?: string | undefined;
}

export class UpdateManufactureOrderScheduleRequest implements IUpdateManufactureOrderScheduleRequest {
    id!: number;
    plannedDate?: Date | undefined;
    changeReason?: string | undefined;

    constructor(data?: IUpdateManufactureOrderScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : <any>undefined;
            this.changeReason = _data["changeReason"];
        }
    }

    static fromJS(data: any): UpdateManufactureOrderScheduleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateManufactureOrderScheduleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plannedDate"] = this.plannedDate ? formatDate(this.plannedDate) : <any>undefined;
        data["changeReason"] = this.changeReason;
        return data;
    }
}

export interface IUpdateManufactureOrderScheduleRequest {
    id: number;
    plannedDate?: Date | undefined;
    changeReason?: string | undefined;
}

export class GetManufactureOutputResponse extends BaseResponse implements IGetManufactureOutputResponse {
    months?: ManufactureOutputMonth[];

    constructor(data?: IGetManufactureOutputResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["months"])) {
                this.months = [] as any;
                for (let item of _data["months"])
                    this.months!.push(ManufactureOutputMonth.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetManufactureOutputResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufactureOutputResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.months)) {
            data["months"] = [];
            for (let item of this.months)
                data["months"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetManufactureOutputResponse extends IBaseResponse {
    months?: ManufactureOutputMonth[];
}

export class ManufactureOutputMonth implements IManufactureOutputMonth {
    month?: string;
    totalOutput?: number;
    products?: ProductContribution[];
    productionDetails?: ProductionDetail[];

    constructor(data?: IManufactureOutputMonth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.totalOutput = _data["totalOutput"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductContribution.fromJS(item));
            }
            if (Array.isArray(_data["productionDetails"])) {
                this.productionDetails = [] as any;
                for (let item of _data["productionDetails"])
                    this.productionDetails!.push(ProductionDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ManufactureOutputMonth {
        data = typeof data === 'object' ? data : {};
        let result = new ManufactureOutputMonth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["totalOutput"] = this.totalOutput;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (Array.isArray(this.productionDetails)) {
            data["productionDetails"] = [];
            for (let item of this.productionDetails)
                data["productionDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IManufactureOutputMonth {
    month?: string;
    totalOutput?: number;
    products?: ProductContribution[];
    productionDetails?: ProductionDetail[];
}

export class ProductContribution implements IProductContribution {
    productCode?: string;
    productName?: string;
    quantity?: number;
    difficulty?: number;
    weightedValue?: number;
    isNd?: boolean;

    constructor(data?: IProductContribution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.quantity = _data["quantity"];
            this.difficulty = _data["difficulty"];
            this.weightedValue = _data["weightedValue"];
            this.isNd = _data["isNd"];
        }
    }

    static fromJS(data: any): ProductContribution {
        data = typeof data === 'object' ? data : {};
        let result = new ProductContribution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["quantity"] = this.quantity;
        data["difficulty"] = this.difficulty;
        data["weightedValue"] = this.weightedValue;
        data["isNd"] = this.isNd;
        return data;
    }
}

export interface IProductContribution {
    productCode?: string;
    productName?: string;
    quantity?: number;
    difficulty?: number;
    weightedValue?: number;
    isNd?: boolean;
}

export class ProductionDetail implements IProductionDetail {
    productCode?: string;
    productName?: string;
    date?: Date;
    amount?: number;
    pricePerPiece?: number;
    priceTotal?: number;
    documentNumber?: string;

    constructor(data?: IProductionDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.pricePerPiece = _data["pricePerPiece"];
            this.priceTotal = _data["priceTotal"];
            this.documentNumber = _data["documentNumber"];
        }
    }

    static fromJS(data: any): ProductionDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["pricePerPiece"] = this.pricePerPiece;
        data["priceTotal"] = this.priceTotal;
        data["documentNumber"] = this.documentNumber;
        return data;
    }
}

export interface IProductionDetail {
    productCode?: string;
    productName?: string;
    date?: Date;
    amount?: number;
    pricePerPiece?: number;
    priceTotal?: number;
    documentNumber?: string;
}

export class GetManufactureSettingsResponse extends BaseResponse implements IGetManufactureSettingsResponse {
    manufactureGroupId?: string | undefined;

    constructor(data?: IGetManufactureSettingsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.manufactureGroupId = _data["manufactureGroupId"];
        }
    }

    static override fromJS(data: any): GetManufactureSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufactureSettingsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufactureGroupId"] = this.manufactureGroupId;
        super.toJSON(data);
        return data;
    }
}

export interface IGetManufactureSettingsResponse extends IBaseResponse {
    manufactureGroupId?: string | undefined;
}

export class SubmitManufactureStockTakingResponse extends BaseResponse implements ISubmitManufactureStockTakingResponse {
    id?: string | undefined;
    type?: string | undefined;
    code?: string | undefined;
    amountNew?: number;
    amountOld?: number;
    date?: Date;
    user?: string | undefined;
    error?: string | undefined;

    constructor(data?: ISubmitManufactureStockTakingResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.code = _data["code"];
            this.amountNew = _data["amountNew"];
            this.amountOld = _data["amountOld"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.error = _data["error"];
        }
    }

    static override fromJS(data: any): SubmitManufactureStockTakingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitManufactureStockTakingResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["code"] = this.code;
        data["amountNew"] = this.amountNew;
        data["amountOld"] = this.amountOld;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["error"] = this.error;
        super.toJSON(data);
        return data;
    }
}

export interface ISubmitManufactureStockTakingResponse extends IBaseResponse {
    id?: string | undefined;
    type?: string | undefined;
    code?: string | undefined;
    amountNew?: number;
    amountOld?: number;
    date?: Date;
    user?: string | undefined;
    error?: string | undefined;
}

export class SubmitManufactureStockTakingRequest implements ISubmitManufactureStockTakingRequest {
    productCode!: string;
    targetAmount?: number | undefined;
    softStockTaking?: boolean;
    lots?: ManufactureStockTakingLotDto[] | undefined;

    constructor(data?: ISubmitManufactureStockTakingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.targetAmount = _data["targetAmount"];
            this.softStockTaking = _data["softStockTaking"];
            if (Array.isArray(_data["lots"])) {
                this.lots = [] as any;
                for (let item of _data["lots"])
                    this.lots!.push(ManufactureStockTakingLotDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubmitManufactureStockTakingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitManufactureStockTakingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["targetAmount"] = this.targetAmount;
        data["softStockTaking"] = this.softStockTaking;
        if (Array.isArray(this.lots)) {
            data["lots"] = [];
            for (let item of this.lots)
                data["lots"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubmitManufactureStockTakingRequest {
    productCode: string;
    targetAmount?: number | undefined;
    softStockTaking?: boolean;
    lots?: ManufactureStockTakingLotDto[] | undefined;
}

export class ManufactureStockTakingLotDto implements IManufactureStockTakingLotDto {
    lotCode?: string | undefined;
    expiration?: Date | undefined;
    amount!: number;
    softStockTaking?: boolean;

    constructor(data?: IManufactureStockTakingLotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lotCode = _data["lotCode"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.softStockTaking = _data["softStockTaking"];
        }
    }

    static fromJS(data: any): ManufactureStockTakingLotDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufactureStockTakingLotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lotCode"] = this.lotCode;
        data["expiration"] = this.expiration ? formatDate(this.expiration) : <any>undefined;
        data["amount"] = this.amount;
        data["softStockTaking"] = this.softStockTaking;
        return data;
    }
}

export interface IManufactureStockTakingLotDto {
    lotCode?: string | undefined;
    expiration?: Date | undefined;
    amount: number;
    softStockTaking?: boolean;
}

export class GetManufactureStockTakingHistoryResponse extends BaseResponse implements IGetManufactureStockTakingHistoryResponse {
    items?: ManufactureStockTakingHistoryItemDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;

    constructor(data?: IGetManufactureStockTakingHistoryResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ManufactureStockTakingHistoryItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static override fromJS(data: any): GetManufactureStockTakingHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufactureStockTakingHistoryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        super.toJSON(data);
        return data;
    }
}

export interface IGetManufactureStockTakingHistoryResponse extends IBaseResponse {
    items?: ManufactureStockTakingHistoryItemDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class ManufactureStockTakingHistoryItemDto implements IManufactureStockTakingHistoryItemDto {
    id?: number;
    type?: StockTakingType;
    code?: string;
    amountNew?: number;
    amountOld?: number;
    date?: Date;
    user?: string | undefined;
    error?: string | undefined;
    difference?: number;

    constructor(data?: IManufactureStockTakingHistoryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.code = _data["code"];
            this.amountNew = _data["amountNew"];
            this.amountOld = _data["amountOld"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.error = _data["error"];
            this.difference = _data["difference"];
        }
    }

    static fromJS(data: any): ManufactureStockTakingHistoryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufactureStockTakingHistoryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["code"] = this.code;
        data["amountNew"] = this.amountNew;
        data["amountOld"] = this.amountOld;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["error"] = this.error;
        data["difference"] = this.difference;
        return data;
    }
}

export interface IManufactureStockTakingHistoryItemDto {
    id?: number;
    type?: StockTakingType;
    code?: string;
    amountNew?: number;
    amountOld?: number;
    date?: Date;
    user?: string | undefined;
    error?: string | undefined;
    difference?: number;
}

export enum StockTakingType {
    Eshop = "Eshop",
    Erp = "Erp",
}

export class GetManufacturingStockAnalysisResponse extends BaseResponse implements IGetManufacturingStockAnalysisResponse {
    items?: ManufacturingStockItemDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    summary?: ManufacturingStockSummaryDto;

    constructor(data?: IGetManufacturingStockAnalysisResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ManufacturingStockItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.summary = _data["summary"] ? ManufacturingStockSummaryDto.fromJS(_data["summary"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetManufacturingStockAnalysisResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetManufacturingStockAnalysisResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetManufacturingStockAnalysisResponse extends IBaseResponse {
    items?: ManufacturingStockItemDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    summary?: ManufacturingStockSummaryDto;
}

export class ManufacturingStockItemDto implements IManufacturingStockItemDto {
    code?: string;
    name?: string;
    nameNormalized?: string;
    currentStock?: number;
    erpStock?: number;
    eshopStock?: number;
    transportStock?: number;
    manufacturedStock?: number;
    primaryStockSource?: string;
    reserve?: number;
    quarantine?: number;
    planned?: number;
    salesInPeriod?: number;
    dailySalesRate?: number;
    optimalDaysSetup?: number;
    stockDaysAvailable?: number;
    minimumStock?: number;
    overstockPercentage?: number;
    batchSize?: string;
    productFamily?: string | undefined;
    severity?: ManufacturingStockSeverity;
    isConfigured?: boolean;
    isNd?: boolean;

    constructor(data?: IManufacturingStockItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.nameNormalized = _data["nameNormalized"];
            this.currentStock = _data["currentStock"];
            this.erpStock = _data["erpStock"];
            this.eshopStock = _data["eshopStock"];
            this.transportStock = _data["transportStock"];
            this.manufacturedStock = _data["manufacturedStock"];
            this.primaryStockSource = _data["primaryStockSource"];
            this.reserve = _data["reserve"];
            this.quarantine = _data["quarantine"];
            this.planned = _data["planned"];
            this.salesInPeriod = _data["salesInPeriod"];
            this.dailySalesRate = _data["dailySalesRate"];
            this.optimalDaysSetup = _data["optimalDaysSetup"];
            this.stockDaysAvailable = _data["stockDaysAvailable"];
            this.minimumStock = _data["minimumStock"];
            this.overstockPercentage = _data["overstockPercentage"];
            this.batchSize = _data["batchSize"];
            this.productFamily = _data["productFamily"];
            this.severity = _data["severity"];
            this.isConfigured = _data["isConfigured"];
            this.isNd = _data["isNd"];
        }
    }

    static fromJS(data: any): ManufacturingStockItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturingStockItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["nameNormalized"] = this.nameNormalized;
        data["currentStock"] = this.currentStock;
        data["erpStock"] = this.erpStock;
        data["eshopStock"] = this.eshopStock;
        data["transportStock"] = this.transportStock;
        data["manufacturedStock"] = this.manufacturedStock;
        data["primaryStockSource"] = this.primaryStockSource;
        data["reserve"] = this.reserve;
        data["quarantine"] = this.quarantine;
        data["planned"] = this.planned;
        data["salesInPeriod"] = this.salesInPeriod;
        data["dailySalesRate"] = this.dailySalesRate;
        data["optimalDaysSetup"] = this.optimalDaysSetup;
        data["stockDaysAvailable"] = this.stockDaysAvailable;
        data["minimumStock"] = this.minimumStock;
        data["overstockPercentage"] = this.overstockPercentage;
        data["batchSize"] = this.batchSize;
        data["productFamily"] = this.productFamily;
        data["severity"] = this.severity;
        data["isConfigured"] = this.isConfigured;
        data["isNd"] = this.isNd;
        return data;
    }
}

export interface IManufacturingStockItemDto {
    code?: string;
    name?: string;
    nameNormalized?: string;
    currentStock?: number;
    erpStock?: number;
    eshopStock?: number;
    transportStock?: number;
    manufacturedStock?: number;
    primaryStockSource?: string;
    reserve?: number;
    quarantine?: number;
    planned?: number;
    salesInPeriod?: number;
    dailySalesRate?: number;
    optimalDaysSetup?: number;
    stockDaysAvailable?: number;
    minimumStock?: number;
    overstockPercentage?: number;
    batchSize?: string;
    productFamily?: string | undefined;
    severity?: ManufacturingStockSeverity;
    isConfigured?: boolean;
    isNd?: boolean;
}

export enum ManufacturingStockSeverity {
    Critical = "Critical",
    Major = "Major",
    Minor = "Minor",
    Adequate = "Adequate",
    Unconfigured = "Unconfigured",
}

export class ManufacturingStockSummaryDto implements IManufacturingStockSummaryDto {
    totalProducts?: number;
    criticalCount?: number;
    majorCount?: number;
    minorCount?: number;
    adequateCount?: number;
    unconfiguredCount?: number;
    analysisPeriodStart?: Date;
    analysisPeriodEnd?: Date;
    productFamilies?: string[];

    constructor(data?: IManufacturingStockSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProducts = _data["totalProducts"];
            this.criticalCount = _data["criticalCount"];
            this.majorCount = _data["majorCount"];
            this.minorCount = _data["minorCount"];
            this.adequateCount = _data["adequateCount"];
            this.unconfiguredCount = _data["unconfiguredCount"];
            this.analysisPeriodStart = _data["analysisPeriodStart"] ? new Date(_data["analysisPeriodStart"].toString()) : <any>undefined;
            this.analysisPeriodEnd = _data["analysisPeriodEnd"] ? new Date(_data["analysisPeriodEnd"].toString()) : <any>undefined;
            if (Array.isArray(_data["productFamilies"])) {
                this.productFamilies = [] as any;
                for (let item of _data["productFamilies"])
                    this.productFamilies!.push(item);
            }
        }
    }

    static fromJS(data: any): ManufacturingStockSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManufacturingStockSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProducts"] = this.totalProducts;
        data["criticalCount"] = this.criticalCount;
        data["majorCount"] = this.majorCount;
        data["minorCount"] = this.minorCount;
        data["adequateCount"] = this.adequateCount;
        data["unconfiguredCount"] = this.unconfiguredCount;
        data["analysisPeriodStart"] = this.analysisPeriodStart ? this.analysisPeriodStart.toISOString() : <any>undefined;
        data["analysisPeriodEnd"] = this.analysisPeriodEnd ? this.analysisPeriodEnd.toISOString() : <any>undefined;
        if (Array.isArray(this.productFamilies)) {
            data["productFamilies"] = [];
            for (let item of this.productFamilies)
                data["productFamilies"].push(item);
        }
        return data;
    }
}

export interface IManufacturingStockSummaryDto {
    totalProducts?: number;
    criticalCount?: number;
    majorCount?: number;
    minorCount?: number;
    adequateCount?: number;
    unconfiguredCount?: number;
    analysisPeriodStart?: Date;
    analysisPeriodEnd?: Date;
    productFamilies?: string[];
}

export enum ManufacturingStockSortBy {
    ProductCode = "ProductCode",
    ProductName = "ProductName",
    CurrentStock = "CurrentStock",
    Reserve = "Reserve",
    Quarantine = "Quarantine",
    Planned = "Planned",
    SalesInPeriod = "SalesInPeriod",
    DailySales = "DailySales",
    OptimalDaysSetup = "OptimalDaysSetup",
    StockDaysAvailable = "StockDaysAvailable",
    MinimumStock = "MinimumStock",
    OverstockPercentage = "OverstockPercentage",
    BatchSize = "BatchSize",
}

export class ListAdAuditEventsResponse extends BaseResponse implements IListAdAuditEventsResponse {
    items?: AdAuditEventDto[];
    totalCount?: number;

    constructor(data?: IListAdAuditEventsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdAuditEventDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static override fromJS(data: any): ListAdAuditEventsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListAdAuditEventsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        super.toJSON(data);
        return data;
    }
}

export interface IListAdAuditEventsResponse extends IBaseResponse {
    items?: AdAuditEventDto[];
    totalCount?: number;
}

export class AdAuditEventDto implements IAdAuditEventDto {
    id?: number;
    proposalId?: number | undefined;
    version?: number | undefined;
    eventType?: AdAuditEventType;
    actorPrincipal?: string;
    actorKind?: AdActorKind;
    channel?: ApprovalChannel;
    payloadJson?: string;
    occurredAt?: Date;

    constructor(data?: IAdAuditEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.proposalId = _data["proposalId"];
            this.version = _data["version"];
            this.eventType = _data["eventType"];
            this.actorPrincipal = _data["actorPrincipal"];
            this.actorKind = _data["actorKind"];
            this.channel = _data["channel"];
            this.payloadJson = _data["payloadJson"];
            this.occurredAt = _data["occurredAt"] ? new Date(_data["occurredAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AdAuditEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdAuditEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["proposalId"] = this.proposalId;
        data["version"] = this.version;
        data["eventType"] = this.eventType;
        data["actorPrincipal"] = this.actorPrincipal;
        data["actorKind"] = this.actorKind;
        data["channel"] = this.channel;
        data["payloadJson"] = this.payloadJson;
        data["occurredAt"] = this.occurredAt ? this.occurredAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAdAuditEventDto {
    id?: number;
    proposalId?: number | undefined;
    version?: number | undefined;
    eventType?: AdAuditEventType;
    actorPrincipal?: string;
    actorKind?: AdActorKind;
    channel?: ApprovalChannel;
    payloadJson?: string;
    occurredAt?: Date;
}

export enum AdAuditEventType {
    Submitted = "Submitted",
    Revised = "Revised",
    Approved = "Approved",
    Rejected = "Rejected",
    Expired = "Expired",
    ExecutionStarted = "ExecutionStarted",
    ActionExecuted = "ActionExecuted",
    ActionFailed = "ActionFailed",
    Reverted = "Reverted",
    SettingChanged = "SettingChanged",
    KillSwitchChanged = "KillSwitchChanged",
}

export enum AdActorKind {
    Human = "Human",
    Agent = "Agent",
    System = "System",
}

export enum ApprovalChannel {
    Web = "Web",
    Mcp = "Mcp",
    System = "System",
}

export class ListAgentRunsResponse extends BaseResponse implements IListAgentRunsResponse {
    items?: AgentRunDto[];
    totalCount?: number;

    constructor(data?: IListAgentRunsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AgentRunDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static override fromJS(data: any): ListAgentRunsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListAgentRunsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        super.toJSON(data);
        return data;
    }
}

export interface IListAgentRunsResponse extends IBaseResponse {
    items?: AgentRunDto[];
    totalCount?: number;
}

export class AgentRunDto implements IAgentRunDto {
    id?: string;
    agentName?: string;
    principal?: string;
    startedAt?: Date;
    finishedAt?: Date | undefined;
    status?: AgentRunStatus;
    summary?: string | undefined;
    dataScopesRead?: string[];
    proposalsCreated?: number;
    inputTokens?: number | undefined;
    outputTokens?: number | undefined;
    costCzk?: number | undefined;

    constructor(data?: IAgentRunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agentName = _data["agentName"];
            this.principal = _data["principal"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.finishedAt = _data["finishedAt"] ? new Date(_data["finishedAt"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.summary = _data["summary"];
            if (Array.isArray(_data["dataScopesRead"])) {
                this.dataScopesRead = [] as any;
                for (let item of _data["dataScopesRead"])
                    this.dataScopesRead!.push(item);
            }
            this.proposalsCreated = _data["proposalsCreated"];
            this.inputTokens = _data["inputTokens"];
            this.outputTokens = _data["outputTokens"];
            this.costCzk = _data["costCzk"];
        }
    }

    static fromJS(data: any): AgentRunDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentRunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agentName"] = this.agentName;
        data["principal"] = this.principal;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["finishedAt"] = this.finishedAt ? this.finishedAt.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["summary"] = this.summary;
        if (Array.isArray(this.dataScopesRead)) {
            data["dataScopesRead"] = [];
            for (let item of this.dataScopesRead)
                data["dataScopesRead"].push(item);
        }
        data["proposalsCreated"] = this.proposalsCreated;
        data["inputTokens"] = this.inputTokens;
        data["outputTokens"] = this.outputTokens;
        data["costCzk"] = this.costCzk;
        return data;
    }
}

export interface IAgentRunDto {
    id?: string;
    agentName?: string;
    principal?: string;
    startedAt?: Date;
    finishedAt?: Date | undefined;
    status?: AgentRunStatus;
    summary?: string | undefined;
    dataScopesRead?: string[];
    proposalsCreated?: number;
    inputTokens?: number | undefined;
    outputTokens?: number | undefined;
    costCzk?: number | undefined;
}

export enum AgentRunStatus {
    Running = "Running",
    Succeeded = "Succeeded",
    Failed = "Failed",
}

export class GetAdChangeHistoryResponse extends BaseResponse implements IGetAdChangeHistoryResponse {
    from?: Date;
    to?: Date;
    pageNumber?: number;
    pageSize?: number;
    totalCount?: number;
    events?: AdChangeEventDto[];

    constructor(data?: IGetAdChangeHistoryResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(AdChangeEventDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetAdChangeHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdChangeHistoryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAdChangeHistoryResponse extends IBaseResponse {
    from?: Date;
    to?: Date;
    pageNumber?: number;
    pageSize?: number;
    totalCount?: number;
    events?: AdChangeEventDto[];
}

export class AdChangeEventDto implements IAdChangeEventDto {
    id?: number;
    platform?: AdPlatform;
    accountExternalId?: string;
    occurredAt?: Date;
    actor?: string | undefined;
    actorKind?: AdChangeActorKind;
    entityLevel?: AdEntityLevel | undefined;
    entityExternalId?: string | undefined;
    entityName?: string | undefined;
    changeType?: string;
    oldValueJson?: string | undefined;
    newValueJson?: string | undefined;
    source?: AdChangeSource;
    origin?: AdChangeOrigin;
    matchedExecutionId?: string | undefined;

    constructor(data?: IAdChangeEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.platform = _data["platform"];
            this.accountExternalId = _data["accountExternalId"];
            this.occurredAt = _data["occurredAt"] ? new Date(_data["occurredAt"].toString()) : <any>undefined;
            this.actor = _data["actor"];
            this.actorKind = _data["actorKind"];
            this.entityLevel = _data["entityLevel"];
            this.entityExternalId = _data["entityExternalId"];
            this.entityName = _data["entityName"];
            this.changeType = _data["changeType"];
            this.oldValueJson = _data["oldValueJson"];
            this.newValueJson = _data["newValueJson"];
            this.source = _data["source"];
            this.origin = _data["origin"];
            this.matchedExecutionId = _data["matchedExecutionId"];
        }
    }

    static fromJS(data: any): AdChangeEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdChangeEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["platform"] = this.platform;
        data["accountExternalId"] = this.accountExternalId;
        data["occurredAt"] = this.occurredAt ? this.occurredAt.toISOString() : <any>undefined;
        data["actor"] = this.actor;
        data["actorKind"] = this.actorKind;
        data["entityLevel"] = this.entityLevel;
        data["entityExternalId"] = this.entityExternalId;
        data["entityName"] = this.entityName;
        data["changeType"] = this.changeType;
        data["oldValueJson"] = this.oldValueJson;
        data["newValueJson"] = this.newValueJson;
        data["source"] = this.source;
        data["origin"] = this.origin;
        data["matchedExecutionId"] = this.matchedExecutionId;
        return data;
    }
}

export interface IAdChangeEventDto {
    id?: number;
    platform?: AdPlatform;
    accountExternalId?: string;
    occurredAt?: Date;
    actor?: string | undefined;
    actorKind?: AdChangeActorKind;
    entityLevel?: AdEntityLevel | undefined;
    entityExternalId?: string | undefined;
    entityName?: string | undefined;
    changeType?: string;
    oldValueJson?: string | undefined;
    newValueJson?: string | undefined;
    source?: AdChangeSource;
    origin?: AdChangeOrigin;
    matchedExecutionId?: string | undefined;
}

export enum AdPlatform {
    GoogleAds = "GoogleAds",
    MetaAds = "MetaAds",
    Sklik = "Sklik",
}

export enum AdChangeActorKind {
    Unknown = "Unknown",
    Heblo = "Heblo",
    User = "User",
    PlatformAutomation = "PlatformAutomation",
}

export enum AdEntityLevel {
    Campaign = "Campaign",
    AdGroup = "AdGroup",
    Keyword = "Keyword",
    NegativeKeyword = "NegativeKeyword",
    Ad = "Ad",
}

export enum AdChangeSource {
    PlatformChangeLog = "PlatformChangeLog",
    SnapshotDiff = "SnapshotDiff",
}

export enum AdChangeOrigin {
    Heblo = "Heblo",
    OutOfBand = "OutOfBand",
}

export class ListAdProposalsResponse extends BaseResponse implements IListAdProposalsResponse {
    items?: AdProposalSummaryDto[];
    totalCount?: number;

    constructor(data?: IListAdProposalsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdProposalSummaryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static override fromJS(data: any): ListAdProposalsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListAdProposalsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        super.toJSON(data);
        return data;
    }
}

export interface IListAdProposalsResponse extends IBaseResponse {
    items?: AdProposalSummaryDto[];
    totalCount?: number;
}

export class AdProposalSummaryDto implements IAdProposalSummaryDto {
    id?: number;
    currentVersion?: number;
    status?: AdProposalStatus;
    platform?: AdPlatform;
    accountExternalId?: string;
    actionType?: AdActionType;
    actionCount?: number;
    createdByPrincipal?: string;
    createdByKind?: AdActorKind;
    agentRunId?: string | undefined;
    createdAt?: Date;
    expiresAt?: Date;
    updatedAt?: Date;
    diffLines?: string[];

    constructor(data?: IAdProposalSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.currentVersion = _data["currentVersion"];
            this.status = _data["status"];
            this.platform = _data["platform"];
            this.accountExternalId = _data["accountExternalId"];
            this.actionType = _data["actionType"];
            this.actionCount = _data["actionCount"];
            this.createdByPrincipal = _data["createdByPrincipal"];
            this.createdByKind = _data["createdByKind"];
            this.agentRunId = _data["agentRunId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["diffLines"])) {
                this.diffLines = [] as any;
                for (let item of _data["diffLines"])
                    this.diffLines!.push(item);
            }
        }
    }

    static fromJS(data: any): AdProposalSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdProposalSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["currentVersion"] = this.currentVersion;
        data["status"] = this.status;
        data["platform"] = this.platform;
        data["accountExternalId"] = this.accountExternalId;
        data["actionType"] = this.actionType;
        data["actionCount"] = this.actionCount;
        data["createdByPrincipal"] = this.createdByPrincipal;
        data["createdByKind"] = this.createdByKind;
        data["agentRunId"] = this.agentRunId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.diffLines)) {
            data["diffLines"] = [];
            for (let item of this.diffLines)
                data["diffLines"].push(item);
        }
        return data;
    }
}

export interface IAdProposalSummaryDto {
    id?: number;
    currentVersion?: number;
    status?: AdProposalStatus;
    platform?: AdPlatform;
    accountExternalId?: string;
    actionType?: AdActionType;
    actionCount?: number;
    createdByPrincipal?: string;
    createdByKind?: AdActorKind;
    agentRunId?: string | undefined;
    createdAt?: Date;
    expiresAt?: Date;
    updatedAt?: Date;
    diffLines?: string[];
}

export enum AdProposalStatus {
    Pending = "Pending",
    Approved = "Approved",
    Executing = "Executing",
    Executed = "Executed",
    PartiallyExecuted = "PartiallyExecuted",
    Failed = "Failed",
    Rejected = "Rejected",
    Expired = "Expired",
    Reverted = "Reverted",
}

export enum AdActionType {
    AddNegativeKeyword = "AddNegativeKeyword",
    PauseAd = "PauseAd",
}

export class GetAdProposalResponse extends BaseResponse implements IGetAdProposalResponse {
    proposal?: AdProposalDetailDto;

    constructor(data?: IGetAdProposalResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.proposal = _data["proposal"] ? AdProposalDetailDto.fromJS(_data["proposal"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetAdProposalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdProposalResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposal"] = this.proposal ? this.proposal.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetAdProposalResponse extends IBaseResponse {
    proposal?: AdProposalDetailDto;
}

export class AdProposalDetailDto implements IAdProposalDetailDto {
    summary?: AdProposalSummaryDto;
    versions?: AdProposalVersionDto[];
    approvals?: AdProposalApprovalDto[];
    executions?: AdActionExecutionDto[];
    currentEvaluation?: AdLimitsEvaluationDto | undefined;

    constructor(data?: IAdProposalDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? AdProposalSummaryDto.fromJS(_data["summary"]) : <any>undefined;
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(AdProposalVersionDto.fromJS(item));
            }
            if (Array.isArray(_data["approvals"])) {
                this.approvals = [] as any;
                for (let item of _data["approvals"])
                    this.approvals!.push(AdProposalApprovalDto.fromJS(item));
            }
            if (Array.isArray(_data["executions"])) {
                this.executions = [] as any;
                for (let item of _data["executions"])
                    this.executions!.push(AdActionExecutionDto.fromJS(item));
            }
            this.currentEvaluation = _data["currentEvaluation"] ? AdLimitsEvaluationDto.fromJS(_data["currentEvaluation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AdProposalDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdProposalDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        if (Array.isArray(this.approvals)) {
            data["approvals"] = [];
            for (let item of this.approvals)
                data["approvals"].push(item.toJSON());
        }
        if (Array.isArray(this.executions)) {
            data["executions"] = [];
            for (let item of this.executions)
                data["executions"].push(item.toJSON());
        }
        data["currentEvaluation"] = this.currentEvaluation ? this.currentEvaluation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAdProposalDetailDto {
    summary?: AdProposalSummaryDto;
    versions?: AdProposalVersionDto[];
    approvals?: AdProposalApprovalDto[];
    executions?: AdActionExecutionDto[];
    currentEvaluation?: AdLimitsEvaluationDto | undefined;
}

export class AdProposalVersionDto implements IAdProposalVersionDto {
    version?: number;
    actionCount?: number;
    reasoning?: string;
    createdBy?: string;
    createdAt?: Date;
    diffLines?: string[];

    constructor(data?: IAdProposalVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.actionCount = _data["actionCount"];
            this.reasoning = _data["reasoning"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["diffLines"])) {
                this.diffLines = [] as any;
                for (let item of _data["diffLines"])
                    this.diffLines!.push(item);
            }
        }
    }

    static fromJS(data: any): AdProposalVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdProposalVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["actionCount"] = this.actionCount;
        data["reasoning"] = this.reasoning;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        if (Array.isArray(this.diffLines)) {
            data["diffLines"] = [];
            for (let item of this.diffLines)
                data["diffLines"].push(item);
        }
        return data;
    }
}

export interface IAdProposalVersionDto {
    version?: number;
    actionCount?: number;
    reasoning?: string;
    createdBy?: string;
    createdAt?: Date;
    diffLines?: string[];
}

export class AdProposalApprovalDto implements IAdProposalApprovalDto {
    version?: number;
    principal?: string;
    channel?: ApprovalChannel;
    decision?: ApprovalDecision;
    reason?: string | undefined;
    at?: Date;

    constructor(data?: IAdProposalApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.principal = _data["principal"];
            this.channel = _data["channel"];
            this.decision = _data["decision"];
            this.reason = _data["reason"];
            this.at = _data["at"] ? new Date(_data["at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AdProposalApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdProposalApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["principal"] = this.principal;
        data["channel"] = this.channel;
        data["decision"] = this.decision;
        data["reason"] = this.reason;
        data["at"] = this.at ? this.at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAdProposalApprovalDto {
    version?: number;
    principal?: string;
    channel?: ApprovalChannel;
    decision?: ApprovalDecision;
    reason?: string | undefined;
    at?: Date;
}

export enum ApprovalDecision {
    Approved = "Approved",
    Rejected = "Rejected",
}

export class AdActionExecutionDto implements IAdActionExecutionDto {
    version?: number;
    actionIndex?: number;
    targetExternalId?: string;
    state?: AdActionExecutionState;
    beforeValue?: string | undefined;
    afterValue?: string | undefined;
    platformResourceId?: string | undefined;
    error?: string | undefined;
    validateOnly?: boolean;
    executedAt?: Date;
    revertState?: AdActionRevertState;
    revertedAt?: Date | undefined;
    revertError?: string | undefined;
    revertValidateOnly?: boolean;

    constructor(data?: IAdActionExecutionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.actionIndex = _data["actionIndex"];
            this.targetExternalId = _data["targetExternalId"];
            this.state = _data["state"];
            this.beforeValue = _data["beforeValue"];
            this.afterValue = _data["afterValue"];
            this.platformResourceId = _data["platformResourceId"];
            this.error = _data["error"];
            this.validateOnly = _data["validateOnly"];
            this.executedAt = _data["executedAt"] ? new Date(_data["executedAt"].toString()) : <any>undefined;
            this.revertState = _data["revertState"];
            this.revertedAt = _data["revertedAt"] ? new Date(_data["revertedAt"].toString()) : <any>undefined;
            this.revertError = _data["revertError"];
            this.revertValidateOnly = _data["revertValidateOnly"];
        }
    }

    static fromJS(data: any): AdActionExecutionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdActionExecutionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["actionIndex"] = this.actionIndex;
        data["targetExternalId"] = this.targetExternalId;
        data["state"] = this.state;
        data["beforeValue"] = this.beforeValue;
        data["afterValue"] = this.afterValue;
        data["platformResourceId"] = this.platformResourceId;
        data["error"] = this.error;
        data["validateOnly"] = this.validateOnly;
        data["executedAt"] = this.executedAt ? this.executedAt.toISOString() : <any>undefined;
        data["revertState"] = this.revertState;
        data["revertedAt"] = this.revertedAt ? this.revertedAt.toISOString() : <any>undefined;
        data["revertError"] = this.revertError;
        data["revertValidateOnly"] = this.revertValidateOnly;
        return data;
    }
}

export interface IAdActionExecutionDto {
    version?: number;
    actionIndex?: number;
    targetExternalId?: string;
    state?: AdActionExecutionState;
    beforeValue?: string | undefined;
    afterValue?: string | undefined;
    platformResourceId?: string | undefined;
    error?: string | undefined;
    validateOnly?: boolean;
    executedAt?: Date;
    revertState?: AdActionRevertState;
    revertedAt?: Date | undefined;
    revertError?: string | undefined;
    revertValidateOnly?: boolean;
}

export enum AdActionExecutionState {
    Succeeded = "Succeeded",
    Failed = "Failed",
    StaleState = "StaleState",
    Skipped = "Skipped",
}

export enum AdActionRevertState {
    NotReverted = "NotReverted",
    Reverted = "Reverted",
    RevertFailed = "RevertFailed",
}

export class AdLimitsEvaluationDto implements IAdLimitsEvaluationDto {
    decision?: AdLimitsDecision;
    reason?: string | undefined;

    constructor(data?: IAdLimitsEvaluationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.decision = _data["decision"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): AdLimitsEvaluationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdLimitsEvaluationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["decision"] = this.decision;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IAdLimitsEvaluationDto {
    decision?: AdLimitsDecision;
    reason?: string | undefined;
}

export enum AdLimitsDecision {
    Allowed = "Allowed",
    NeedsSecondApprover = "NeedsSecondApprover",
    NeedsWebApproval = "NeedsWebApproval",
    Denied = "Denied",
}

export abstract class AdProposalMutationResponse extends BaseResponse implements IAdProposalMutationResponse {
    proposalId?: number;
    version?: number;
    status?: AdProposalStatus;
    autoApproved?: boolean;
    evaluation?: AdLimitsEvaluationDto;
    diffLines?: string[];

    constructor(data?: IAdProposalMutationResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.proposalId = _data["proposalId"];
            this.version = _data["version"];
            this.status = _data["status"];
            this.autoApproved = _data["autoApproved"];
            this.evaluation = _data["evaluation"] ? AdLimitsEvaluationDto.fromJS(_data["evaluation"]) : <any>undefined;
            if (Array.isArray(_data["diffLines"])) {
                this.diffLines = [] as any;
                for (let item of _data["diffLines"])
                    this.diffLines!.push(item);
            }
        }
    }

    static override fromJS(data: any): AdProposalMutationResponse {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AdProposalMutationResponse' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalId"] = this.proposalId;
        data["version"] = this.version;
        data["status"] = this.status;
        data["autoApproved"] = this.autoApproved;
        data["evaluation"] = this.evaluation ? this.evaluation.toJSON() : <any>undefined;
        if (Array.isArray(this.diffLines)) {
            data["diffLines"] = [];
            for (let item of this.diffLines)
                data["diffLines"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAdProposalMutationResponse extends IBaseResponse {
    proposalId?: number;
    version?: number;
    status?: AdProposalStatus;
    autoApproved?: boolean;
    evaluation?: AdLimitsEvaluationDto;
    diffLines?: string[];
}

export class SubmitAdProposalResponse extends AdProposalMutationResponse implements ISubmitAdProposalResponse {

    constructor(data?: ISubmitAdProposalResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SubmitAdProposalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitAdProposalResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISubmitAdProposalResponse extends IAdProposalMutationResponse {
}

export class SubmitAdProposalRequest implements ISubmitAdProposalRequest {
    platform?: AdPlatform;
    accountExternalId?: string;
    actionType?: AdActionType;
    actions?: AdActionInputDto[];
    reasoning?: string;
    agentRunId?: string | undefined;

    constructor(data?: ISubmitAdProposalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["platform"];
            this.accountExternalId = _data["accountExternalId"];
            this.actionType = _data["actionType"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(AdActionInputDto.fromJS(item));
            }
            this.reasoning = _data["reasoning"];
            this.agentRunId = _data["agentRunId"];
        }
    }

    static fromJS(data: any): SubmitAdProposalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitAdProposalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        data["accountExternalId"] = this.accountExternalId;
        data["actionType"] = this.actionType;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        data["reasoning"] = this.reasoning;
        data["agentRunId"] = this.agentRunId;
        return data;
    }
}

export interface ISubmitAdProposalRequest {
    platform?: AdPlatform;
    accountExternalId?: string;
    actionType?: AdActionType;
    actions?: AdActionInputDto[];
    reasoning?: string;
    agentRunId?: string | undefined;
}

export class AdActionInputDto implements IAdActionInputDto {
    targetLevel?: AdEntityLevel;
    targetExternalId?: string;
    keywordText?: string | undefined;
    matchType?: KeywordMatchType | undefined;

    constructor(data?: IAdActionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetLevel = _data["targetLevel"];
            this.targetExternalId = _data["targetExternalId"];
            this.keywordText = _data["keywordText"];
            this.matchType = _data["matchType"];
        }
    }

    static fromJS(data: any): AdActionInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdActionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetLevel"] = this.targetLevel;
        data["targetExternalId"] = this.targetExternalId;
        data["keywordText"] = this.keywordText;
        data["matchType"] = this.matchType;
        return data;
    }
}

export interface IAdActionInputDto {
    targetLevel?: AdEntityLevel;
    targetExternalId?: string;
    keywordText?: string | undefined;
    matchType?: KeywordMatchType | undefined;
}

export enum KeywordMatchType {
    Exact = "Exact",
    Phrase = "Phrase",
    Broad = "Broad",
}

export class ReviseAdProposalResponse extends AdProposalMutationResponse implements IReviseAdProposalResponse {

    constructor(data?: IReviseAdProposalResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ReviseAdProposalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReviseAdProposalResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IReviseAdProposalResponse extends IAdProposalMutationResponse {
}

export class ReviseAdProposalRequest implements IReviseAdProposalRequest {
    id?: number;
    expectedVersion?: number;
    actions?: AdActionInputDto[];
    reasoning?: string;

    constructor(data?: IReviseAdProposalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.expectedVersion = _data["expectedVersion"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(AdActionInputDto.fromJS(item));
            }
            this.reasoning = _data["reasoning"];
        }
    }

    static fromJS(data: any): ReviseAdProposalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReviseAdProposalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expectedVersion"] = this.expectedVersion;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        data["reasoning"] = this.reasoning;
        return data;
    }
}

export interface IReviseAdProposalRequest {
    id?: number;
    expectedVersion?: number;
    actions?: AdActionInputDto[];
    reasoning?: string;
}

export class ApproveAdProposalResponse extends BaseResponse implements IApproveAdProposalResponse {
    proposalId?: number;
    version?: number;
    status?: AdProposalStatus;
    awaitingSecondApprover?: boolean;
    executionJobId?: string | undefined;

    constructor(data?: IApproveAdProposalResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.proposalId = _data["proposalId"];
            this.version = _data["version"];
            this.status = _data["status"];
            this.awaitingSecondApprover = _data["awaitingSecondApprover"];
            this.executionJobId = _data["executionJobId"];
        }
    }

    static override fromJS(data: any): ApproveAdProposalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveAdProposalResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalId"] = this.proposalId;
        data["version"] = this.version;
        data["status"] = this.status;
        data["awaitingSecondApprover"] = this.awaitingSecondApprover;
        data["executionJobId"] = this.executionJobId;
        super.toJSON(data);
        return data;
    }
}

export interface IApproveAdProposalResponse extends IBaseResponse {
    proposalId?: number;
    version?: number;
    status?: AdProposalStatus;
    awaitingSecondApprover?: boolean;
    executionJobId?: string | undefined;
}

export class ApproveAdProposalRequest implements IApproveAdProposalRequest {
    id?: number;
    version?: number;

    constructor(data?: IApproveAdProposalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): ApproveAdProposalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveAdProposalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["version"] = this.version;
        return data;
    }
}

export interface IApproveAdProposalRequest {
    id?: number;
    version?: number;
}

export class RejectAdProposalResponse extends BaseResponse implements IRejectAdProposalResponse {
    proposalId?: number;
    version?: number;
    status?: AdProposalStatus;

    constructor(data?: IRejectAdProposalResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.proposalId = _data["proposalId"];
            this.version = _data["version"];
            this.status = _data["status"];
        }
    }

    static override fromJS(data: any): RejectAdProposalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RejectAdProposalResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalId"] = this.proposalId;
        data["version"] = this.version;
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IRejectAdProposalResponse extends IBaseResponse {
    proposalId?: number;
    version?: number;
    status?: AdProposalStatus;
}

export class RejectAdProposalRequest implements IRejectAdProposalRequest {
    id?: number;
    version?: number;
    reason?: string;

    constructor(data?: IRejectAdProposalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.version = _data["version"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): RejectAdProposalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RejectAdProposalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["version"] = this.version;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IRejectAdProposalRequest {
    id?: number;
    version?: number;
    reason?: string;
}

export class RevertAdProposalResponse extends BaseResponse implements IRevertAdProposalResponse {
    proposalId?: number;
    status?: AdProposalStatus;
    revertedActions?: number;
    failedActions?: number;
    validateOnlyActions?: number;

    constructor(data?: IRevertAdProposalResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.proposalId = _data["proposalId"];
            this.status = _data["status"];
            this.revertedActions = _data["revertedActions"];
            this.failedActions = _data["failedActions"];
            this.validateOnlyActions = _data["validateOnlyActions"];
        }
    }

    static override fromJS(data: any): RevertAdProposalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RevertAdProposalResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalId"] = this.proposalId;
        data["status"] = this.status;
        data["revertedActions"] = this.revertedActions;
        data["failedActions"] = this.failedActions;
        data["validateOnlyActions"] = this.validateOnlyActions;
        super.toJSON(data);
        return data;
    }
}

export interface IRevertAdProposalResponse extends IBaseResponse {
    proposalId?: number;
    status?: AdProposalStatus;
    revertedActions?: number;
    failedActions?: number;
    validateOnlyActions?: number;
}

export class GetAdSettingsResponse extends BaseResponse implements IGetAdSettingsResponse {
    autonomy?: AdAutonomySettingDto[];
    limits?: AdLimitSettingDto[];
    killSwitches?: AdKillSwitchDto[];
    isExecutionEnabledGlobally?: boolean;
    approvalRates?: AdApprovalRateDto[];

    constructor(data?: IGetAdSettingsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["autonomy"])) {
                this.autonomy = [] as any;
                for (let item of _data["autonomy"])
                    this.autonomy!.push(AdAutonomySettingDto.fromJS(item));
            }
            if (Array.isArray(_data["limits"])) {
                this.limits = [] as any;
                for (let item of _data["limits"])
                    this.limits!.push(AdLimitSettingDto.fromJS(item));
            }
            if (Array.isArray(_data["killSwitches"])) {
                this.killSwitches = [] as any;
                for (let item of _data["killSwitches"])
                    this.killSwitches!.push(AdKillSwitchDto.fromJS(item));
            }
            this.isExecutionEnabledGlobally = _data["isExecutionEnabledGlobally"];
            if (Array.isArray(_data["approvalRates"])) {
                this.approvalRates = [] as any;
                for (let item of _data["approvalRates"])
                    this.approvalRates!.push(AdApprovalRateDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetAdSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdSettingsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.autonomy)) {
            data["autonomy"] = [];
            for (let item of this.autonomy)
                data["autonomy"].push(item.toJSON());
        }
        if (Array.isArray(this.limits)) {
            data["limits"] = [];
            for (let item of this.limits)
                data["limits"].push(item.toJSON());
        }
        if (Array.isArray(this.killSwitches)) {
            data["killSwitches"] = [];
            for (let item of this.killSwitches)
                data["killSwitches"].push(item.toJSON());
        }
        data["isExecutionEnabledGlobally"] = this.isExecutionEnabledGlobally;
        if (Array.isArray(this.approvalRates)) {
            data["approvalRates"] = [];
            for (let item of this.approvalRates)
                data["approvalRates"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAdSettingsResponse extends IBaseResponse {
    autonomy?: AdAutonomySettingDto[];
    limits?: AdLimitSettingDto[];
    killSwitches?: AdKillSwitchDto[];
    isExecutionEnabledGlobally?: boolean;
    approvalRates?: AdApprovalRateDto[];
}

export class AdAutonomySettingDto implements IAdAutonomySettingDto {
    platform?: AdPlatform;
    actionType?: AdActionType;
    mode?: AdAutonomyMode;
    updatedAt?: Date;
    updatedBy?: string;

    constructor(data?: IAdAutonomySettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["platform"];
            this.actionType = _data["actionType"];
            this.mode = _data["mode"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): AdAutonomySettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdAutonomySettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        data["actionType"] = this.actionType;
        data["mode"] = this.mode;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IAdAutonomySettingDto {
    platform?: AdPlatform;
    actionType?: AdActionType;
    mode?: AdAutonomyMode;
    updatedAt?: Date;
    updatedBy?: string;
}

export enum AdAutonomyMode {
    ProposeOnly = "ProposeOnly",
    AutoWithinLimits = "AutoWithinLimits",
    Auto = "Auto",
}

export class AdLimitSettingDto implements IAdLimitSettingDto {
    platform?: AdPlatform;
    actionType?: AdActionType;
    key?: string;
    value?: number;
    updatedAt?: Date;
    updatedBy?: string;

    constructor(data?: IAdLimitSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["platform"];
            this.actionType = _data["actionType"];
            this.key = _data["key"];
            this.value = _data["value"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): AdLimitSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdLimitSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        data["actionType"] = this.actionType;
        data["key"] = this.key;
        data["value"] = this.value;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IAdLimitSettingDto {
    platform?: AdPlatform;
    actionType?: AdActionType;
    key?: string;
    value?: number;
    updatedAt?: Date;
    updatedBy?: string;
}

export class AdKillSwitchDto implements IAdKillSwitchDto {
    scope?: string;
    executionEnabled?: boolean;
    updatedAt?: Date;
    updatedBy?: string;

    constructor(data?: IAdKillSwitchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scope = _data["scope"];
            this.executionEnabled = _data["executionEnabled"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): AdKillSwitchDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdKillSwitchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scope"] = this.scope;
        data["executionEnabled"] = this.executionEnabled;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IAdKillSwitchDto {
    scope?: string;
    executionEnabled?: boolean;
    updatedAt?: Date;
    updatedBy?: string;
}

export class AdApprovalRateDto implements IAdApprovalRateDto {
    platform?: AdPlatform;
    actionType?: AdActionType;
    decided?: number;
    approvedWithoutEdit?: number;
    rate?: number | undefined;

    constructor(data?: IAdApprovalRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["platform"];
            this.actionType = _data["actionType"];
            this.decided = _data["decided"];
            this.approvedWithoutEdit = _data["approvedWithoutEdit"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): AdApprovalRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdApprovalRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        data["actionType"] = this.actionType;
        data["decided"] = this.decided;
        data["approvedWithoutEdit"] = this.approvedWithoutEdit;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IAdApprovalRateDto {
    platform?: AdPlatform;
    actionType?: AdActionType;
    decided?: number;
    approvedWithoutEdit?: number;
    rate?: number | undefined;
}

export class UpdateAdAutonomySettingResponse extends BaseResponse implements IUpdateAdAutonomySettingResponse {

    constructor(data?: IUpdateAdAutonomySettingResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateAdAutonomySettingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdAutonomySettingResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateAdAutonomySettingResponse extends IBaseResponse {
}

export class UpdateAdAutonomySettingRequest implements IUpdateAdAutonomySettingRequest {
    platform?: AdPlatform;
    actionType?: AdActionType;
    mode?: AdAutonomyMode;

    constructor(data?: IUpdateAdAutonomySettingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["platform"];
            this.actionType = _data["actionType"];
            this.mode = _data["mode"];
        }
    }

    static fromJS(data: any): UpdateAdAutonomySettingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdAutonomySettingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        data["actionType"] = this.actionType;
        data["mode"] = this.mode;
        return data;
    }
}

export interface IUpdateAdAutonomySettingRequest {
    platform?: AdPlatform;
    actionType?: AdActionType;
    mode?: AdAutonomyMode;
}

export class UpdateAdLimitSettingResponse extends BaseResponse implements IUpdateAdLimitSettingResponse {

    constructor(data?: IUpdateAdLimitSettingResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateAdLimitSettingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdLimitSettingResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateAdLimitSettingResponse extends IBaseResponse {
}

export class UpdateAdLimitSettingRequest implements IUpdateAdLimitSettingRequest {
    platform?: AdPlatform;
    actionType?: AdActionType;
    key?: string;
    value?: number;

    constructor(data?: IUpdateAdLimitSettingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["platform"];
            this.actionType = _data["actionType"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateAdLimitSettingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdLimitSettingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        data["actionType"] = this.actionType;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateAdLimitSettingRequest {
    platform?: AdPlatform;
    actionType?: AdActionType;
    key?: string;
    value?: number;
}

export class SetAdKillSwitchResponse extends BaseResponse implements ISetAdKillSwitchResponse {

    constructor(data?: ISetAdKillSwitchResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SetAdKillSwitchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetAdKillSwitchResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISetAdKillSwitchResponse extends IBaseResponse {
}

export class SetAdKillSwitchRequest implements ISetAdKillSwitchRequest {
    platform?: AdPlatform | undefined;
    executionEnabled?: boolean;

    constructor(data?: ISetAdKillSwitchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["platform"];
            this.executionEnabled = _data["executionEnabled"];
        }
    }

    static fromJS(data: any): SetAdKillSwitchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetAdKillSwitchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        data["executionEnabled"] = this.executionEnabled;
        return data;
    }
}

export interface ISetAdKillSwitchRequest {
    platform?: AdPlatform | undefined;
    executionEnabled?: boolean;
}

export class GetMarketingActionsResponse extends BaseResponse implements IGetMarketingActionsResponse {
    actions?: MarketingActionDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;

    constructor(data?: IGetMarketingActionsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(MarketingActionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static override fromJS(data: any): GetMarketingActionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketingActionsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        super.toJSON(data);
        return data;
    }
}

export interface IGetMarketingActionsResponse extends IBaseResponse {
    actions?: MarketingActionDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
}

export class MarketingActionDto implements IMarketingActionDto {
    id?: number;
    title?: string;
    description?: string | undefined;
    actionType?: string;
    startDate?: Date;
    endDate?: Date | undefined;
    createdAt?: Date;
    modifiedAt?: Date;
    createdByUserId?: string;
    createdByUsername?: string | undefined;
    modifiedByUserId?: string | undefined;
    modifiedByUsername?: string | undefined;
    associatedProducts?: string[];
    folderLinks?: MarketingActionFolderLinkDto[];
    outlookSyncStatus?: string;
    outlookEventId?: string | undefined;

    constructor(data?: IMarketingActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.actionType = _data["actionType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : <any>undefined;
            this.createdByUserId = _data["createdByUserId"];
            this.createdByUsername = _data["createdByUsername"];
            this.modifiedByUserId = _data["modifiedByUserId"];
            this.modifiedByUsername = _data["modifiedByUsername"];
            if (Array.isArray(_data["associatedProducts"])) {
                this.associatedProducts = [] as any;
                for (let item of _data["associatedProducts"])
                    this.associatedProducts!.push(item);
            }
            if (Array.isArray(_data["folderLinks"])) {
                this.folderLinks = [] as any;
                for (let item of _data["folderLinks"])
                    this.folderLinks!.push(MarketingActionFolderLinkDto.fromJS(item));
            }
            this.outlookSyncStatus = _data["outlookSyncStatus"];
            this.outlookEventId = _data["outlookEventId"];
        }
    }

    static fromJS(data: any): MarketingActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["actionType"] = this.actionType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : <any>undefined;
        data["createdByUserId"] = this.createdByUserId;
        data["createdByUsername"] = this.createdByUsername;
        data["modifiedByUserId"] = this.modifiedByUserId;
        data["modifiedByUsername"] = this.modifiedByUsername;
        if (Array.isArray(this.associatedProducts)) {
            data["associatedProducts"] = [];
            for (let item of this.associatedProducts)
                data["associatedProducts"].push(item);
        }
        if (Array.isArray(this.folderLinks)) {
            data["folderLinks"] = [];
            for (let item of this.folderLinks)
                data["folderLinks"].push(item.toJSON());
        }
        data["outlookSyncStatus"] = this.outlookSyncStatus;
        data["outlookEventId"] = this.outlookEventId;
        return data;
    }
}

export interface IMarketingActionDto {
    id?: number;
    title?: string;
    description?: string | undefined;
    actionType?: string;
    startDate?: Date;
    endDate?: Date | undefined;
    createdAt?: Date;
    modifiedAt?: Date;
    createdByUserId?: string;
    createdByUsername?: string | undefined;
    modifiedByUserId?: string | undefined;
    modifiedByUsername?: string | undefined;
    associatedProducts?: string[];
    folderLinks?: MarketingActionFolderLinkDto[];
    outlookSyncStatus?: string;
    outlookEventId?: string | undefined;
}

export class MarketingActionFolderLinkDto implements IMarketingActionFolderLinkDto {
    folderKey?: string;
    folderType?: string;

    constructor(data?: IMarketingActionFolderLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folderKey = _data["folderKey"];
            this.folderType = _data["folderType"];
        }
    }

    static fromJS(data: any): MarketingActionFolderLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingActionFolderLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderKey"] = this.folderKey;
        data["folderType"] = this.folderType;
        return data;
    }
}

export interface IMarketingActionFolderLinkDto {
    folderKey?: string;
    folderType?: string;
}

export enum MarketingActionType {
    SocialMedia = "SocialMedia",
    Blog = "Blog",
    Newsletter = "Newsletter",
    PR = "PR",
    Event = "Event",
    Meeting = "Meeting",
}

export class GetMarketingActionResponse extends BaseResponse implements IGetMarketingActionResponse {
    action?: MarketingActionDto | undefined;

    constructor(data?: IGetMarketingActionResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.action = _data["action"] ? MarketingActionDto.fromJS(_data["action"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetMarketingActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketingActionResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action ? this.action.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetMarketingActionResponse extends IBaseResponse {
    action?: MarketingActionDto | undefined;
}

export class GetMarketingCalendarResponse extends BaseResponse implements IGetMarketingCalendarResponse {
    actions?: MarketingActionCalendarDto[];

    constructor(data?: IGetMarketingCalendarResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(MarketingActionCalendarDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetMarketingCalendarResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketingCalendarResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetMarketingCalendarResponse extends IBaseResponse {
    actions?: MarketingActionCalendarDto[];
}

export class MarketingActionCalendarDto implements IMarketingActionCalendarDto {
    id?: number;
    title?: string;
    actionType?: string;
    startDate?: Date;
    endDate?: Date | undefined;
    associatedProducts?: string[];
    outlookSyncStatus?: string;

    constructor(data?: IMarketingActionCalendarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.actionType = _data["actionType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["associatedProducts"])) {
                this.associatedProducts = [] as any;
                for (let item of _data["associatedProducts"])
                    this.associatedProducts!.push(item);
            }
            this.outlookSyncStatus = _data["outlookSyncStatus"];
        }
    }

    static fromJS(data: any): MarketingActionCalendarDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingActionCalendarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["actionType"] = this.actionType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.associatedProducts)) {
            data["associatedProducts"] = [];
            for (let item of this.associatedProducts)
                data["associatedProducts"].push(item);
        }
        data["outlookSyncStatus"] = this.outlookSyncStatus;
        return data;
    }
}

export interface IMarketingActionCalendarDto {
    id?: number;
    title?: string;
    actionType?: string;
    startDate?: Date;
    endDate?: Date | undefined;
    associatedProducts?: string[];
    outlookSyncStatus?: string;
}

export class CreateMarketingActionResponse extends BaseResponse implements ICreateMarketingActionResponse {
    id?: number;
    createdAt?: Date;
    message?: string;

    constructor(data?: ICreateMarketingActionResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static override fromJS(data: any): CreateMarketingActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMarketingActionResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateMarketingActionResponse extends IBaseResponse {
    id?: number;
    createdAt?: Date;
    message?: string;
}

export class CreateMarketingActionRequest implements ICreateMarketingActionRequest {
    title!: string;
    description?: string | undefined;
    actionType!: MarketingActionType;
    startDate!: Date;
    endDate?: Date | undefined;
    associatedProducts?: string[] | undefined;
    folderLinks?: MarketingFolderLinkRequest[] | undefined;

    constructor(data?: ICreateMarketingActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.actionType = _data["actionType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["associatedProducts"])) {
                this.associatedProducts = [] as any;
                for (let item of _data["associatedProducts"])
                    this.associatedProducts!.push(item);
            }
            if (Array.isArray(_data["folderLinks"])) {
                this.folderLinks = [] as any;
                for (let item of _data["folderLinks"])
                    this.folderLinks!.push(MarketingFolderLinkRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMarketingActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMarketingActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["actionType"] = this.actionType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.associatedProducts)) {
            data["associatedProducts"] = [];
            for (let item of this.associatedProducts)
                data["associatedProducts"].push(item);
        }
        if (Array.isArray(this.folderLinks)) {
            data["folderLinks"] = [];
            for (let item of this.folderLinks)
                data["folderLinks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateMarketingActionRequest {
    title: string;
    description?: string | undefined;
    actionType: MarketingActionType;
    startDate: Date;
    endDate?: Date | undefined;
    associatedProducts?: string[] | undefined;
    folderLinks?: MarketingFolderLinkRequest[] | undefined;
}

export class MarketingFolderLinkRequest implements IMarketingFolderLinkRequest {
    folderKey!: string;
    folderType!: MarketingFolderType;

    constructor(data?: IMarketingFolderLinkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folderKey = _data["folderKey"];
            this.folderType = _data["folderType"];
        }
    }

    static fromJS(data: any): MarketingFolderLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingFolderLinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderKey"] = this.folderKey;
        data["folderType"] = this.folderType;
        return data;
    }
}

export interface IMarketingFolderLinkRequest {
    folderKey: string;
    folderType: MarketingFolderType;
}

export enum MarketingFolderType {
    Images = "Images",
    Texts = "Texts",
    Videos = "Videos",
    Graphics = "Graphics",
    Other = "Other",
}

export class UpdateMarketingActionResponse extends BaseResponse implements IUpdateMarketingActionResponse {
    id?: number;
    modifiedAt?: Date;
    message?: string;

    constructor(data?: IUpdateMarketingActionResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static override fromJS(data: any): UpdateMarketingActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMarketingActionResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : <any>undefined;
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateMarketingActionResponse extends IBaseResponse {
    id?: number;
    modifiedAt?: Date;
    message?: string;
}

export class UpdateMarketingActionRequest implements IUpdateMarketingActionRequest {
    id?: number;
    title!: string;
    description?: string | undefined;
    actionType!: MarketingActionType;
    startDate!: Date;
    endDate?: Date | undefined;
    associatedProducts?: string[] | undefined;
    folderLinks?: MarketingFolderLinkRequest[] | undefined;

    constructor(data?: IUpdateMarketingActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.actionType = _data["actionType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["associatedProducts"])) {
                this.associatedProducts = [] as any;
                for (let item of _data["associatedProducts"])
                    this.associatedProducts!.push(item);
            }
            if (Array.isArray(_data["folderLinks"])) {
                this.folderLinks = [] as any;
                for (let item of _data["folderLinks"])
                    this.folderLinks!.push(MarketingFolderLinkRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateMarketingActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMarketingActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["actionType"] = this.actionType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.associatedProducts)) {
            data["associatedProducts"] = [];
            for (let item of this.associatedProducts)
                data["associatedProducts"].push(item);
        }
        if (Array.isArray(this.folderLinks)) {
            data["folderLinks"] = [];
            for (let item of this.folderLinks)
                data["folderLinks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateMarketingActionRequest {
    id?: number;
    title: string;
    description?: string | undefined;
    actionType: MarketingActionType;
    startDate: Date;
    endDate?: Date | undefined;
    associatedProducts?: string[] | undefined;
    folderLinks?: MarketingFolderLinkRequest[] | undefined;
}

export class MoveMarketingActionResponse extends BaseResponse implements IMoveMarketingActionResponse {
    id?: number;
    modifiedAt?: Date;
    message?: string;

    constructor(data?: IMoveMarketingActionResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static override fromJS(data: any): MoveMarketingActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MoveMarketingActionResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : <any>undefined;
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }
}

export interface IMoveMarketingActionResponse extends IBaseResponse {
    id?: number;
    modifiedAt?: Date;
    message?: string;
}

export class MoveMarketingActionRequest implements IMoveMarketingActionRequest {
    id?: number;
    startDate!: Date;
    endDate?: Date | undefined;

    constructor(data?: IMoveMarketingActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MoveMarketingActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MoveMarketingActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMoveMarketingActionRequest {
    id?: number;
    startDate: Date;
    endDate?: Date | undefined;
}

export class DeleteMarketingActionResponse extends BaseResponse implements IDeleteMarketingActionResponse {
    id?: number;
    message?: string;

    constructor(data?: IDeleteMarketingActionResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
        }
    }

    static override fromJS(data: any): DeleteMarketingActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMarketingActionResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteMarketingActionResponse extends IBaseResponse {
    id?: number;
    message?: string;
}

export class ImportFromOutlookResponse extends BaseResponse implements IImportFromOutlookResponse {
    created?: number;
    updated?: number;
    skipped?: number;
    failed?: number;
    deleted?: number;
    unmappedCategories!: string[];
    items?: ImportedItemDto[];

    constructor(data?: IImportFromOutlookResponse) {
        super(data);
        if (!data) {
            this.unmappedCategories = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.created = _data["created"];
            this.updated = _data["updated"];
            this.skipped = _data["skipped"];
            this.failed = _data["failed"];
            this.deleted = _data["deleted"];
            if (Array.isArray(_data["unmappedCategories"])) {
                this.unmappedCategories = [] as any;
                for (let item of _data["unmappedCategories"])
                    this.unmappedCategories!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ImportedItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ImportFromOutlookResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportFromOutlookResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created;
        data["updated"] = this.updated;
        data["skipped"] = this.skipped;
        data["failed"] = this.failed;
        data["deleted"] = this.deleted;
        if (Array.isArray(this.unmappedCategories)) {
            data["unmappedCategories"] = [];
            for (let item of this.unmappedCategories)
                data["unmappedCategories"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IImportFromOutlookResponse extends IBaseResponse {
    created?: number;
    updated?: number;
    skipped?: number;
    failed?: number;
    deleted?: number;
    unmappedCategories: string[];
    items?: ImportedItemDto[];
}

export class ImportedItemDto implements IImportedItemDto {
    outlookEventId?: string;
    subject?: string;
    status?: string;
    error?: string | undefined;
    createdActionId?: number | undefined;

    constructor(data?: IImportedItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outlookEventId = _data["outlookEventId"];
            this.subject = _data["subject"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.createdActionId = _data["createdActionId"];
        }
    }

    static fromJS(data: any): ImportedItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportedItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outlookEventId"] = this.outlookEventId;
        data["subject"] = this.subject;
        data["status"] = this.status;
        data["error"] = this.error;
        data["createdActionId"] = this.createdActionId;
        return data;
    }
}

export interface IImportedItemDto {
    outlookEventId?: string;
    subject?: string;
    status?: string;
    error?: string | undefined;
    createdActionId?: number | undefined;
}

export class ImportFromOutlookRequest implements IImportFromOutlookRequest {
    fromUtc?: Date;
    toUtc?: Date;
    dryRun?: boolean;

    constructor(data?: IImportFromOutlookRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromUtc = _data["fromUtc"] ? new Date(_data["fromUtc"].toString()) : <any>undefined;
            this.toUtc = _data["toUtc"] ? new Date(_data["toUtc"].toString()) : <any>undefined;
            this.dryRun = _data["dryRun"];
        }
    }

    static fromJS(data: any): ImportFromOutlookRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportFromOutlookRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromUtc"] = this.fromUtc ? this.fromUtc.toISOString() : <any>undefined;
        data["toUtc"] = this.toUtc ? this.toUtc.toISOString() : <any>undefined;
        data["dryRun"] = this.dryRun;
        return data;
    }
}

export interface IImportFromOutlookRequest {
    fromUtc?: Date;
    toUtc?: Date;
    dryRun?: boolean;
}

export class GetMarketingPerformanceMonthsResponse extends BaseResponse implements IGetMarketingPerformanceMonthsResponse {
    months!: MonthlyMarketingPerformanceDto[];
    channels!: ChannelInfoDto[];
    from!: string;
    to!: string;
    includeWholesale!: boolean;
    vatRate!: number;
    lastRefreshAt?: Date | undefined;

    constructor(data?: IGetMarketingPerformanceMonthsResponse) {
        super(data);
        if (!data) {
            this.months = [];
            this.channels = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["months"])) {
                this.months = [] as any;
                for (let item of _data["months"])
                    this.months!.push(MonthlyMarketingPerformanceDto.fromJS(item));
            }
            if (Array.isArray(_data["channels"])) {
                this.channels = [] as any;
                for (let item of _data["channels"])
                    this.channels!.push(ChannelInfoDto.fromJS(item));
            }
            this.from = _data["from"];
            this.to = _data["to"];
            this.includeWholesale = _data["includeWholesale"];
            this.vatRate = _data["vatRate"];
            this.lastRefreshAt = _data["lastRefreshAt"] ? new Date(_data["lastRefreshAt"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetMarketingPerformanceMonthsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketingPerformanceMonthsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.months)) {
            data["months"] = [];
            for (let item of this.months)
                data["months"].push(item.toJSON());
        }
        if (Array.isArray(this.channels)) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item.toJSON());
        }
        data["from"] = this.from;
        data["to"] = this.to;
        data["includeWholesale"] = this.includeWholesale;
        data["vatRate"] = this.vatRate;
        data["lastRefreshAt"] = this.lastRefreshAt ? this.lastRefreshAt.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetMarketingPerformanceMonthsResponse extends IBaseResponse {
    months: MonthlyMarketingPerformanceDto[];
    channels: ChannelInfoDto[];
    from: string;
    to: string;
    includeWholesale: boolean;
    vatRate: number;
    lastRefreshAt?: Date | undefined;
}

export class MonthlyMarketingPerformanceDto implements IMonthlyMarketingPerformanceDto {
    year!: number;
    month!: number;
    monthYearDisplay!: string;
    hasData!: boolean;
    isLocked!: boolean;
    isPartial!: boolean;
    orders!: number;
    revenueWithVat!: number;
    revenueWithoutVat!: number;
    channelCosts!: ChannelCostDto[];
    totalCost!: number;
    pno?: number | undefined;
    roas?: number | undefined;
    profit!: number;
    avgOrderValue?: number | undefined;
    costPerOrder?: number | undefined;
    yoyCostPercent?: number | undefined;
    yoyRevenuePercent?: number | undefined;
    yoyOrdersPercent?: number | undefined;
    skippedEurInvoiceCount!: number;
    revenueComputedAt?: Date | undefined;
    costsComputedAt?: Date | undefined;
    lastError?: string | undefined;

    constructor(data?: IMonthlyMarketingPerformanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.channelCosts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.monthYearDisplay = _data["monthYearDisplay"];
            this.hasData = _data["hasData"];
            this.isLocked = _data["isLocked"];
            this.isPartial = _data["isPartial"];
            this.orders = _data["orders"];
            this.revenueWithVat = _data["revenueWithVat"];
            this.revenueWithoutVat = _data["revenueWithoutVat"];
            if (Array.isArray(_data["channelCosts"])) {
                this.channelCosts = [] as any;
                for (let item of _data["channelCosts"])
                    this.channelCosts!.push(ChannelCostDto.fromJS(item));
            }
            this.totalCost = _data["totalCost"];
            this.pno = _data["pno"];
            this.roas = _data["roas"];
            this.profit = _data["profit"];
            this.avgOrderValue = _data["avgOrderValue"];
            this.costPerOrder = _data["costPerOrder"];
            this.yoyCostPercent = _data["yoyCostPercent"];
            this.yoyRevenuePercent = _data["yoyRevenuePercent"];
            this.yoyOrdersPercent = _data["yoyOrdersPercent"];
            this.skippedEurInvoiceCount = _data["skippedEurInvoiceCount"];
            this.revenueComputedAt = _data["revenueComputedAt"] ? new Date(_data["revenueComputedAt"].toString()) : <any>undefined;
            this.costsComputedAt = _data["costsComputedAt"] ? new Date(_data["costsComputedAt"].toString()) : <any>undefined;
            this.lastError = _data["lastError"];
        }
    }

    static fromJS(data: any): MonthlyMarketingPerformanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyMarketingPerformanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["monthYearDisplay"] = this.monthYearDisplay;
        data["hasData"] = this.hasData;
        data["isLocked"] = this.isLocked;
        data["isPartial"] = this.isPartial;
        data["orders"] = this.orders;
        data["revenueWithVat"] = this.revenueWithVat;
        data["revenueWithoutVat"] = this.revenueWithoutVat;
        if (Array.isArray(this.channelCosts)) {
            data["channelCosts"] = [];
            for (let item of this.channelCosts)
                data["channelCosts"].push(item.toJSON());
        }
        data["totalCost"] = this.totalCost;
        data["pno"] = this.pno;
        data["roas"] = this.roas;
        data["profit"] = this.profit;
        data["avgOrderValue"] = this.avgOrderValue;
        data["costPerOrder"] = this.costPerOrder;
        data["yoyCostPercent"] = this.yoyCostPercent;
        data["yoyRevenuePercent"] = this.yoyRevenuePercent;
        data["yoyOrdersPercent"] = this.yoyOrdersPercent;
        data["skippedEurInvoiceCount"] = this.skippedEurInvoiceCount;
        data["revenueComputedAt"] = this.revenueComputedAt ? this.revenueComputedAt.toISOString() : <any>undefined;
        data["costsComputedAt"] = this.costsComputedAt ? this.costsComputedAt.toISOString() : <any>undefined;
        data["lastError"] = this.lastError;
        return data;
    }
}

export interface IMonthlyMarketingPerformanceDto {
    year: number;
    month: number;
    monthYearDisplay: string;
    hasData: boolean;
    isLocked: boolean;
    isPartial: boolean;
    orders: number;
    revenueWithVat: number;
    revenueWithoutVat: number;
    channelCosts: ChannelCostDto[];
    totalCost: number;
    pno?: number | undefined;
    roas?: number | undefined;
    profit: number;
    avgOrderValue?: number | undefined;
    costPerOrder?: number | undefined;
    yoyCostPercent?: number | undefined;
    yoyRevenuePercent?: number | undefined;
    yoyOrdersPercent?: number | undefined;
    skippedEurInvoiceCount: number;
    revenueComputedAt?: Date | undefined;
    costsComputedAt?: Date | undefined;
    lastError?: string | undefined;
}

export class ChannelCostDto implements IChannelCostDto {
    channelCode!: string;
    label!: string;
    costWithoutVat!: number;
    invoiceCount!: number;

    constructor(data?: IChannelCostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelCode = _data["channelCode"];
            this.label = _data["label"];
            this.costWithoutVat = _data["costWithoutVat"];
            this.invoiceCount = _data["invoiceCount"];
        }
    }

    static fromJS(data: any): ChannelCostDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelCostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelCode"] = this.channelCode;
        data["label"] = this.label;
        data["costWithoutVat"] = this.costWithoutVat;
        data["invoiceCount"] = this.invoiceCount;
        return data;
    }
}

export interface IChannelCostDto {
    channelCode: string;
    label: string;
    costWithoutVat: number;
    invoiceCount: number;
}

export class ChannelInfoDto implements IChannelInfoDto {
    code!: string;
    label!: string;

    constructor(data?: IChannelInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ChannelInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["label"] = this.label;
        return data;
    }
}

export interface IChannelInfoDto {
    code: string;
    label: string;
}

export class GetMarketingPerformanceComparisonResponse extends BaseResponse implements IGetMarketingPerformanceComparisonResponse {
    series!: MarketingYearSeriesDto[];
    anchorYear!: number;
    currentMonth!: number;
    channels!: ChannelInfoDto[];
    includeWholesale!: boolean;
    lastRefreshAt?: Date | undefined;

    constructor(data?: IGetMarketingPerformanceComparisonResponse) {
        super(data);
        if (!data) {
            this.series = [];
            this.channels = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(MarketingYearSeriesDto.fromJS(item));
            }
            this.anchorYear = _data["anchorYear"];
            this.currentMonth = _data["currentMonth"];
            if (Array.isArray(_data["channels"])) {
                this.channels = [] as any;
                for (let item of _data["channels"])
                    this.channels!.push(ChannelInfoDto.fromJS(item));
            }
            this.includeWholesale = _data["includeWholesale"];
            this.lastRefreshAt = _data["lastRefreshAt"] ? new Date(_data["lastRefreshAt"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetMarketingPerformanceComparisonResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketingPerformanceComparisonResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        data["anchorYear"] = this.anchorYear;
        data["currentMonth"] = this.currentMonth;
        if (Array.isArray(this.channels)) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item.toJSON());
        }
        data["includeWholesale"] = this.includeWholesale;
        data["lastRefreshAt"] = this.lastRefreshAt ? this.lastRefreshAt.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetMarketingPerformanceComparisonResponse extends IBaseResponse {
    series: MarketingYearSeriesDto[];
    anchorYear: number;
    currentMonth: number;
    channels: ChannelInfoDto[];
    includeWholesale: boolean;
    lastRefreshAt?: Date | undefined;
}

export class MarketingYearSeriesDto implements IMarketingYearSeriesDto {
    year!: number;
    months!: MonthlyMarketingPerformanceDto[];
    ytdOrders!: number;
    ytdRevenueWithoutVat!: number;
    ytdTotalCost!: number;
    ytdPno?: number | undefined;

    constructor(data?: IMarketingYearSeriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.months = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            if (Array.isArray(_data["months"])) {
                this.months = [] as any;
                for (let item of _data["months"])
                    this.months!.push(MonthlyMarketingPerformanceDto.fromJS(item));
            }
            this.ytdOrders = _data["ytdOrders"];
            this.ytdRevenueWithoutVat = _data["ytdRevenueWithoutVat"];
            this.ytdTotalCost = _data["ytdTotalCost"];
            this.ytdPno = _data["ytdPno"];
        }
    }

    static fromJS(data: any): MarketingYearSeriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingYearSeriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        if (Array.isArray(this.months)) {
            data["months"] = [];
            for (let item of this.months)
                data["months"].push(item.toJSON());
        }
        data["ytdOrders"] = this.ytdOrders;
        data["ytdRevenueWithoutVat"] = this.ytdRevenueWithoutVat;
        data["ytdTotalCost"] = this.ytdTotalCost;
        data["ytdPno"] = this.ytdPno;
        return data;
    }
}

export interface IMarketingYearSeriesDto {
    year: number;
    months: MonthlyMarketingPerformanceDto[];
    ytdOrders: number;
    ytdRevenueWithoutVat: number;
    ytdTotalCost: number;
    ytdPno?: number | undefined;
}

export class RecomputeMarketingPerformanceResponse extends BaseResponse implements IRecomputeMarketingPerformanceResponse {
    jobId?: string | undefined;
    monthCount?: number;

    constructor(data?: IRecomputeMarketingPerformanceResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobId = _data["jobId"];
            this.monthCount = _data["monthCount"];
        }
    }

    static override fromJS(data: any): RecomputeMarketingPerformanceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecomputeMarketingPerformanceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["monthCount"] = this.monthCount;
        super.toJSON(data);
        return data;
    }
}

export interface IRecomputeMarketingPerformanceResponse extends IBaseResponse {
    jobId?: string | undefined;
    monthCount?: number;
}

export class RecomputeMarketingPerformanceRequest implements IRecomputeMarketingPerformanceRequest {
    from?: string;
    to?: string;

    constructor(data?: IRecomputeMarketingPerformanceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.to = _data["to"];
        }
    }

    static fromJS(data: any): RecomputeMarketingPerformanceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecomputeMarketingPerformanceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["to"] = this.to;
        return data;
    }
}

export interface IRecomputeMarketingPerformanceRequest {
    from?: string;
    to?: string;
}

export class ListMaterialContainersResponse extends BaseResponse implements IListMaterialContainersResponse {
    containers?: MaterialContainerDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IListMaterialContainersResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["containers"])) {
                this.containers = [] as any;
                for (let item of _data["containers"])
                    this.containers!.push(MaterialContainerDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static override fromJS(data: any): ListMaterialContainersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListMaterialContainersResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.containers)) {
            data["containers"] = [];
            for (let item of this.containers)
                data["containers"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}

export interface IListMaterialContainersResponse extends IBaseResponse {
    containers?: MaterialContainerDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class GetLastUsedLotForMaterialResponse extends BaseResponse implements IGetLastUsedLotForMaterialResponse {
    lotCode?: string | undefined;

    constructor(data?: IGetLastUsedLotForMaterialResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lotCode = _data["lotCode"];
        }
    }

    static override fromJS(data: any): GetLastUsedLotForMaterialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLastUsedLotForMaterialResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lotCode"] = this.lotCode;
        super.toJSON(data);
        return data;
    }
}

export interface IGetLastUsedLotForMaterialResponse extends IBaseResponse {
    lotCode?: string | undefined;
}

export class GetMaterialContainerByCodeResponse extends BaseResponse implements IGetMaterialContainerByCodeResponse {
    container?: MaterialContainerDto;

    constructor(data?: IGetMaterialContainerByCodeResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.container = _data["container"] ? MaterialContainerDto.fromJS(_data["container"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetMaterialContainerByCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMaterialContainerByCodeResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["container"] = this.container ? this.container.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetMaterialContainerByCodeResponse extends IBaseResponse {
    container?: MaterialContainerDto;
}

export class CreateMaterialContainersResponse extends BaseResponse implements ICreateMaterialContainersResponse {
    containers?: MaterialContainerDto[];

    constructor(data?: ICreateMaterialContainersResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["containers"])) {
                this.containers = [] as any;
                for (let item of _data["containers"])
                    this.containers!.push(MaterialContainerDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CreateMaterialContainersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMaterialContainersResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.containers)) {
            data["containers"] = [];
            for (let item of this.containers)
                data["containers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICreateMaterialContainersResponse extends IBaseResponse {
    containers?: MaterialContainerDto[];
}

export class CreateMaterialContainersRequest implements ICreateMaterialContainersRequest {
    items?: CreateMaterialContainerItem[];

    constructor(data?: ICreateMaterialContainersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CreateMaterialContainerItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMaterialContainersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMaterialContainersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateMaterialContainersRequest {
    items?: CreateMaterialContainerItem[];
}

export class CreateMaterialContainerItem implements ICreateMaterialContainerItem {
    code?: string;
    materialCode?: string;
    lotCode?: string;
    amount?: number | undefined;
    unit?: string | undefined;
    purchaseOrderLineId?: number | undefined;

    constructor(data?: ICreateMaterialContainerItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.materialCode = _data["materialCode"];
            this.lotCode = _data["lotCode"];
            this.amount = _data["amount"];
            this.unit = _data["unit"];
            this.purchaseOrderLineId = _data["purchaseOrderLineId"];
        }
    }

    static fromJS(data: any): CreateMaterialContainerItem {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMaterialContainerItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["materialCode"] = this.materialCode;
        data["lotCode"] = this.lotCode;
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        data["purchaseOrderLineId"] = this.purchaseOrderLineId;
        return data;
    }
}

export interface ICreateMaterialContainerItem {
    code?: string;
    materialCode?: string;
    lotCode?: string;
    amount?: number | undefined;
    unit?: string | undefined;
    purchaseOrderLineId?: number | undefined;
}

export class DiscardMaterialContainerResponse extends BaseResponse implements IDiscardMaterialContainerResponse {

    constructor(data?: IDiscardMaterialContainerResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DiscardMaterialContainerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DiscardMaterialContainerResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDiscardMaterialContainerResponse extends IBaseResponse {
}

export class PrintMaterialContainerLabelsResponse extends BaseResponse implements IPrintMaterialContainerLabelsResponse {
    containers?: MaterialContainerDto[];
    requiresMediaChangeConfirmation?: boolean;

    constructor(data?: IPrintMaterialContainerLabelsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["containers"])) {
                this.containers = [] as any;
                for (let item of _data["containers"])
                    this.containers!.push(MaterialContainerDto.fromJS(item));
            }
            this.requiresMediaChangeConfirmation = _data["requiresMediaChangeConfirmation"];
        }
    }

    static override fromJS(data: any): PrintMaterialContainerLabelsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrintMaterialContainerLabelsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.containers)) {
            data["containers"] = [];
            for (let item of this.containers)
                data["containers"].push(item.toJSON());
        }
        data["requiresMediaChangeConfirmation"] = this.requiresMediaChangeConfirmation;
        super.toJSON(data);
        return data;
    }
}

export interface IPrintMaterialContainerLabelsResponse extends IBaseResponse {
    containers?: MaterialContainerDto[];
    requiresMediaChangeConfirmation?: boolean;
}

export class PrintMaterialContainerLabelsRequest implements IPrintMaterialContainerLabelsRequest {
    count?: number;
    mediaChangeConfirmed?: boolean;

    constructor(data?: IPrintMaterialContainerLabelsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.mediaChangeConfirmed = _data["mediaChangeConfirmed"];
        }
    }

    static fromJS(data: any): PrintMaterialContainerLabelsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PrintMaterialContainerLabelsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["mediaChangeConfirmed"] = this.mediaChangeConfirmed;
        return data;
    }
}

export interface IPrintMaterialContainerLabelsRequest {
    count?: number;
    mediaChangeConfirmed?: boolean;
}

export class GetTranscriptListResponse extends BaseResponse implements IGetTranscriptListResponse {
    items?: MeetingTranscriptDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;

    constructor(data?: IGetTranscriptListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeetingTranscriptDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static override fromJS(data: any): GetTranscriptListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTranscriptListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTranscriptListResponse extends IBaseResponse {
    items?: MeetingTranscriptDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class MeetingTranscriptDto implements IMeetingTranscriptDto {
    id?: string;
    plaudRecordingId?: string;
    plaudCreatedAt?: Date;
    subject?: string;
    summary?: string;
    rawTranscript?: string;
    status?: string;
    receivedAt?: Date;
    reviewedAt?: Date | undefined;
    reviewedByUser?: string | undefined;
    taskCount?: number;
    approvedTaskCount?: number;
    rejectedTaskCount?: number;
    tasks?: ProposedTaskDto[];
    participants?: string[];
    accessLevel?: string;
    accessGrants?: MeetingAccessGrantDto[];

    constructor(data?: IMeetingTranscriptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plaudRecordingId = _data["plaudRecordingId"];
            this.plaudCreatedAt = _data["plaudCreatedAt"] ? new Date(_data["plaudCreatedAt"].toString()) : <any>undefined;
            this.subject = _data["subject"];
            this.summary = _data["summary"];
            this.rawTranscript = _data["rawTranscript"];
            this.status = _data["status"];
            this.receivedAt = _data["receivedAt"] ? new Date(_data["receivedAt"].toString()) : <any>undefined;
            this.reviewedAt = _data["reviewedAt"] ? new Date(_data["reviewedAt"].toString()) : <any>undefined;
            this.reviewedByUser = _data["reviewedByUser"];
            this.taskCount = _data["taskCount"];
            this.approvedTaskCount = _data["approvedTaskCount"];
            this.rejectedTaskCount = _data["rejectedTaskCount"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(ProposedTaskDto.fromJS(item));
            }
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(item);
            }
            this.accessLevel = _data["accessLevel"];
            if (Array.isArray(_data["accessGrants"])) {
                this.accessGrants = [] as any;
                for (let item of _data["accessGrants"])
                    this.accessGrants!.push(MeetingAccessGrantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeetingTranscriptDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingTranscriptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plaudRecordingId"] = this.plaudRecordingId;
        data["plaudCreatedAt"] = this.plaudCreatedAt ? this.plaudCreatedAt.toISOString() : <any>undefined;
        data["subject"] = this.subject;
        data["summary"] = this.summary;
        data["rawTranscript"] = this.rawTranscript;
        data["status"] = this.status;
        data["receivedAt"] = this.receivedAt ? this.receivedAt.toISOString() : <any>undefined;
        data["reviewedAt"] = this.reviewedAt ? this.reviewedAt.toISOString() : <any>undefined;
        data["reviewedByUser"] = this.reviewedByUser;
        data["taskCount"] = this.taskCount;
        data["approvedTaskCount"] = this.approvedTaskCount;
        data["rejectedTaskCount"] = this.rejectedTaskCount;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item);
        }
        data["accessLevel"] = this.accessLevel;
        if (Array.isArray(this.accessGrants)) {
            data["accessGrants"] = [];
            for (let item of this.accessGrants)
                data["accessGrants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMeetingTranscriptDto {
    id?: string;
    plaudRecordingId?: string;
    plaudCreatedAt?: Date;
    subject?: string;
    summary?: string;
    rawTranscript?: string;
    status?: string;
    receivedAt?: Date;
    reviewedAt?: Date | undefined;
    reviewedByUser?: string | undefined;
    taskCount?: number;
    approvedTaskCount?: number;
    rejectedTaskCount?: number;
    tasks?: ProposedTaskDto[];
    participants?: string[];
    accessLevel?: string;
    accessGrants?: MeetingAccessGrantDto[];
}

export class ProposedTaskDto implements IProposedTaskDto {
    id?: string;
    title?: string;
    description?: string;
    assignee?: string;
    assigneeEmail?: string | undefined;
    dueDate?: Date | undefined;
    status?: string;
    externalTaskId?: string | undefined;
    isManuallyAdded?: boolean;

    constructor(data?: IProposedTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.assignee = _data["assignee"];
            this.assigneeEmail = _data["assigneeEmail"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.externalTaskId = _data["externalTaskId"];
            this.isManuallyAdded = _data["isManuallyAdded"];
        }
    }

    static fromJS(data: any): ProposedTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProposedTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["assignee"] = this.assignee;
        data["assigneeEmail"] = this.assigneeEmail;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["externalTaskId"] = this.externalTaskId;
        data["isManuallyAdded"] = this.isManuallyAdded;
        return data;
    }
}

export interface IProposedTaskDto {
    id?: string;
    title?: string;
    description?: string;
    assignee?: string;
    assigneeEmail?: string | undefined;
    dueDate?: Date | undefined;
    status?: string;
    externalTaskId?: string | undefined;
    isManuallyAdded?: boolean;
}

export class MeetingAccessGrantDto implements IMeetingAccessGrantDto {
    userEmail?: string;
    userDisplayName?: string | undefined;

    constructor(data?: IMeetingAccessGrantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userEmail = _data["userEmail"];
            this.userDisplayName = _data["userDisplayName"];
        }
    }

    static fromJS(data: any): MeetingAccessGrantDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingAccessGrantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userEmail"] = this.userEmail;
        data["userDisplayName"] = this.userDisplayName;
        return data;
    }
}

export interface IMeetingAccessGrantDto {
    userEmail?: string;
    userDisplayName?: string | undefined;
}

export class GetMeetingUsersResponse extends BaseResponse implements IGetMeetingUsersResponse {
    users?: MeetingUserDto[];

    constructor(data?: IGetMeetingUsersResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(MeetingUserDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetMeetingUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeetingUsersResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetMeetingUsersResponse extends IBaseResponse {
    users?: MeetingUserDto[];
}

export class MeetingUserDto implements IMeetingUserDto {
    email?: string;
    displayName?: string;
    aliases?: string[];

    constructor(data?: IMeetingUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["aliases"])) {
                this.aliases = [] as any;
                for (let item of _data["aliases"])
                    this.aliases!.push(item);
            }
        }
    }

    static fromJS(data: any): MeetingUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.aliases)) {
            data["aliases"] = [];
            for (let item of this.aliases)
                data["aliases"].push(item);
        }
        return data;
    }
}

export interface IMeetingUserDto {
    email?: string;
    displayName?: string;
    aliases?: string[];
}

export class GetTranscriptDetailResponse extends BaseResponse implements IGetTranscriptDetailResponse {
    transcript?: MeetingTranscriptDto;

    constructor(data?: IGetTranscriptDetailResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transcript = _data["transcript"] ? MeetingTranscriptDto.fromJS(_data["transcript"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetTranscriptDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTranscriptDetailResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transcript"] = this.transcript ? this.transcript.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTranscriptDetailResponse extends IBaseResponse {
    transcript?: MeetingTranscriptDto;
}

export class UpdateProposedTaskResponse extends BaseResponse implements IUpdateProposedTaskResponse {

    constructor(data?: IUpdateProposedTaskResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateProposedTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProposedTaskResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateProposedTaskResponse extends IBaseResponse {
}

export class UpdateProposedTaskRequest implements IUpdateProposedTaskRequest {
    transcriptId?: string;
    taskId?: string;
    title!: string;
    description?: string;
    assignee!: string;
    assigneeEmail?: string | undefined;
    dueDate?: Date | undefined;

    constructor(data?: IUpdateProposedTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transcriptId = _data["transcriptId"];
            this.taskId = _data["taskId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.assignee = _data["assignee"];
            this.assigneeEmail = _data["assigneeEmail"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateProposedTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProposedTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transcriptId"] = this.transcriptId;
        data["taskId"] = this.taskId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["assignee"] = this.assignee;
        data["assigneeEmail"] = this.assigneeEmail;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateProposedTaskRequest {
    transcriptId?: string;
    taskId?: string;
    title: string;
    description?: string;
    assignee: string;
    assigneeEmail?: string | undefined;
    dueDate?: Date | undefined;
}

export class UpdateProposedTaskStatusResponse extends BaseResponse implements IUpdateProposedTaskStatusResponse {

    constructor(data?: IUpdateProposedTaskStatusResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateProposedTaskStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProposedTaskStatusResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateProposedTaskStatusResponse extends IBaseResponse {
}

export class UpdateProposedTaskStatusRequest implements IUpdateProposedTaskStatusRequest {
    transcriptId?: string;
    taskId?: string;
    status!: string;

    constructor(data?: IUpdateProposedTaskStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transcriptId = _data["transcriptId"];
            this.taskId = _data["taskId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateProposedTaskStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProposedTaskStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transcriptId"] = this.transcriptId;
        data["taskId"] = this.taskId;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateProposedTaskStatusRequest {
    transcriptId?: string;
    taskId?: string;
    status: string;
}

export class UpdateTranscriptStatusResponse extends BaseResponse implements IUpdateTranscriptStatusResponse {
    status?: string | undefined;

    constructor(data?: IUpdateTranscriptStatusResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static override fromJS(data: any): UpdateTranscriptStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTranscriptStatusResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateTranscriptStatusResponse extends IBaseResponse {
    status?: string | undefined;
}

export class UpdateTranscriptStatusRequest implements IUpdateTranscriptStatusRequest {
    transcriptId?: string;
    status?: string;

    constructor(data?: IUpdateTranscriptStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transcriptId = _data["transcriptId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateTranscriptStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTranscriptStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transcriptId"] = this.transcriptId;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateTranscriptStatusRequest {
    transcriptId?: string;
    status?: string;
}

export class AddProposedTaskResponse extends BaseResponse implements IAddProposedTaskResponse {
    task?: ProposedTaskDto | undefined;

    constructor(data?: IAddProposedTaskResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.task = _data["task"] ? ProposedTaskDto.fromJS(_data["task"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AddProposedTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddProposedTaskResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["task"] = this.task ? this.task.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAddProposedTaskResponse extends IBaseResponse {
    task?: ProposedTaskDto | undefined;
}

export class AddProposedTaskRequest implements IAddProposedTaskRequest {
    transcriptId?: string;
    title!: string;
    description?: string;
    assignee!: string;
    assigneeEmail?: string | undefined;
    dueDate?: Date | undefined;

    constructor(data?: IAddProposedTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transcriptId = _data["transcriptId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.assignee = _data["assignee"];
            this.assigneeEmail = _data["assigneeEmail"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AddProposedTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddProposedTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transcriptId"] = this.transcriptId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["assignee"] = this.assignee;
        data["assigneeEmail"] = this.assigneeEmail;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAddProposedTaskRequest {
    transcriptId?: string;
    title: string;
    description?: string;
    assignee: string;
    assigneeEmail?: string | undefined;
    dueDate?: Date | undefined;
}

export class SubmitToTodoResponse extends BaseResponse implements ISubmitToTodoResponse {
    successCount?: number;
    failedCount?: number;
    errors?: string[];

    constructor(data?: ISubmitToTodoResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.successCount = _data["successCount"];
            this.failedCount = _data["failedCount"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static override fromJS(data: any): SubmitToTodoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitToTodoResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["successCount"] = this.successCount;
        data["failedCount"] = this.failedCount;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISubmitToTodoResponse extends IBaseResponse {
    successCount?: number;
    failedCount?: number;
    errors?: string[];
}

export class ExplainSummaryResponse extends BaseResponse implements IExplainSummaryResponse {
    relevantTranscript?: string;
    explanation?: string;

    constructor(data?: IExplainSummaryResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.relevantTranscript = _data["relevantTranscript"];
            this.explanation = _data["explanation"];
        }
    }

    static override fromJS(data: any): ExplainSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExplainSummaryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relevantTranscript"] = this.relevantTranscript;
        data["explanation"] = this.explanation;
        super.toJSON(data);
        return data;
    }
}

export interface IExplainSummaryResponse extends IBaseResponse {
    relevantTranscript?: string;
    explanation?: string;
}

export class ExplainSummaryRequest implements IExplainSummaryRequest {
    transcriptId?: string;
    selectedText!: string;

    constructor(data?: IExplainSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transcriptId = _data["transcriptId"];
            this.selectedText = _data["selectedText"];
        }
    }

    static fromJS(data: any): ExplainSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExplainSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transcriptId"] = this.transcriptId;
        data["selectedText"] = this.selectedText;
        return data;
    }
}

export interface IExplainSummaryRequest {
    transcriptId?: string;
    selectedText: string;
}

export class UpdateMeetingAccessResponse extends BaseResponse implements IUpdateMeetingAccessResponse {
    accessLevel?: string | undefined;
    grants?: MeetingAccessGrantDto[];

    constructor(data?: IUpdateMeetingAccessResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accessLevel = _data["accessLevel"];
            if (Array.isArray(_data["grants"])) {
                this.grants = [] as any;
                for (let item of _data["grants"])
                    this.grants!.push(MeetingAccessGrantDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): UpdateMeetingAccessResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeetingAccessResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessLevel"] = this.accessLevel;
        if (Array.isArray(this.grants)) {
            data["grants"] = [];
            for (let item of this.grants)
                data["grants"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateMeetingAccessResponse extends IBaseResponse {
    accessLevel?: string | undefined;
    grants?: MeetingAccessGrantDto[];
}

export class UpdateMeetingAccessRequest implements IUpdateMeetingAccessRequest {
    transcriptId?: string;
    accessLevel?: string;
    restrictedUserEmails?: string[];

    constructor(data?: IUpdateMeetingAccessRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transcriptId = _data["transcriptId"];
            this.accessLevel = _data["accessLevel"];
            if (Array.isArray(_data["restrictedUserEmails"])) {
                this.restrictedUserEmails = [] as any;
                for (let item of _data["restrictedUserEmails"])
                    this.restrictedUserEmails!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateMeetingAccessRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeetingAccessRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transcriptId"] = this.transcriptId;
        data["accessLevel"] = this.accessLevel;
        if (Array.isArray(this.restrictedUserEmails)) {
            data["restrictedUserEmails"] = [];
            for (let item of this.restrictedUserEmails)
                data["restrictedUserEmails"].push(item);
        }
        return data;
    }
}

export interface IUpdateMeetingAccessRequest {
    transcriptId?: string;
    accessLevel?: string;
    restrictedUserEmails?: string[];
}

export class ReimportMeetingTranscriptResponse extends BaseResponse implements IReimportMeetingTranscriptResponse {

    constructor(data?: IReimportMeetingTranscriptResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ReimportMeetingTranscriptResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReimportMeetingTranscriptResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IReimportMeetingTranscriptResponse extends IBaseResponse {
}

export class DeleteMeetingTranscriptResponse extends BaseResponse implements IDeleteMeetingTranscriptResponse {

    constructor(data?: IDeleteMeetingTranscriptResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DeleteMeetingTranscriptResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMeetingTranscriptResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteMeetingTranscriptResponse extends IBaseResponse {
}

export class GetMindMapListResponse extends BaseResponse implements IGetMindMapListResponse {
    items?: MindMapListItemDto[];

    constructor(data?: IGetMindMapListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MindMapListItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetMindMapListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMindMapListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetMindMapListResponse extends IBaseResponse {
    items?: MindMapListItemDto[];
}

export class MindMapListItemDto implements IMindMapListItemDto {
    id?: string;
    name?: string;
    description?: string | undefined;
    status?: string;
    meetingCount?: number;
    updatedAt?: Date;

    constructor(data?: IMindMapListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.meetingCount = _data["meetingCount"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MindMapListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MindMapListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["meetingCount"] = this.meetingCount;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMindMapListItemDto {
    id?: string;
    name?: string;
    description?: string | undefined;
    status?: string;
    meetingCount?: number;
    updatedAt?: Date;
}

export class GetMindMapDetailResponse extends BaseResponse implements IGetMindMapDetailResponse {
    id?: string;
    name?: string;
    description?: string | undefined;
    status?: string;
    lastError?: string | undefined;
    documentJson?: string;
    meetings?: AttachedMeetingDto[];
    versions?: MindMapVersionDto[];

    constructor(data?: IGetMindMapDetailResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.lastError = _data["lastError"];
            this.documentJson = _data["documentJson"];
            if (Array.isArray(_data["meetings"])) {
                this.meetings = [] as any;
                for (let item of _data["meetings"])
                    this.meetings!.push(AttachedMeetingDto.fromJS(item));
            }
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(MindMapVersionDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetMindMapDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMindMapDetailResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["lastError"] = this.lastError;
        data["documentJson"] = this.documentJson;
        if (Array.isArray(this.meetings)) {
            data["meetings"] = [];
            for (let item of this.meetings)
                data["meetings"].push(item.toJSON());
        }
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetMindMapDetailResponse extends IBaseResponse {
    id?: string;
    name?: string;
    description?: string | undefined;
    status?: string;
    lastError?: string | undefined;
    documentJson?: string;
    meetings?: AttachedMeetingDto[];
    versions?: MindMapVersionDto[];
}

export class AttachedMeetingDto implements IAttachedMeetingDto {
    meetingTranscriptId?: string;
    subject?: string;
    plaudCreatedAt?: Date;
    attachedAt?: Date;
    processedAt?: Date | undefined;

    constructor(data?: IAttachedMeetingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meetingTranscriptId = _data["meetingTranscriptId"];
            this.subject = _data["subject"];
            this.plaudCreatedAt = _data["plaudCreatedAt"] ? new Date(_data["plaudCreatedAt"].toString()) : <any>undefined;
            this.attachedAt = _data["attachedAt"] ? new Date(_data["attachedAt"].toString()) : <any>undefined;
            this.processedAt = _data["processedAt"] ? new Date(_data["processedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AttachedMeetingDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachedMeetingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meetingTranscriptId"] = this.meetingTranscriptId;
        data["subject"] = this.subject;
        data["plaudCreatedAt"] = this.plaudCreatedAt ? this.plaudCreatedAt.toISOString() : <any>undefined;
        data["attachedAt"] = this.attachedAt ? this.attachedAt.toISOString() : <any>undefined;
        data["processedAt"] = this.processedAt ? this.processedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAttachedMeetingDto {
    meetingTranscriptId?: string;
    subject?: string;
    plaudCreatedAt?: Date;
    attachedAt?: Date;
    processedAt?: Date | undefined;
}

export class MindMapVersionDto implements IMindMapVersionDto {
    versionNumber?: number;
    createdAt?: Date;
    triggerMeetingId?: string | undefined;
    triggerMeetingSubject?: string | undefined;

    constructor(data?: IMindMapVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNumber = _data["versionNumber"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.triggerMeetingId = _data["triggerMeetingId"];
            this.triggerMeetingSubject = _data["triggerMeetingSubject"];
        }
    }

    static fromJS(data: any): MindMapVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MindMapVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNumber"] = this.versionNumber;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["triggerMeetingId"] = this.triggerMeetingId;
        data["triggerMeetingSubject"] = this.triggerMeetingSubject;
        return data;
    }
}

export interface IMindMapVersionDto {
    versionNumber?: number;
    createdAt?: Date;
    triggerMeetingId?: string | undefined;
    triggerMeetingSubject?: string | undefined;
}

export class CreateMindMapResponse extends BaseResponse implements ICreateMindMapResponse {
    id?: string;

    constructor(data?: ICreateMindMapResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): CreateMindMapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMindMapResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateMindMapResponse extends IBaseResponse {
    id?: string;
}

export class CreateMindMapRequest implements ICreateMindMapRequest {
    name!: string;
    description?: string | undefined;

    constructor(data?: ICreateMindMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateMindMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMindMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateMindMapRequest {
    name: string;
    description?: string | undefined;
}

export class DeleteMindMapResponse extends BaseResponse implements IDeleteMindMapResponse {

    constructor(data?: IDeleteMindMapResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DeleteMindMapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMindMapResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteMindMapResponse extends IBaseResponse {
}

export class AttachMeetingResponse extends BaseResponse implements IAttachMeetingResponse {

    constructor(data?: IAttachMeetingResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AttachMeetingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AttachMeetingResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAttachMeetingResponse extends IBaseResponse {
}

export class AttachMeetingRequest implements IAttachMeetingRequest {
    mindMapId?: string;
    meetingTranscriptId!: string;

    constructor(data?: IAttachMeetingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mindMapId = _data["mindMapId"];
            this.meetingTranscriptId = _data["meetingTranscriptId"];
        }
    }

    static fromJS(data: any): AttachMeetingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AttachMeetingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mindMapId"] = this.mindMapId;
        data["meetingTranscriptId"] = this.meetingTranscriptId;
        return data;
    }
}

export interface IAttachMeetingRequest {
    mindMapId?: string;
    meetingTranscriptId: string;
}

export class DetachMeetingResponse extends BaseResponse implements IDetachMeetingResponse {

    constructor(data?: IDetachMeetingResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DetachMeetingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DetachMeetingResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDetachMeetingResponse extends IBaseResponse {
}

export class RegenerateMindMapResponse extends BaseResponse implements IRegenerateMindMapResponse {

    constructor(data?: IRegenerateMindMapResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): RegenerateMindMapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegenerateMindMapResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRegenerateMindMapResponse extends IBaseResponse {
}

export class SaveMindMapDocumentResponse extends BaseResponse implements ISaveMindMapDocumentResponse {
    documentJson?: string;

    constructor(data?: ISaveMindMapDocumentResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentJson = _data["documentJson"];
        }
    }

    static override fromJS(data: any): SaveMindMapDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMindMapDocumentResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentJson"] = this.documentJson;
        super.toJSON(data);
        return data;
    }
}

export interface ISaveMindMapDocumentResponse extends IBaseResponse {
    documentJson?: string;
}

export class SaveMindMapDocumentRequest implements ISaveMindMapDocumentRequest {
    id?: string;
    documentJson!: string;

    constructor(data?: ISaveMindMapDocumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentJson = _data["documentJson"];
        }
    }

    static fromJS(data: any): SaveMindMapDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMindMapDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentJson"] = this.documentJson;
        return data;
    }
}

export interface ISaveMindMapDocumentRequest {
    id?: string;
    documentJson: string;
}

export class RestoreMindMapVersionResponse extends BaseResponse implements IRestoreMindMapVersionResponse {
    documentJson?: string;

    constructor(data?: IRestoreMindMapVersionResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentJson = _data["documentJson"];
        }
    }

    static override fromJS(data: any): RestoreMindMapVersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreMindMapVersionResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentJson"] = this.documentJson;
        super.toJSON(data);
        return data;
    }
}

export interface IRestoreMindMapVersionResponse extends IBaseResponse {
    documentJson?: string;
}

export class OrgChartResponse extends BaseResponse implements IOrgChartResponse {
    organization?: OrganizationDto;

    constructor(data?: IOrgChartResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organization = _data["organization"] ? OrganizationDto.fromJS(_data["organization"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): OrgChartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrgChartResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IOrgChartResponse extends IBaseResponse {
    organization?: OrganizationDto;
}

export class OrganizationDto implements IOrganizationDto {
    name?: string;
    positions?: PositionDto[];

    constructor(data?: IOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(PositionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganizationDto {
    name?: string;
    positions?: PositionDto[];
}

export class PositionDto implements IPositionDto {
    id?: string;
    title?: string;
    description?: string;
    level?: number | undefined;
    parentPositionId?: string | undefined;
    department?: string;
    employees?: EmployeeDto[];
    url?: string | undefined;

    constructor(data?: IPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.level = _data["level"];
            this.parentPositionId = _data["parentPositionId"];
            this.department = _data["department"];
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(EmployeeDto.fromJS(item));
            }
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): PositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["level"] = this.level;
        data["parentPositionId"] = this.parentPositionId;
        data["department"] = this.department;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item.toJSON());
        }
        data["url"] = this.url;
        return data;
    }
}

export interface IPositionDto {
    id?: string;
    title?: string;
    description?: string;
    level?: number | undefined;
    parentPositionId?: string | undefined;
    department?: string;
    employees?: EmployeeDto[];
    url?: string | undefined;
}

export class EmployeeDto implements IEmployeeDto {
    id?: string;
    name?: string;
    email?: string;
    startDate?: string;
    isPrimary?: boolean;
    url?: string | undefined;

    constructor(data?: IEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.startDate = _data["startDate"];
            this.isPrimary = _data["isPrimary"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): EmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["startDate"] = this.startDate;
        data["isPrimary"] = this.isPrimary;
        data["url"] = this.url;
        return data;
    }
}

export interface IEmployeeDto {
    id?: string;
    name?: string;
    email?: string;
    startDate?: string;
    isPrimary?: boolean;
    url?: string | undefined;
}

export class GetOvertimeEmployeesResponse extends BaseResponse implements IGetOvertimeEmployeesResponse {
    employees?: OvertimeEmployeeDto[];
    availablePeople?: AvailableLogetoPersonDto[];

    constructor(data?: IGetOvertimeEmployeesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(OvertimeEmployeeDto.fromJS(item));
            }
            if (Array.isArray(_data["availablePeople"])) {
                this.availablePeople = [] as any;
                for (let item of _data["availablePeople"])
                    this.availablePeople!.push(AvailableLogetoPersonDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetOvertimeEmployeesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOvertimeEmployeesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item.toJSON());
        }
        if (Array.isArray(this.availablePeople)) {
            data["availablePeople"] = [];
            for (let item of this.availablePeople)
                data["availablePeople"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetOvertimeEmployeesResponse extends IBaseResponse {
    employees?: OvertimeEmployeeDto[];
    availablePeople?: AvailableLogetoPersonDto[];
}

export class OvertimeEmployeeDto implements IOvertimeEmployeeDto {
    personId?: string;
    displayName?: string;
    baselineHours?: number;
    baselineDate?: Date;
    isActive?: boolean;
    currentBalance?: number;

    constructor(data?: IOvertimeEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.displayName = _data["displayName"];
            this.baselineHours = _data["baselineHours"];
            this.baselineDate = _data["baselineDate"] ? new Date(_data["baselineDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.currentBalance = _data["currentBalance"];
        }
    }

    static fromJS(data: any): OvertimeEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OvertimeEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["displayName"] = this.displayName;
        data["baselineHours"] = this.baselineHours;
        data["baselineDate"] = this.baselineDate ? formatDate(this.baselineDate) : <any>undefined;
        data["isActive"] = this.isActive;
        data["currentBalance"] = this.currentBalance;
        return data;
    }
}

export interface IOvertimeEmployeeDto {
    personId?: string;
    displayName?: string;
    baselineHours?: number;
    baselineDate?: Date;
    isActive?: boolean;
    currentBalance?: number;
}

export class AvailableLogetoPersonDto implements IAvailableLogetoPersonDto {
    personId?: string;
    fullName?: string;

    constructor(data?: IAvailableLogetoPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): AvailableLogetoPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableLogetoPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IAvailableLogetoPersonDto {
    personId?: string;
    fullName?: string;
}

export class UpsertOvertimeEmployeeResponse extends BaseResponse implements IUpsertOvertimeEmployeeResponse {

    constructor(data?: IUpsertOvertimeEmployeeResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpsertOvertimeEmployeeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertOvertimeEmployeeResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertOvertimeEmployeeResponse extends IBaseResponse {
}

export class UpsertOvertimeEmployeeRequest implements IUpsertOvertimeEmployeeRequest {
    personId?: string;
    displayName?: string;
    baselineHours?: number;
    baselineDate?: Date;
    isActive?: boolean;

    constructor(data?: IUpsertOvertimeEmployeeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.displayName = _data["displayName"];
            this.baselineHours = _data["baselineHours"];
            this.baselineDate = _data["baselineDate"] ? new Date(_data["baselineDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpsertOvertimeEmployeeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertOvertimeEmployeeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["displayName"] = this.displayName;
        data["baselineHours"] = this.baselineHours;
        data["baselineDate"] = this.baselineDate ? formatDate(this.baselineDate) : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpsertOvertimeEmployeeRequest {
    personId?: string;
    displayName?: string;
    baselineHours?: number;
    baselineDate?: Date;
    isActive?: boolean;
}

export class GetMonthlyStatementsResponse extends BaseResponse implements IGetMonthlyStatementsResponse {
    year?: number;
    month?: number;
    isClosed?: boolean;
    statements?: OvertimeStatementDto[];

    constructor(data?: IGetMonthlyStatementsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.isClosed = _data["isClosed"];
            if (Array.isArray(_data["statements"])) {
                this.statements = [] as any;
                for (let item of _data["statements"])
                    this.statements!.push(OvertimeStatementDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetMonthlyStatementsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthlyStatementsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["isClosed"] = this.isClosed;
        if (Array.isArray(this.statements)) {
            data["statements"] = [];
            for (let item of this.statements)
                data["statements"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetMonthlyStatementsResponse extends IBaseResponse {
    year?: number;
    month?: number;
    isClosed?: boolean;
    statements?: OvertimeStatementDto[];
}

export class OvertimeStatementDto implements IOvertimeStatementDto {
    personId?: string;
    displayName?: string;
    isReviewed?: boolean;
    dailyContractHours?: number | undefined;
    requiredHours?: number;
    workedHours?: number;
    vacationHours?: number;
    sickHours?: number;
    doctorHours?: number;
    compTimeHours?: number;
    otherAbsenceHours?: number;
    deltaHours?: number;
    previousBalance?: number;
    adjustmentsTotal?: number;
    projectedBalance?: number;
    warnings?: string[];
    adjustments?: OvertimeAdjustmentDto[];

    constructor(data?: IOvertimeStatementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.displayName = _data["displayName"];
            this.isReviewed = _data["isReviewed"];
            this.dailyContractHours = _data["dailyContractHours"];
            this.requiredHours = _data["requiredHours"];
            this.workedHours = _data["workedHours"];
            this.vacationHours = _data["vacationHours"];
            this.sickHours = _data["sickHours"];
            this.doctorHours = _data["doctorHours"];
            this.compTimeHours = _data["compTimeHours"];
            this.otherAbsenceHours = _data["otherAbsenceHours"];
            this.deltaHours = _data["deltaHours"];
            this.previousBalance = _data["previousBalance"];
            this.adjustmentsTotal = _data["adjustmentsTotal"];
            this.projectedBalance = _data["projectedBalance"];
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
            if (Array.isArray(_data["adjustments"])) {
                this.adjustments = [] as any;
                for (let item of _data["adjustments"])
                    this.adjustments!.push(OvertimeAdjustmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OvertimeStatementDto {
        data = typeof data === 'object' ? data : {};
        let result = new OvertimeStatementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["displayName"] = this.displayName;
        data["isReviewed"] = this.isReviewed;
        data["dailyContractHours"] = this.dailyContractHours;
        data["requiredHours"] = this.requiredHours;
        data["workedHours"] = this.workedHours;
        data["vacationHours"] = this.vacationHours;
        data["sickHours"] = this.sickHours;
        data["doctorHours"] = this.doctorHours;
        data["compTimeHours"] = this.compTimeHours;
        data["otherAbsenceHours"] = this.otherAbsenceHours;
        data["deltaHours"] = this.deltaHours;
        data["previousBalance"] = this.previousBalance;
        data["adjustmentsTotal"] = this.adjustmentsTotal;
        data["projectedBalance"] = this.projectedBalance;
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        if (Array.isArray(this.adjustments)) {
            data["adjustments"] = [];
            for (let item of this.adjustments)
                data["adjustments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOvertimeStatementDto {
    personId?: string;
    displayName?: string;
    isReviewed?: boolean;
    dailyContractHours?: number | undefined;
    requiredHours?: number;
    workedHours?: number;
    vacationHours?: number;
    sickHours?: number;
    doctorHours?: number;
    compTimeHours?: number;
    otherAbsenceHours?: number;
    deltaHours?: number;
    previousBalance?: number;
    adjustmentsTotal?: number;
    projectedBalance?: number;
    warnings?: string[];
    adjustments?: OvertimeAdjustmentDto[];
}

export class OvertimeAdjustmentDto implements IOvertimeAdjustmentDto {
    id?: number;
    personId?: string;
    type?: OvertimeAdjustmentType;
    hours?: number;
    note?: string;
    createdAtUtc?: Date;
    createdBy?: string;

    constructor(data?: IOvertimeAdjustmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.type = _data["type"];
            this.hours = _data["hours"];
            this.note = _data["note"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): OvertimeAdjustmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new OvertimeAdjustmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["type"] = this.type;
        data["hours"] = this.hours;
        data["note"] = this.note;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IOvertimeAdjustmentDto {
    id?: number;
    personId?: string;
    type?: OvertimeAdjustmentType;
    hours?: number;
    note?: string;
    createdAtUtc?: Date;
    createdBy?: string;
}

export enum OvertimeAdjustmentType {
    Payout = "Payout",
    PurchaseDeduction = "PurchaseDeduction",
    Correction = "Correction",
    SportBenefit = "SportBenefit",
    Other = "Other",
}

export class SetStatementReviewedResponse extends BaseResponse implements ISetStatementReviewedResponse {

    constructor(data?: ISetStatementReviewedResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SetStatementReviewedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetStatementReviewedResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISetStatementReviewedResponse extends IBaseResponse {
}

export class SetStatementReviewedRequest implements ISetStatementReviewedRequest {
    personId?: string;
    year?: number;
    month?: number;
    isReviewed?: boolean;

    constructor(data?: ISetStatementReviewedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.isReviewed = _data["isReviewed"];
        }
    }

    static fromJS(data: any): SetStatementReviewedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetStatementReviewedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["isReviewed"] = this.isReviewed;
        return data;
    }
}

export interface ISetStatementReviewedRequest {
    personId?: string;
    year?: number;
    month?: number;
    isReviewed?: boolean;
}

export class CreateAdjustmentResponse extends BaseResponse implements ICreateAdjustmentResponse {
    id?: number;

    constructor(data?: ICreateAdjustmentResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): CreateAdjustmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAdjustmentResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateAdjustmentResponse extends IBaseResponse {
    id?: number;
}

export class CreateAdjustmentRequest implements ICreateAdjustmentRequest {
    personId?: string;
    year?: number;
    month?: number;
    type?: OvertimeAdjustmentType;
    hours?: number;
    note?: string;

    constructor(data?: ICreateAdjustmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.type = _data["type"];
            this.hours = _data["hours"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateAdjustmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAdjustmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["type"] = this.type;
        data["hours"] = this.hours;
        data["note"] = this.note;
        return data;
    }
}

export interface ICreateAdjustmentRequest {
    personId?: string;
    year?: number;
    month?: number;
    type?: OvertimeAdjustmentType;
    hours?: number;
    note?: string;
}

export class DeleteAdjustmentResponse extends BaseResponse implements IDeleteAdjustmentResponse {

    constructor(data?: IDeleteAdjustmentResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DeleteAdjustmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAdjustmentResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteAdjustmentResponse extends IBaseResponse {
}

export class CloseMonthResponse extends BaseResponse implements ICloseMonthResponse {
    closedCount?: number;
    publishSkipped?: boolean;
    publishFailed?: boolean;

    constructor(data?: ICloseMonthResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.closedCount = _data["closedCount"];
            this.publishSkipped = _data["publishSkipped"];
            this.publishFailed = _data["publishFailed"];
        }
    }

    static override fromJS(data: any): CloseMonthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CloseMonthResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["closedCount"] = this.closedCount;
        data["publishSkipped"] = this.publishSkipped;
        data["publishFailed"] = this.publishFailed;
        super.toJSON(data);
        return data;
    }
}

export interface ICloseMonthResponse extends IBaseResponse {
    closedCount?: number;
    publishSkipped?: boolean;
    publishFailed?: boolean;
}

export class ExportOvertimeReportResponse extends BaseResponse implements IExportOvertimeReportResponse {
    content?: string;
    fileName?: string;

    constructor(data?: IExportOvertimeReportResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.content = _data["content"];
            this.fileName = _data["fileName"];
        }
    }

    static override fromJS(data: any): ExportOvertimeReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOvertimeReportResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["fileName"] = this.fileName;
        super.toJSON(data);
        return data;
    }
}

export interface IExportOvertimeReportResponse extends IBaseResponse {
    content?: string;
    fileName?: string;
}

export class ScanPackingOrderResponse extends BaseResponse implements IScanPackingOrderResponse {
    order?: ScanOrderData | undefined;
    shipment?: ScanShipmentData | undefined;

    constructor(data?: IScanPackingOrderResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.order = _data["order"] ? ScanOrderData.fromJS(_data["order"]) : <any>undefined;
            this.shipment = _data["shipment"] ? ScanShipmentData.fromJS(_data["shipment"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ScanPackingOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScanPackingOrderResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["shipment"] = this.shipment ? this.shipment.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IScanPackingOrderResponse extends IBaseResponse {
    order?: ScanOrderData | undefined;
    shipment?: ScanShipmentData | undefined;
}

export class ScanOrderData implements IScanOrderData {
    code?: string;
    customerName?: string;
    shippingMethodName?: string;
    cooling?: Cooling;
    isCooled?: boolean;
    customerNote?: string | undefined;
    eshopNote?: string | undefined;
    shippingAddress?: ShippingAddress | undefined;
    eligibility?: ScanOrderEligibility;
    items?: ScanPackingOrderItemDto[];

    constructor(data?: IScanOrderData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.customerName = _data["customerName"];
            this.shippingMethodName = _data["shippingMethodName"];
            this.cooling = _data["cooling"];
            this.isCooled = _data["isCooled"];
            this.customerNote = _data["customerNote"];
            this.eshopNote = _data["eshopNote"];
            this.shippingAddress = _data["shippingAddress"] ? ShippingAddress.fromJS(_data["shippingAddress"]) : <any>undefined;
            this.eligibility = _data["eligibility"] ? ScanOrderEligibility.fromJS(_data["eligibility"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScanPackingOrderItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScanOrderData {
        data = typeof data === 'object' ? data : {};
        let result = new ScanOrderData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["customerName"] = this.customerName;
        data["shippingMethodName"] = this.shippingMethodName;
        data["cooling"] = this.cooling;
        data["isCooled"] = this.isCooled;
        data["customerNote"] = this.customerNote;
        data["eshopNote"] = this.eshopNote;
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : <any>undefined;
        data["eligibility"] = this.eligibility ? this.eligibility.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScanOrderData {
    code?: string;
    customerName?: string;
    shippingMethodName?: string;
    cooling?: Cooling;
    isCooled?: boolean;
    customerNote?: string | undefined;
    eshopNote?: string | undefined;
    shippingAddress?: ShippingAddress | undefined;
    eligibility?: ScanOrderEligibility;
    items?: ScanPackingOrderItemDto[];
}

export class ShippingAddress implements IShippingAddress {
    street?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;

    constructor(data?: IShippingAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.city = _data["city"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): ShippingAddress {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["city"] = this.city;
        data["zip"] = this.zip;
        return data;
    }
}

export interface IShippingAddress {
    street?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
}

export class ScanOrderEligibility implements IScanOrderEligibility {
    isEligible?: boolean;

    constructor(data?: IScanOrderEligibility) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEligible = _data["isEligible"];
        }
    }

    static fromJS(data: any): ScanOrderEligibility {
        data = typeof data === 'object' ? data : {};
        let result = new ScanOrderEligibility();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEligible"] = this.isEligible;
        return data;
    }
}

export interface IScanOrderEligibility {
    isEligible?: boolean;
}

export class ScanPackingOrderItemDto implements IScanPackingOrderItemDto {
    name?: string;
    quantity?: number;
    imageUrl?: string | undefined;
    setName?: string | undefined;

    constructor(data?: IScanPackingOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.imageUrl = _data["imageUrl"];
            this.setName = _data["setName"];
        }
    }

    static fromJS(data: any): ScanPackingOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScanPackingOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["imageUrl"] = this.imageUrl;
        data["setName"] = this.setName;
        return data;
    }
}

export interface IScanPackingOrderItemDto {
    name?: string;
    quantity?: number;
    imageUrl?: string | undefined;
    setName?: string | undefined;
}

export class ScanShipmentData implements IScanShipmentData {
    shipmentGuid?: string;
    packages?: ScanShipmentPackage[];
    alreadyExisted?: boolean;
    pendingCompletion?: boolean;

    constructor(data?: IScanShipmentData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipmentGuid = _data["shipmentGuid"];
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages!.push(ScanShipmentPackage.fromJS(item));
            }
            this.alreadyExisted = _data["alreadyExisted"];
            this.pendingCompletion = _data["pendingCompletion"];
        }
    }

    static fromJS(data: any): ScanShipmentData {
        data = typeof data === 'object' ? data : {};
        let result = new ScanShipmentData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipmentGuid"] = this.shipmentGuid;
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item.toJSON());
        }
        data["alreadyExisted"] = this.alreadyExisted;
        data["pendingCompletion"] = this.pendingCompletion;
        return data;
    }
}

export interface IScanShipmentData {
    shipmentGuid?: string;
    packages?: ScanShipmentPackage[];
    alreadyExisted?: boolean;
    pendingCompletion?: boolean;
}

export class ScanShipmentPackage implements IScanShipmentPackage {
    trackingNumber?: string | undefined;
    labelUrl?: string | undefined;
    labelZpl?: string | undefined;

    constructor(data?: IScanShipmentPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackingNumber = _data["trackingNumber"];
            this.labelUrl = _data["labelUrl"];
            this.labelZpl = _data["labelZpl"];
        }
    }

    static fromJS(data: any): ScanShipmentPackage {
        data = typeof data === 'object' ? data : {};
        let result = new ScanShipmentPackage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackingNumber"] = this.trackingNumber;
        data["labelUrl"] = this.labelUrl;
        data["labelZpl"] = this.labelZpl;
        return data;
    }
}

export interface IScanShipmentPackage {
    trackingNumber?: string | undefined;
    labelUrl?: string | undefined;
    labelZpl?: string | undefined;
}

export class ScanOrderBody implements IScanOrderBody {
    packingUserId?: string | undefined;

    constructor(data?: IScanOrderBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packingUserId = _data["packingUserId"];
        }
    }

    static fromJS(data: any): ScanOrderBody {
        data = typeof data === 'object' ? data : {};
        let result = new ScanOrderBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packingUserId"] = this.packingUserId;
        return data;
    }
}

export interface IScanOrderBody {
    packingUserId?: string | undefined;
}

export class ResetOrderShipmentResponse extends BaseResponse implements IResetOrderShipmentResponse {
    shipment?: ResetShipmentData | undefined;

    constructor(data?: IResetOrderShipmentResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.shipment = _data["shipment"] ? ResetShipmentData.fromJS(_data["shipment"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ResetOrderShipmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetOrderShipmentResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipment"] = this.shipment ? this.shipment.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResetOrderShipmentResponse extends IBaseResponse {
    shipment?: ResetShipmentData | undefined;
}

export class ResetShipmentData implements IResetShipmentData {
    shipmentGuid?: string;
    packages?: ResetShipmentPackage[];
    pendingCompletion?: boolean;

    constructor(data?: IResetShipmentData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipmentGuid = _data["shipmentGuid"];
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages!.push(ResetShipmentPackage.fromJS(item));
            }
            this.pendingCompletion = _data["pendingCompletion"];
        }
    }

    static fromJS(data: any): ResetShipmentData {
        data = typeof data === 'object' ? data : {};
        let result = new ResetShipmentData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipmentGuid"] = this.shipmentGuid;
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item.toJSON());
        }
        data["pendingCompletion"] = this.pendingCompletion;
        return data;
    }
}

export interface IResetShipmentData {
    shipmentGuid?: string;
    packages?: ResetShipmentPackage[];
    pendingCompletion?: boolean;
}

export class ResetShipmentPackage implements IResetShipmentPackage {
    trackingNumber?: string | undefined;
    labelUrl?: string | undefined;
    labelZpl?: string | undefined;

    constructor(data?: IResetShipmentPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackingNumber = _data["trackingNumber"];
            this.labelUrl = _data["labelUrl"];
            this.labelZpl = _data["labelZpl"];
        }
    }

    static fromJS(data: any): ResetShipmentPackage {
        data = typeof data === 'object' ? data : {};
        let result = new ResetShipmentPackage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackingNumber"] = this.trackingNumber;
        data["labelUrl"] = this.labelUrl;
        data["labelZpl"] = this.labelZpl;
        return data;
    }
}

export interface IResetShipmentPackage {
    trackingNumber?: string | undefined;
    labelUrl?: string | undefined;
    labelZpl?: string | undefined;
}

export class GetOrderTrackingNumberResponse extends BaseResponse implements IGetOrderTrackingNumberResponse {
    trackingNumber?: string | undefined;

    constructor(data?: IGetOrderTrackingNumberResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackingNumber = _data["trackingNumber"];
        }
    }

    static override fromJS(data: any): GetOrderTrackingNumberResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderTrackingNumberResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackingNumber"] = this.trackingNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IGetOrderTrackingNumberResponse extends IBaseResponse {
    trackingNumber?: string | undefined;
}

export class GetOrderTrackingNumbersResponse extends BaseResponse implements IGetOrderTrackingNumbersResponse {
    trackingNumbers?: string[];

    constructor(data?: IGetOrderTrackingNumbersResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["trackingNumbers"])) {
                this.trackingNumbers = [] as any;
                for (let item of _data["trackingNumbers"])
                    this.trackingNumbers!.push(item);
            }
        }
    }

    static override fromJS(data: any): GetOrderTrackingNumbersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderTrackingNumbersResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trackingNumbers)) {
            data["trackingNumbers"] = [];
            for (let item of this.trackingNumbers)
                data["trackingNumbers"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetOrderTrackingNumbersResponse extends IBaseResponse {
    trackingNumbers?: string[];
}

export class GetPackingDashboardResponse extends BaseResponse implements IGetPackingDashboardResponse {
    ordersBeingPackedCount?: number | undefined;
    ordersBeingProcessedCount?: number | undefined;
    ordersBeingPackedCountLastSync?: Date | undefined;
    totalOrdersPackedToday?: number;
    packedByPacker?: PackerStatsDto[];

    constructor(data?: IGetPackingDashboardResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ordersBeingPackedCount = _data["ordersBeingPackedCount"];
            this.ordersBeingProcessedCount = _data["ordersBeingProcessedCount"];
            this.ordersBeingPackedCountLastSync = _data["ordersBeingPackedCountLastSync"] ? new Date(_data["ordersBeingPackedCountLastSync"].toString()) : <any>undefined;
            this.totalOrdersPackedToday = _data["totalOrdersPackedToday"];
            if (Array.isArray(_data["packedByPacker"])) {
                this.packedByPacker = [] as any;
                for (let item of _data["packedByPacker"])
                    this.packedByPacker!.push(PackerStatsDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetPackingDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPackingDashboardResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordersBeingPackedCount"] = this.ordersBeingPackedCount;
        data["ordersBeingProcessedCount"] = this.ordersBeingProcessedCount;
        data["ordersBeingPackedCountLastSync"] = this.ordersBeingPackedCountLastSync ? this.ordersBeingPackedCountLastSync.toISOString() : <any>undefined;
        data["totalOrdersPackedToday"] = this.totalOrdersPackedToday;
        if (Array.isArray(this.packedByPacker)) {
            data["packedByPacker"] = [];
            for (let item of this.packedByPacker)
                data["packedByPacker"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPackingDashboardResponse extends IBaseResponse {
    ordersBeingPackedCount?: number | undefined;
    ordersBeingProcessedCount?: number | undefined;
    ordersBeingPackedCountLastSync?: Date | undefined;
    totalOrdersPackedToday?: number;
    packedByPacker?: PackerStatsDto[];
}

export class PackerStatsDto implements IPackerStatsDto {
    packerId?: string | undefined;
    packerName?: string;
    orderCount?: number;

    constructor(data?: IPackerStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packerId = _data["packerId"];
            this.packerName = _data["packerName"];
            this.orderCount = _data["orderCount"];
        }
    }

    static fromJS(data: any): PackerStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackerStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packerId"] = this.packerId;
        data["packerName"] = this.packerName;
        data["orderCount"] = this.orderCount;
        return data;
    }
}

export interface IPackerStatsDto {
    packerId?: string | undefined;
    packerName?: string;
    orderCount?: number;
}

export class GetPackingStatisticsResponse extends BaseResponse implements IGetPackingStatisticsResponse {
    fromDate?: Date;
    toDate?: Date;
    packerAttributionSince?: Date | undefined;
    summary?: PackingStatisticsSummaryDto;
    throughputDaily?: DailyThroughputDto[];
    hourHeatmap?: HourBucketDto[];
    byPacker?: PackerThroughputDto[];
    byCarrier?: CarrierMixDto[];
    packagesPerOrder?: PackagesPerOrderBucketDto[];

    constructor(data?: IGetPackingStatisticsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.packerAttributionSince = _data["packerAttributionSince"] ? new Date(_data["packerAttributionSince"].toString()) : <any>undefined;
            this.summary = _data["summary"] ? PackingStatisticsSummaryDto.fromJS(_data["summary"]) : <any>undefined;
            if (Array.isArray(_data["throughputDaily"])) {
                this.throughputDaily = [] as any;
                for (let item of _data["throughputDaily"])
                    this.throughputDaily!.push(DailyThroughputDto.fromJS(item));
            }
            if (Array.isArray(_data["hourHeatmap"])) {
                this.hourHeatmap = [] as any;
                for (let item of _data["hourHeatmap"])
                    this.hourHeatmap!.push(HourBucketDto.fromJS(item));
            }
            if (Array.isArray(_data["byPacker"])) {
                this.byPacker = [] as any;
                for (let item of _data["byPacker"])
                    this.byPacker!.push(PackerThroughputDto.fromJS(item));
            }
            if (Array.isArray(_data["byCarrier"])) {
                this.byCarrier = [] as any;
                for (let item of _data["byCarrier"])
                    this.byCarrier!.push(CarrierMixDto.fromJS(item));
            }
            if (Array.isArray(_data["packagesPerOrder"])) {
                this.packagesPerOrder = [] as any;
                for (let item of _data["packagesPerOrder"])
                    this.packagesPerOrder!.push(PackagesPerOrderBucketDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetPackingStatisticsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPackingStatisticsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["packerAttributionSince"] = this.packerAttributionSince ? this.packerAttributionSince.toISOString() : <any>undefined;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        if (Array.isArray(this.throughputDaily)) {
            data["throughputDaily"] = [];
            for (let item of this.throughputDaily)
                data["throughputDaily"].push(item.toJSON());
        }
        if (Array.isArray(this.hourHeatmap)) {
            data["hourHeatmap"] = [];
            for (let item of this.hourHeatmap)
                data["hourHeatmap"].push(item.toJSON());
        }
        if (Array.isArray(this.byPacker)) {
            data["byPacker"] = [];
            for (let item of this.byPacker)
                data["byPacker"].push(item.toJSON());
        }
        if (Array.isArray(this.byCarrier)) {
            data["byCarrier"] = [];
            for (let item of this.byCarrier)
                data["byCarrier"].push(item.toJSON());
        }
        if (Array.isArray(this.packagesPerOrder)) {
            data["packagesPerOrder"] = [];
            for (let item of this.packagesPerOrder)
                data["packagesPerOrder"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPackingStatisticsResponse extends IBaseResponse {
    fromDate?: Date;
    toDate?: Date;
    packerAttributionSince?: Date | undefined;
    summary?: PackingStatisticsSummaryDto;
    throughputDaily?: DailyThroughputDto[];
    hourHeatmap?: HourBucketDto[];
    byPacker?: PackerThroughputDto[];
    byCarrier?: CarrierMixDto[];
    packagesPerOrder?: PackagesPerOrderBucketDto[];
}

export class PackingStatisticsSummaryDto implements IPackingStatisticsSummaryDto {
    totalPackages?: number;
    totalOrders?: number;
    distinctPackers?: number;
    averagePackagesPerOrder?: number;
    trackingCoveragePercent?: number;
    busiestDay?: DailyThroughputDto | undefined;
    busiestHour?: HourBucketDto | undefined;

    constructor(data?: IPackingStatisticsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPackages = _data["totalPackages"];
            this.totalOrders = _data["totalOrders"];
            this.distinctPackers = _data["distinctPackers"];
            this.averagePackagesPerOrder = _data["averagePackagesPerOrder"];
            this.trackingCoveragePercent = _data["trackingCoveragePercent"];
            this.busiestDay = _data["busiestDay"] ? DailyThroughputDto.fromJS(_data["busiestDay"]) : <any>undefined;
            this.busiestHour = _data["busiestHour"] ? HourBucketDto.fromJS(_data["busiestHour"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PackingStatisticsSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackingStatisticsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPackages"] = this.totalPackages;
        data["totalOrders"] = this.totalOrders;
        data["distinctPackers"] = this.distinctPackers;
        data["averagePackagesPerOrder"] = this.averagePackagesPerOrder;
        data["trackingCoveragePercent"] = this.trackingCoveragePercent;
        data["busiestDay"] = this.busiestDay ? this.busiestDay.toJSON() : <any>undefined;
        data["busiestHour"] = this.busiestHour ? this.busiestHour.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPackingStatisticsSummaryDto {
    totalPackages?: number;
    totalOrders?: number;
    distinctPackers?: number;
    averagePackagesPerOrder?: number;
    trackingCoveragePercent?: number;
    busiestDay?: DailyThroughputDto | undefined;
    busiestHour?: HourBucketDto | undefined;
}

export class DailyThroughputDto implements IDailyThroughputDto {
    date?: Date;
    orderCount?: number;
    packageCount?: number;

    constructor(data?: IDailyThroughputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.orderCount = _data["orderCount"];
            this.packageCount = _data["packageCount"];
        }
    }

    static fromJS(data: any): DailyThroughputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DailyThroughputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["orderCount"] = this.orderCount;
        data["packageCount"] = this.packageCount;
        return data;
    }
}

export interface IDailyThroughputDto {
    date?: Date;
    orderCount?: number;
    packageCount?: number;
}

export class HourBucketDto implements IHourBucketDto {
    dayOfWeek?: number;
    hour?: number;
    packageCount?: number;

    constructor(data?: IHourBucketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayOfWeek = _data["dayOfWeek"];
            this.hour = _data["hour"];
            this.packageCount = _data["packageCount"];
        }
    }

    static fromJS(data: any): HourBucketDto {
        data = typeof data === 'object' ? data : {};
        let result = new HourBucketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOfWeek"] = this.dayOfWeek;
        data["hour"] = this.hour;
        data["packageCount"] = this.packageCount;
        return data;
    }
}

export interface IHourBucketDto {
    dayOfWeek?: number;
    hour?: number;
    packageCount?: number;
}

export class PackerThroughputDto implements IPackerThroughputDto {
    packerId?: string | undefined;
    packerName?: string;
    orderCount?: number;
    packageCount?: number;

    constructor(data?: IPackerThroughputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packerId = _data["packerId"];
            this.packerName = _data["packerName"];
            this.orderCount = _data["orderCount"];
            this.packageCount = _data["packageCount"];
        }
    }

    static fromJS(data: any): PackerThroughputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackerThroughputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packerId"] = this.packerId;
        data["packerName"] = this.packerName;
        data["orderCount"] = this.orderCount;
        data["packageCount"] = this.packageCount;
        return data;
    }
}

export interface IPackerThroughputDto {
    packerId?: string | undefined;
    packerName?: string;
    orderCount?: number;
    packageCount?: number;
}

export class CarrierMixDto implements ICarrierMixDto {
    code?: string;
    name?: string;
    packageCount?: number;

    constructor(data?: ICarrierMixDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.packageCount = _data["packageCount"];
        }
    }

    static fromJS(data: any): CarrierMixDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierMixDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["packageCount"] = this.packageCount;
        return data;
    }
}

export interface ICarrierMixDto {
    code?: string;
    name?: string;
    packageCount?: number;
}

export class PackagesPerOrderBucketDto implements IPackagesPerOrderBucketDto {
    packageCount?: number;
    orderCount?: number;

    constructor(data?: IPackagesPerOrderBucketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageCount = _data["packageCount"];
            this.orderCount = _data["orderCount"];
        }
    }

    static fromJS(data: any): PackagesPerOrderBucketDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackagesPerOrderBucketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageCount"] = this.packageCount;
        data["orderCount"] = this.orderCount;
        return data;
    }
}

export interface IPackagesPerOrderBucketDto {
    packageCount?: number;
    orderCount?: number;
}

export class GetPackagesResponse extends BaseResponse implements IGetPackagesResponse {
    items?: PackageDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGetPackagesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PackageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static override fromJS(data: any): GetPackagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPackagesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPackagesResponse extends IBaseResponse {
    items?: PackageDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class PackageDto implements IPackageDto {
    id?: number;
    orderCode?: string;
    customerName?: string;
    packageNumber?: string;
    trackingNumber?: string | undefined;
    shippingProviderCode?: string;
    shippingProviderName?: string | undefined;
    packedAt?: Date;
    packedBy?: string | undefined;
    packedByUserId?: string | undefined;

    constructor(data?: IPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderCode = _data["orderCode"];
            this.customerName = _data["customerName"];
            this.packageNumber = _data["packageNumber"];
            this.trackingNumber = _data["trackingNumber"];
            this.shippingProviderCode = _data["shippingProviderCode"];
            this.shippingProviderName = _data["shippingProviderName"];
            this.packedAt = _data["packedAt"] ? new Date(_data["packedAt"].toString()) : <any>undefined;
            this.packedBy = _data["packedBy"];
            this.packedByUserId = _data["packedByUserId"];
        }
    }

    static fromJS(data: any): PackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderCode"] = this.orderCode;
        data["customerName"] = this.customerName;
        data["packageNumber"] = this.packageNumber;
        data["trackingNumber"] = this.trackingNumber;
        data["shippingProviderCode"] = this.shippingProviderCode;
        data["shippingProviderName"] = this.shippingProviderName;
        data["packedAt"] = this.packedAt ? this.packedAt.toISOString() : <any>undefined;
        data["packedBy"] = this.packedBy;
        data["packedByUserId"] = this.packedByUserId;
        return data;
    }
}

export interface IPackageDto {
    id?: number;
    orderCode?: string;
    customerName?: string;
    packageNumber?: string;
    trackingNumber?: string | undefined;
    shippingProviderCode?: string;
    shippingProviderName?: string | undefined;
    packedAt?: Date;
    packedBy?: string | undefined;
    packedByUserId?: string | undefined;
}

export class GetPackingUsersResponse extends BaseResponse implements IGetPackingUsersResponse {
    users?: PackingUserDto[];

    constructor(data?: IGetPackingUsersResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(PackingUserDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetPackingUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPackingUsersResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPackingUsersResponse extends IBaseResponse {
    users?: PackingUserDto[];
}

export class PackingUserDto implements IPackingUserDto {
    id?: string;
    displayName?: string;

    constructor(data?: IPackingUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): PackingUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackingUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IPackingUserDto {
    id?: string;
    displayName?: string;
}

export class DeletePackageResponse extends BaseResponse implements IDeletePackageResponse {
    deleted?: boolean;

    constructor(data?: IDeletePackageResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deleted = _data["deleted"];
        }
    }

    static override fromJS(data: any): DeletePackageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePackageResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deleted"] = this.deleted;
        super.toJSON(data);
        return data;
    }
}

export interface IDeletePackageResponse extends IBaseResponse {
    deleted?: boolean;
}

export class CompletePackingOrderResponse extends BaseResponse implements ICompletePackingOrderResponse {
    completed?: boolean;

    constructor(data?: ICompletePackingOrderResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.completed = _data["completed"];
        }
    }

    static override fromJS(data: any): CompletePackingOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompletePackingOrderResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completed"] = this.completed;
        super.toJSON(data);
        return data;
    }
}

export interface ICompletePackingOrderResponse extends IBaseResponse {
    completed?: boolean;
}

export class GetPackingMaterialsListResponse extends BaseResponse implements IGetPackingMaterialsListResponse {
    materials?: PackingMaterialDto[];

    constructor(data?: IGetPackingMaterialsListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(PackingMaterialDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetPackingMaterialsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPackingMaterialsListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPackingMaterialsListResponse extends IBaseResponse {
    materials?: PackingMaterialDto[];
}

export class PackingMaterialDto implements IPackingMaterialDto {
    id?: number;
    name?: string;
    consumptionRate?: number;
    consumptionType?: ConsumptionType;
    consumptionTypeText?: string;
    currentQuantity?: number;
    forecastedDays?: number | undefined;
    createdAt?: Date;
    updatedAt?: Date | undefined;

    constructor(data?: IPackingMaterialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.consumptionRate = _data["consumptionRate"];
            this.consumptionType = _data["consumptionType"];
            this.consumptionTypeText = _data["consumptionTypeText"];
            this.currentQuantity = _data["currentQuantity"];
            this.forecastedDays = _data["forecastedDays"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PackingMaterialDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackingMaterialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["consumptionRate"] = this.consumptionRate;
        data["consumptionType"] = this.consumptionType;
        data["consumptionTypeText"] = this.consumptionTypeText;
        data["currentQuantity"] = this.currentQuantity;
        data["forecastedDays"] = this.forecastedDays;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPackingMaterialDto {
    id?: number;
    name?: string;
    consumptionRate?: number;
    consumptionType?: ConsumptionType;
    consumptionTypeText?: string;
    currentQuantity?: number;
    forecastedDays?: number | undefined;
    createdAt?: Date;
    updatedAt?: Date | undefined;
}

export enum ConsumptionType {
    PerOrder = "PerOrder",
    PerProduct = "PerProduct",
    PerDay = "PerDay",
}

export class CreatePackingMaterialResponse extends BaseResponse implements ICreatePackingMaterialResponse {
    id?: number;
    material?: PackingMaterialDto;

    constructor(data?: ICreatePackingMaterialResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.material = _data["material"] ? PackingMaterialDto.fromJS(_data["material"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CreatePackingMaterialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackingMaterialResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["material"] = this.material ? this.material.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreatePackingMaterialResponse extends IBaseResponse {
    id?: number;
    material?: PackingMaterialDto;
}

export class CreatePackingMaterialRequest implements ICreatePackingMaterialRequest {
    name?: string;
    consumptionRate?: number;
    consumptionType?: ConsumptionType;
    currentQuantity?: number;

    constructor(data?: ICreatePackingMaterialRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.consumptionRate = _data["consumptionRate"];
            this.consumptionType = _data["consumptionType"];
            this.currentQuantity = _data["currentQuantity"];
        }
    }

    static fromJS(data: any): CreatePackingMaterialRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackingMaterialRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["consumptionRate"] = this.consumptionRate;
        data["consumptionType"] = this.consumptionType;
        data["currentQuantity"] = this.currentQuantity;
        return data;
    }
}

export interface ICreatePackingMaterialRequest {
    name?: string;
    consumptionRate?: number;
    consumptionType?: ConsumptionType;
    currentQuantity?: number;
}

export class UpdatePackingMaterialResponse extends BaseResponse implements IUpdatePackingMaterialResponse {
    material?: PackingMaterialDto;
    error?: string | undefined;

    constructor(data?: IUpdatePackingMaterialResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.material = _data["material"] ? PackingMaterialDto.fromJS(_data["material"]) : <any>undefined;
            this.error = _data["error"];
        }
    }

    static override fromJS(data: any): UpdatePackingMaterialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePackingMaterialResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["material"] = this.material ? this.material.toJSON() : <any>undefined;
        data["error"] = this.error;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePackingMaterialResponse extends IBaseResponse {
    material?: PackingMaterialDto;
    error?: string | undefined;
}

export class UpdatePackingMaterialRequest implements IUpdatePackingMaterialRequest {
    id?: number;
    name?: string;
    consumptionRate?: number;
    consumptionType?: ConsumptionType;

    constructor(data?: IUpdatePackingMaterialRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.consumptionRate = _data["consumptionRate"];
            this.consumptionType = _data["consumptionType"];
        }
    }

    static fromJS(data: any): UpdatePackingMaterialRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePackingMaterialRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["consumptionRate"] = this.consumptionRate;
        data["consumptionType"] = this.consumptionType;
        return data;
    }
}

export interface IUpdatePackingMaterialRequest {
    id?: number;
    name?: string;
    consumptionRate?: number;
    consumptionType?: ConsumptionType;
}

export class UpdatePackingMaterialQuantityResponse extends BaseResponse implements IUpdatePackingMaterialQuantityResponse {
    material?: PackingMaterialDto;
    error?: string | undefined;

    constructor(data?: IUpdatePackingMaterialQuantityResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.material = _data["material"] ? PackingMaterialDto.fromJS(_data["material"]) : <any>undefined;
            this.error = _data["error"];
        }
    }

    static override fromJS(data: any): UpdatePackingMaterialQuantityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePackingMaterialQuantityResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["material"] = this.material ? this.material.toJSON() : <any>undefined;
        data["error"] = this.error;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePackingMaterialQuantityResponse extends IBaseResponse {
    material?: PackingMaterialDto;
    error?: string | undefined;
}

export class UpdateQuantityRequest implements IUpdateQuantityRequest {
    newQuantity?: number;
    date?: Date;

    constructor(data?: IUpdateQuantityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newQuantity = _data["newQuantity"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateQuantityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuantityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newQuantity"] = this.newQuantity;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        return data;
    }
}

export interface IUpdateQuantityRequest {
    newQuantity?: number;
    date?: Date;
}

export class ProcessDailyConsumptionResponse extends BaseResponse implements IProcessDailyConsumptionResponse {
    processedDate?: Date;
    materialsProcessed?: number;
    message?: string;

    constructor(data?: IProcessDailyConsumptionResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.processedDate = _data["processedDate"] ? new Date(_data["processedDate"].toString()) : <any>undefined;
            this.materialsProcessed = _data["materialsProcessed"];
            this.message = _data["message"];
        }
    }

    static override fromJS(data: any): ProcessDailyConsumptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDailyConsumptionResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processedDate"] = this.processedDate ? formatDate(this.processedDate) : <any>undefined;
        data["materialsProcessed"] = this.materialsProcessed;
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }
}

export interface IProcessDailyConsumptionResponse extends IBaseResponse {
    processedDate?: Date;
    materialsProcessed?: number;
    message?: string;
}

export class ProcessDailyConsumptionRequest implements IProcessDailyConsumptionRequest {
    processingDate?: Date;

    constructor(data?: IProcessDailyConsumptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processingDate = _data["processingDate"] ? new Date(_data["processingDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProcessDailyConsumptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDailyConsumptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processingDate"] = this.processingDate ? formatDate(this.processingDate) : <any>undefined;
        return data;
    }
}

export interface IProcessDailyConsumptionRequest {
    processingDate?: Date;
}

export class GetDailyConsumptionBreakdownResponse extends BaseResponse implements IGetDailyConsumptionBreakdownResponse {
    error?: string | undefined;
    date?: Date;
    groupBy?: string;
    groups?: ConsumptionGroupDto[];

    constructor(data?: IGetDailyConsumptionBreakdownResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.error = _data["error"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.groupBy = _data["groupBy"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(ConsumptionGroupDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetDailyConsumptionBreakdownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailyConsumptionBreakdownResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["groupBy"] = this.groupBy;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDailyConsumptionBreakdownResponse extends IBaseResponse {
    error?: string | undefined;
    date?: Date;
    groupBy?: string;
    groups?: ConsumptionGroupDto[];
}

export class ConsumptionGroupDto implements IConsumptionGroupDto {
    key?: string;
    label?: string;
    totalAmount?: number;
    rowCount?: number;
    details?: ConsumptionDetailDto[];

    constructor(data?: IConsumptionGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.totalAmount = _data["totalAmount"];
            this.rowCount = _data["rowCount"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(ConsumptionDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsumptionGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["totalAmount"] = this.totalAmount;
        data["rowCount"] = this.rowCount;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConsumptionGroupDto {
    key?: string;
    label?: string;
    totalAmount?: number;
    rowCount?: number;
    details?: ConsumptionDetailDto[];
}

export class ConsumptionDetailDto implements IConsumptionDetailDto {
    key?: string;
    label?: string;
    amount?: number;

    constructor(data?: IConsumptionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): ConsumptionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IConsumptionDetailDto {
    key?: string;
    label?: string;
    amount?: number;
}

export enum ConsumptionGroupBy {
    Material = "Material",
    Product = "Product",
    Order = "Order",
}

export class GetConsumptionHistoryResponse extends BaseResponse implements IGetConsumptionHistoryResponse {
    items?: MaterialConsumptionHistoryItemDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;

    constructor(data?: IGetConsumptionHistoryResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MaterialConsumptionHistoryItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static override fromJS(data: any): GetConsumptionHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConsumptionHistoryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        super.toJSON(data);
        return data;
    }
}

export interface IGetConsumptionHistoryResponse extends IBaseResponse {
    items?: MaterialConsumptionHistoryItemDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class MaterialConsumptionHistoryItemDto implements IMaterialConsumptionHistoryItemDto {
    recordType?: HistoryRecordType;
    recordTypeText?: string;
    packingMaterialId?: number;
    materialName?: string;
    date?: Date;
    createdAt?: Date;
    consumptionType?: ConsumptionType | undefined;
    consumptionTypeText?: string | undefined;
    invoiceId?: string | undefined;
    productCode?: string | undefined;
    productQuantity?: number | undefined;
    amount?: number | undefined;
    oldQuantity?: number | undefined;
    newQuantity?: number | undefined;
    changeAmount?: number | undefined;
    logType?: LogEntryType | undefined;
    logTypeText?: string | undefined;
    userId?: string | undefined;

    constructor(data?: IMaterialConsumptionHistoryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordType = _data["recordType"];
            this.recordTypeText = _data["recordTypeText"];
            this.packingMaterialId = _data["packingMaterialId"];
            this.materialName = _data["materialName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.consumptionType = _data["consumptionType"];
            this.consumptionTypeText = _data["consumptionTypeText"];
            this.invoiceId = _data["invoiceId"];
            this.productCode = _data["productCode"];
            this.productQuantity = _data["productQuantity"];
            this.amount = _data["amount"];
            this.oldQuantity = _data["oldQuantity"];
            this.newQuantity = _data["newQuantity"];
            this.changeAmount = _data["changeAmount"];
            this.logType = _data["logType"];
            this.logTypeText = _data["logTypeText"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): MaterialConsumptionHistoryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialConsumptionHistoryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordType"] = this.recordType;
        data["recordTypeText"] = this.recordTypeText;
        data["packingMaterialId"] = this.packingMaterialId;
        data["materialName"] = this.materialName;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["consumptionType"] = this.consumptionType;
        data["consumptionTypeText"] = this.consumptionTypeText;
        data["invoiceId"] = this.invoiceId;
        data["productCode"] = this.productCode;
        data["productQuantity"] = this.productQuantity;
        data["amount"] = this.amount;
        data["oldQuantity"] = this.oldQuantity;
        data["newQuantity"] = this.newQuantity;
        data["changeAmount"] = this.changeAmount;
        data["logType"] = this.logType;
        data["logTypeText"] = this.logTypeText;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IMaterialConsumptionHistoryItemDto {
    recordType?: HistoryRecordType;
    recordTypeText?: string;
    packingMaterialId?: number;
    materialName?: string;
    date?: Date;
    createdAt?: Date;
    consumptionType?: ConsumptionType | undefined;
    consumptionTypeText?: string | undefined;
    invoiceId?: string | undefined;
    productCode?: string | undefined;
    productQuantity?: number | undefined;
    amount?: number | undefined;
    oldQuantity?: number | undefined;
    newQuantity?: number | undefined;
    changeAmount?: number | undefined;
    logType?: LogEntryType | undefined;
    logTypeText?: string | undefined;
    userId?: string | undefined;
}

export enum HistoryRecordType {
    Consumption = "Consumption",
    QuantityChange = "QuantityChange",
}

export enum LogEntryType {
    Manual = "Manual",
    AutomaticConsumption = "AutomaticConsumption",
}

export class GetPackingMaterialLogsResponse extends BaseResponse implements IGetPackingMaterialLogsResponse {
    material?: PackingMaterialDto;
    logs?: PackingMaterialLogDto[];
    error?: string | undefined;

    constructor(data?: IGetPackingMaterialLogsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.material = _data["material"] ? PackingMaterialDto.fromJS(_data["material"]) : <any>undefined;
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(PackingMaterialLogDto.fromJS(item));
            }
            this.error = _data["error"];
        }
    }

    static override fromJS(data: any): GetPackingMaterialLogsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPackingMaterialLogsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["material"] = this.material ? this.material.toJSON() : <any>undefined;
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        data["error"] = this.error;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPackingMaterialLogsResponse extends IBaseResponse {
    material?: PackingMaterialDto;
    logs?: PackingMaterialLogDto[];
    error?: string | undefined;
}

export class PackingMaterialLogDto implements IPackingMaterialLogDto {
    id?: number;
    packingMaterialId?: number;
    date?: Date;
    oldQuantity?: number;
    newQuantity?: number;
    changeAmount?: number;
    logType?: LogEntryType;
    logTypeText?: string;
    userId?: string | undefined;
    createdAt?: Date;

    constructor(data?: IPackingMaterialLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packingMaterialId = _data["packingMaterialId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.oldQuantity = _data["oldQuantity"];
            this.newQuantity = _data["newQuantity"];
            this.changeAmount = _data["changeAmount"];
            this.logType = _data["logType"];
            this.logTypeText = _data["logTypeText"];
            this.userId = _data["userId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PackingMaterialLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackingMaterialLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packingMaterialId"] = this.packingMaterialId;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["oldQuantity"] = this.oldQuantity;
        data["newQuantity"] = this.newQuantity;
        data["changeAmount"] = this.changeAmount;
        data["logType"] = this.logType;
        data["logTypeText"] = this.logTypeText;
        data["userId"] = this.userId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPackingMaterialLogDto {
    id?: number;
    packingMaterialId?: number;
    date?: Date;
    oldQuantity?: number;
    newQuantity?: number;
    changeAmount?: number;
    logType?: LogEntryType;
    logTypeText?: string;
    userId?: string | undefined;
    createdAt?: Date;
}

export class GetAllocationsResponse extends BaseResponse implements IGetAllocationsResponse {
    error?: string | undefined;
    allocations?: PackingMaterialAllocationDto[];

    constructor(data?: IGetAllocationsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.error = _data["error"];
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(PackingMaterialAllocationDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetAllocationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllocationsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAllocationsResponse extends IBaseResponse {
    error?: string | undefined;
    allocations?: PackingMaterialAllocationDto[];
}

export class PackingMaterialAllocationDto implements IPackingMaterialAllocationDto {
    id?: number;
    packingMaterialId?: number;
    productCode?: string;
    amountPerUnit?: number;
    createdAt?: Date;

    constructor(data?: IPackingMaterialAllocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packingMaterialId = _data["packingMaterialId"];
            this.productCode = _data["productCode"];
            this.amountPerUnit = _data["amountPerUnit"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PackingMaterialAllocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackingMaterialAllocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packingMaterialId"] = this.packingMaterialId;
        data["productCode"] = this.productCode;
        data["amountPerUnit"] = this.amountPerUnit;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPackingMaterialAllocationDto {
    id?: number;
    packingMaterialId?: number;
    productCode?: string;
    amountPerUnit?: number;
    createdAt?: Date;
}

export class CreateAllocationResponse extends BaseResponse implements ICreateAllocationResponse {
    error?: string | undefined;
    allocation?: PackingMaterialAllocationDto | undefined;

    constructor(data?: ICreateAllocationResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.error = _data["error"];
            this.allocation = _data["allocation"] ? PackingMaterialAllocationDto.fromJS(_data["allocation"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CreateAllocationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAllocationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        data["allocation"] = this.allocation ? this.allocation.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateAllocationResponse extends IBaseResponse {
    error?: string | undefined;
    allocation?: PackingMaterialAllocationDto | undefined;
}

export class CreateAllocationRequestBody implements ICreateAllocationRequestBody {
    productCode?: string;
    amountPerUnit?: number;

    constructor(data?: ICreateAllocationRequestBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.amountPerUnit = _data["amountPerUnit"];
        }
    }

    static fromJS(data: any): CreateAllocationRequestBody {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAllocationRequestBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["amountPerUnit"] = this.amountPerUnit;
        return data;
    }
}

export interface ICreateAllocationRequestBody {
    productCode?: string;
    amountPerUnit?: number;
}

export class UpdateAllocationResponse extends BaseResponse implements IUpdateAllocationResponse {
    error?: string | undefined;

    constructor(data?: IUpdateAllocationResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.error = _data["error"];
        }
    }

    static override fromJS(data: any): UpdateAllocationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAllocationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateAllocationResponse extends IBaseResponse {
    error?: string | undefined;
}

export class UpdateAllocationRequestBody implements IUpdateAllocationRequestBody {
    productCode?: string;
    amountPerUnit?: number;

    constructor(data?: IUpdateAllocationRequestBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.amountPerUnit = _data["amountPerUnit"];
        }
    }

    static fromJS(data: any): UpdateAllocationRequestBody {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAllocationRequestBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["amountPerUnit"] = this.amountPerUnit;
        return data;
    }
}

export interface IUpdateAllocationRequestBody {
    productCode?: string;
    amountPerUnit?: number;
}

export class GetPhotosResponse extends BaseResponse implements IGetPhotosResponse {
    items?: PhotoDto[];
    total?: number;
    page?: number;
    pageSize?: number;

    constructor(data?: IGetPhotosResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PhotoDto.fromJS(item));
            }
            this.total = _data["total"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static override fromJS(data: any): GetPhotosResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPhotosResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPhotosResponse extends IBaseResponse {
    items?: PhotoDto[];
    total?: number;
    page?: number;
    pageSize?: number;
}

export class PhotoDto implements IPhotoDto {
    id?: number;
    sharePointFileId?: string;
    driveId?: string | undefined;
    name?: string;
    folderPath?: string;
    sharePointWebUrl?: string | undefined;
    fileSizeBytes?: number | undefined;
    lastModifiedAt?: Date;
    tags?: TagDto[];

    constructor(data?: IPhotoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sharePointFileId = _data["sharePointFileId"];
            this.driveId = _data["driveId"];
            this.name = _data["name"];
            this.folderPath = _data["folderPath"];
            this.sharePointWebUrl = _data["sharePointWebUrl"];
            this.fileSizeBytes = _data["fileSizeBytes"];
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PhotoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sharePointFileId"] = this.sharePointFileId;
        data["driveId"] = this.driveId;
        data["name"] = this.name;
        data["folderPath"] = this.folderPath;
        data["sharePointWebUrl"] = this.sharePointWebUrl;
        data["fileSizeBytes"] = this.fileSizeBytes;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPhotoDto {
    id?: number;
    sharePointFileId?: string;
    driveId?: string | undefined;
    name?: string;
    folderPath?: string;
    sharePointWebUrl?: string | undefined;
    fileSizeBytes?: number | undefined;
    lastModifiedAt?: Date;
    tags?: TagDto[];
}

export class TagDto implements ITagDto {
    id?: number;
    name?: string;
    source?: string | undefined;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["source"] = this.source;
        return data;
    }
}

export interface ITagDto {
    id?: number;
    name?: string;
    source?: string | undefined;
}

export class GetTagsResponse extends BaseResponse implements IGetTagsResponse {
    tags?: TagWithCountDto[];

    constructor(data?: IGetTagsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagWithCountDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetTagsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTagsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTagsResponse extends IBaseResponse {
    tags?: TagWithCountDto[];
}

export class TagWithCountDto implements ITagWithCountDto {
    id?: number;
    name?: string;
    count?: number;

    constructor(data?: ITagWithCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): TagWithCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagWithCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["count"] = this.count;
        return data;
    }
}

export interface ITagWithCountDto {
    id?: number;
    name?: string;
    count?: number;
}

export class CreateTagResponse extends BaseResponse implements ICreateTagResponse {
    id?: number;
    name?: string;
    alreadyExisted?: boolean;

    constructor(data?: ICreateTagResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.alreadyExisted = _data["alreadyExisted"];
        }
    }

    static override fromJS(data: any): CreateTagResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTagResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["alreadyExisted"] = this.alreadyExisted;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateTagResponse extends IBaseResponse {
    id?: number;
    name?: string;
    alreadyExisted?: boolean;
}

export class CreateTagBody implements ICreateTagBody {
    name?: string;

    constructor(data?: ICreateTagBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateTagBody {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTagBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateTagBody {
    name?: string;
}

export class DeleteTagResponse extends BaseResponse implements IDeleteTagResponse {
    removedAssignmentCount?: number;

    constructor(data?: IDeleteTagResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.removedAssignmentCount = _data["removedAssignmentCount"];
        }
    }

    static override fromJS(data: any): DeleteTagResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTagResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["removedAssignmentCount"] = this.removedAssignmentCount;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteTagResponse extends IBaseResponse {
    removedAssignmentCount?: number;
}

export class AddPhotoTagResponse extends BaseResponse implements IAddPhotoTagResponse {
    tagId?: number;
    tagName?: string;

    constructor(data?: IAddPhotoTagResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tagId = _data["tagId"];
            this.tagName = _data["tagName"];
        }
    }

    static override fromJS(data: any): AddPhotoTagResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddPhotoTagResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["tagName"] = this.tagName;
        super.toJSON(data);
        return data;
    }
}

export interface IAddPhotoTagResponse extends IBaseResponse {
    tagId?: number;
    tagName?: string;
}

export class AddPhotoTagBody implements IAddPhotoTagBody {
    tagName?: string;

    constructor(data?: IAddPhotoTagBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagName = _data["tagName"];
        }
    }

    static fromJS(data: any): AddPhotoTagBody {
        data = typeof data === 'object' ? data : {};
        let result = new AddPhotoTagBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagName"] = this.tagName;
        return data;
    }
}

export interface IAddPhotoTagBody {
    tagName?: string;
}

export class RemovePhotoTagResponse extends BaseResponse implements IRemovePhotoTagResponse {

    constructor(data?: IRemovePhotoTagResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): RemovePhotoTagResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemovePhotoTagResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRemovePhotoTagResponse extends IBaseResponse {
}

export class BulkAddPhotoTagResponse extends BaseResponse implements IBulkAddPhotoTagResponse {
    tagId?: number;
    tagName?: string;
    addedCount?: number;
    alreadyTaggedCount?: number;

    constructor(data?: IBulkAddPhotoTagResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tagId = _data["tagId"];
            this.tagName = _data["tagName"];
            this.addedCount = _data["addedCount"];
            this.alreadyTaggedCount = _data["alreadyTaggedCount"];
        }
    }

    static override fromJS(data: any): BulkAddPhotoTagResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BulkAddPhotoTagResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["tagName"] = this.tagName;
        data["addedCount"] = this.addedCount;
        data["alreadyTaggedCount"] = this.alreadyTaggedCount;
        super.toJSON(data);
        return data;
    }
}

export interface IBulkAddPhotoTagResponse extends IBaseResponse {
    tagId?: number;
    tagName?: string;
    addedCount?: number;
    alreadyTaggedCount?: number;
}

export class BulkAddPhotoTagBody implements IBulkAddPhotoTagBody {
    tags?: string[] | undefined;
    search?: string | undefined;
    tagName?: string;

    constructor(data?: IBulkAddPhotoTagBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.search = _data["search"];
            this.tagName = _data["tagName"];
        }
    }

    static fromJS(data: any): BulkAddPhotoTagBody {
        data = typeof data === 'object' ? data : {};
        let result = new BulkAddPhotoTagBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["search"] = this.search;
        data["tagName"] = this.tagName;
        return data;
    }
}

export interface IBulkAddPhotoTagBody {
    tags?: string[] | undefined;
    search?: string | undefined;
    tagName?: string;
}

export class BulkAddPhotoTagByIdsResponse extends BaseResponse implements IBulkAddPhotoTagByIdsResponse {
    tagId?: number;
    tagName?: string;
    addedCount?: number;
    alreadyTaggedCount?: number;

    constructor(data?: IBulkAddPhotoTagByIdsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tagId = _data["tagId"];
            this.tagName = _data["tagName"];
            this.addedCount = _data["addedCount"];
            this.alreadyTaggedCount = _data["alreadyTaggedCount"];
        }
    }

    static override fromJS(data: any): BulkAddPhotoTagByIdsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BulkAddPhotoTagByIdsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["tagName"] = this.tagName;
        data["addedCount"] = this.addedCount;
        data["alreadyTaggedCount"] = this.alreadyTaggedCount;
        super.toJSON(data);
        return data;
    }
}

export interface IBulkAddPhotoTagByIdsResponse extends IBaseResponse {
    tagId?: number;
    tagName?: string;
    addedCount?: number;
    alreadyTaggedCount?: number;
}

export class BulkAddPhotoTagByIdsBody implements IBulkAddPhotoTagByIdsBody {
    photoIds?: number[];
    tagName?: string;

    constructor(data?: IBulkAddPhotoTagByIdsBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["photoIds"])) {
                this.photoIds = [] as any;
                for (let item of _data["photoIds"])
                    this.photoIds!.push(item);
            }
            this.tagName = _data["tagName"];
        }
    }

    static fromJS(data: any): BulkAddPhotoTagByIdsBody {
        data = typeof data === 'object' ? data : {};
        let result = new BulkAddPhotoTagByIdsBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.photoIds)) {
            data["photoIds"] = [];
            for (let item of this.photoIds)
                data["photoIds"].push(item);
        }
        data["tagName"] = this.tagName;
        return data;
    }
}

export interface IBulkAddPhotoTagByIdsBody {
    photoIds?: number[];
    tagName?: string;
}

export class RetagPhotosResponse extends BaseResponse implements IRetagPhotosResponse {
    jobId?: string | undefined;

    constructor(data?: IRetagPhotosResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobId = _data["jobId"];
        }
    }

    static override fromJS(data: any): RetagPhotosResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RetagPhotosResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        super.toJSON(data);
        return data;
    }
}

export interface IRetagPhotosResponse extends IBaseResponse {
    jobId?: string | undefined;
}

export class RetagPhotosBody implements IRetagPhotosBody {
    photoIds?: number[];
    clearExistingAiTags?: boolean;

    constructor(data?: IRetagPhotosBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["photoIds"])) {
                this.photoIds = [] as any;
                for (let item of _data["photoIds"])
                    this.photoIds!.push(item);
            }
            this.clearExistingAiTags = _data["clearExistingAiTags"];
        }
    }

    static fromJS(data: any): RetagPhotosBody {
        data = typeof data === 'object' ? data : {};
        let result = new RetagPhotosBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.photoIds)) {
            data["photoIds"] = [];
            for (let item of this.photoIds)
                data["photoIds"].push(item);
        }
        data["clearExistingAiTags"] = this.clearExistingAiTags;
        return data;
    }
}

export interface IRetagPhotosBody {
    photoIds?: number[];
    clearExistingAiTags?: boolean;
}

export class GetRootsResponse extends BaseResponse implements IGetRootsResponse {
    roots?: IndexRootDto[];

    constructor(data?: IGetRootsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["roots"])) {
                this.roots = [] as any;
                for (let item of _data["roots"])
                    this.roots!.push(IndexRootDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetRootsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRootsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roots)) {
            data["roots"] = [];
            for (let item of this.roots)
                data["roots"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetRootsResponse extends IBaseResponse {
    roots?: IndexRootDto[];
}

export class IndexRootDto implements IIndexRootDto {
    id?: number;
    sharePointPath?: string;
    displayName?: string | undefined;
    driveId?: string | undefined;
    rootItemId?: string | undefined;
    isActive?: boolean;
    createdAt?: Date;
    lastIndexedAt?: Date | undefined;

    constructor(data?: IIndexRootDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sharePointPath = _data["sharePointPath"];
            this.displayName = _data["displayName"];
            this.driveId = _data["driveId"];
            this.rootItemId = _data["rootItemId"];
            this.isActive = _data["isActive"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.lastIndexedAt = _data["lastIndexedAt"] ? new Date(_data["lastIndexedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IndexRootDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndexRootDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sharePointPath"] = this.sharePointPath;
        data["displayName"] = this.displayName;
        data["driveId"] = this.driveId;
        data["rootItemId"] = this.rootItemId;
        data["isActive"] = this.isActive;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["lastIndexedAt"] = this.lastIndexedAt ? this.lastIndexedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IIndexRootDto {
    id?: number;
    sharePointPath?: string;
    displayName?: string | undefined;
    driveId?: string | undefined;
    rootItemId?: string | undefined;
    isActive?: boolean;
    createdAt?: Date;
    lastIndexedAt?: Date | undefined;
}

export class AddRootResponse extends BaseResponse implements IAddRootResponse {
    id?: number;

    constructor(data?: IAddRootResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): AddRootResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddRootResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IAddRootResponse extends IBaseResponse {
    id?: number;
}

export class AddRootBody implements IAddRootBody {
    sharePointPath?: string;
    displayName?: string | undefined;
    driveId?: string;

    constructor(data?: IAddRootBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sharePointPath = _data["sharePointPath"];
            this.displayName = _data["displayName"];
            this.driveId = _data["driveId"];
        }
    }

    static fromJS(data: any): AddRootBody {
        data = typeof data === 'object' ? data : {};
        let result = new AddRootBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sharePointPath"] = this.sharePointPath;
        data["displayName"] = this.displayName;
        data["driveId"] = this.driveId;
        return data;
    }
}

export interface IAddRootBody {
    sharePointPath?: string;
    displayName?: string | undefined;
    driveId?: string;
}

export class DeleteRootResponse extends BaseResponse implements IDeleteRootResponse {

    constructor(data?: IDeleteRootResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DeleteRootResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRootResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteRootResponse extends IBaseResponse {
}

export class GetRulesResponse extends BaseResponse implements IGetRulesResponse {
    rules?: TagRuleDto[];

    constructor(data?: IGetRulesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(TagRuleDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetRulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRulesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetRulesResponse extends IBaseResponse {
    rules?: TagRuleDto[];
}

export class TagRuleDto implements ITagRuleDto {
    id?: number;
    pathPattern?: string;
    tagName?: string;
    isActive?: boolean;
    sortOrder?: number;

    constructor(data?: ITagRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pathPattern = _data["pathPattern"];
            this.tagName = _data["tagName"];
            this.isActive = _data["isActive"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): TagRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pathPattern"] = this.pathPattern;
        data["tagName"] = this.tagName;
        data["isActive"] = this.isActive;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ITagRuleDto {
    id?: number;
    pathPattern?: string;
    tagName?: string;
    isActive?: boolean;
    sortOrder?: number;
}

export class AddRuleResponse extends BaseResponse implements IAddRuleResponse {
    id?: number;

    constructor(data?: IAddRuleResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): AddRuleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddRuleResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IAddRuleResponse extends IBaseResponse {
    id?: number;
}

export class AddRuleBody implements IAddRuleBody {
    pathPattern?: string;
    tagName?: string;
    sortOrder?: number;

    constructor(data?: IAddRuleBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pathPattern = _data["pathPattern"];
            this.tagName = _data["tagName"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): AddRuleBody {
        data = typeof data === 'object' ? data : {};
        let result = new AddRuleBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pathPattern"] = this.pathPattern;
        data["tagName"] = this.tagName;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IAddRuleBody {
    pathPattern?: string;
    tagName?: string;
    sortOrder?: number;
}

export class UpdateRuleResponse extends BaseResponse implements IUpdateRuleResponse {

    constructor(data?: IUpdateRuleResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateRuleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRuleResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateRuleResponse extends IBaseResponse {
}

export class UpdateRuleBody implements IUpdateRuleBody {
    pathPattern?: string;
    tagName?: string;
    isActive?: boolean;
    sortOrder?: number;

    constructor(data?: IUpdateRuleBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pathPattern = _data["pathPattern"];
            this.tagName = _data["tagName"];
            this.isActive = _data["isActive"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): UpdateRuleBody {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRuleBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pathPattern"] = this.pathPattern;
        data["tagName"] = this.tagName;
        data["isActive"] = this.isActive;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IUpdateRuleBody {
    pathPattern?: string;
    tagName?: string;
    isActive?: boolean;
    sortOrder?: number;
}

export class DeleteRuleResponse extends BaseResponse implements IDeleteRuleResponse {

    constructor(data?: IDeleteRuleResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DeleteRuleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRuleResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteRuleResponse extends IBaseResponse {
}

export class ReapplyRulesResponse extends BaseResponse implements IReapplyRulesResponse {
    photosUpdated?: number;

    constructor(data?: IReapplyRulesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.photosUpdated = _data["photosUpdated"];
        }
    }

    static override fromJS(data: any): ReapplyRulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReapplyRulesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["photosUpdated"] = this.photosUpdated;
        super.toJSON(data);
        return data;
    }
}

export interface IReapplyRulesResponse extends IBaseResponse {
    photosUpdated?: number;
}

export enum ThumbnailSize {
    Medium = "Medium",
    Large = "Large",
}

export class GetPricingScenariosResponse extends BaseResponse implements IGetPricingScenariosResponse {
    scenarios?: PricingScenarioSummaryDto[];

    constructor(data?: IGetPricingScenariosResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["scenarios"])) {
                this.scenarios = [] as any;
                for (let item of _data["scenarios"])
                    this.scenarios!.push(PricingScenarioSummaryDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetPricingScenariosResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPricingScenariosResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scenarios)) {
            data["scenarios"] = [];
            for (let item of this.scenarios)
                data["scenarios"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPricingScenariosResponse extends IBaseResponse {
    scenarios?: PricingScenarioSummaryDto[];
}

export class PricingScenarioSummaryDto implements IPricingScenarioSummaryDto {
    id?: string;
    name?: string;
    description?: string | undefined;
    createdBy?: string;
    createdAt?: Date;
    modifiedAt?: Date;
    editedProductCount?: number;

    constructor(data?: IPricingScenarioSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : <any>undefined;
            this.editedProductCount = _data["editedProductCount"];
        }
    }

    static fromJS(data: any): PricingScenarioSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PricingScenarioSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : <any>undefined;
        data["editedProductCount"] = this.editedProductCount;
        return data;
    }
}

export interface IPricingScenarioSummaryDto {
    id?: string;
    name?: string;
    description?: string | undefined;
    createdBy?: string;
    createdAt?: Date;
    modifiedAt?: Date;
    editedProductCount?: number;
}

export class SavePricingScenarioResponse extends BaseResponse implements ISavePricingScenarioResponse {
    id?: string;

    constructor(data?: ISavePricingScenarioResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): SavePricingScenarioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SavePricingScenarioResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface ISavePricingScenarioResponse extends IBaseResponse {
    id?: string;
}

export class SavePricingScenarioRequest implements ISavePricingScenarioRequest {
    id?: string | undefined;
    name?: string;
    description?: string | undefined;
    productCode?: string | undefined;
    productName?: string | undefined;
    productType?: ProductType | undefined;
    overrides?: PricingOverrideDto[];

    constructor(data?: ISavePricingScenarioRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.productType = _data["productType"];
            if (Array.isArray(_data["overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["overrides"])
                    this.overrides!.push(PricingOverrideDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SavePricingScenarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SavePricingScenarioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productType"] = this.productType;
        if (Array.isArray(this.overrides)) {
            data["overrides"] = [];
            for (let item of this.overrides)
                data["overrides"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISavePricingScenarioRequest {
    id?: string | undefined;
    name?: string;
    description?: string | undefined;
    productCode?: string | undefined;
    productName?: string | undefined;
    productType?: ProductType | undefined;
    overrides?: PricingOverrideDto[];
}

export class PricingOverrideDto implements IPricingOverrideDto {
    productCode?: string;
    price?: number | undefined;
    materialCost?: number | undefined;
    manufacturingCost?: number | undefined;
    forecastQuantity?: number | undefined;

    constructor(data?: IPricingOverrideDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.price = _data["price"];
            this.materialCost = _data["materialCost"];
            this.manufacturingCost = _data["manufacturingCost"];
            this.forecastQuantity = _data["forecastQuantity"];
        }
    }

    static fromJS(data: any): PricingOverrideDto {
        data = typeof data === 'object' ? data : {};
        let result = new PricingOverrideDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["price"] = this.price;
        data["materialCost"] = this.materialCost;
        data["manufacturingCost"] = this.manufacturingCost;
        data["forecastQuantity"] = this.forecastQuantity;
        return data;
    }
}

export interface IPricingOverrideDto {
    productCode?: string;
    price?: number | undefined;
    materialCost?: number | undefined;
    manufacturingCost?: number | undefined;
    forecastQuantity?: number | undefined;
}

export class GetPricingScenarioResponse extends BaseResponse implements IGetPricingScenarioResponse {
    scenario?: PricingScenarioSummaryDto;
    rows?: PricingRowDto[];
    totals?: PricingTotalsDto;
    overrides?: PricingOverrideDto[];

    constructor(data?: IGetPricingScenarioResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.scenario = _data["scenario"] ? PricingScenarioSummaryDto.fromJS(_data["scenario"]) : <any>undefined;
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PricingRowDto.fromJS(item));
            }
            this.totals = _data["totals"] ? PricingTotalsDto.fromJS(_data["totals"]) : <any>undefined;
            if (Array.isArray(_data["overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["overrides"])
                    this.overrides!.push(PricingOverrideDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetPricingScenarioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPricingScenarioResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenario"] = this.scenario ? this.scenario.toJSON() : <any>undefined;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totals"] = this.totals ? this.totals.toJSON() : <any>undefined;
        if (Array.isArray(this.overrides)) {
            data["overrides"] = [];
            for (let item of this.overrides)
                data["overrides"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPricingScenarioResponse extends IBaseResponse {
    scenario?: PricingScenarioSummaryDto;
    rows?: PricingRowDto[];
    totals?: PricingTotalsDto;
    overrides?: PricingOverrideDto[];
}

export class PricingRowDto implements IPricingRowDto {
    productCode?: string;
    productName?: string;
    baselinePrice?: number;
    baselineMaterialCost?: number;
    baselineManufacturingCost?: number;
    baselineQuantity?: number;
    price?: number;
    materialCost?: number;
    manufacturingCost?: number;
    forecastQuantity?: number;
    m0Amount?: number;
    m0Percentage?: number;
    m1Amount?: number;
    m1Percentage?: number;
    baselineM0Amount?: number;
    baselineM1Amount?: number;
    baselineM0Percentage?: number;
    baselineM1Percentage?: number;
    isEdited?: boolean;
    isExcluded?: boolean;
    baselineDrifted?: boolean;

    constructor(data?: IPricingRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.baselinePrice = _data["baselinePrice"];
            this.baselineMaterialCost = _data["baselineMaterialCost"];
            this.baselineManufacturingCost = _data["baselineManufacturingCost"];
            this.baselineQuantity = _data["baselineQuantity"];
            this.price = _data["price"];
            this.materialCost = _data["materialCost"];
            this.manufacturingCost = _data["manufacturingCost"];
            this.forecastQuantity = _data["forecastQuantity"];
            this.m0Amount = _data["m0Amount"];
            this.m0Percentage = _data["m0Percentage"];
            this.m1Amount = _data["m1Amount"];
            this.m1Percentage = _data["m1Percentage"];
            this.baselineM0Amount = _data["baselineM0Amount"];
            this.baselineM1Amount = _data["baselineM1Amount"];
            this.baselineM0Percentage = _data["baselineM0Percentage"];
            this.baselineM1Percentage = _data["baselineM1Percentage"];
            this.isEdited = _data["isEdited"];
            this.isExcluded = _data["isExcluded"];
            this.baselineDrifted = _data["baselineDrifted"];
        }
    }

    static fromJS(data: any): PricingRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new PricingRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["baselinePrice"] = this.baselinePrice;
        data["baselineMaterialCost"] = this.baselineMaterialCost;
        data["baselineManufacturingCost"] = this.baselineManufacturingCost;
        data["baselineQuantity"] = this.baselineQuantity;
        data["price"] = this.price;
        data["materialCost"] = this.materialCost;
        data["manufacturingCost"] = this.manufacturingCost;
        data["forecastQuantity"] = this.forecastQuantity;
        data["m0Amount"] = this.m0Amount;
        data["m0Percentage"] = this.m0Percentage;
        data["m1Amount"] = this.m1Amount;
        data["m1Percentage"] = this.m1Percentage;
        data["baselineM0Amount"] = this.baselineM0Amount;
        data["baselineM1Amount"] = this.baselineM1Amount;
        data["baselineM0Percentage"] = this.baselineM0Percentage;
        data["baselineM1Percentage"] = this.baselineM1Percentage;
        data["isEdited"] = this.isEdited;
        data["isExcluded"] = this.isExcluded;
        data["baselineDrifted"] = this.baselineDrifted;
        return data;
    }
}

export interface IPricingRowDto {
    productCode?: string;
    productName?: string;
    baselinePrice?: number;
    baselineMaterialCost?: number;
    baselineManufacturingCost?: number;
    baselineQuantity?: number;
    price?: number;
    materialCost?: number;
    manufacturingCost?: number;
    forecastQuantity?: number;
    m0Amount?: number;
    m0Percentage?: number;
    m1Amount?: number;
    m1Percentage?: number;
    baselineM0Amount?: number;
    baselineM1Amount?: number;
    baselineM0Percentage?: number;
    baselineM1Percentage?: number;
    isEdited?: boolean;
    isExcluded?: boolean;
    baselineDrifted?: boolean;
}

export class PricingTotalsDto implements IPricingTotalsDto {
    revenueBefore?: number;
    revenueAfter?: number;
    revenueDelta?: number;
    revenueDeltaPercentage?: number;
    m0Before?: number;
    m0After?: number;
    m0Delta?: number;
    m0DeltaPercentage?: number;
    m1Before?: number;
    m1After?: number;
    m1Delta?: number;
    m1DeltaPercentage?: number;
    editedProductCount?: number;
    excludedProductCount?: number;

    constructor(data?: IPricingTotalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.revenueBefore = _data["revenueBefore"];
            this.revenueAfter = _data["revenueAfter"];
            this.revenueDelta = _data["revenueDelta"];
            this.revenueDeltaPercentage = _data["revenueDeltaPercentage"];
            this.m0Before = _data["m0Before"];
            this.m0After = _data["m0After"];
            this.m0Delta = _data["m0Delta"];
            this.m0DeltaPercentage = _data["m0DeltaPercentage"];
            this.m1Before = _data["m1Before"];
            this.m1After = _data["m1After"];
            this.m1Delta = _data["m1Delta"];
            this.m1DeltaPercentage = _data["m1DeltaPercentage"];
            this.editedProductCount = _data["editedProductCount"];
            this.excludedProductCount = _data["excludedProductCount"];
        }
    }

    static fromJS(data: any): PricingTotalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PricingTotalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["revenueBefore"] = this.revenueBefore;
        data["revenueAfter"] = this.revenueAfter;
        data["revenueDelta"] = this.revenueDelta;
        data["revenueDeltaPercentage"] = this.revenueDeltaPercentage;
        data["m0Before"] = this.m0Before;
        data["m0After"] = this.m0After;
        data["m0Delta"] = this.m0Delta;
        data["m0DeltaPercentage"] = this.m0DeltaPercentage;
        data["m1Before"] = this.m1Before;
        data["m1After"] = this.m1After;
        data["m1Delta"] = this.m1Delta;
        data["m1DeltaPercentage"] = this.m1DeltaPercentage;
        data["editedProductCount"] = this.editedProductCount;
        data["excludedProductCount"] = this.excludedProductCount;
        return data;
    }
}

export interface IPricingTotalsDto {
    revenueBefore?: number;
    revenueAfter?: number;
    revenueDelta?: number;
    revenueDeltaPercentage?: number;
    m0Before?: number;
    m0After?: number;
    m0Delta?: number;
    m0DeltaPercentage?: number;
    m1Before?: number;
    m1After?: number;
    m1Delta?: number;
    m1DeltaPercentage?: number;
    editedProductCount?: number;
    excludedProductCount?: number;
}

export class DeletePricingScenarioResponse extends BaseResponse implements IDeletePricingScenarioResponse {

    constructor(data?: IDeletePricingScenarioResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DeletePricingScenarioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePricingScenarioResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDeletePricingScenarioResponse extends IBaseResponse {
}

export class GetPricingBaselineResponse extends BaseResponse implements IGetPricingBaselineResponse {
    rows?: PricingRowDto[];
    totals?: PricingTotalsDto;

    constructor(data?: IGetPricingBaselineResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PricingRowDto.fromJS(item));
            }
            this.totals = _data["totals"] ? PricingTotalsDto.fromJS(_data["totals"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetPricingBaselineResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPricingBaselineResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totals"] = this.totals ? this.totals.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPricingBaselineResponse extends IBaseResponse {
    rows?: PricingRowDto[];
    totals?: PricingTotalsDto;
}

export class RecalculatePricingResponse extends BaseResponse implements IRecalculatePricingResponse {
    rows?: PricingRowDto[];
    totals?: PricingTotalsDto;
    overrides?: PricingOverrideDto[];

    constructor(data?: IRecalculatePricingResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PricingRowDto.fromJS(item));
            }
            this.totals = _data["totals"] ? PricingTotalsDto.fromJS(_data["totals"]) : <any>undefined;
            if (Array.isArray(_data["overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["overrides"])
                    this.overrides!.push(PricingOverrideDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RecalculatePricingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecalculatePricingResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totals"] = this.totals ? this.totals.toJSON() : <any>undefined;
        if (Array.isArray(this.overrides)) {
            data["overrides"] = [];
            for (let item of this.overrides)
                data["overrides"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IRecalculatePricingResponse extends IBaseResponse {
    rows?: PricingRowDto[];
    totals?: PricingTotalsDto;
    overrides?: PricingOverrideDto[];
}

export class RecalculatePricingRequest implements IRecalculatePricingRequest {
    productCode?: string | undefined;
    productName?: string | undefined;
    productType?: ProductType | undefined;
    overrides?: PricingOverrideDto[];
    edit?: PricingEditDto | undefined;

    constructor(data?: IRecalculatePricingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.productType = _data["productType"];
            if (Array.isArray(_data["overrides"])) {
                this.overrides = [] as any;
                for (let item of _data["overrides"])
                    this.overrides!.push(PricingOverrideDto.fromJS(item));
            }
            this.edit = _data["edit"] ? PricingEditDto.fromJS(_data["edit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RecalculatePricingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecalculatePricingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productType"] = this.productType;
        if (Array.isArray(this.overrides)) {
            data["overrides"] = [];
            for (let item of this.overrides)
                data["overrides"].push(item.toJSON());
        }
        data["edit"] = this.edit ? this.edit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRecalculatePricingRequest {
    productCode?: string | undefined;
    productName?: string | undefined;
    productType?: ProductType | undefined;
    overrides?: PricingOverrideDto[];
    edit?: PricingEditDto | undefined;
}

export class PricingEditDto implements IPricingEditDto {
    productCode?: string;
    field?: PricingEditField;
    value?: number;

    constructor(data?: IPricingEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.field = _data["field"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PricingEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new PricingEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["field"] = this.field;
        data["value"] = this.value;
        return data;
    }
}

export interface IPricingEditDto {
    productCode?: string;
    field?: PricingEditField;
    value?: number;
}

export enum PricingEditField {
    Price = "Price",
    MaterialCost = "MaterialCost",
    ManufacturingCost = "ManufacturingCost",
    M0Amount = "M0Amount",
    M0Percentage = "M0Percentage",
    M1Amount = "M1Amount",
    M1Percentage = "M1Percentage",
    ForecastQuantity = "ForecastQuantity",
}

export class GetProductMarginsResponse extends BaseResponse implements IGetProductMarginsResponse {
    items?: ProductMarginDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;

    constructor(data?: IGetProductMarginsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProductMarginDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static override fromJS(data: any): GetProductMarginsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductMarginsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        super.toJSON(data);
        return data;
    }
}

export interface IGetProductMarginsResponse extends IBaseResponse {
    items?: ProductMarginDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class ProductMarginDto implements IProductMarginDto {
    productCode?: string;
    productName?: string;
    productNameSuffix?: string | undefined;
    priceWithoutVat?: number | undefined;
    purchasePrice?: number | undefined;
    manufactureDifficulty?: number;
    priceWithoutVatIsFromEshop?: boolean;
    m0?: MarginLevelDto;
    m1?: MarginLevelDto;
    m2?: MarginLevelDto;
    m3?: MarginLevelDto;
    monthlyHistory?: MonthlyMarginDto[];

    constructor(data?: IProductMarginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.productNameSuffix = _data["productNameSuffix"];
            this.priceWithoutVat = _data["priceWithoutVat"];
            this.purchasePrice = _data["purchasePrice"];
            this.manufactureDifficulty = _data["manufactureDifficulty"];
            this.priceWithoutVatIsFromEshop = _data["priceWithoutVatIsFromEshop"];
            this.m0 = _data["m0"] ? MarginLevelDto.fromJS(_data["m0"]) : <any>undefined;
            this.m1 = _data["m1"] ? MarginLevelDto.fromJS(_data["m1"]) : <any>undefined;
            this.m2 = _data["m2"] ? MarginLevelDto.fromJS(_data["m2"]) : <any>undefined;
            this.m3 = _data["m3"] ? MarginLevelDto.fromJS(_data["m3"]) : <any>undefined;
            if (Array.isArray(_data["monthlyHistory"])) {
                this.monthlyHistory = [] as any;
                for (let item of _data["monthlyHistory"])
                    this.monthlyHistory!.push(MonthlyMarginDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductMarginDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMarginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productNameSuffix"] = this.productNameSuffix;
        data["priceWithoutVat"] = this.priceWithoutVat;
        data["purchasePrice"] = this.purchasePrice;
        data["manufactureDifficulty"] = this.manufactureDifficulty;
        data["priceWithoutVatIsFromEshop"] = this.priceWithoutVatIsFromEshop;
        data["m0"] = this.m0 ? this.m0.toJSON() : <any>undefined;
        data["m1"] = this.m1 ? this.m1.toJSON() : <any>undefined;
        data["m2"] = this.m2 ? this.m2.toJSON() : <any>undefined;
        data["m3"] = this.m3 ? this.m3.toJSON() : <any>undefined;
        if (Array.isArray(this.monthlyHistory)) {
            data["monthlyHistory"] = [];
            for (let item of this.monthlyHistory)
                data["monthlyHistory"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductMarginDto {
    productCode?: string;
    productName?: string;
    productNameSuffix?: string | undefined;
    priceWithoutVat?: number | undefined;
    purchasePrice?: number | undefined;
    manufactureDifficulty?: number;
    priceWithoutVatIsFromEshop?: boolean;
    m0?: MarginLevelDto;
    m1?: MarginLevelDto;
    m2?: MarginLevelDto;
    m3?: MarginLevelDto;
    monthlyHistory?: MonthlyMarginDto[];
}

export class MonthlyMarginDto implements IMonthlyMarginDto {
    month?: Date;
    m0?: MarginLevelDto;
    m1?: MarginLevelDto;
    m2?: MarginLevelDto;
    m3?: MarginLevelDto;

    constructor(data?: IMonthlyMarginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"] ? new Date(_data["month"].toString()) : <any>undefined;
            this.m0 = _data["m0"] ? MarginLevelDto.fromJS(_data["m0"]) : <any>undefined;
            this.m1 = _data["m1"] ? MarginLevelDto.fromJS(_data["m1"]) : <any>undefined;
            this.m2 = _data["m2"] ? MarginLevelDto.fromJS(_data["m2"]) : <any>undefined;
            this.m3 = _data["m3"] ? MarginLevelDto.fromJS(_data["m3"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MonthlyMarginDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyMarginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month ? this.month.toISOString() : <any>undefined;
        data["m0"] = this.m0 ? this.m0.toJSON() : <any>undefined;
        data["m1"] = this.m1 ? this.m1.toJSON() : <any>undefined;
        data["m2"] = this.m2 ? this.m2.toJSON() : <any>undefined;
        data["m3"] = this.m3 ? this.m3.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMonthlyMarginDto {
    month?: Date;
    m0?: MarginLevelDto;
    m1?: MarginLevelDto;
    m2?: MarginLevelDto;
    m3?: MarginLevelDto;
}

export class GetPriceDivergenceReportResponse extends BaseResponse implements IGetPriceDivergenceReportResponse {
    rows?: PriceDivergenceRowDto[];
    summary?: PriceDivergenceSummaryDto;

    constructor(data?: IGetPriceDivergenceReportResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PriceDivergenceRowDto.fromJS(item));
            }
            this.summary = _data["summary"] ? PriceDivergenceSummaryDto.fromJS(_data["summary"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetPriceDivergenceReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPriceDivergenceReportResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPriceDivergenceReportResponse extends IBaseResponse {
    rows?: PriceDivergenceRowDto[];
    summary?: PriceDivergenceSummaryDto;
}

export class PriceDivergenceRowDto implements IPriceDivergenceRowDto {
    productCode?: string;
    productName?: string;
    shoptetPriceWithVat?: number | undefined;
    flexiPriceWithVat?: number | undefined;
    flexiPriceWithoutVat?: number | undefined;
    flexiPriceType?: string | undefined;
    differenceWithVat?: number | undefined;
    differencePercent?: number | undefined;
    kind?: PriceDivergenceKind;

    constructor(data?: IPriceDivergenceRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.shoptetPriceWithVat = _data["shoptetPriceWithVat"];
            this.flexiPriceWithVat = _data["flexiPriceWithVat"];
            this.flexiPriceWithoutVat = _data["flexiPriceWithoutVat"];
            this.flexiPriceType = _data["flexiPriceType"];
            this.differenceWithVat = _data["differenceWithVat"];
            this.differencePercent = _data["differencePercent"];
            this.kind = _data["kind"];
        }
    }

    static fromJS(data: any): PriceDivergenceRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriceDivergenceRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["shoptetPriceWithVat"] = this.shoptetPriceWithVat;
        data["flexiPriceWithVat"] = this.flexiPriceWithVat;
        data["flexiPriceWithoutVat"] = this.flexiPriceWithoutVat;
        data["flexiPriceType"] = this.flexiPriceType;
        data["differenceWithVat"] = this.differenceWithVat;
        data["differencePercent"] = this.differencePercent;
        data["kind"] = this.kind;
        return data;
    }
}

export interface IPriceDivergenceRowDto {
    productCode?: string;
    productName?: string;
    shoptetPriceWithVat?: number | undefined;
    flexiPriceWithVat?: number | undefined;
    flexiPriceWithoutVat?: number | undefined;
    flexiPriceType?: string | undefined;
    differenceWithVat?: number | undefined;
    differencePercent?: number | undefined;
    kind?: PriceDivergenceKind;
}

export enum PriceDivergenceKind {
    InAgreement = "InAgreement",
    FlexiDiffers = "FlexiDiffers",
    MissingInShoptet = "MissingInShoptet",
    MissingInFlexi = "MissingInFlexi",
    FlexiPriceTypeUnknown = "FlexiPriceTypeUnknown",
    FlexiVatRateUnknown = "FlexiVatRateUnknown",
}

export class PriceDivergenceSummaryDto implements IPriceDivergenceSummaryDto {
    totalInScope?: number;
    inAgreementCount?: number;
    flexiDiffersCount?: number;
    missingInShoptetCount?: number;
    missingInFlexiCount?: number;
    flexiPriceTypeUnknownCount?: number;
    flexiVatRateUnknownCount?: number;

    constructor(data?: IPriceDivergenceSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalInScope = _data["totalInScope"];
            this.inAgreementCount = _data["inAgreementCount"];
            this.flexiDiffersCount = _data["flexiDiffersCount"];
            this.missingInShoptetCount = _data["missingInShoptetCount"];
            this.missingInFlexiCount = _data["missingInFlexiCount"];
            this.flexiPriceTypeUnknownCount = _data["flexiPriceTypeUnknownCount"];
            this.flexiVatRateUnknownCount = _data["flexiVatRateUnknownCount"];
        }
    }

    static fromJS(data: any): PriceDivergenceSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriceDivergenceSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalInScope"] = this.totalInScope;
        data["inAgreementCount"] = this.inAgreementCount;
        data["flexiDiffersCount"] = this.flexiDiffersCount;
        data["missingInShoptetCount"] = this.missingInShoptetCount;
        data["missingInFlexiCount"] = this.missingInFlexiCount;
        data["flexiPriceTypeUnknownCount"] = this.flexiPriceTypeUnknownCount;
        data["flexiVatRateUnknownCount"] = this.flexiVatRateUnknownCount;
        return data;
    }
}

export interface IPriceDivergenceSummaryDto {
    totalInScope?: number;
    inAgreementCount?: number;
    flexiDiffersCount?: number;
    missingInShoptetCount?: number;
    missingInFlexiCount?: number;
    flexiPriceTypeUnknownCount?: number;
    flexiVatRateUnknownCount?: number;
}

export class SyncProductPricesResponse extends BaseResponse implements ISyncProductPricesResponse {
    rows?: PriceDivergenceRowDto[];
    writtenCount?: number;
    failedCount?: number;
    remainingCount?: number;

    constructor(data?: ISyncProductPricesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PriceDivergenceRowDto.fromJS(item));
            }
            this.writtenCount = _data["writtenCount"];
            this.failedCount = _data["failedCount"];
            this.remainingCount = _data["remainingCount"];
        }
    }

    static override fromJS(data: any): SyncProductPricesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SyncProductPricesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["writtenCount"] = this.writtenCount;
        data["failedCount"] = this.failedCount;
        data["remainingCount"] = this.remainingCount;
        super.toJSON(data);
        return data;
    }
}

export interface ISyncProductPricesResponse extends IBaseResponse {
    rows?: PriceDivergenceRowDto[];
    writtenCount?: number;
    failedCount?: number;
    remainingCount?: number;
}

export class SyncProductPricesRequest implements ISyncProductPricesRequest {
    productCodes?: string[];

    constructor(data?: ISyncProductPricesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productCodes"])) {
                this.productCodes = [] as any;
                for (let item of _data["productCodes"])
                    this.productCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): SyncProductPricesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SyncProductPricesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productCodes)) {
            data["productCodes"] = [];
            for (let item of this.productCodes)
                data["productCodes"].push(item);
        }
        return data;
    }
}

export interface ISyncProductPricesRequest {
    productCodes?: string[];
}

export class SetProductPriceResponse extends BaseResponse implements ISetProductPriceResponse {
    priceWithVat?: number;

    constructor(data?: ISetProductPriceResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.priceWithVat = _data["priceWithVat"];
        }
    }

    static override fromJS(data: any): SetProductPriceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetProductPriceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceWithVat"] = this.priceWithVat;
        super.toJSON(data);
        return data;
    }
}

export interface ISetProductPriceResponse extends IBaseResponse {
    priceWithVat?: number;
}

export class SetProductPriceRequest implements ISetProductPriceRequest {
    productCode?: string;
    priceWithVat?: number;

    constructor(data?: ISetProductPriceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.priceWithVat = _data["priceWithVat"];
        }
    }

    static fromJS(data: any): SetProductPriceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetProductPriceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["priceWithVat"] = this.priceWithVat;
        return data;
    }
}

export interface ISetProductPriceRequest {
    productCode?: string;
    priceWithVat?: number;
}

export class GetPurchaseOrdersResponse extends BaseResponse implements IGetPurchaseOrdersResponse {
    orders?: PurchaseOrderSummaryDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;

    constructor(data?: IGetPurchaseOrdersResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(PurchaseOrderSummaryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static override fromJS(data: any): GetPurchaseOrdersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchaseOrdersResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPurchaseOrdersResponse extends IBaseResponse {
    orders?: PurchaseOrderSummaryDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class PurchaseOrderSummaryDto implements IPurchaseOrderSummaryDto {
    id?: number;
    orderNumber?: string;
    supplierName?: string;
    orderDate?: Date;
    expectedDeliveryDate?: Date | undefined;
    contactVia?: ContactVia | undefined;
    status?: string;
    invoiceAcquired?: boolean;
    totalAmount?: number;
    lineCount?: number;
    isEditable?: boolean;
    createdAt?: Date;
    createdBy?: string;

    constructor(data?: IPurchaseOrderSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.supplierName = _data["supplierName"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] ? new Date(_data["expectedDeliveryDate"].toString()) : <any>undefined;
            this.contactVia = _data["contactVia"];
            this.status = _data["status"];
            this.invoiceAcquired = _data["invoiceAcquired"];
            this.totalAmount = _data["totalAmount"];
            this.lineCount = _data["lineCount"];
            this.isEditable = _data["isEditable"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): PurchaseOrderSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["supplierName"] = this.supplierName;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate ? this.expectedDeliveryDate.toISOString() : <any>undefined;
        data["contactVia"] = this.contactVia;
        data["status"] = this.status;
        data["invoiceAcquired"] = this.invoiceAcquired;
        data["totalAmount"] = this.totalAmount;
        data["lineCount"] = this.lineCount;
        data["isEditable"] = this.isEditable;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IPurchaseOrderSummaryDto {
    id?: number;
    orderNumber?: string;
    supplierName?: string;
    orderDate?: Date;
    expectedDeliveryDate?: Date | undefined;
    contactVia?: ContactVia | undefined;
    status?: string;
    invoiceAcquired?: boolean;
    totalAmount?: number;
    lineCount?: number;
    isEditable?: boolean;
    createdAt?: Date;
    createdBy?: string;
}

export enum ContactVia {
    Email = "Email",
    Phone = "Phone",
    WhatsApp = "WhatsApp",
    F2F = "F2F",
    Eshop = "Eshop",
    Other = "Other",
}

export class CreatePurchaseOrderResponse extends BaseResponse implements ICreatePurchaseOrderResponse {
    id?: number;
    orderNumber?: string;
    supplierId?: number;
    supplierName?: string;
    orderDate?: Date;
    expectedDeliveryDate?: Date | undefined;
    contactVia?: ContactVia | undefined;
    status?: string;
    notes?: string | undefined;
    totalAmount?: number;
    lines?: PurchaseOrderLineDto[];
    history?: PurchaseOrderHistoryDto[];
    createdAt?: Date;
    createdBy?: string;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;

    constructor(data?: ICreatePurchaseOrderResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] ? new Date(_data["expectedDeliveryDate"].toString()) : <any>undefined;
            this.contactVia = _data["contactVia"];
            this.status = _data["status"];
            this.notes = _data["notes"];
            this.totalAmount = _data["totalAmount"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(PurchaseOrderLineDto.fromJS(item));
            }
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(PurchaseOrderHistoryDto.fromJS(item));
            }
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static override fromJS(data: any): CreatePurchaseOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseOrderResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate ? this.expectedDeliveryDate.toISOString() : <any>undefined;
        data["contactVia"] = this.contactVia;
        data["status"] = this.status;
        data["notes"] = this.notes;
        data["totalAmount"] = this.totalAmount;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        super.toJSON(data);
        return data;
    }
}

export interface ICreatePurchaseOrderResponse extends IBaseResponse {
    id?: number;
    orderNumber?: string;
    supplierId?: number;
    supplierName?: string;
    orderDate?: Date;
    expectedDeliveryDate?: Date | undefined;
    contactVia?: ContactVia | undefined;
    status?: string;
    notes?: string | undefined;
    totalAmount?: number;
    lines?: PurchaseOrderLineDto[];
    history?: PurchaseOrderHistoryDto[];
    createdAt?: Date;
    createdBy?: string;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;
}

export class PurchaseOrderLineDto implements IPurchaseOrderLineDto {
    id?: number;
    materialId?: string;
    code?: string;
    materialName?: string;
    quantity?: number;
    unitPrice?: number;
    lineTotal?: number;
    notes?: string | undefined;
    catalogNote?: string | undefined;

    constructor(data?: IPurchaseOrderLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialId = _data["materialId"];
            this.code = _data["code"];
            this.materialName = _data["materialName"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.lineTotal = _data["lineTotal"];
            this.notes = _data["notes"];
            this.catalogNote = _data["catalogNote"];
        }
    }

    static fromJS(data: any): PurchaseOrderLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialId"] = this.materialId;
        data["code"] = this.code;
        data["materialName"] = this.materialName;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["lineTotal"] = this.lineTotal;
        data["notes"] = this.notes;
        data["catalogNote"] = this.catalogNote;
        return data;
    }
}

export interface IPurchaseOrderLineDto {
    id?: number;
    materialId?: string;
    code?: string;
    materialName?: string;
    quantity?: number;
    unitPrice?: number;
    lineTotal?: number;
    notes?: string | undefined;
    catalogNote?: string | undefined;
}

export class PurchaseOrderHistoryDto implements IPurchaseOrderHistoryDto {
    id?: number;
    action?: string;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    changedAt?: Date;
    changedBy?: string;

    constructor(data?: IPurchaseOrderHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.action = _data["action"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.changedAt = _data["changedAt"] ? new Date(_data["changedAt"].toString()) : <any>undefined;
            this.changedBy = _data["changedBy"];
        }
    }

    static fromJS(data: any): PurchaseOrderHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["action"] = this.action;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["changedAt"] = this.changedAt ? this.changedAt.toISOString() : <any>undefined;
        data["changedBy"] = this.changedBy;
        return data;
    }
}

export interface IPurchaseOrderHistoryDto {
    id?: number;
    action?: string;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    changedAt?: Date;
    changedBy?: string;
}

export class CreatePurchaseOrderRequest implements ICreatePurchaseOrderRequest {
    supplierId!: number;
    orderDate?: Date;
    expectedDeliveryDate?: Date | undefined;
    contactVia?: ContactVia | undefined;
    notes?: string | undefined;
    orderNumber?: string | undefined;
    lines?: CreatePurchaseOrderLineRequest[] | undefined;

    constructor(data?: ICreatePurchaseOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierId = _data["supplierId"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] ? new Date(_data["expectedDeliveryDate"].toString()) : <any>undefined;
            this.contactVia = _data["contactVia"];
            this.notes = _data["notes"];
            this.orderNumber = _data["orderNumber"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(CreatePurchaseOrderLineRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePurchaseOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierId"] = this.supplierId;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate ? this.expectedDeliveryDate.toISOString() : <any>undefined;
        data["contactVia"] = this.contactVia;
        data["notes"] = this.notes;
        data["orderNumber"] = this.orderNumber;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreatePurchaseOrderRequest {
    supplierId: number;
    orderDate?: Date;
    expectedDeliveryDate?: Date | undefined;
    contactVia?: ContactVia | undefined;
    notes?: string | undefined;
    orderNumber?: string | undefined;
    lines?: CreatePurchaseOrderLineRequest[] | undefined;
}

export class CreatePurchaseOrderLineRequest implements ICreatePurchaseOrderLineRequest {
    materialId!: string;
    name?: string | undefined;
    quantity!: number;
    unitPrice!: number;
    notes?: string | undefined;

    constructor(data?: ICreatePurchaseOrderLineRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialId = _data["materialId"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreatePurchaseOrderLineRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseOrderLineRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialId"] = this.materialId;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreatePurchaseOrderLineRequest {
    materialId: string;
    name?: string | undefined;
    quantity: number;
    unitPrice: number;
    notes?: string | undefined;
}

export class GetPurchaseOrderByIdResponse extends BaseResponse implements IGetPurchaseOrderByIdResponse {
    id?: number;
    orderNumber?: string;
    supplierId?: number;
    supplierName?: string;
    orderDate?: Date;
    expectedDeliveryDate?: Date | undefined;
    contactVia?: ContactVia | undefined;
    status?: string;
    invoiceAcquired?: boolean;
    notes?: string | undefined;
    totalAmount?: number;
    isEditable?: boolean;
    lines?: PurchaseOrderLineDto[];
    history?: PurchaseOrderHistoryDto[];
    createdAt?: Date;
    createdBy?: string;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;
    supplierNote?: string | undefined;

    constructor(data?: IGetPurchaseOrderByIdResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] ? new Date(_data["expectedDeliveryDate"].toString()) : <any>undefined;
            this.contactVia = _data["contactVia"];
            this.status = _data["status"];
            this.invoiceAcquired = _data["invoiceAcquired"];
            this.notes = _data["notes"];
            this.totalAmount = _data["totalAmount"];
            this.isEditable = _data["isEditable"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(PurchaseOrderLineDto.fromJS(item));
            }
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(PurchaseOrderHistoryDto.fromJS(item));
            }
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.supplierNote = _data["supplierNote"];
        }
    }

    static override fromJS(data: any): GetPurchaseOrderByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchaseOrderByIdResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate ? this.expectedDeliveryDate.toISOString() : <any>undefined;
        data["contactVia"] = this.contactVia;
        data["status"] = this.status;
        data["invoiceAcquired"] = this.invoiceAcquired;
        data["notes"] = this.notes;
        data["totalAmount"] = this.totalAmount;
        data["isEditable"] = this.isEditable;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["supplierNote"] = this.supplierNote;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPurchaseOrderByIdResponse extends IBaseResponse {
    id?: number;
    orderNumber?: string;
    supplierId?: number;
    supplierName?: string;
    orderDate?: Date;
    expectedDeliveryDate?: Date | undefined;
    contactVia?: ContactVia | undefined;
    status?: string;
    invoiceAcquired?: boolean;
    notes?: string | undefined;
    totalAmount?: number;
    isEditable?: boolean;
    lines?: PurchaseOrderLineDto[];
    history?: PurchaseOrderHistoryDto[];
    createdAt?: Date;
    createdBy?: string;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;
    supplierNote?: string | undefined;
}

export class UpdatePurchaseOrderResponse extends BaseResponse implements IUpdatePurchaseOrderResponse {
    id?: number;
    orderNumber?: string;
    supplierId?: number;
    supplierName?: string;
    orderDate?: Date;
    expectedDeliveryDate?: Date | undefined;
    contactVia?: ContactVia | undefined;
    status?: string;
    notes?: string | undefined;
    totalAmount?: number;
    lines?: PurchaseOrderLineDto[];
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IUpdatePurchaseOrderResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] ? new Date(_data["expectedDeliveryDate"].toString()) : <any>undefined;
            this.contactVia = _data["contactVia"];
            this.status = _data["status"];
            this.notes = _data["notes"];
            this.totalAmount = _data["totalAmount"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(PurchaseOrderLineDto.fromJS(item));
            }
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static override fromJS(data: any): UpdatePurchaseOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePurchaseOrderResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate ? this.expectedDeliveryDate.toISOString() : <any>undefined;
        data["contactVia"] = this.contactVia;
        data["status"] = this.status;
        data["notes"] = this.notes;
        data["totalAmount"] = this.totalAmount;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePurchaseOrderResponse extends IBaseResponse {
    id?: number;
    orderNumber?: string;
    supplierId?: number;
    supplierName?: string;
    orderDate?: Date;
    expectedDeliveryDate?: Date | undefined;
    contactVia?: ContactVia | undefined;
    status?: string;
    notes?: string | undefined;
    totalAmount?: number;
    lines?: PurchaseOrderLineDto[];
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;
}

export class UpdatePurchaseOrderRequest implements IUpdatePurchaseOrderRequest {
    id!: number;
    supplierId!: number;
    expectedDeliveryDate?: Date | undefined;
    contactVia?: ContactVia | undefined;
    notes?: string | undefined;
    lines!: UpdatePurchaseOrderLineRequest[];
    orderNumber?: string | undefined;

    constructor(data?: IUpdatePurchaseOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.lines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supplierId = _data["supplierId"];
            this.expectedDeliveryDate = _data["expectedDeliveryDate"] ? new Date(_data["expectedDeliveryDate"].toString()) : <any>undefined;
            this.contactVia = _data["contactVia"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(UpdatePurchaseOrderLineRequest.fromJS(item));
            }
            this.orderNumber = _data["orderNumber"];
        }
    }

    static fromJS(data: any): UpdatePurchaseOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePurchaseOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supplierId"] = this.supplierId;
        data["expectedDeliveryDate"] = this.expectedDeliveryDate ? this.expectedDeliveryDate.toISOString() : <any>undefined;
        data["contactVia"] = this.contactVia;
        data["notes"] = this.notes;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["orderNumber"] = this.orderNumber;
        return data;
    }
}

export interface IUpdatePurchaseOrderRequest {
    id: number;
    supplierId: number;
    expectedDeliveryDate?: Date | undefined;
    contactVia?: ContactVia | undefined;
    notes?: string | undefined;
    lines: UpdatePurchaseOrderLineRequest[];
    orderNumber?: string | undefined;
}

export class UpdatePurchaseOrderLineRequest implements IUpdatePurchaseOrderLineRequest {
    id?: number | undefined;
    materialId!: string;
    name?: string | undefined;
    quantity!: number;
    unitPrice!: number;
    notes?: string | undefined;

    constructor(data?: IUpdatePurchaseOrderLineRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialId = _data["materialId"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdatePurchaseOrderLineRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePurchaseOrderLineRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialId"] = this.materialId;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdatePurchaseOrderLineRequest {
    id?: number | undefined;
    materialId: string;
    name?: string | undefined;
    quantity: number;
    unitPrice: number;
    notes?: string | undefined;
}

export class UpdatePurchaseOrderStatusResponse extends BaseResponse implements IUpdatePurchaseOrderStatusResponse {
    id?: number;
    orderNumber?: string;
    status?: string;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IUpdatePurchaseOrderStatusResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.status = _data["status"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static override fromJS(data: any): UpdatePurchaseOrderStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePurchaseOrderStatusResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["status"] = this.status;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePurchaseOrderStatusResponse extends IBaseResponse {
    id?: number;
    orderNumber?: string;
    status?: string;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;
}

export class UpdatePurchaseOrderStatusRequest implements IUpdatePurchaseOrderStatusRequest {
    id?: number;
    status?: string;

    constructor(data?: IUpdatePurchaseOrderStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdatePurchaseOrderStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePurchaseOrderStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdatePurchaseOrderStatusRequest {
    id?: number;
    status?: string;
}

export class UpdatePurchaseOrderInvoiceAcquiredResponse extends BaseResponse implements IUpdatePurchaseOrderInvoiceAcquiredResponse {
    id?: number;
    invoiceAcquired?: boolean;

    constructor(data?: IUpdatePurchaseOrderInvoiceAcquiredResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.invoiceAcquired = _data["invoiceAcquired"];
        }
    }

    static override fromJS(data: any): UpdatePurchaseOrderInvoiceAcquiredResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePurchaseOrderInvoiceAcquiredResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceAcquired"] = this.invoiceAcquired;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePurchaseOrderInvoiceAcquiredResponse extends IBaseResponse {
    id?: number;
    invoiceAcquired?: boolean;
}

export class UpdatePurchaseOrderInvoiceAcquiredRequest implements IUpdatePurchaseOrderInvoiceAcquiredRequest {
    id?: number;
    invoiceAcquired?: boolean;

    constructor(data?: IUpdatePurchaseOrderInvoiceAcquiredRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceAcquired = _data["invoiceAcquired"];
        }
    }

    static fromJS(data: any): UpdatePurchaseOrderInvoiceAcquiredRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePurchaseOrderInvoiceAcquiredRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceAcquired"] = this.invoiceAcquired;
        return data;
    }
}

export interface IUpdatePurchaseOrderInvoiceAcquiredRequest {
    id?: number;
    invoiceAcquired?: boolean;
}

export class ListResponseOfPurchaseOrderHistoryDto extends BaseResponse implements IListResponseOfPurchaseOrderHistoryDto {
    items?: PurchaseOrderHistoryDto[];
    totalCount?: number;

    constructor(data?: IListResponseOfPurchaseOrderHistoryDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PurchaseOrderHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static override fromJS(data: any): ListResponseOfPurchaseOrderHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfPurchaseOrderHistoryDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfPurchaseOrderHistoryDto extends IBaseResponse {
    items?: PurchaseOrderHistoryDto[];
    totalCount?: number;
}

export class RecalculatePurchasePriceResponse extends BaseResponse implements IRecalculatePurchasePriceResponse {
    successCount?: number;
    failedCount?: number;
    totalCount?: number;
    processedProducts?: ProductRecalculationResult[];
    priceSync?: PurchasePriceSyncSummary;
    semiProducts?: BomRecalculationSummary;
    products?: BomRecalculationSummary;
    isSuccess?: boolean;
    message?: string;

    constructor(data?: IRecalculatePurchasePriceResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.successCount = _data["successCount"];
            this.failedCount = _data["failedCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["processedProducts"])) {
                this.processedProducts = [] as any;
                for (let item of _data["processedProducts"])
                    this.processedProducts!.push(ProductRecalculationResult.fromJS(item));
            }
            this.priceSync = _data["priceSync"] ? PurchasePriceSyncSummary.fromJS(_data["priceSync"]) : <any>undefined;
            this.semiProducts = _data["semiProducts"] ? BomRecalculationSummary.fromJS(_data["semiProducts"]) : <any>undefined;
            this.products = _data["products"] ? BomRecalculationSummary.fromJS(_data["products"]) : <any>undefined;
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static override fromJS(data: any): RecalculatePurchasePriceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecalculatePurchasePriceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["successCount"] = this.successCount;
        data["failedCount"] = this.failedCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.processedProducts)) {
            data["processedProducts"] = [];
            for (let item of this.processedProducts)
                data["processedProducts"].push(item.toJSON());
        }
        data["priceSync"] = this.priceSync ? this.priceSync.toJSON() : <any>undefined;
        data["semiProducts"] = this.semiProducts ? this.semiProducts.toJSON() : <any>undefined;
        data["products"] = this.products ? this.products.toJSON() : <any>undefined;
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }
}

export interface IRecalculatePurchasePriceResponse extends IBaseResponse {
    successCount?: number;
    failedCount?: number;
    totalCount?: number;
    processedProducts?: ProductRecalculationResult[];
    priceSync?: PurchasePriceSyncSummary;
    semiProducts?: BomRecalculationSummary;
    products?: BomRecalculationSummary;
    isSuccess?: boolean;
    message?: string;
}

export class ProductRecalculationResult extends BaseResponse implements IProductRecalculationResult {
    productCode?: string;

    constructor(data?: IProductRecalculationResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productCode = _data["productCode"];
        }
    }

    static override fromJS(data: any): ProductRecalculationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProductRecalculationResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        super.toJSON(data);
        return data;
    }
}

export interface IProductRecalculationResult extends IBaseResponse {
    productCode?: string;
}

export class PurchasePriceSyncSummary implements IPurchasePriceSyncSummary {
    candidates?: number;
    written?: number;
    unchanged?: number;
    skippedNoStockPrice?: number;
    failed?: number;

    constructor(data?: IPurchasePriceSyncSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidates = _data["candidates"];
            this.written = _data["written"];
            this.unchanged = _data["unchanged"];
            this.skippedNoStockPrice = _data["skippedNoStockPrice"];
            this.failed = _data["failed"];
        }
    }

    static fromJS(data: any): PurchasePriceSyncSummary {
        data = typeof data === 'object' ? data : {};
        let result = new PurchasePriceSyncSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidates"] = this.candidates;
        data["written"] = this.written;
        data["unchanged"] = this.unchanged;
        data["skippedNoStockPrice"] = this.skippedNoStockPrice;
        data["failed"] = this.failed;
        return data;
    }
}

export interface IPurchasePriceSyncSummary {
    candidates?: number;
    written?: number;
    unchanged?: number;
    skippedNoStockPrice?: number;
    failed?: number;
}

export class BomRecalculationSummary implements IBomRecalculationSummary {
    succeeded?: number;
    failed?: number;

    constructor(data?: IBomRecalculationSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.failed = _data["failed"];
        }
    }

    static fromJS(data: any): BomRecalculationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new BomRecalculationSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["failed"] = this.failed;
        return data;
    }
}

export interface IBomRecalculationSummary {
    succeeded?: number;
    failed?: number;
}

export class RecalculatePurchasePriceRequest implements IRecalculatePurchasePriceRequest {
    productCode?: string | undefined;
    recalculateAll?: boolean;
    forceReload?: boolean;

    constructor(data?: IRecalculatePurchasePriceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.recalculateAll = _data["recalculateAll"];
            this.forceReload = _data["forceReload"];
        }
    }

    static fromJS(data: any): RecalculatePurchasePriceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecalculatePurchasePriceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["recalculateAll"] = this.recalculateAll;
        data["forceReload"] = this.forceReload;
        return data;
    }
}

export interface IRecalculatePurchasePriceRequest {
    productCode?: string | undefined;
    recalculateAll?: boolean;
    forceReload?: boolean;
}

export class GetPurchaseStockAnalysisResponse extends BaseResponse implements IGetPurchaseStockAnalysisResponse {
    items?: StockAnalysisItemDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    summary?: StockAnalysisSummaryDto;

    constructor(data?: IGetPurchaseStockAnalysisResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StockAnalysisItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.summary = _data["summary"] ? StockAnalysisSummaryDto.fromJS(_data["summary"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetPurchaseStockAnalysisResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPurchaseStockAnalysisResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPurchaseStockAnalysisResponse extends IBaseResponse {
    items?: StockAnalysisItemDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    summary?: StockAnalysisSummaryDto;
}

export class StockAnalysisItemDto implements IStockAnalysisItemDto {
    productCode?: string;
    productName?: string;
    productNameNormalized?: string;
    productNameSuffix?: string | undefined;
    productType?: string;
    availableStock?: number;
    orderedStock?: number;
    effectiveStock?: number;
    minStockLevel?: number;
    optimalStockLevel?: number;
    consumptionInPeriod?: number;
    dailyConsumption?: number;
    daysUntilStockout?: number | undefined;
    stockEfficiencyPercentage?: number;
    severity?: StockSeverity;
    minimalOrderQuantity?: string;
    lastPurchase?: LastPurchaseInfoDto | undefined;
    supplier?: string | undefined;
    recommendedOrderQuantity?: number | undefined;
    isConfigured?: boolean;

    constructor(data?: IStockAnalysisItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.productNameNormalized = _data["productNameNormalized"];
            this.productNameSuffix = _data["productNameSuffix"];
            this.productType = _data["productType"];
            this.availableStock = _data["availableStock"];
            this.orderedStock = _data["orderedStock"];
            this.effectiveStock = _data["effectiveStock"];
            this.minStockLevel = _data["minStockLevel"];
            this.optimalStockLevel = _data["optimalStockLevel"];
            this.consumptionInPeriod = _data["consumptionInPeriod"];
            this.dailyConsumption = _data["dailyConsumption"];
            this.daysUntilStockout = _data["daysUntilStockout"];
            this.stockEfficiencyPercentage = _data["stockEfficiencyPercentage"];
            this.severity = _data["severity"];
            this.minimalOrderQuantity = _data["minimalOrderQuantity"];
            this.lastPurchase = _data["lastPurchase"] ? LastPurchaseInfoDto.fromJS(_data["lastPurchase"]) : <any>undefined;
            this.supplier = _data["supplier"];
            this.recommendedOrderQuantity = _data["recommendedOrderQuantity"];
            this.isConfigured = _data["isConfigured"];
        }
    }

    static fromJS(data: any): StockAnalysisItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockAnalysisItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productNameNormalized"] = this.productNameNormalized;
        data["productNameSuffix"] = this.productNameSuffix;
        data["productType"] = this.productType;
        data["availableStock"] = this.availableStock;
        data["orderedStock"] = this.orderedStock;
        data["effectiveStock"] = this.effectiveStock;
        data["minStockLevel"] = this.minStockLevel;
        data["optimalStockLevel"] = this.optimalStockLevel;
        data["consumptionInPeriod"] = this.consumptionInPeriod;
        data["dailyConsumption"] = this.dailyConsumption;
        data["daysUntilStockout"] = this.daysUntilStockout;
        data["stockEfficiencyPercentage"] = this.stockEfficiencyPercentage;
        data["severity"] = this.severity;
        data["minimalOrderQuantity"] = this.minimalOrderQuantity;
        data["lastPurchase"] = this.lastPurchase ? this.lastPurchase.toJSON() : <any>undefined;
        data["supplier"] = this.supplier;
        data["recommendedOrderQuantity"] = this.recommendedOrderQuantity;
        data["isConfigured"] = this.isConfigured;
        return data;
    }
}

export interface IStockAnalysisItemDto {
    productCode?: string;
    productName?: string;
    productNameNormalized?: string;
    productNameSuffix?: string | undefined;
    productType?: string;
    availableStock?: number;
    orderedStock?: number;
    effectiveStock?: number;
    minStockLevel?: number;
    optimalStockLevel?: number;
    consumptionInPeriod?: number;
    dailyConsumption?: number;
    daysUntilStockout?: number | undefined;
    stockEfficiencyPercentage?: number;
    severity?: StockSeverity;
    minimalOrderQuantity?: string;
    lastPurchase?: LastPurchaseInfoDto | undefined;
    supplier?: string | undefined;
    recommendedOrderQuantity?: number | undefined;
    isConfigured?: boolean;
}

export enum StockSeverity {
    Critical = "Critical",
    Low = "Low",
    Optimal = "Optimal",
    Overstocked = "Overstocked",
    NotConfigured = "NotConfigured",
}

export class LastPurchaseInfoDto implements ILastPurchaseInfoDto {
    date?: Date;
    supplierName?: string;
    amount?: number;
    unitPrice?: number;
    totalPrice?: number;

    constructor(data?: ILastPurchaseInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.supplierName = _data["supplierName"];
            this.amount = _data["amount"];
            this.unitPrice = _data["unitPrice"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): LastPurchaseInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new LastPurchaseInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["supplierName"] = this.supplierName;
        data["amount"] = this.amount;
        data["unitPrice"] = this.unitPrice;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface ILastPurchaseInfoDto {
    date?: Date;
    supplierName?: string;
    amount?: number;
    unitPrice?: number;
    totalPrice?: number;
}

export class StockAnalysisSummaryDto implements IStockAnalysisSummaryDto {
    totalProducts?: number;
    criticalCount?: number;
    lowStockCount?: number;
    optimalCount?: number;
    overstockedCount?: number;
    notConfiguredCount?: number;
    totalInventoryValue?: number;
    analysisPeriodStart?: Date;
    analysisPeriodEnd?: Date;

    constructor(data?: IStockAnalysisSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProducts = _data["totalProducts"];
            this.criticalCount = _data["criticalCount"];
            this.lowStockCount = _data["lowStockCount"];
            this.optimalCount = _data["optimalCount"];
            this.overstockedCount = _data["overstockedCount"];
            this.notConfiguredCount = _data["notConfiguredCount"];
            this.totalInventoryValue = _data["totalInventoryValue"];
            this.analysisPeriodStart = _data["analysisPeriodStart"] ? new Date(_data["analysisPeriodStart"].toString()) : <any>undefined;
            this.analysisPeriodEnd = _data["analysisPeriodEnd"] ? new Date(_data["analysisPeriodEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StockAnalysisSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockAnalysisSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProducts"] = this.totalProducts;
        data["criticalCount"] = this.criticalCount;
        data["lowStockCount"] = this.lowStockCount;
        data["optimalCount"] = this.optimalCount;
        data["overstockedCount"] = this.overstockedCount;
        data["notConfiguredCount"] = this.notConfiguredCount;
        data["totalInventoryValue"] = this.totalInventoryValue;
        data["analysisPeriodStart"] = this.analysisPeriodStart ? this.analysisPeriodStart.toISOString() : <any>undefined;
        data["analysisPeriodEnd"] = this.analysisPeriodEnd ? this.analysisPeriodEnd.toISOString() : <any>undefined;
        return data;
    }
}

export interface IStockAnalysisSummaryDto {
    totalProducts?: number;
    criticalCount?: number;
    lowStockCount?: number;
    optimalCount?: number;
    overstockedCount?: number;
    notConfiguredCount?: number;
    totalInventoryValue?: number;
    analysisPeriodStart?: Date;
    analysisPeriodEnd?: Date;
}

export enum StockStatusFilter {
    All = "All",
    Critical = "Critical",
    Low = "Low",
    Optimal = "Optimal",
    Overstocked = "Overstocked",
    NotConfigured = "NotConfigured",
}

export enum MaterialCategoryFilter {
    All = "All",
    Labels = "Labels",
    Packaging = "Packaging",
    Other = "Other",
}

export enum StockAnalysisSortBy {
    ProductCode = "ProductCode",
    ProductName = "ProductName",
    AvailableStock = "AvailableStock",
    Consumption = "Consumption",
    StockEfficiency = "StockEfficiency",
    LastPurchaseDate = "LastPurchaseDate",
}

export class GetRecurringJobsListResponse extends BaseResponse implements IGetRecurringJobsListResponse {
    jobs?: RecurringJobDto[];

    constructor(data?: IGetRecurringJobsListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["jobs"])) {
                this.jobs = [] as any;
                for (let item of _data["jobs"])
                    this.jobs!.push(RecurringJobDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetRecurringJobsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecurringJobsListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jobs)) {
            data["jobs"] = [];
            for (let item of this.jobs)
                data["jobs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetRecurringJobsListResponse extends IBaseResponse {
    jobs?: RecurringJobDto[];
}

export class RecurringJobDto implements IRecurringJobDto {
    jobName?: string;
    displayName?: string;
    description?: string;
    category?: RecurringJobCategory;
    cronExpression?: string;
    timeZoneId?: string;
    isEnabled?: boolean;
    lastModifiedAt?: Date;
    lastModifiedBy?: string;
    nextRunAt?: Date | undefined;

    constructor(data?: IRecurringJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobName = _data["jobName"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.category = _data["category"];
            this.cronExpression = _data["cronExpression"];
            this.timeZoneId = _data["timeZoneId"];
            this.isEnabled = _data["isEnabled"];
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.nextRunAt = _data["nextRunAt"] ? new Date(_data["nextRunAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecurringJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecurringJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobName"] = this.jobName;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["category"] = this.category;
        data["cronExpression"] = this.cronExpression;
        data["timeZoneId"] = this.timeZoneId;
        data["isEnabled"] = this.isEnabled;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["nextRunAt"] = this.nextRunAt ? this.nextRunAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRecurringJobDto {
    jobName?: string;
    displayName?: string;
    description?: string;
    category?: RecurringJobCategory;
    cronExpression?: string;
    timeZoneId?: string;
    isEnabled?: boolean;
    lastModifiedAt?: Date;
    lastModifiedBy?: string;
    nextRunAt?: Date | undefined;
}

export enum RecurringJobCategory {
    Uncategorized = "Uncategorized",
    Finance = "Finance",
    Marketing = "Marketing",
    Catalog = "Catalog",
    Warehouse = "Warehouse",
    DataQuality = "DataQuality",
    Content = "Content",
    Attendance = "Attendance",
    Integrations = "Integrations",
}

export class GetRecurringJobResponse extends BaseResponse implements IGetRecurringJobResponse {
    job?: RecurringJobDto | undefined;

    constructor(data?: IGetRecurringJobResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.job = _data["job"] ? RecurringJobDto.fromJS(_data["job"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetRecurringJobResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecurringJobResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["job"] = this.job ? this.job.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetRecurringJobResponse extends IBaseResponse {
    job?: RecurringJobDto | undefined;
}

export class UpdateRecurringJobStatusResponse extends BaseResponse implements IUpdateRecurringJobStatusResponse {
    jobName?: string;
    isEnabled?: boolean;
    lastModifiedAt?: Date;
    lastModifiedBy?: string;

    constructor(data?: IUpdateRecurringJobStatusResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobName = _data["jobName"];
            this.isEnabled = _data["isEnabled"];
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static override fromJS(data: any): UpdateRecurringJobStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRecurringJobStatusResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobName"] = this.jobName;
        data["isEnabled"] = this.isEnabled;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateRecurringJobStatusResponse extends IBaseResponse {
    jobName?: string;
    isEnabled?: boolean;
    lastModifiedAt?: Date;
    lastModifiedBy?: string;
}

export class UpdateJobStatusRequestBody implements IUpdateJobStatusRequestBody {
    isEnabled?: boolean;

    constructor(data?: IUpdateJobStatusRequestBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): UpdateJobStatusRequestBody {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobStatusRequestBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IUpdateJobStatusRequestBody {
    isEnabled?: boolean;
}

export class UpdateRecurringJobCronResponse extends BaseResponse implements IUpdateRecurringJobCronResponse {
    jobName?: string;
    cronExpression?: string;
    lastModifiedAt?: Date;
    lastModifiedBy?: string;

    constructor(data?: IUpdateRecurringJobCronResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobName = _data["jobName"];
            this.cronExpression = _data["cronExpression"];
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static override fromJS(data: any): UpdateRecurringJobCronResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRecurringJobCronResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobName"] = this.jobName;
        data["cronExpression"] = this.cronExpression;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateRecurringJobCronResponse extends IBaseResponse {
    jobName?: string;
    cronExpression?: string;
    lastModifiedAt?: Date;
    lastModifiedBy?: string;
}

export class UpdateJobCronRequestBody implements IUpdateJobCronRequestBody {
    cronExpression!: string;

    constructor(data?: IUpdateJobCronRequestBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cronExpression = _data["cronExpression"];
        }
    }

    static fromJS(data: any): UpdateJobCronRequestBody {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobCronRequestBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cronExpression"] = this.cronExpression;
        return data;
    }
}

export interface IUpdateJobCronRequestBody {
    cronExpression: string;
}

export class TriggerRecurringJobResponse extends BaseResponse implements ITriggerRecurringJobResponse {
    jobId?: string | undefined;

    constructor(data?: ITriggerRecurringJobResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobId = _data["jobId"];
        }
    }

    static override fromJS(data: any): TriggerRecurringJobResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerRecurringJobResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        super.toJSON(data);
        return data;
    }
}

export interface ITriggerRecurringJobResponse extends IBaseResponse {
    jobId?: string | undefined;
}

export class GetOrderShipmentLabelsResponse extends BaseResponse implements IGetOrderShipmentLabelsResponse {
    labels?: ShipmentLabelDto[];

    constructor(data?: IGetOrderShipmentLabelsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(ShipmentLabelDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetOrderShipmentLabelsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderShipmentLabelsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetOrderShipmentLabelsResponse extends IBaseResponse {
    labels?: ShipmentLabelDto[];
}

export class ShipmentLabelDto implements IShipmentLabelDto {
    shipmentGuid?: string;
    packageName?: string;
    labelUrl?: string | undefined;
    labelZpl?: string | undefined;
    hasPdf?: boolean;
    hasZpl?: boolean;
    trackingNumber?: string | undefined;
    trackingUrl?: string | undefined;

    constructor(data?: IShipmentLabelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipmentGuid = _data["shipmentGuid"];
            this.packageName = _data["packageName"];
            this.labelUrl = _data["labelUrl"];
            this.labelZpl = _data["labelZpl"];
            this.hasPdf = _data["hasPdf"];
            this.hasZpl = _data["hasZpl"];
            this.trackingNumber = _data["trackingNumber"];
            this.trackingUrl = _data["trackingUrl"];
        }
    }

    static fromJS(data: any): ShipmentLabelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentLabelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipmentGuid"] = this.shipmentGuid;
        data["packageName"] = this.packageName;
        data["labelUrl"] = this.labelUrl;
        data["labelZpl"] = this.labelZpl;
        data["hasPdf"] = this.hasPdf;
        data["hasZpl"] = this.hasZpl;
        data["trackingNumber"] = this.trackingNumber;
        data["trackingUrl"] = this.trackingUrl;
        return data;
    }
}

export interface IShipmentLabelDto {
    shipmentGuid?: string;
    packageName?: string;
    labelUrl?: string | undefined;
    labelZpl?: string | undefined;
    hasPdf?: boolean;
    hasZpl?: boolean;
    trackingNumber?: string | undefined;
    trackingUrl?: string | undefined;
}

export class GetShipmentLabelsRequest implements IGetShipmentLabelsRequest {
    orderCode?: string;

    constructor(data?: IGetShipmentLabelsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderCode = _data["orderCode"];
        }
    }

    static fromJS(data: any): GetShipmentLabelsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetShipmentLabelsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCode"] = this.orderCode;
        return data;
    }
}

export interface IGetShipmentLabelsRequest {
    orderCode?: string;
}

export class CreateOrderShipmentResponse extends BaseResponse implements ICreateOrderShipmentResponse {
    shipmentGuid?: string | undefined;
    status?: string | undefined;
    labelReady?: boolean;
    labels?: ShipmentLabelDto[];
    existingShipmentFound?: boolean;

    constructor(data?: ICreateOrderShipmentResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.shipmentGuid = _data["shipmentGuid"];
            this.status = _data["status"];
            this.labelReady = _data["labelReady"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(ShipmentLabelDto.fromJS(item));
            }
            this.existingShipmentFound = _data["existingShipmentFound"];
        }
    }

    static override fromJS(data: any): CreateOrderShipmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderShipmentResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipmentGuid"] = this.shipmentGuid;
        data["status"] = this.status;
        data["labelReady"] = this.labelReady;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item.toJSON());
        }
        data["existingShipmentFound"] = this.existingShipmentFound;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateOrderShipmentResponse extends IBaseResponse {
    shipmentGuid?: string | undefined;
    status?: string | undefined;
    labelReady?: boolean;
    labels?: ShipmentLabelDto[];
    existingShipmentFound?: boolean;
}

export class CreateShipmentRequest implements ICreateShipmentRequest {
    orderCode?: string;
    forceCreate?: boolean;

    constructor(data?: ICreateShipmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderCode = _data["orderCode"];
            this.forceCreate = _data["forceCreate"];
        }
    }

    static fromJS(data: any): CreateShipmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateShipmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCode"] = this.orderCode;
        data["forceCreate"] = this.forceCreate;
        return data;
    }
}

export interface ICreateShipmentRequest {
    orderCode?: string;
    forceCreate?: boolean;
}

export class BlockOrderProcessingResponse extends BaseResponse implements IBlockOrderProcessingResponse {

    constructor(data?: IBlockOrderProcessingResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): BlockOrderProcessingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BlockOrderProcessingResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IBlockOrderProcessingResponse extends IBaseResponse {
}

export class BlockOrderRequest implements IBlockOrderRequest {
    note?: string;

    constructor(data?: IBlockOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): BlockOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BlockOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        return data;
    }
}

export interface IBlockOrderRequest {
    note?: string;
}

export class GetPackingOrderResponse extends BaseResponse implements IGetPackingOrderResponse {
    code?: string;
    customerName?: string;
    shippingMethodName?: string;
    cooling?: Cooling;
    isCooled?: boolean;
    eligibility?: PackingEligibility;
    customerNote?: string | undefined;
    eshopNote?: string | undefined;
    shippingStreet?: string | undefined;
    shippingCity?: string | undefined;
    shippingZip?: string | undefined;
    items?: PackingOrderItemDto[];

    constructor(data?: IGetPackingOrderResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.customerName = _data["customerName"];
            this.shippingMethodName = _data["shippingMethodName"];
            this.cooling = _data["cooling"];
            this.isCooled = _data["isCooled"];
            this.eligibility = _data["eligibility"] ? PackingEligibility.fromJS(_data["eligibility"]) : <any>undefined;
            this.customerNote = _data["customerNote"];
            this.eshopNote = _data["eshopNote"];
            this.shippingStreet = _data["shippingStreet"];
            this.shippingCity = _data["shippingCity"];
            this.shippingZip = _data["shippingZip"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PackingOrderItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetPackingOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPackingOrderResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["customerName"] = this.customerName;
        data["shippingMethodName"] = this.shippingMethodName;
        data["cooling"] = this.cooling;
        data["isCooled"] = this.isCooled;
        data["eligibility"] = this.eligibility ? this.eligibility.toJSON() : <any>undefined;
        data["customerNote"] = this.customerNote;
        data["eshopNote"] = this.eshopNote;
        data["shippingStreet"] = this.shippingStreet;
        data["shippingCity"] = this.shippingCity;
        data["shippingZip"] = this.shippingZip;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPackingOrderResponse extends IBaseResponse {
    code?: string;
    customerName?: string;
    shippingMethodName?: string;
    cooling?: Cooling;
    isCooled?: boolean;
    eligibility?: PackingEligibility;
    customerNote?: string | undefined;
    eshopNote?: string | undefined;
    shippingStreet?: string | undefined;
    shippingCity?: string | undefined;
    shippingZip?: string | undefined;
    items?: PackingOrderItemDto[];
}

export class PackingEligibility implements IPackingEligibility {
    isEligible?: boolean;

    constructor(data?: IPackingEligibility) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEligible = _data["isEligible"];
        }
    }

    static fromJS(data: any): PackingEligibility {
        data = typeof data === 'object' ? data : {};
        let result = new PackingEligibility();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEligible"] = this.isEligible;
        return data;
    }
}

export interface IPackingEligibility {
    isEligible?: boolean;
}

export class PackingOrderItemDto implements IPackingOrderItemDto {
    name?: string;
    quantity?: number;
    imageUrl?: string | undefined;
    setName?: string | undefined;

    constructor(data?: IPackingOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.imageUrl = _data["imageUrl"];
            this.setName = _data["setName"];
        }
    }

    static fromJS(data: any): PackingOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackingOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["imageUrl"] = this.imageUrl;
        data["setName"] = this.setName;
        return data;
    }
}

export interface IPackingOrderItemDto {
    name?: string;
    quantity?: number;
    imageUrl?: string | undefined;
    setName?: string | undefined;
}

export class ListConversationsResponse extends BaseResponse implements IListConversationsResponse {
    items?: ConversationDto[];
    total?: number;
    page?: number;
    pageSize?: number;

    constructor(data?: IListConversationsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ConversationDto.fromJS(item));
            }
            this.total = _data["total"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static override fromJS(data: any): ListConversationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListConversationsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}

export interface IListConversationsResponse extends IBaseResponse {
    items?: ConversationDto[];
    total?: number;
    page?: number;
    pageSize?: number;
}

export class ConversationDto implements IConversationDto {
    id?: string;
    subject?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    contactAvatarUrl?: string | undefined;
    status?: string;
    isUnread?: boolean;
    lastMessageAt?: Date | undefined;
    lastMessagePreview?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    rating?: number | undefined;
    ratingText?: string | undefined;
    closeType?: string | undefined;
    closedByAgentId?: string | undefined;
    assignedAgentIds?: string[];
    channel?: string | undefined;
    isServed?: boolean;
    finishedAt?: Date | undefined;
    domain?: string | undefined;
    referer?: string | undefined;
    locationCountry?: string | undefined;
    locationCity?: string | undefined;
    locationCode?: string | undefined;
    tags?: string[];
    contactPhone?: string | undefined;
    contactNote?: string | undefined;
    contactTags?: string[];
    contactProperties?: { [key: string]: string; };
    locationIp?: string | undefined;
    variables?: { [key: string]: string; };
    otherConversations?: ConversationSummaryDto[];
    activeViewers?: ConversationPresenceDto[];

    constructor(data?: IConversationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactAvatarUrl = _data["contactAvatarUrl"];
            this.status = _data["status"];
            this.isUnread = _data["isUnread"];
            this.lastMessageAt = _data["lastMessageAt"] ? new Date(_data["lastMessageAt"].toString()) : <any>undefined;
            this.lastMessagePreview = _data["lastMessagePreview"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.rating = _data["rating"];
            this.ratingText = _data["ratingText"];
            this.closeType = _data["closeType"];
            this.closedByAgentId = _data["closedByAgentId"];
            if (Array.isArray(_data["assignedAgentIds"])) {
                this.assignedAgentIds = [] as any;
                for (let item of _data["assignedAgentIds"])
                    this.assignedAgentIds!.push(item);
            }
            this.channel = _data["channel"];
            this.isServed = _data["isServed"];
            this.finishedAt = _data["finishedAt"] ? new Date(_data["finishedAt"].toString()) : <any>undefined;
            this.domain = _data["domain"];
            this.referer = _data["referer"];
            this.locationCountry = _data["locationCountry"];
            this.locationCity = _data["locationCity"];
            this.locationCode = _data["locationCode"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.contactPhone = _data["contactPhone"];
            this.contactNote = _data["contactNote"];
            if (Array.isArray(_data["contactTags"])) {
                this.contactTags = [] as any;
                for (let item of _data["contactTags"])
                    this.contactTags!.push(item);
            }
            if (_data["contactProperties"]) {
                this.contactProperties = {} as any;
                for (let key in _data["contactProperties"]) {
                    if (_data["contactProperties"].hasOwnProperty(key))
                        (<any>this.contactProperties)![key] = _data["contactProperties"][key];
                }
            }
            this.locationIp = _data["locationIp"];
            if (_data["variables"]) {
                this.variables = {} as any;
                for (let key in _data["variables"]) {
                    if (_data["variables"].hasOwnProperty(key))
                        (<any>this.variables)![key] = _data["variables"][key];
                }
            }
            if (Array.isArray(_data["otherConversations"])) {
                this.otherConversations = [] as any;
                for (let item of _data["otherConversations"])
                    this.otherConversations!.push(ConversationSummaryDto.fromJS(item));
            }
            if (Array.isArray(_data["activeViewers"])) {
                this.activeViewers = [] as any;
                for (let item of _data["activeViewers"])
                    this.activeViewers!.push(ConversationPresenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConversationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactAvatarUrl"] = this.contactAvatarUrl;
        data["status"] = this.status;
        data["isUnread"] = this.isUnread;
        data["lastMessageAt"] = this.lastMessageAt ? this.lastMessageAt.toISOString() : <any>undefined;
        data["lastMessagePreview"] = this.lastMessagePreview;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["rating"] = this.rating;
        data["ratingText"] = this.ratingText;
        data["closeType"] = this.closeType;
        data["closedByAgentId"] = this.closedByAgentId;
        if (Array.isArray(this.assignedAgentIds)) {
            data["assignedAgentIds"] = [];
            for (let item of this.assignedAgentIds)
                data["assignedAgentIds"].push(item);
        }
        data["channel"] = this.channel;
        data["isServed"] = this.isServed;
        data["finishedAt"] = this.finishedAt ? this.finishedAt.toISOString() : <any>undefined;
        data["domain"] = this.domain;
        data["referer"] = this.referer;
        data["locationCountry"] = this.locationCountry;
        data["locationCity"] = this.locationCity;
        data["locationCode"] = this.locationCode;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["contactPhone"] = this.contactPhone;
        data["contactNote"] = this.contactNote;
        if (Array.isArray(this.contactTags)) {
            data["contactTags"] = [];
            for (let item of this.contactTags)
                data["contactTags"].push(item);
        }
        if (this.contactProperties) {
            data["contactProperties"] = {};
            for (let key in this.contactProperties) {
                if (this.contactProperties.hasOwnProperty(key))
                    (<any>data["contactProperties"])[key] = (<any>this.contactProperties)[key];
            }
        }
        data["locationIp"] = this.locationIp;
        if (this.variables) {
            data["variables"] = {};
            for (let key in this.variables) {
                if (this.variables.hasOwnProperty(key))
                    (<any>data["variables"])[key] = (<any>this.variables)[key];
            }
        }
        if (Array.isArray(this.otherConversations)) {
            data["otherConversations"] = [];
            for (let item of this.otherConversations)
                data["otherConversations"].push(item.toJSON());
        }
        if (Array.isArray(this.activeViewers)) {
            data["activeViewers"] = [];
            for (let item of this.activeViewers)
                data["activeViewers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConversationDto {
    id?: string;
    subject?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    contactAvatarUrl?: string | undefined;
    status?: string;
    isUnread?: boolean;
    lastMessageAt?: Date | undefined;
    lastMessagePreview?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    rating?: number | undefined;
    ratingText?: string | undefined;
    closeType?: string | undefined;
    closedByAgentId?: string | undefined;
    assignedAgentIds?: string[];
    channel?: string | undefined;
    isServed?: boolean;
    finishedAt?: Date | undefined;
    domain?: string | undefined;
    referer?: string | undefined;
    locationCountry?: string | undefined;
    locationCity?: string | undefined;
    locationCode?: string | undefined;
    tags?: string[];
    contactPhone?: string | undefined;
    contactNote?: string | undefined;
    contactTags?: string[];
    contactProperties?: { [key: string]: string; };
    locationIp?: string | undefined;
    variables?: { [key: string]: string; };
    otherConversations?: ConversationSummaryDto[];
    activeViewers?: ConversationPresenceDto[];
}

export class ConversationSummaryDto implements IConversationSummaryDto {
    id?: string;
    status?: string;
    lastMessageAt?: Date | undefined;
    lastMessagePreview?: string | undefined;
    isUnread?: boolean;

    constructor(data?: IConversationSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.lastMessageAt = _data["lastMessageAt"] ? new Date(_data["lastMessageAt"].toString()) : <any>undefined;
            this.lastMessagePreview = _data["lastMessagePreview"];
            this.isUnread = _data["isUnread"];
        }
    }

    static fromJS(data: any): ConversationSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["lastMessageAt"] = this.lastMessageAt ? this.lastMessageAt.toISOString() : <any>undefined;
        data["lastMessagePreview"] = this.lastMessagePreview;
        data["isUnread"] = this.isUnread;
        return data;
    }
}

export interface IConversationSummaryDto {
    id?: string;
    status?: string;
    lastMessageAt?: Date | undefined;
    lastMessagePreview?: string | undefined;
    isUnread?: boolean;
}

export class ConversationPresenceDto implements IConversationPresenceDto {
    agentId?: string;
    displayName?: string;
    source?: string;
    isCurrentUser?: boolean;
    enteredAt?: Date;

    constructor(data?: IConversationPresenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            this.displayName = _data["displayName"];
            this.source = _data["source"];
            this.isCurrentUser = _data["isCurrentUser"];
            this.enteredAt = _data["enteredAt"] ? new Date(_data["enteredAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ConversationPresenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationPresenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["displayName"] = this.displayName;
        data["source"] = this.source;
        data["isCurrentUser"] = this.isCurrentUser;
        data["enteredAt"] = this.enteredAt ? this.enteredAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IConversationPresenceDto {
    agentId?: string;
    displayName?: string;
    source?: string;
    isCurrentUser?: boolean;
    enteredAt?: Date;
}

export class GetConversationResponse extends BaseResponse implements IGetConversationResponse {
    conversation?: ConversationDto | undefined;
    messages?: MessageDto[];
    agentNames?: { [key: string]: string; };

    constructor(data?: IGetConversationResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.conversation = _data["conversation"] ? ConversationDto.fromJS(_data["conversation"]) : <any>undefined;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(MessageDto.fromJS(item));
            }
            if (_data["agentNames"]) {
                this.agentNames = {} as any;
                for (let key in _data["agentNames"]) {
                    if (_data["agentNames"].hasOwnProperty(key))
                        (<any>this.agentNames)![key] = _data["agentNames"][key];
                }
            }
        }
    }

    static override fromJS(data: any): GetConversationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConversationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversation"] = this.conversation ? this.conversation.toJSON() : <any>undefined;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        if (this.agentNames) {
            data["agentNames"] = {};
            for (let key in this.agentNames) {
                if (this.agentNames.hasOwnProperty(key))
                    (<any>data["agentNames"])[key] = (<any>this.agentNames)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetConversationResponse extends IBaseResponse {
    conversation?: ConversationDto | undefined;
    messages?: MessageDto[];
    agentNames?: { [key: string]: string; };
}

export class MessageDto implements IMessageDto {
    id?: string;
    authorType?: string;
    authorName?: string | undefined;
    content?: string | undefined;
    createdAt?: Date;
    agentId?: string | undefined;
    subType?: string | undefined;
    deliveryStatus?: string | undefined;
    deliveredAt?: Date | undefined;
    responseTime?: number | undefined;
    isFirstReply?: boolean;
    pageUrl?: string | undefined;
    attachments?: MessageAttachmentDto[];

    constructor(data?: IMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.authorType = _data["authorType"];
            this.authorName = _data["authorName"];
            this.content = _data["content"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.agentId = _data["agentId"];
            this.subType = _data["subType"];
            this.deliveryStatus = _data["deliveryStatus"];
            this.deliveredAt = _data["deliveredAt"] ? new Date(_data["deliveredAt"].toString()) : <any>undefined;
            this.responseTime = _data["responseTime"];
            this.isFirstReply = _data["isFirstReply"];
            this.pageUrl = _data["pageUrl"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(MessageAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["authorType"] = this.authorType;
        data["authorName"] = this.authorName;
        data["content"] = this.content;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["agentId"] = this.agentId;
        data["subType"] = this.subType;
        data["deliveryStatus"] = this.deliveryStatus;
        data["deliveredAt"] = this.deliveredAt ? this.deliveredAt.toISOString() : <any>undefined;
        data["responseTime"] = this.responseTime;
        data["isFirstReply"] = this.isFirstReply;
        data["pageUrl"] = this.pageUrl;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageDto {
    id?: string;
    authorType?: string;
    authorName?: string | undefined;
    content?: string | undefined;
    createdAt?: Date;
    agentId?: string | undefined;
    subType?: string | undefined;
    deliveryStatus?: string | undefined;
    deliveredAt?: Date | undefined;
    responseTime?: number | undefined;
    isFirstReply?: boolean;
    pageUrl?: string | undefined;
    attachments?: MessageAttachmentDto[];
}

export class MessageAttachmentDto implements IMessageAttachmentDto {
    type?: string;
    fileName?: string;
    fileType?: string | undefined;
    url?: string;
    size?: number | undefined;
    thumbUrl?: string | undefined;

    constructor(data?: IMessageAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.url = _data["url"];
            this.size = _data["size"];
            this.thumbUrl = _data["thumbUrl"];
        }
    }

    static fromJS(data: any): MessageAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["url"] = this.url;
        data["size"] = this.size;
        data["thumbUrl"] = this.thumbUrl;
        return data;
    }
}

export interface IMessageAttachmentDto {
    type?: string;
    fileName?: string;
    fileType?: string | undefined;
    url?: string;
    size?: number | undefined;
    thumbUrl?: string | undefined;
}

export class GenerateDraftReplyResponse extends BaseResponse implements IGenerateDraftReplyResponse {
    id?: string | undefined;
    answer?: string;
    sources?: DraftReplySource[];

    constructor(data?: IGenerateDraftReplyResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.answer = _data["answer"];
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(DraftReplySource.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GenerateDraftReplyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateDraftReplyResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["answer"] = this.answer;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGenerateDraftReplyResponse extends IBaseResponse {
    id?: string | undefined;
    answer?: string;
    sources?: DraftReplySource[];
}

export class DraftReplySource implements IDraftReplySource {
    chunkId?: string;
    documentId?: string;
    filename?: string;
    excerpt?: string;
    score?: number;

    constructor(data?: IDraftReplySource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chunkId = _data["chunkId"];
            this.documentId = _data["documentId"];
            this.filename = _data["filename"];
            this.excerpt = _data["excerpt"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): DraftReplySource {
        data = typeof data === 'object' ? data : {};
        let result = new DraftReplySource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chunkId"] = this.chunkId;
        data["documentId"] = this.documentId;
        data["filename"] = this.filename;
        data["excerpt"] = this.excerpt;
        data["score"] = this.score;
        return data;
    }
}

export interface IDraftReplySource {
    chunkId?: string;
    documentId?: string;
    filename?: string;
    excerpt?: string;
    score?: number;
}

export class GenerateDraftReplyBody implements IGenerateDraftReplyBody {
    topic?: string | undefined;

    constructor(data?: IGenerateDraftReplyBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topic = _data["topic"];
        }
    }

    static fromJS(data: any): GenerateDraftReplyBody {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateDraftReplyBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topic"] = this.topic;
        return data;
    }
}

export interface IGenerateDraftReplyBody {
    topic?: string | undefined;
}

export class GetSmartsuppContactShoptetInfoResponse extends BaseResponse implements IGetSmartsuppContactShoptetInfoResponse {
    contactInfo?: ShoptetContactInfoDto | undefined;

    constructor(data?: IGetSmartsuppContactShoptetInfoResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contactInfo = _data["contactInfo"] ? ShoptetContactInfoDto.fromJS(_data["contactInfo"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetSmartsuppContactShoptetInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSmartsuppContactShoptetInfoResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactInfo"] = this.contactInfo ? this.contactInfo.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSmartsuppContactShoptetInfoResponse extends IBaseResponse {
    contactInfo?: ShoptetContactInfoDto | undefined;
}

export class ShoptetContactInfoDto implements IShoptetContactInfoDto {
    customer?: ShoptetCustomerSnapshotDto | undefined;
    recentOrders?: ShoptetOrderSnapshotDto[];
    cartUpdatedAt?: Date | undefined;

    constructor(data?: IShoptetContactInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer = _data["customer"] ? ShoptetCustomerSnapshotDto.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["recentOrders"])) {
                this.recentOrders = [] as any;
                for (let item of _data["recentOrders"])
                    this.recentOrders!.push(ShoptetOrderSnapshotDto.fromJS(item));
            }
            this.cartUpdatedAt = _data["cartUpdatedAt"] ? new Date(_data["cartUpdatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ShoptetContactInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShoptetContactInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.recentOrders)) {
            data["recentOrders"] = [];
            for (let item of this.recentOrders)
                data["recentOrders"].push(item.toJSON());
        }
        data["cartUpdatedAt"] = this.cartUpdatedAt ? this.cartUpdatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IShoptetContactInfoDto {
    customer?: ShoptetCustomerSnapshotDto | undefined;
    recentOrders?: ShoptetOrderSnapshotDto[];
    cartUpdatedAt?: Date | undefined;
}

export class ShoptetCustomerSnapshotDto implements IShoptetCustomerSnapshotDto {
    fullName?: string | undefined;
    email?: string | undefined;
    customerGroup?: string | undefined;
    priceList?: string | undefined;
    defaultShippingAddress?: string | undefined;

    constructor(data?: IShoptetCustomerSnapshotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.customerGroup = _data["customerGroup"];
            this.priceList = _data["priceList"];
            this.defaultShippingAddress = _data["defaultShippingAddress"];
        }
    }

    static fromJS(data: any): ShoptetCustomerSnapshotDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShoptetCustomerSnapshotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["customerGroup"] = this.customerGroup;
        data["priceList"] = this.priceList;
        data["defaultShippingAddress"] = this.defaultShippingAddress;
        return data;
    }
}

export interface IShoptetCustomerSnapshotDto {
    fullName?: string | undefined;
    email?: string | undefined;
    customerGroup?: string | undefined;
    priceList?: string | undefined;
    defaultShippingAddress?: string | undefined;
}

export class ShoptetOrderSnapshotDto implements IShoptetOrderSnapshotDto {
    code?: string;
    statusName?: string | undefined;
    totalWithVat?: number | undefined;
    currencyCode?: string | undefined;
    orderDate?: Date | undefined;
    adminUrl?: string | undefined;

    constructor(data?: IShoptetOrderSnapshotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.statusName = _data["statusName"];
            this.totalWithVat = _data["totalWithVat"];
            this.currencyCode = _data["currencyCode"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.adminUrl = _data["adminUrl"];
        }
    }

    static fromJS(data: any): ShoptetOrderSnapshotDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShoptetOrderSnapshotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["statusName"] = this.statusName;
        data["totalWithVat"] = this.totalWithVat;
        data["currencyCode"] = this.currencyCode;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["adminUrl"] = this.adminUrl;
        return data;
    }
}

export interface IShoptetOrderSnapshotDto {
    code?: string;
    statusName?: string | undefined;
    totalWithVat?: number | undefined;
    currencyCode?: string | undefined;
    orderDate?: Date | undefined;
    adminUrl?: string | undefined;
}

export class GetVisitorInfoResponse extends BaseResponse implements IGetVisitorInfoResponse {
    visitorInfo?: VisitorInfoDto | undefined;

    constructor(data?: IGetVisitorInfoResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.visitorInfo = _data["visitorInfo"] ? VisitorInfoDto.fromJS(_data["visitorInfo"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetVisitorInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetVisitorInfoResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitorInfo"] = this.visitorInfo ? this.visitorInfo.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetVisitorInfoResponse extends IBaseResponse {
    visitorInfo?: VisitorInfoDto | undefined;
}

export class VisitorInfoDto implements IVisitorInfoDto {
    os?: string | undefined;
    browser?: string | undefined;
    browserVersion?: string | undefined;
    userAgent?: string | undefined;
    visitsCount?: number | undefined;
    chatsCount?: number;
    pages?: VisitorPageDto[];

    constructor(data?: IVisitorInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.os = _data["os"];
            this.browser = _data["browser"];
            this.browserVersion = _data["browserVersion"];
            this.userAgent = _data["userAgent"];
            this.visitsCount = _data["visitsCount"];
            this.chatsCount = _data["chatsCount"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(VisitorPageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VisitorInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitorInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["os"] = this.os;
        data["browser"] = this.browser;
        data["browserVersion"] = this.browserVersion;
        data["userAgent"] = this.userAgent;
        data["visitsCount"] = this.visitsCount;
        data["chatsCount"] = this.chatsCount;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVisitorInfoDto {
    os?: string | undefined;
    browser?: string | undefined;
    browserVersion?: string | undefined;
    userAgent?: string | undefined;
    visitsCount?: number | undefined;
    chatsCount?: number;
    pages?: VisitorPageDto[];
}

export class VisitorPageDto implements IVisitorPageDto {
    url?: string;

    constructor(data?: IVisitorPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): VisitorPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitorPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IVisitorPageDto {
    url?: string;
}

export class SendMessageResponse extends BaseResponse implements ISendMessageResponse {
    messageId?: string;
    createdAt?: Date;

    constructor(data?: ISendMessageResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.messageId = _data["messageId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): SendMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendMessageResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISendMessageResponse extends IBaseResponse {
    messageId?: string;
    createdAt?: Date;
}

export class SendMessageBody implements ISendMessageBody {
    content?: string;
    draftLogId?: string | undefined;

    constructor(data?: ISendMessageBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.draftLogId = _data["draftLogId"];
        }
    }

    static fromJS(data: any): SendMessageBody {
        data = typeof data === 'object' ? data : {};
        let result = new SendMessageBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["draftLogId"] = this.draftLogId;
        return data;
    }
}

export interface ISendMessageBody {
    content?: string;
    draftLogId?: string | undefined;
}

export class SubmitDraftReplyFeedbackResponse extends BaseResponse implements ISubmitDraftReplyFeedbackResponse {

    constructor(data?: ISubmitDraftReplyFeedbackResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SubmitDraftReplyFeedbackResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitDraftReplyFeedbackResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISubmitDraftReplyFeedbackResponse extends IBaseResponse {
}

export class SubmitDraftReplyFeedbackRequest implements ISubmitDraftReplyFeedbackRequest {
    logId?: string;
    precisionScore?: number;
    styleScore?: number;
    comment?: string | undefined;

    constructor(data?: ISubmitDraftReplyFeedbackRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logId = _data["logId"];
            this.precisionScore = _data["precisionScore"];
            this.styleScore = _data["styleScore"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): SubmitDraftReplyFeedbackRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitDraftReplyFeedbackRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logId"] = this.logId;
        data["precisionScore"] = this.precisionScore;
        data["styleScore"] = this.styleScore;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ISubmitDraftReplyFeedbackRequest {
    logId?: string;
    precisionScore?: number;
    styleScore?: number;
    comment?: string | undefined;
}

export class GetDraftReplyFeedbackListResponse extends BaseResponse implements IGetDraftReplyFeedbackListResponse {
    logs?: RagFeedbackLogSummary[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    stats?: RagFeedbackStatsDto;

    constructor(data?: IGetDraftReplyFeedbackListResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(RagFeedbackLogSummary.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.stats = _data["stats"] ? RagFeedbackStatsDto.fromJS(_data["stats"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetDraftReplyFeedbackListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDraftReplyFeedbackListResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["stats"] = this.stats ? this.stats.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetDraftReplyFeedbackListResponse extends IBaseResponse {
    logs?: RagFeedbackLogSummary[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    stats?: RagFeedbackStatsDto;
}

export class CloseConversationResponse extends BaseResponse implements ICloseConversationResponse {

    constructor(data?: ICloseConversationResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CloseConversationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CloseConversationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICloseConversationResponse extends IBaseResponse {
}

export class RecordPresenceResponse extends BaseResponse implements IRecordPresenceResponse {

    constructor(data?: IRecordPresenceResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): RecordPresenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecordPresenceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRecordPresenceResponse extends IBaseResponse {
}

export class RemovePresenceResponse extends BaseResponse implements IRemovePresenceResponse {

    constructor(data?: IRemovePresenceResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): RemovePresenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemovePresenceResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRemovePresenceResponse extends IBaseResponse {
}

export class RefreshOrphanContactsResponse extends BaseResponse implements IRefreshOrphanContactsResponse {
    scanned?: number;
    updated?: number;
    skippedNoContactId?: number;
    failed?: number;
    failedIds?: string[];

    constructor(data?: IRefreshOrphanContactsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.scanned = _data["scanned"];
            this.updated = _data["updated"];
            this.skippedNoContactId = _data["skippedNoContactId"];
            this.failed = _data["failed"];
            if (Array.isArray(_data["failedIds"])) {
                this.failedIds = [] as any;
                for (let item of _data["failedIds"])
                    this.failedIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): RefreshOrphanContactsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshOrphanContactsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scanned"] = this.scanned;
        data["updated"] = this.updated;
        data["skippedNoContactId"] = this.skippedNoContactId;
        data["failed"] = this.failed;
        if (Array.isArray(this.failedIds)) {
            data["failedIds"] = [];
            for (let item of this.failedIds)
                data["failedIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IRefreshOrphanContactsResponse extends IBaseResponse {
    scanned?: number;
    updated?: number;
    skippedNoContactId?: number;
    failed?: number;
    failedIds?: string[];
}

export class ListWebhookAuditResponse extends BaseResponse implements IListWebhookAuditResponse {
    items?: WebhookAuditSummaryDto[];
    total?: number;
    skip?: number;
    pageSize?: number;

    constructor(data?: IListWebhookAuditResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WebhookAuditSummaryDto.fromJS(item));
            }
            this.total = _data["total"];
            this.skip = _data["skip"];
            this.pageSize = _data["pageSize"];
        }
    }

    static override fromJS(data: any): ListWebhookAuditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListWebhookAuditResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["skip"] = this.skip;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}

export interface IListWebhookAuditResponse extends IBaseResponse {
    items?: WebhookAuditSummaryDto[];
    total?: number;
    skip?: number;
    pageSize?: number;
}

export class WebhookAuditSummaryDto implements IWebhookAuditSummaryDto {
    id?: string;
    receivedAt?: Date;
    eventName?: string | undefined;
    accountId?: string | undefined;
    appId?: string | undefined;
    signatureStatus?: SmartsuppWebhookSignatureStatus;
    processingStatus?: SmartsuppWebhookProcessingStatus;
    bodySizeBytes?: number;
    processingDurationMs?: number;
    replayCount?: number;
    lastReplayedAt?: Date | undefined;
    processedAt?: Date | undefined;

    constructor(data?: IWebhookAuditSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.receivedAt = _data["receivedAt"] ? new Date(_data["receivedAt"].toString()) : <any>undefined;
            this.eventName = _data["eventName"];
            this.accountId = _data["accountId"];
            this.appId = _data["appId"];
            this.signatureStatus = _data["signatureStatus"];
            this.processingStatus = _data["processingStatus"];
            this.bodySizeBytes = _data["bodySizeBytes"];
            this.processingDurationMs = _data["processingDurationMs"];
            this.replayCount = _data["replayCount"];
            this.lastReplayedAt = _data["lastReplayedAt"] ? new Date(_data["lastReplayedAt"].toString()) : <any>undefined;
            this.processedAt = _data["processedAt"] ? new Date(_data["processedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WebhookAuditSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookAuditSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["receivedAt"] = this.receivedAt ? this.receivedAt.toISOString() : <any>undefined;
        data["eventName"] = this.eventName;
        data["accountId"] = this.accountId;
        data["appId"] = this.appId;
        data["signatureStatus"] = this.signatureStatus;
        data["processingStatus"] = this.processingStatus;
        data["bodySizeBytes"] = this.bodySizeBytes;
        data["processingDurationMs"] = this.processingDurationMs;
        data["replayCount"] = this.replayCount;
        data["lastReplayedAt"] = this.lastReplayedAt ? this.lastReplayedAt.toISOString() : <any>undefined;
        data["processedAt"] = this.processedAt ? this.processedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWebhookAuditSummaryDto {
    id?: string;
    receivedAt?: Date;
    eventName?: string | undefined;
    accountId?: string | undefined;
    appId?: string | undefined;
    signatureStatus?: SmartsuppWebhookSignatureStatus;
    processingStatus?: SmartsuppWebhookProcessingStatus;
    bodySizeBytes?: number;
    processingDurationMs?: number;
    replayCount?: number;
    lastReplayedAt?: Date | undefined;
    processedAt?: Date | undefined;
}

export enum SmartsuppWebhookSignatureStatus {
    Valid = "Valid",
    Missing = "Missing",
    Mismatch = "Mismatch",
    AppIdMismatch = "AppIdMismatch",
}

export enum SmartsuppWebhookProcessingStatus {
    NotProcessed = "NotProcessed",
    MalformedJson = "MalformedJson",
    Success = "Success",
    HandlerException = "HandlerException",
}

export class GetWebhookAuditEntryResponse extends BaseResponse implements IGetWebhookAuditEntryResponse {
    entry?: WebhookAuditEntryDto | undefined;

    constructor(data?: IGetWebhookAuditEntryResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entry = _data["entry"] ? WebhookAuditEntryDto.fromJS(_data["entry"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetWebhookAuditEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWebhookAuditEntryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entry"] = this.entry ? this.entry.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetWebhookAuditEntryResponse extends IBaseResponse {
    entry?: WebhookAuditEntryDto | undefined;
}

export class WebhookAuditEntryDto implements IWebhookAuditEntryDto {
    id?: string;
    receivedAt?: Date;
    remoteIp?: string;
    signatureHeader?: string | undefined;
    signatureStatus?: SmartsuppWebhookSignatureStatus;
    headersJson?: string;
    rawBody?: string;
    bodySizeBytes?: number;
    eventName?: string | undefined;
    accountId?: string | undefined;
    appId?: string | undefined;
    eventTimestamp?: Date | undefined;
    processingStatus?: SmartsuppWebhookProcessingStatus;
    processingError?: string | undefined;
    processingDurationMs?: number;
    processedAt?: Date | undefined;
    replayCount?: number;
    lastReplayedAt?: Date | undefined;
    lastReplayedBy?: string | undefined;

    constructor(data?: IWebhookAuditEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.receivedAt = _data["receivedAt"] ? new Date(_data["receivedAt"].toString()) : <any>undefined;
            this.remoteIp = _data["remoteIp"];
            this.signatureHeader = _data["signatureHeader"];
            this.signatureStatus = _data["signatureStatus"];
            this.headersJson = _data["headersJson"];
            this.rawBody = _data["rawBody"];
            this.bodySizeBytes = _data["bodySizeBytes"];
            this.eventName = _data["eventName"];
            this.accountId = _data["accountId"];
            this.appId = _data["appId"];
            this.eventTimestamp = _data["eventTimestamp"] ? new Date(_data["eventTimestamp"].toString()) : <any>undefined;
            this.processingStatus = _data["processingStatus"];
            this.processingError = _data["processingError"];
            this.processingDurationMs = _data["processingDurationMs"];
            this.processedAt = _data["processedAt"] ? new Date(_data["processedAt"].toString()) : <any>undefined;
            this.replayCount = _data["replayCount"];
            this.lastReplayedAt = _data["lastReplayedAt"] ? new Date(_data["lastReplayedAt"].toString()) : <any>undefined;
            this.lastReplayedBy = _data["lastReplayedBy"];
        }
    }

    static fromJS(data: any): WebhookAuditEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookAuditEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["receivedAt"] = this.receivedAt ? this.receivedAt.toISOString() : <any>undefined;
        data["remoteIp"] = this.remoteIp;
        data["signatureHeader"] = this.signatureHeader;
        data["signatureStatus"] = this.signatureStatus;
        data["headersJson"] = this.headersJson;
        data["rawBody"] = this.rawBody;
        data["bodySizeBytes"] = this.bodySizeBytes;
        data["eventName"] = this.eventName;
        data["accountId"] = this.accountId;
        data["appId"] = this.appId;
        data["eventTimestamp"] = this.eventTimestamp ? this.eventTimestamp.toISOString() : <any>undefined;
        data["processingStatus"] = this.processingStatus;
        data["processingError"] = this.processingError;
        data["processingDurationMs"] = this.processingDurationMs;
        data["processedAt"] = this.processedAt ? this.processedAt.toISOString() : <any>undefined;
        data["replayCount"] = this.replayCount;
        data["lastReplayedAt"] = this.lastReplayedAt ? this.lastReplayedAt.toISOString() : <any>undefined;
        data["lastReplayedBy"] = this.lastReplayedBy;
        return data;
    }
}

export interface IWebhookAuditEntryDto {
    id?: string;
    receivedAt?: Date;
    remoteIp?: string;
    signatureHeader?: string | undefined;
    signatureStatus?: SmartsuppWebhookSignatureStatus;
    headersJson?: string;
    rawBody?: string;
    bodySizeBytes?: number;
    eventName?: string | undefined;
    accountId?: string | undefined;
    appId?: string | undefined;
    eventTimestamp?: Date | undefined;
    processingStatus?: SmartsuppWebhookProcessingStatus;
    processingError?: string | undefined;
    processingDurationMs?: number;
    processedAt?: Date | undefined;
    replayCount?: number;
    lastReplayedAt?: Date | undefined;
    lastReplayedBy?: string | undefined;
}

export class ReplayWebhookEventResponse extends BaseResponse implements IReplayWebhookEventResponse {
    replayCount?: number;
    lastReplayedAt?: Date | undefined;

    constructor(data?: IReplayWebhookEventResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.replayCount = _data["replayCount"];
            this.lastReplayedAt = _data["lastReplayedAt"] ? new Date(_data["lastReplayedAt"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): ReplayWebhookEventResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReplayWebhookEventResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["replayCount"] = this.replayCount;
        data["lastReplayedAt"] = this.lastReplayedAt ? this.lastReplayedAt.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IReplayWebhookEventResponse extends IBaseResponse {
    replayCount?: number;
    lastReplayedAt?: Date | undefined;
}

export class SubmitStockTakingResponse extends BaseResponse implements ISubmitStockTakingResponse {
    id?: number;
    type?: StockTakingType;
    code?: string;
    amountNew?: number;
    amountOld?: number;
    date?: Date;
    user?: string | undefined;
    error?: string | undefined;

    constructor(data?: ISubmitStockTakingResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.code = _data["code"];
            this.amountNew = _data["amountNew"];
            this.amountOld = _data["amountOld"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.error = _data["error"];
        }
    }

    static override fromJS(data: any): SubmitStockTakingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitStockTakingResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["code"] = this.code;
        data["amountNew"] = this.amountNew;
        data["amountOld"] = this.amountOld;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["error"] = this.error;
        super.toJSON(data);
        return data;
    }
}

export interface ISubmitStockTakingResponse extends IBaseResponse {
    id?: number;
    type?: StockTakingType;
    code?: string;
    amountNew?: number;
    amountOld?: number;
    date?: Date;
    user?: string | undefined;
    error?: string | undefined;
}

export class SubmitStockTakingRequest implements ISubmitStockTakingRequest {
    productCode!: string;
    targetAmount!: number;
    softStockTaking?: boolean;

    constructor(data?: ISubmitStockTakingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.targetAmount = _data["targetAmount"];
            this.softStockTaking = _data["softStockTaking"];
        }
    }

    static fromJS(data: any): SubmitStockTakingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitStockTakingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["targetAmount"] = this.targetAmount;
        data["softStockTaking"] = this.softStockTaking;
        return data;
    }
}

export interface ISubmitStockTakingRequest {
    productCode: string;
    targetAmount: number;
    softStockTaking?: boolean;
}

export class GetStockTakingHistoryResponse extends BaseResponse implements IGetStockTakingHistoryResponse {
    items?: StockTakingHistoryItemDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;

    constructor(data?: IGetStockTakingHistoryResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StockTakingHistoryItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static override fromJS(data: any): GetStockTakingHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockTakingHistoryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        super.toJSON(data);
        return data;
    }
}

export interface IGetStockTakingHistoryResponse extends IBaseResponse {
    items?: StockTakingHistoryItemDto[];
    totalCount?: number;
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
}

export class StockTakingHistoryItemDto implements IStockTakingHistoryItemDto {
    id?: number;
    type?: StockTakingType;
    code?: string;
    amountNew?: number;
    amountOld?: number;
    date?: Date;
    user?: string | undefined;
    error?: string | undefined;
    difference?: number;

    constructor(data?: IStockTakingHistoryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.code = _data["code"];
            this.amountNew = _data["amountNew"];
            this.amountOld = _data["amountOld"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.error = _data["error"];
            this.difference = _data["difference"];
        }
    }

    static fromJS(data: any): StockTakingHistoryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockTakingHistoryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["code"] = this.code;
        data["amountNew"] = this.amountNew;
        data["amountOld"] = this.amountOld;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["error"] = this.error;
        data["difference"] = this.difference;
        return data;
    }
}

export interface IStockTakingHistoryItemDto {
    id?: number;
    type?: StockTakingType;
    code?: string;
    amountNew?: number;
    amountOld?: number;
    date?: Date;
    user?: string | undefined;
    error?: string | undefined;
    difference?: number;
}

export class GetStockUpOperationsResponse extends BaseResponse implements IGetStockUpOperationsResponse {
    operations?: StockUpOperationDto[];
    totalCount?: number;

    constructor(data?: IGetStockUpOperationsResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(StockUpOperationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static override fromJS(data: any): GetStockUpOperationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockUpOperationsResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        super.toJSON(data);
        return data;
    }
}

export interface IGetStockUpOperationsResponse extends IBaseResponse {
    operations?: StockUpOperationDto[];
    totalCount?: number;
}

export class StockUpOperationDto implements IStockUpOperationDto {
    id?: number;
    documentNumber?: string;
    productCode?: string;
    amount?: number;
    state?: StockUpOperationState;
    sourceType?: StockUpSourceType;
    sourceId?: number;
    createdAt?: Date;
    submittedAt?: Date | undefined;
    completedAt?: Date | undefined;
    failedAt?: Date | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IStockUpOperationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentNumber = _data["documentNumber"];
            this.productCode = _data["productCode"];
            this.amount = _data["amount"];
            this.state = _data["state"];
            this.sourceType = _data["sourceType"];
            this.sourceId = _data["sourceId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.submittedAt = _data["submittedAt"] ? new Date(_data["submittedAt"].toString()) : <any>undefined;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : <any>undefined;
            this.failedAt = _data["failedAt"] ? new Date(_data["failedAt"].toString()) : <any>undefined;
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): StockUpOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockUpOperationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentNumber"] = this.documentNumber;
        data["productCode"] = this.productCode;
        data["amount"] = this.amount;
        data["state"] = this.state;
        data["sourceType"] = this.sourceType;
        data["sourceId"] = this.sourceId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : <any>undefined;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        data["failedAt"] = this.failedAt ? this.failedAt.toISOString() : <any>undefined;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IStockUpOperationDto {
    id?: number;
    documentNumber?: string;
    productCode?: string;
    amount?: number;
    state?: StockUpOperationState;
    sourceType?: StockUpSourceType;
    sourceId?: number;
    createdAt?: Date;
    submittedAt?: Date | undefined;
    completedAt?: Date | undefined;
    failedAt?: Date | undefined;
    errorMessage?: string | undefined;
}

export enum StockUpOperationState {
    Pending = "Pending",
    Submitted = "Submitted",
    Completed = "Completed",
    Failed = "Failed",
}

export enum StockUpSourceType {
    TransportBox = "TransportBox",
    GiftPackageManufacture = "GiftPackageManufacture",
}

export class RetryStockUpOperationResponse extends BaseResponse implements IRetryStockUpOperationResponse {
    status?: StockUpResultStatus;
    errorMessage?: string | undefined;

    constructor(data?: IRetryStockUpOperationResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static override fromJS(data: any): RetryStockUpOperationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RetryStockUpOperationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["errorMessage"] = this.errorMessage;
        super.toJSON(data);
        return data;
    }
}

export interface IRetryStockUpOperationResponse extends IBaseResponse {
    status?: StockUpResultStatus;
    errorMessage?: string | undefined;
}

export enum StockUpResultStatus {
    Success = "Success",
    AlreadyCompleted = "AlreadyCompleted",
    AlreadyInShoptet = "AlreadyInShoptet",
    InProgress = "InProgress",
    PreviouslyFailed = "PreviouslyFailed",
    Failed = "Failed",
}

export class AcceptStockUpOperationResponse extends BaseResponse implements IAcceptStockUpOperationResponse {
    status?: StockUpResultStatus;
    errorMessage?: string | undefined;

    constructor(data?: IAcceptStockUpOperationResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static override fromJS(data: any): AcceptStockUpOperationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptStockUpOperationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["errorMessage"] = this.errorMessage;
        super.toJSON(data);
        return data;
    }
}

export interface IAcceptStockUpOperationResponse extends IBaseResponse {
    status?: StockUpResultStatus;
    errorMessage?: string | undefined;
}

export class GetStockUpOperationsSummaryResponse extends BaseResponse implements IGetStockUpOperationsSummaryResponse {
    pendingCount?: number;
    submittedCount?: number;
    failedCount?: number;
    totalInQueue?: number;

    constructor(data?: IGetStockUpOperationsSummaryResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pendingCount = _data["pendingCount"];
            this.submittedCount = _data["submittedCount"];
            this.failedCount = _data["failedCount"];
            this.totalInQueue = _data["totalInQueue"];
        }
    }

    static override fromJS(data: any): GetStockUpOperationsSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockUpOperationsSummaryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingCount"] = this.pendingCount;
        data["submittedCount"] = this.submittedCount;
        data["failedCount"] = this.failedCount;
        data["totalInQueue"] = this.totalInQueue;
        super.toJSON(data);
        return data;
    }
}

export interface IGetStockUpOperationsSummaryResponse extends IBaseResponse {
    pendingCount?: number;
    submittedCount?: number;
    failedCount?: number;
    totalInQueue?: number;
}

export class SearchSuppliersResponse extends BaseResponse implements ISearchSuppliersResponse {
    suppliers?: SupplierDto[];

    constructor(data?: ISearchSuppliersResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(SupplierDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SearchSuppliersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchSuppliersResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISearchSuppliersResponse extends IBaseResponse {
    suppliers?: SupplierDto[];
}

export class SupplierDto implements ISupplierDto {
    id?: number;
    name?: string;
    code?: string;
    note?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    url?: string | undefined;

    constructor(data?: ISupplierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.note = _data["note"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): SupplierDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["note"] = this.note;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["url"] = this.url;
        return data;
    }
}

export interface ISupplierDto {
    id?: number;
    name?: string;
    code?: string;
    note?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    url?: string | undefined;
}

export class GetTransportBoxesResponse extends BaseResponse implements IGetTransportBoxesResponse {
    items?: TransportBoxDto[];
    totalCount?: number;
    skip?: number;
    take?: number;

    constructor(data?: IGetTransportBoxesResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TransportBoxDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static override fromJS(data: any): GetTransportBoxesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransportBoxesResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["skip"] = this.skip;
        data["take"] = this.take;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTransportBoxesResponse extends IBaseResponse {
    items?: TransportBoxDto[];
    totalCount?: number;
    skip?: number;
    take?: number;
}

export class TransportBoxDto implements ITransportBoxDto {
    id?: number;
    code?: string | undefined;
    state?: string;
    defaultReceiveState?: string;
    description?: string | undefined;
    lastStateChanged?: Date | undefined;
    location?: string | undefined;
    isInTransit?: boolean;
    isInReserve?: boolean;
    isInQuarantine?: boolean;
    isReceivable?: boolean;
    itemCount?: number;
    creationTime?: Date;
    creatorId?: string | undefined;
    lastModificationTime?: Date | undefined;
    lastModifierId?: string | undefined;
    items?: TransportBoxItemDto[];
    stateLog?: TransportBoxStateLogDto[];
    allowedTransitions?: TransportBoxTransitionDto[];

    constructor(data?: ITransportBoxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.state = _data["state"];
            this.defaultReceiveState = _data["defaultReceiveState"];
            this.description = _data["description"];
            this.lastStateChanged = _data["lastStateChanged"] ? new Date(_data["lastStateChanged"].toString()) : <any>undefined;
            this.location = _data["location"];
            this.isInTransit = _data["isInTransit"];
            this.isInReserve = _data["isInReserve"];
            this.isInQuarantine = _data["isInQuarantine"];
            this.isReceivable = _data["isReceivable"];
            this.itemCount = _data["itemCount"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorId = _data["creatorId"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierId = _data["lastModifierId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TransportBoxItemDto.fromJS(item));
            }
            if (Array.isArray(_data["stateLog"])) {
                this.stateLog = [] as any;
                for (let item of _data["stateLog"])
                    this.stateLog!.push(TransportBoxStateLogDto.fromJS(item));
            }
            if (Array.isArray(_data["allowedTransitions"])) {
                this.allowedTransitions = [] as any;
                for (let item of _data["allowedTransitions"])
                    this.allowedTransitions!.push(TransportBoxTransitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransportBoxDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransportBoxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["state"] = this.state;
        data["defaultReceiveState"] = this.defaultReceiveState;
        data["description"] = this.description;
        data["lastStateChanged"] = this.lastStateChanged ? this.lastStateChanged.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["isInTransit"] = this.isInTransit;
        data["isInReserve"] = this.isInReserve;
        data["isInQuarantine"] = this.isInQuarantine;
        data["isReceivable"] = this.isReceivable;
        data["itemCount"] = this.itemCount;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierId"] = this.lastModifierId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.stateLog)) {
            data["stateLog"] = [];
            for (let item of this.stateLog)
                data["stateLog"].push(item.toJSON());
        }
        if (Array.isArray(this.allowedTransitions)) {
            data["allowedTransitions"] = [];
            for (let item of this.allowedTransitions)
                data["allowedTransitions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITransportBoxDto {
    id?: number;
    code?: string | undefined;
    state?: string;
    defaultReceiveState?: string;
    description?: string | undefined;
    lastStateChanged?: Date | undefined;
    location?: string | undefined;
    isInTransit?: boolean;
    isInReserve?: boolean;
    isInQuarantine?: boolean;
    isReceivable?: boolean;
    itemCount?: number;
    creationTime?: Date;
    creatorId?: string | undefined;
    lastModificationTime?: Date | undefined;
    lastModifierId?: string | undefined;
    items?: TransportBoxItemDto[];
    stateLog?: TransportBoxStateLogDto[];
    allowedTransitions?: TransportBoxTransitionDto[];
}

export class TransportBoxItemDto implements ITransportBoxItemDto {
    id?: number;
    productCode?: string;
    productName?: string;
    amount?: number;
    imageUrl?: string | undefined;
    dateAdded?: Date;
    userAdded?: string;
    onStock?: number;
    lotNumber?: string | undefined;
    expirationDate?: Date | undefined;

    constructor(data?: ITransportBoxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.amount = _data["amount"];
            this.imageUrl = _data["imageUrl"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : <any>undefined;
            this.userAdded = _data["userAdded"];
            this.onStock = _data["onStock"];
            this.lotNumber = _data["lotNumber"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TransportBoxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransportBoxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["amount"] = this.amount;
        data["imageUrl"] = this.imageUrl;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>undefined;
        data["userAdded"] = this.userAdded;
        data["onStock"] = this.onStock;
        data["lotNumber"] = this.lotNumber;
        data["expirationDate"] = this.expirationDate ? formatDate(this.expirationDate) : <any>undefined;
        return data;
    }
}

export interface ITransportBoxItemDto {
    id?: number;
    productCode?: string;
    productName?: string;
    amount?: number;
    imageUrl?: string | undefined;
    dateAdded?: Date;
    userAdded?: string;
    onStock?: number;
    lotNumber?: string | undefined;
    expirationDate?: Date | undefined;
}

export class TransportBoxStateLogDto implements ITransportBoxStateLogDto {
    id?: number;
    state?: string;
    stateDate?: Date;
    user?: string | undefined;
    description?: string | undefined;

    constructor(data?: ITransportBoxStateLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.state = _data["state"];
            this.stateDate = _data["stateDate"] ? new Date(_data["stateDate"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TransportBoxStateLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransportBoxStateLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["state"] = this.state;
        data["stateDate"] = this.stateDate ? this.stateDate.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["description"] = this.description;
        return data;
    }
}

export interface ITransportBoxStateLogDto {
    id?: number;
    state?: string;
    stateDate?: Date;
    user?: string | undefined;
    description?: string | undefined;
}

export class TransportBoxTransitionDto implements ITransportBoxTransitionDto {
    newState?: string;
    transitionType?: string;
    systemOnly?: boolean;
    label?: string;

    constructor(data?: ITransportBoxTransitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newState = _data["newState"];
            this.transitionType = _data["transitionType"];
            this.systemOnly = _data["systemOnly"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): TransportBoxTransitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransportBoxTransitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newState"] = this.newState;
        data["transitionType"] = this.transitionType;
        data["systemOnly"] = this.systemOnly;
        data["label"] = this.label;
        return data;
    }
}

export interface ITransportBoxTransitionDto {
    newState?: string;
    transitionType?: string;
    systemOnly?: boolean;
    label?: string;
}

export class GetTransportBoxSummaryResponse extends BaseResponse implements IGetTransportBoxSummaryResponse {
    totalBoxes?: number;
    activeBoxes?: number;
    statesCounts?: { [key: string]: number; };

    constructor(data?: IGetTransportBoxSummaryResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalBoxes = _data["totalBoxes"];
            this.activeBoxes = _data["activeBoxes"];
            if (_data["statesCounts"]) {
                this.statesCounts = {} as any;
                for (let key in _data["statesCounts"]) {
                    if (_data["statesCounts"].hasOwnProperty(key))
                        (<any>this.statesCounts)![key] = _data["statesCounts"][key];
                }
            }
        }
    }

    static override fromJS(data: any): GetTransportBoxSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransportBoxSummaryResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalBoxes"] = this.totalBoxes;
        data["activeBoxes"] = this.activeBoxes;
        if (this.statesCounts) {
            data["statesCounts"] = {};
            for (let key in this.statesCounts) {
                if (this.statesCounts.hasOwnProperty(key))
                    (<any>data["statesCounts"])[key] = (<any>this.statesCounts)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTransportBoxSummaryResponse extends IBaseResponse {
    totalBoxes?: number;
    activeBoxes?: number;
    statesCounts?: { [key: string]: number; };
}

export class GetTransportBoxByIdResponse extends BaseResponse implements IGetTransportBoxByIdResponse {
    transportBox?: TransportBoxDto | undefined;

    constructor(data?: IGetTransportBoxByIdResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transportBox = _data["transportBox"] ? TransportBoxDto.fromJS(_data["transportBox"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetTransportBoxByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransportBoxByIdResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transportBox"] = this.transportBox ? this.transportBox.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTransportBoxByIdResponse extends IBaseResponse {
    transportBox?: TransportBoxDto | undefined;
}

export class ChangeTransportBoxStateResponse extends BaseResponse implements IChangeTransportBoxStateResponse {
    updatedBox?: GetTransportBoxByIdResponse | undefined;

    constructor(data?: IChangeTransportBoxStateResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.updatedBox = _data["updatedBox"] ? GetTransportBoxByIdResponse.fromJS(_data["updatedBox"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ChangeTransportBoxStateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeTransportBoxStateResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedBox"] = this.updatedBox ? this.updatedBox.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IChangeTransportBoxStateResponse extends IBaseResponse {
    updatedBox?: GetTransportBoxByIdResponse | undefined;
}

export class ChangeTransportBoxStateRequest implements IChangeTransportBoxStateRequest {
    boxId?: number;
    newState?: TransportBoxState;
    description?: string | undefined;
    boxCode?: string | undefined;
    location?: string | undefined;

    constructor(data?: IChangeTransportBoxStateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boxId = _data["boxId"];
            this.newState = _data["newState"];
            this.description = _data["description"];
            this.boxCode = _data["boxCode"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): ChangeTransportBoxStateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeTransportBoxStateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boxId"] = this.boxId;
        data["newState"] = this.newState;
        data["description"] = this.description;
        data["boxCode"] = this.boxCode;
        data["location"] = this.location;
        return data;
    }
}

export interface IChangeTransportBoxStateRequest {
    boxId?: number;
    newState?: TransportBoxState;
    description?: string | undefined;
    boxCode?: string | undefined;
    location?: string | undefined;
}

export enum TransportBoxState {
    New = "New",
    Opened = "Opened",
    InTransit = "InTransit",
    Received = "Received",
    InSwap = "InSwap",
    Stocked = "Stocked",
    Closed = "Closed",
    Error = "Error",
    Reserve = "Reserve",
    Quarantine = "Quarantine",
}

export class CreateNewTransportBoxResponse extends BaseResponse implements ICreateNewTransportBoxResponse {
    transportBox?: TransportBoxDto | undefined;

    constructor(data?: ICreateNewTransportBoxResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transportBox = _data["transportBox"] ? TransportBoxDto.fromJS(_data["transportBox"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CreateNewTransportBoxResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewTransportBoxResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transportBox"] = this.transportBox ? this.transportBox.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateNewTransportBoxResponse extends IBaseResponse {
    transportBox?: TransportBoxDto | undefined;
}

export class CreateNewTransportBoxRequest implements ICreateNewTransportBoxRequest {
    description?: string | undefined;

    constructor(data?: ICreateNewTransportBoxRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateNewTransportBoxRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewTransportBoxRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateNewTransportBoxRequest {
    description?: string | undefined;
}

export class AddItemToBoxResponse extends BaseResponse implements IAddItemToBoxResponse {
    item?: TransportBoxItemDto | undefined;
    transportBox?: TransportBoxDto | undefined;

    constructor(data?: IAddItemToBoxResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.item = _data["item"] ? TransportBoxItemDto.fromJS(_data["item"]) : <any>undefined;
            this.transportBox = _data["transportBox"] ? TransportBoxDto.fromJS(_data["transportBox"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AddItemToBoxResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddItemToBoxResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["transportBox"] = this.transportBox ? this.transportBox.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAddItemToBoxResponse extends IBaseResponse {
    item?: TransportBoxItemDto | undefined;
    transportBox?: TransportBoxDto | undefined;
}

export class AddItemToBoxRequest implements IAddItemToBoxRequest {
    boxId?: number;
    productCode!: string;
    productName!: string;
    amount!: number;
    sourceInventoryId?: number | undefined;
    lotNumber?: string | undefined;
    expirationDate?: Date | undefined;
    allowNegativeStock?: boolean;

    constructor(data?: IAddItemToBoxRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boxId = _data["boxId"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.amount = _data["amount"];
            this.sourceInventoryId = _data["sourceInventoryId"];
            this.lotNumber = _data["lotNumber"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.allowNegativeStock = _data["allowNegativeStock"];
        }
    }

    static fromJS(data: any): AddItemToBoxRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddItemToBoxRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boxId"] = this.boxId;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["amount"] = this.amount;
        data["sourceInventoryId"] = this.sourceInventoryId;
        data["lotNumber"] = this.lotNumber;
        data["expirationDate"] = this.expirationDate ? formatDate(this.expirationDate) : <any>undefined;
        data["allowNegativeStock"] = this.allowNegativeStock;
        return data;
    }
}

export interface IAddItemToBoxRequest {
    boxId?: number;
    productCode: string;
    productName: string;
    amount: number;
    sourceInventoryId?: number | undefined;
    lotNumber?: string | undefined;
    expirationDate?: Date | undefined;
    allowNegativeStock?: boolean;
}

export class RemoveItemFromBoxResponse extends BaseResponse implements IRemoveItemFromBoxResponse {
    transportBox?: TransportBoxDto | undefined;

    constructor(data?: IRemoveItemFromBoxResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transportBox = _data["transportBox"] ? TransportBoxDto.fromJS(_data["transportBox"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): RemoveItemFromBoxResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveItemFromBoxResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transportBox"] = this.transportBox ? this.transportBox.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IRemoveItemFromBoxResponse extends IBaseResponse {
    transportBox?: TransportBoxDto | undefined;
}

export class UpdateTransportBoxDescriptionResponse extends BaseResponse implements IUpdateTransportBoxDescriptionResponse {
    updatedBox?: GetTransportBoxByIdResponse | undefined;

    constructor(data?: IUpdateTransportBoxDescriptionResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.updatedBox = _data["updatedBox"] ? GetTransportBoxByIdResponse.fromJS(_data["updatedBox"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): UpdateTransportBoxDescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTransportBoxDescriptionResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedBox"] = this.updatedBox ? this.updatedBox.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateTransportBoxDescriptionResponse extends IBaseResponse {
    updatedBox?: GetTransportBoxByIdResponse | undefined;
}

export class UpdateTransportBoxDescriptionRequest implements IUpdateTransportBoxDescriptionRequest {
    boxId?: number;
    description?: string | undefined;

    constructor(data?: IUpdateTransportBoxDescriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boxId = _data["boxId"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateTransportBoxDescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTransportBoxDescriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boxId"] = this.boxId;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateTransportBoxDescriptionRequest {
    boxId?: number;
    description?: string | undefined;
}

export class GetTransportBoxByCodeResponse extends BaseResponse implements IGetTransportBoxByCodeResponse {
    transportBox?: TransportBoxDto | undefined;

    constructor(data?: IGetTransportBoxByCodeResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transportBox = _data["transportBox"] ? TransportBoxDto.fromJS(_data["transportBox"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): GetTransportBoxByCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransportBoxByCodeResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transportBox"] = this.transportBox ? this.transportBox.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTransportBoxByCodeResponse extends IBaseResponse {
    transportBox?: TransportBoxDto | undefined;
}

export class OpenOrResumeBoxByCodeResponse extends BaseResponse implements IOpenOrResumeBoxByCodeResponse {
    transportBox?: TransportBoxDto | undefined;
    resumed?: boolean;

    constructor(data?: IOpenOrResumeBoxByCodeResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transportBox = _data["transportBox"] ? TransportBoxDto.fromJS(_data["transportBox"]) : <any>undefined;
            this.resumed = _data["resumed"];
        }
    }

    static override fromJS(data: any): OpenOrResumeBoxByCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OpenOrResumeBoxByCodeResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transportBox"] = this.transportBox ? this.transportBox.toJSON() : <any>undefined;
        data["resumed"] = this.resumed;
        super.toJSON(data);
        return data;
    }
}

export interface IOpenOrResumeBoxByCodeResponse extends IBaseResponse {
    transportBox?: TransportBoxDto | undefined;
    resumed?: boolean;
}

export class OpenOrResumeBoxByCodeRequest implements IOpenOrResumeBoxByCodeRequest {
    boxCode?: string;

    constructor(data?: IOpenOrResumeBoxByCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boxCode = _data["boxCode"];
        }
    }

    static fromJS(data: any): OpenOrResumeBoxByCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OpenOrResumeBoxByCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boxCode"] = this.boxCode;
        return data;
    }
}

export interface IOpenOrResumeBoxByCodeRequest {
    boxCode?: string;
}

export class GetGroupMembersResponse extends BaseResponse implements IGetGroupMembersResponse {
    members?: UserDto[];

    constructor(data?: IGetGroupMembersResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(UserDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetGroupMembersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupMembersResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetGroupMembersResponse extends IBaseResponse {
    members?: UserDto[];
}

export class UserDto implements IUserDto {
    id?: string;
    displayName?: string;
    email?: string;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        return data;
    }
}

export interface IUserDto {
    id?: string;
    displayName?: string;
    email?: string;
}

export class GetWeatherForecastResponse extends BaseResponse implements IGetWeatherForecastResponse {
    days?: HottestDayDto[];

    constructor(data?: IGetWeatherForecastResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(HottestDayDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GetWeatherForecastResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWeatherForecastResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetWeatherForecastResponse extends IBaseResponse {
    days?: HottestDayDto[];
}

export class HottestDayDto implements IHottestDayDto {
    date?: Date;
    cityName?: string;
    minTemperatureCelsius?: number;
    maxTemperatureCelsius?: number;
    weatherCode?: number;

    constructor(data?: IHottestDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.cityName = _data["cityName"];
            this.minTemperatureCelsius = _data["minTemperatureCelsius"];
            this.maxTemperatureCelsius = _data["maxTemperatureCelsius"];
            this.weatherCode = _data["weatherCode"];
        }
    }

    static fromJS(data: any): HottestDayDto {
        data = typeof data === 'object' ? data : {};
        let result = new HottestDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["cityName"] = this.cityName;
        data["minTemperatureCelsius"] = this.minTemperatureCelsius;
        data["maxTemperatureCelsius"] = this.maxTemperatureCelsius;
        data["weatherCode"] = this.weatherCode;
        return data;
    }
}

export interface IHottestDayDto {
    date?: Date;
    cityName?: string;
    minTemperatureCelsius?: number;
    maxTemperatureCelsius?: number;
    weatherCode?: number;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}